import { jsx as jsx$2, ThemeContext, Global, withEmotionCache } from '@emotion/react';
export { Global } from '@emotion/react';
import * as React from 'react';
import React__default, { createContext as createContext$1, useContext, createElement, useState, useEffect, forwardRef as forwardRef$1, useRef, useCallback, useMemo, Component } from 'react';
import packageInfo from '@emotion/react/package.json';
import AnimateHeight from 'react-animate-height';
import Tippy from '@tippyjs/react/headless';
import debounce$1 from 'lodash/fp/debounce';
import require$$3 from 'date-fns/isDate';
import require$$4 from 'date-fns/isValid';
import require$$5 from 'date-fns/format';
import require$$6 from 'date-fns/addMinutes';
import require$$7 from 'date-fns/addHours';
import require$$8 from 'date-fns/addDays';
import require$$9 from 'date-fns/addWeeks';
import require$$10 from 'date-fns/addMonths';
import require$$11 from 'date-fns/addYears';
import require$$12 from 'date-fns/subMinutes';
import require$$13 from 'date-fns/subHours';
import require$$14 from 'date-fns/subDays';
import require$$15 from 'date-fns/subWeeks';
import require$$16 from 'date-fns/subMonths';
import require$$17 from 'date-fns/subYears';
import require$$18 from 'date-fns/getSeconds';
import require$$19 from 'date-fns/getMinutes';
import require$$20 from 'date-fns/getHours';
import require$$21 from 'date-fns/getDay';
import require$$22 from 'date-fns/getDate';
import require$$23 from 'date-fns/getISOWeek';
import require$$24 from 'date-fns/getMonth';
import require$$25 from 'date-fns/getQuarter';
import require$$26 from 'date-fns/getYear';
import require$$27 from 'date-fns/getTime';
import require$$28 from 'date-fns/setSeconds';
import require$$29 from 'date-fns/setMinutes';
import require$$30 from 'date-fns/setHours';
import require$$31 from 'date-fns/setMonth';
import require$$32 from 'date-fns/setQuarter';
import require$$33 from 'date-fns/setYear';
import require$$34 from 'date-fns/min';
import require$$35 from 'date-fns/max';
import require$$36 from 'date-fns/differenceInCalendarDays';
import require$$37 from 'date-fns/differenceInCalendarMonths';
import require$$38 from 'date-fns/differenceInCalendarWeeks';
import require$$39 from 'date-fns/differenceInCalendarYears';
import require$$40 from 'date-fns/startOfDay';
import require$$41 from 'date-fns/startOfWeek';
import require$$42 from 'date-fns/startOfMonth';
import require$$43 from 'date-fns/startOfQuarter';
import require$$44 from 'date-fns/startOfYear';
import require$$45 from 'date-fns/endOfDay';
import require$$46 from 'date-fns/endOfWeek';
import require$$47 from 'date-fns/endOfMonth';
import require$$48 from 'date-fns/isEqual';
import require$$49 from 'date-fns/isSameDay';
import require$$50 from 'date-fns/isSameMonth';
import require$$51 from 'date-fns/isSameYear';
import require$$52 from 'date-fns/isSameQuarter';
import require$$53 from 'date-fns/isAfter';
import require$$54 from 'date-fns/isBefore';
import require$$55 from 'date-fns/isWithinInterval';
import require$$56 from 'date-fns/toDate';
import require$$57 from 'date-fns/parse';
import require$$58 from 'date-fns/parseISO';
import require$$61, { findDOMNode } from 'react-dom';

var isMergeableObject = function isMergeableObject(value) {
  return isNonNullObject(value) && !isSpecial(value);
};

function isNonNullObject(value) {
  return !!value && typeof value === 'object';
}

function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
} // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25


var canUseSymbol$1 = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol$1 ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}

function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}

function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}

function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}

function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge;
  }

  var customMerge = options.customMerge(key);
  return typeof customMerge === 'function' ? customMerge : deepmerge;
}

function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
    return target.propertyIsEnumerable(symbol);
  }) : [];
}

function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}

function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
} // Protects from prototype poisoning and unexpected merging up the prototype chain.


function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
  && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
  && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
  var destination = {};

  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }

  getKeys(source).forEach(function (key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }

    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}

function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject; // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
  // implementations can use it. The caller may not replace it.

  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}

deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }

  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};

var deepmerge_1 = deepmerge;
var cjs = deepmerge_1;

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}
/**
 * @internal
 * We fall back to `theme.useBodyStyles` when `theme.useRootStyles` is not set.
 */


function __internalGetUseRootStyles(theme) {
  if (theme === void 0) {
    theme = {};
  }

  var _theme = theme,
      useRootStyles = _theme.useRootStyles,
      useBodyStyles = _theme.useBodyStyles;
  var root = 'useRootStyles' in theme && useRootStyles != null;
  return {
    scope: root ? 'html' : 'body',
    rootStyles: root ? useRootStyles : useBodyStyles
  };
}
/**
 * Allows for nested scales with shorthand values
 * @example
 * {
 *   colors: {
 *     primary: { __default: '#00f', light: '#33f' }
 *   }
 * }
 * css({ color: 'primary' }); // { color: '#00f' }
 * css({ color: 'primary.light' }) // { color: '#33f' }
 */


var THEME_UI_DEFAULT_KEY = '__default';

var hasDefault = function hasDefault(x) {
  return typeof x === 'object' && x !== null && THEME_UI_DEFAULT_KEY in x;
};
/**
 * Extracts value under path from a deeply nested object.
 * Used for Themes, variants and Theme UI style objects.
 * Given a path to object with `__default` key, returns the value under that key.
 *
 * @param obj a theme, variant or style object
 * @param path path separated with dots (`.`)
 * @param fallback default value returned if get(obj, path) is not found
 */


function get$2(obj, path, fallback, p, undef) {
  var pathArray = path && typeof path === 'string' ? path.split('.') : [path];

  for (p = 0; p < pathArray.length; p++) {
    obj = obj ? obj[pathArray[p]] : undef;
  }

  if (obj === undef) return fallback;
  return hasDefault(obj) ? obj[THEME_UI_DEFAULT_KEY] : obj;
}

var getObjectWithVariants = function getObjectWithVariants(obj, theme) {
  if (obj && obj['variant']) {
    var result = {};

    for (var key in obj) {
      var x = obj[key];

      if (key === 'variant') {
        var val = typeof x === 'function' ? x(theme) : x;
        var variant = getObjectWithVariants(get$2(theme, val), theme);
        result = _extends$7({}, result, variant);
      } else {
        result[key] = x;
      }
    }

    return result;
  }

  return obj;
};

var defaultBreakpoints$1 = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme$1 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases$2 = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples$1 = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  scrollPaddingX: ['scrollPaddingLeft', 'scrollPaddingRight'],
  scrollPaddingY: ['scrollPaddingTop', 'scrollPaddingBottom'],
  size: ['width', 'height']
};
var scales$1 = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  caretColor: 'colors',
  columnRuleColor: 'colors',
  opacity: 'opacities',
  transition: 'transitions',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  marginBlock: 'space',
  marginBlockEnd: 'space',
  marginBlockStart: 'space',
  marginInline: 'space',
  marginInlineEnd: 'space',
  marginInlineStart: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  paddingBlock: 'space',
  paddingBlockEnd: 'space',
  paddingBlockStart: 'space',
  paddingInline: 'space',
  paddingInlineEnd: 'space',
  paddingInlineStart: 'space',
  scrollPadding: 'space',
  scrollPaddingTop: 'space',
  scrollPaddingRight: 'space',
  scrollPaddingBottom: 'space',
  scrollPaddingLeft: 'space',
  scrollPaddingX: 'space',
  scrollPaddingY: 'space',
  inset: 'space',
  insetBlock: 'space',
  insetBlockEnd: 'space',
  insetBlockStart: 'space',
  insetInline: 'space',
  insetInlineEnd: 'space',
  insetInlineStart: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  borderBlock: 'borders',
  borderBlockEnd: 'borders',
  borderBlockEndStyle: 'borderStyles',
  borderBlockEndWidth: 'borderWidths',
  borderBlockStart: 'borders',
  borderBlockStartStyle: 'borderStyles',
  borderBlockStartWidth: 'borderWidths',
  borderBlockStyle: 'borderStyles',
  borderBlockWidth: 'borderWidths',
  borderEndEndRadius: 'radii',
  borderEndStartRadius: 'radii',
  borderInline: 'borders',
  borderInlineEnd: 'borders',
  borderInlineEndStyle: 'borderStyles',
  borderInlineEndWidth: 'borderWidths',
  borderInlineStart: 'borders',
  borderInlineStartStyle: 'borderStyles',
  borderInlineStartWidth: 'borderWidths',
  borderInlineStyle: 'borderStyles',
  borderInlineWidth: 'borderWidths',
  borderStartEndRadius: 'radii',
  borderStartStartRadius: 'radii',
  outlineColor: 'colors',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  blockSize: 'sizes',
  inlineSize: 'sizes',
  maxBlockSize: 'sizes',
  maxInlineSize: 'sizes',
  minBlockSize: 'sizes',
  minInlineSize: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative$1 = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    if (typeof value === 'string' && value.startsWith('-')) {
      var valueWithoutMinus = value.substring(1);

      var _n = get$2(scale, valueWithoutMinus, valueWithoutMinus);

      return "-" + _n;
    }

    return get$2(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get$2(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return Number(n) * -1;
};

var transforms$1 = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginBlock', 'marginBlockEnd', 'marginBlockStart', 'marginInline', 'marginInlineEnd', 'marginInlineStart', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends$7({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative$1, _extends2));
}, {});

var responsive$1 = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = theme && theme.breakpoints || defaultBreakpoints$1;
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var k in styles) {
      var key = k;
      var value = styles[key];

      if (typeof value === 'function') {
        value = value(theme || {});
      }

      if (value === false || value == null) {
        continue;
      }

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};

var css$1 = function css(args) {
  if (args === void 0) {
    args = {};
  }

  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends$7({}, defaultTheme$1, 'theme' in props ? props.theme : props); // insert variant props before responsive styles, so they can be merged
    // we need to maintain order of the style props, so if a variant is place in the middle
    // of other props, it will extends its props at that same location order.


    var obj = getObjectWithVariants(typeof args === 'function' ? args(theme) : args, theme);
    var styles = responsive$1(obj)(theme);
    var result = {};

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (val && typeof val === 'object') {
        if (hasDefault(val)) {
          result[key] = val[THEME_UI_DEFAULT_KEY];
          continue;
        } // On type level, val can also be an array here,
        // but we transform all arrays in `responsive` function.


        result[key] = css(val)(theme);
        continue;
      }

      var prop = key in aliases$2 ? aliases$2[key] : key;
      var scaleName = prop in scales$1 ? scales$1[prop] : undefined;
      var scale = scaleName ? theme == null ? void 0 : theme[scaleName] : get$2(theme, prop, {});
      var transform = get$2(transforms$1, prop, get$2);
      var value = transform(scale, val, val);

      if (prop in multiples$1) {
        var dirs = multiples$1[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};

var getCSS = function getCSS(props) {
  return function (theme) {
    var styles = css$1(props.sx)(theme);
    var raw = typeof props.css === 'function' ? props.css(theme) : props.css;
    return [styles, raw];
  };
};

var parseProps = function parseProps(props) {
  if (!props || !props.sx && !props.css) return props;
  var next = {};

  for (var key in props) {
    if (key === 'sx') continue;
    next[key] = props[key];
  }

  next.css = getCSS(props);
  return next;
};

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}

var __EMOTION_VERSION__ = packageInfo.version;

var jsx$1 = function jsx(type, props) {
  return jsx$2.apply(void 0, [type, parseProps(props)].concat([].slice.call(arguments, 2)));
};

var Context = createContext$1({
  __EMOTION_VERSION__: __EMOTION_VERSION__,
  theme: {}
});

var useThemeUI = function useThemeUI() {
  return useContext(Context);
};

var canUseSymbol = typeof Symbol === 'function' && Symbol["for"];
var REACT_ELEMENT = canUseSymbol ? Symbol["for"]('react.element') : 0xeac7;
var FORWARD_REF = canUseSymbol ? Symbol["for"]('react.forward_ref') : 0xeac7;
var deepmergeOptions = {
  isMergeableObject: function isMergeableObject(n) {
    return !!n && typeof n === 'object' && n.$$typeof !== REACT_ELEMENT && n.$$typeof !== FORWARD_REF;
  },
  arrayMerge: function arrayMerge(_leftArray, rightArray) {
    return rightArray;
  }
};
/**
 * Deeply merge themes
 */

var merge$1 = function merge(a, b) {
  return cjs(a, b, deepmergeOptions);
};

function mergeAll() {
  return cjs.all([].slice.call(arguments), deepmergeOptions);
}

merge$1.all = mergeAll;

var BaseProvider = function BaseProvider(_ref) {
  var context = _ref.context,
      children = _ref.children;
  return jsx$1(ThemeContext.Provider, {
    value: context.theme
  }, jsx$1(Context.Provider, {
    value: context,
    children: children
  }));
};

function ThemeProvider$1(_ref2) {
  var theme = _ref2.theme,
      children = _ref2.children;
  var outer = useThemeUI();

  var context = typeof theme === 'function' ? _extends$6({}, outer, {
    theme: theme(outer.theme)
  }) : merge$1.all({}, outer, {
    theme: theme
  });
  return jsx$1(BaseProvider, {
    context: context
  }, children);
}

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

var stripKeyDefault = function stripKeyDefault(key) {
  return key.replace('-__default', '');
};

var toVarName = function toVarName(key) {
  return "--theme-ui-" + stripKeyDefault(key);
};

var toVarValue = function toVarValue(key, value) {
  return "var(" + toVarName(key) + ", " + value + ")";
};

var join = function join() {
  return [].slice.call(arguments).filter(Boolean).join('-');
};

var numberScales = {
  fontWeights: true,
  lineHeights: true
};
var reservedKeys = {
  useCustomProperties: true,
  initialColorModeName: true,
  printColorModeName: true,
  initialColorMode: true,
  useLocalStorage: true
};

var toPixel = function toPixel(key, value) {
  if (typeof value !== 'number') return value;
  if (numberScales[key]) return value;
  return value + 'px';
}; // convert theme values to custom properties


var toCustomProperties = function toCustomProperties(obj, parent, themeKey) {
  var next = Array.isArray(obj) ? [] : {};

  for (var key in obj) {
    var value = obj[key];
    var name = join(parent, key);

    if (value && typeof value === 'object') {
      next[key] = toCustomProperties(value, name, key);
      continue;
    }

    if (reservedKeys[key]) {
      next[key] = value;
      continue;
    }

    var val = toPixel(themeKey || key, value);
    next[key] = toVarValue(name, val);
  }

  return next;
};

var objectToVars = function objectToVars(parent, obj) {
  var vars = {};

  for (var key in obj) {
    if (key === 'modes') continue;
    var name = join(parent, key);
    var value = obj[key];

    if (value && typeof value === 'object') {
      vars = _extends$5({}, vars, objectToVars(name, value));
    } else {
      vars[toVarName(name)] = value;
    }
  }

  return vars;
}; // create root styles for color modes


var createColorStyles = function createColorStyles(theme) {
  var _css2;

  if (theme === void 0) {
    theme = {};
  }

  var use = __internalGetUseRootStyles(theme);

  if (!theme.colors || use.rootStyles === false) return {};

  if (theme.useCustomProperties === false || !theme.colors.modes) {
    var _css;

    return css$1((_css = {}, _css[use.scope] = {
      color: 'text',
      bg: 'background'
    }, _css))(theme);
  }

  var _theme = theme,
      colors = _theme.colors,
      initialColorModeName = _theme.initialColorModeName,
      printColorModeName = _theme.printColorModeName;
  var modes = colors.modes || {};
  var styles = objectToVars('colors', colors);
  Object.keys(modes).forEach(function (mode) {
    var key = "&.theme-ui-" + mode;
    styles[key] = objectToVars('colors', modes[mode]);
  });

  if (printColorModeName) {
    var mode = printColorModeName === 'initial' || printColorModeName === initialColorModeName ? colors : modes[printColorModeName];
    styles['@media print'] = objectToVars('colors', mode);
  }

  var colorToVarValue = function colorToVarValue(color) {
    return toVarValue("colors-" + color, get$2(theme, "colors." + color));
  };

  return css$1((_css2 = {}, _css2[use.scope] = _extends$5({}, styles, {
    color: colorToVarValue('text'),
    bg: colorToVarValue('background')
  }), _css2))(theme);
};

var STORAGE_KEY = 'theme-ui-color-mode';
var storage = {
  get: function get(init) {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || init;
    } catch (e) {
      console.warn('localStorage is disabled and color mode might not work as expected.', 'Please check your Site Settings.', e);
    }
  },
  set: function set(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      console.warn('localStorage is disabled and color mode might not work as expected.', 'Please check your Site Settings.', e);
    }
  }
};

var getPreferredColorScheme = function getPreferredColorScheme() {
  if (typeof window !== 'undefined' && window.matchMedia) {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }

    if (window.matchMedia('(prefers-color-scheme: light)').matches) {
      return 'light';
    }
  }

  return null;
};

var useColorModeState = function useColorModeState(theme) {
  if (theme === void 0) {
    theme = {};
  }

  var _React$useState = React__default.useState(function () {
    var preferredMode = theme.useColorSchemeMediaQuery !== false && getPreferredColorScheme();
    return preferredMode || theme.initialColorModeName || 'default';
  }),
      mode = _React$useState[0],
      setMode = _React$useState[1]; // read color mode from local storage


  React__default.useEffect(function () {
    var stored = theme.useLocalStorage !== false && storage.get();
    document.documentElement.classList.remove('theme-ui-' + stored);
    document.body.classList.remove('theme-ui-' + stored);

    if (stored && stored !== mode) {
      setMode(stored);
    }
  }, []);
  React__default.useEffect(function () {
    if (mode && theme.useLocalStorage !== false) {
      storage.set(mode);
    }
  }, [mode]);

  return [mode, setMode];
};

var applyColorMode = function applyColorMode(theme, mode) {
  if (!mode) return theme;
  var modes = get$2(theme, 'colors.modes', {});
  return merge$1.all({}, theme, {
    colors: get$2(modes, mode, {})
  });
};

var BodyStyles = function BodyStyles(_ref) {
  var theme = _ref.theme;
  return jsx$1(Global, {
    styles: function styles() {
      return createColorStyles(theme);
    }
  });
};

var ColorModeProvider = function ColorModeProvider(_ref2) {
  var children = _ref2.children;
  var outer = useThemeUI();

  var _useColorModeState = useColorModeState(outer.theme),
      colorMode = _useColorModeState[0],
      setColorMode = _useColorModeState[1];

  var theme = applyColorMode(outer.theme || {}, colorMode);

  var emotionTheme = _extends$5({}, theme);

  if (theme.useCustomProperties !== false) {
    emotionTheme.colors = toCustomProperties(emotionTheme.colors, 'colors');
  }

  var context = _extends$5({}, outer, {
    theme: theme,
    colorMode: colorMode,
    setColorMode: setColorMode
  });

  return jsx$1(ThemeContext.Provider, {
    value: emotionTheme
  }, jsx$1(Context.Provider, {
    value: context
  }, jsx$1(BodyStyles, {
    key: 'color-mode',
    theme: theme
  }), children));
};

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var isBrowser$1 = "object" !== 'undefined';

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}

var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
      current = current.next;
    } while (current !== undefined);
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;

var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {

      styles += strings[i];
    }
  }


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};

var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var createStyled = function createStyled(tag, options) {

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = withEmotionCache(function (props, cache, ref) {
      var finalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = useContext(ThemeContext);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      insertStyles(cache, serialized, typeof finalTag === 'string');
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      var ele = /*#__PURE__*/createElement(finalTag, newProps);
      return ele;
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, _extends$4({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

var tags$1 = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
var newStyled = createStyled.bind();
tags$1.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$4(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var isFunction$2 = function isFunction(obj) {
  return typeof obj === 'function';
};

var MDXContext = /*#__PURE__*/React__default.createContext({});

var useMDXComponents = function useMDXComponents(components) {
  var contextComponents = React__default.useContext(MDXContext);
  var allComponents = contextComponents;

  if (components) {
    allComponents = isFunction$2(components) ? components(contextComponents) : _objectSpread2(_objectSpread2({}, contextComponents), components);
  }

  return allComponents;
};

var MDXProvider$1 = function MDXProvider(props) {
  var allComponents = useMDXComponents(props.components);
  return /*#__PURE__*/React__default.createElement(MDXContext.Provider, {
    value: allComponents
  }, props.children);
};
var DEFAULTS = {
  inlineCode: 'code',
  wrapper: function wrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {}, children);
  }
};
var MDXCreateElement = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var propComponents = props.components,
      mdxType = props.mdxType,
      originalType = props.originalType,
      parentName = props.parentName,
      etc = _objectWithoutProperties(props, ["components", "mdxType", "originalType", "parentName"]);

  var components = useMDXComponents(propComponents);
  var type = mdxType;
  var Component = components["".concat(parentName, ".").concat(type)] || components[type] || DEFAULTS[type] || originalType;

  if (propComponents) {
    return /*#__PURE__*/React__default.createElement(Component, _objectSpread2(_objectSpread2({
      ref: ref
    }, etc), {}, {
      components: propComponents
    }));
  }

  return /*#__PURE__*/React__default.createElement(Component, _objectSpread2({
    ref: ref
  }, etc));
});
MDXCreateElement.displayName = 'MDXCreateElement';

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var tags = ['p', 'b', 'i', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'pre', 'code', 'ol', 'ul', 'li', 'blockquote', 'hr', 'em', 'table', 'tr', 'th', 'td', 'em', 'strong', 'del', // mdx
'inlineCode', 'thematicBreak', // other
'div', // theme-ui
'root'];
var aliases$1 = {
  inlineCode: 'code',
  thematicBreak: 'hr',
  root: 'div'
};

var isAlias = function isAlias(x) {
  return x in aliases$1;
};

var alias = function alias(n) {
  return isAlias(n) ? aliases$1[n] : n;
};

var propOverrides = {
  th: {
    align: 'textAlign'
  },
  td: {
    align: 'textAlign'
  }
};

var themed = function themed(key) {
  return function (_ref) {
    var theme = _ref.theme,
        rest = _objectWithoutPropertiesLoose$3(_ref, ["theme"]);

    var propsStyle = propOverrides[key];
    var extraStyles = propsStyle ? Object.keys(rest).filter(function (prop) {
      return propsStyle[prop] !== undefined;
    }).reduce(function (acc, prop) {
      var _extends2;

      return _extends$3({}, acc, (_extends2 = {}, _extends2[propsStyle[prop]] = rest[prop], _extends2));
    }, {}) : undefined;
    return css$1(_extends$3({}, get$2(theme, "styles." + key), extraStyles))(theme);
  };
};

var Themed = newStyled('div')(themed('div'));
var components = {};
tags.forEach(function (tag) {
  // fixme?
  components[tag] = newStyled(alias(tag))(themed(tag));
  Themed[tag] = components[tag];
});

var createComponents = function createComponents(comps) {
  var next = _extends$3({}, components);

  var componentKeys = Object.keys(comps);
  componentKeys.forEach(function (key) {
    next[key] = newStyled(comps[key])(themed(key));
  });
  return next;
};

var MDXProvider = function MDXProvider(_ref2) {
  var components = _ref2.components,
      children = _ref2.children;
  var outer = useMDXComponents();
  return jsx$1(MDXProvider$1, {
    components: createComponents(_extends$3({}, outer, components)),
    children: children
  });
};

var RootStyles = function RootStyles() {
  return jsx$1(Global, {
    styles: function styles(emotionTheme) {
      var _css;

      var theme = emotionTheme;

      var use = __internalGetUseRootStyles(theme);

      if (use.rootStyles === false || theme.styles && !theme.styles.root) {
        return false;
      }

      var boxSizing = theme.useBorderBox === false ? undefined : 'border-box';
      return css$1((_css = {
        '*': {
          boxSizing: boxSizing
        }
      }, _css[use.scope] = {
        margin: 0,
        variant: 'styles.root'
      }, _css))(theme);
    }
  });
};

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      components = _ref.components,
      children = _ref.children;
  var outer = useThemeUI();

  if (typeof outer.setColorMode === 'function') {
    return jsx$1(ThemeProvider$1, {
      theme: theme
    }, jsx$1(MDXProvider, {
      components: components,
      children: children
    }));
  }

  return jsx$1(ThemeProvider$1, {
    theme: theme
  }, jsx$1(ColorModeProvider, null, jsx$1(RootStyles), jsx$1(MDXProvider, {
    components: components,
    children: children
  })));
};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

var merge = function merge(a, b) {
  var result = objectAssign({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    objectAssign(result, (_assign = {}, _assign[key] = objectAssign(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults$4 = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue$1 = function getValue(n, scale) {
  return get$1(scale, n, n);
};

var get$1 = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get$1(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get$1(props.theme, 'breakpoints', defaults$4.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      objectAssign(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      objectAssign(styles, style);
    } else {
      var _assign2;

      objectAssign(styles, (_assign2 = {}, _assign2[media] = objectAssign({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      objectAssign(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      objectAssign(styles, (_assign3 = {}, _assign3[media] = objectAssign({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue$1 : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = createStyleFunction(conf);
  });
  var parser = createParser(config);
  return parser;
};
var compose = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    objectAssign(config, parser.config);
  });
  var parser = createParser(config);
  return parser;
};

var isNumber$1 = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth = function getWidth(n, scale) {
  return get$1(scale, n, !isNumber$1(n) || n > 1 ? n : n * 100 + '%');
};

var config$7 = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
system(config$7);

var config$6 = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
config$6.bg = config$6.backgroundColor;
system(config$6);

var defaults$3 = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var config$5 = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: defaults$3.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
system(config$5);

var config$4 = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
system(config$4);

var defaults$2 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$3 = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: defaults$2.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
system(config$3);

var config$2 = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  }
};
config$2.borderTopWidth = {
  property: 'borderTopWidth',
  scale: 'borderWidths'
};
config$2.borderTopColor = {
  property: 'borderTopColor',
  scale: 'colors'
};
config$2.borderTopStyle = {
  property: 'borderTopStyle',
  scale: 'borderStyles'
};
config$2.borderTopLeftRadius = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
};
config$2.borderTopRightRadius = {
  property: 'borderTopRightRadius',
  scale: 'radii'
};
config$2.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
};
config$2.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
};
config$2.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
};
config$2.borderBottomLeftRadius = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
};
config$2.borderBottomRightRadius = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
};
config$2.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
};
config$2.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
};
config$2.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
};
config$2.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
};
config$2.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
};
config$2.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
};
system(config$2);

var config$1 = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config$1.bgImage = config$1.backgroundImage;
config$1.bgSize = config$1.backgroundSize;
config$1.bgPosition = config$1.backgroundPosition;
config$1.bgRepeat = config$1.backgroundRepeat;
system(config$1);

var defaults$1 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: defaults$1.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: defaults$1.space
  }
};
system(config);

var defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var isNumber = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getMargin = function getMargin(n, scale) {
  if (!isNumber(n)) {
    return get$1(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get$1(scale, absolute, absolute);

  if (!isNumber(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: defaults.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: defaults.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding = system(configs.padding);
compose(margin, padding);

system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
} // based on https://github.com/developit/dlv


var get = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  outlineColor: 'colors',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return get(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends$2({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = get(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};
var css = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends$2({}, defaultTheme, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(get(theme, val))(theme);
        result = _extends$2({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = get(aliases, key, key);
      var scaleName = get(scales, prop);
      var scale = get(theme, scaleName, get(theme, prop, {}));
      var transform = get(transforms, prop, get);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};

var variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return css(get$1(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return get$1(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = createParser(config);
  return parser;
};
variant({
  key: 'buttons'
});
variant({
  key: 'textStyles',
  prop: 'textStyle'
});
variant({
  key: 'colorStyles',
  prop: 'colors'
});

var jsx = jsx$1;

const CSSReset = () => React.createElement(Global, {
  styles: `
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;      
        -moz-osx-font-smoothing: grayscale; 
        touch-action: manipulation;
      }
      body {
        position: relative;
        min-height: 100%;
        font-feature-settings: 'kern';
      }
      *,
      *::before,
      *::after {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
      }
      main {
        display: block;
      }
      hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }
      pre,
      code,
      kbd,
      samp {
        font-family: SFMono-Regular,  Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }
      a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }
      abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }
      b,
      strong {
        font-weight: bold;
      }
      small {
        font-size: 80%;
      }
      sub,
      sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }
      sub {
        bottom: -0.25em;
      }
      sup {
        top: -0.5em;
      }
      img {
        border-style: none;
      }
      button,
      input,
      optgroup,
      select,
      textarea {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }
      button,
      input {
        overflow: visible;
      }
      button,
      select {
        text-transform: none;
      }
      button::-moz-focus-inner,
      [type="button"]::-moz-focus-inner,
      [type="reset"]::-moz-focus-inner,
      [type="submit"]::-moz-focus-inner {
        border-style: none;
        padding: 0;
      }
      fieldset {
        padding: 0.35em 0.75em 0.625em;
      }
      legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }
      progress {
        vertical-align: baseline;
      }
      textarea {
        overflow: auto;
      }
      [type="checkbox"],
      [type="radio"] {
        box-sizing: border-box;
        padding: 0;
      }
      [type="number"]::-webkit-inner-spin-button,
      [type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }
      input[type="number"] {
        -moz-appearance: textfield;
      }
      [type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }
      [type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }
      ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }
      details {
        display: block;
      }
      summary {
        display: list-item;
      }
      template {
        display: none;
      }
      [hidden] {
        display: none !important;
      }
      body,
      blockquote,
      dl,
      dd,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      hr,
      figure,
      p,
      pre {
        margin: 0;
      }
      button {
        background: transparent;
        padding: 0;
      }
      fieldset {
        margin: 0;
        padding: 0;
      }
      ol,
      ul {
        margin: 0;
        padding: 0;
      }
      textarea {
        resize: vertical;
      }
      button,
      [role="button"] {
        cursor: pointer;
      }
      button::-moz-focus-inner {
        border: 0 !important;
      }
      table {
        border-collapse: collapse;
      }
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-size: inherit;
        font-weight: inherit;
      }
      button,
      input,
      optgroup,
      select,
      textarea {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }
      img,
      video,
      canvas,
      audio,
      iframe,
      embed,
      object {
        display: block;
        vertical-align: middle;
      }
      img,
      video {
        max-width: 100%;
        height: auto;
      }
      svg {
        vertical-align: middle;
        display: inline-block;
      }
      [data-js-focus-visible] :focus:not([data-focus-visible-added]) {
        outline: none;
        box-shadow: none;
      }
      select::-ms-expand {
        display: none;
      }
      :focus {
        outline: none;
      }
    `
});

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

// Any undefined alias key will define the base, non-responsive value.
// sm, md, lg, xl
let breakpoints = ['640px', '768px', '1024px', '1280px']; // export const breakpoints = {
//   sm: '640px',
//   md: '768px',
//   lg: '1024px',
//   xl: '1280px',
// };

const fontSizes = {
  xs: '0.75rem',
  sm: '0.875rem',
  base: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
  '2xl': '1.5rem',
  '3xl': '1.875rem',
  '4xl': '2.25rem',
  '5xl': '3rem',
  '6xl': '3.75rem',
  '7xl': '4.5rem',
  '8xl': '6rem',
  '9xl': '8rem'
};
const baseFontWeights = {
  normal: 400,
  bold: 600
};
const fontWeights = _extends$1({}, baseFontWeights, {
  body: baseFontWeights.normal,
  heading: baseFontWeights.bold
});
const baseFonts = {
  body: "'Benton Sans', 'Helvetica Neue', 'Arial', sans-serif",
  mono: "'Menlo', 'Monaco', 'Consolas', 'Liberation Mono', 'Courier New', 'monospace'"
};
const fonts = _extends$1({}, baseFonts, {
  body: baseFonts.body,
  heading: 'inherit',
  monospace: baseFonts.mono
});
const letterSpacings = {
  tighter: '-0.05em',
  tight: '-0.025em',
  normal: '0',
  wide: '0.025em',
  wider: '0.05em',
  widest: '0.1em'
};
const lineHeights = {
  none: '1',
  shorter: '1.25',
  short: '1.375',
  normal: '1.5',
  base: '1.5',
  tall: '1.625',
  taller: '2',
  body: 'base',
  heading: 'shorter'
};
const text = {
  '4xl': {
    fontSize: ['3xl', '4xl'],
    lineHeight: ['normal', 'short']
  },
  '3xl': {
    fontSize: ['2xl', '3xl'],
    lineHeight: ['normal', 'normal']
  },
  '2xl': {
    fontSize: ['xl', '2xl'],
    lineHeight: ['normal', 'normal']
  },
  'xl': {
    fontSize: ['lg', 'xl'],
    lineHeight: ['normal', 'normal']
  },
  'lg': {
    fontSize: ['lg', 'lg'],
    lineHeight: ['normal', 'normal']
  },
  'base': {
    fontSize: ['base', 'base'],
    lineHeight: ['tall', 'tall']
  },
  'sm': {
    fontSize: ['sm', 'sm'],
    lineHeight: ['tall', 'tall']
  },
  'xs': {
    fontSize: ['xs', 'xs'],
    lineHeight: ['tall', 'tall']
  }
};
const radii = {
  none: '0',
  sm: '0.125rem',
  base: '0.25rem',
  md: '0.375rem',
  lg: '0.5rem',
  xl: '0.75rem',
  '2xl': '1rem',
  '3xl': '1.5rem',
  full: '9999px'
};
const space = {
  px: '1px',
  0: '0',
  0.5: '0.125rem',
  1: '0.25rem',
  1.5: '0.375rem',
  2: '0.5rem',
  2.5: '0.625rem',
  3: '0.75rem',
  3.5: '0.875rem',
  4: '1rem',
  5: '1.25rem',
  6: '1.5rem',
  7: '1.75rem',
  8: '2rem',
  9: '2.25rem',
  10: '2.5rem',
  12: '3rem',
  14: '3.5rem',
  16: '4rem',
  20: '5rem',
  24: '6rem',
  28: '7rem',
  32: '8rem',
  36: '9rem',
  40: '10rem',
  44: '11rem',
  48: '12rem',
  52: '13rem',
  56: '14rem',
  60: '15rem',
  64: '16rem',
  72: '18rem',
  80: '20rem',
  96: '24rem'
};
const fractionalWidths = {
  '1/2': '50%',
  '1/3': '33.333333%',
  '2/3': '66.666667%',
  '1/4': '25%',
  '2/4': '50%',
  '3/4': '75%',
  '1/5': '20%',
  '2/5': '40%',
  '3/5': '60%',
  '4/5': '80%',
  '1/6': '16.666667%',
  '2/6': '33.333333%',
  '3/6': '50%',
  '4/6': '66.666667%',
  '5/6': '83.333333%',
  '1/12': '8.333333%',
  '2/12': '16.666667%',
  '3/12': '25%',
  '4/12': '33.333333%',
  '5/12': '41.666667%',
  '6/12': '50%',
  '7/12': '58.333333%',
  '8/12': '66.666667%',
  '9/12': '75%',
  '10/12': '83.333333%',
  '11/12': '91.666667%'
};
const sizes = _extends$1({}, space, {
  full: '100%',
  screenHeight: '100vh',
  screenWidth: '100vw',
  '3xs': '14rem',
  '2xs': '16rem',
  xs: '20rem',
  sm: '24rem',
  md: '28rem',
  lg: '32rem',
  xl: '36rem',
  '2xl': '42rem',
  '3xl': '48rem',
  '4xl': '56rem',
  '5xl': '64rem',
  '6xl': '72rem',
  '7xl': '80rem'
}, fractionalWidths); // const container = {
//   sm: "640px",
//   md: "768px",
//   lg: "1024px",
//   xl: "1280px",
// }

const shadows = {
  xs: '0 0 0 1px rgba(0, 0, 0, 0.05)',
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  default: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.15), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
  outline: '0 0 0 3px rgba(66, 153, 225, 0.5)',
  none: 'none'
};
const zIndices = {
  hide: -1,
  auto: 'auto',
  base: 0,
  docked: 10,
  dropdown: 1000,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
};
const heading = {
  fontFamily: 'heading',
  fontWeight: 'heading',
  lineHeight: 'heading',
  m: 0,
  mb: 1
};
const styles = {
  root: {
    fontFamily: 'body',
    lineHeight: 'body',
    fontWeight: 'body',
    backgroundColor: 'background',
    color: 'gray.700'
  },
  a: {
    textDecoration: 'underline',
    fontWeight: 'bold',
    cursor: 'pointer',
    color: 'gray.900'
  },
  h1: _extends$1({}, heading, {
    variant: 'text.4xl',
    mt: 2
  }),
  h2: _extends$1({}, heading, {
    variant: 'text.3xl',
    mt: 2
  }),
  h3: _extends$1({}, heading, {
    variant: 'text.2xl',
    mt: 3
  }),
  h4: _extends$1({}, heading, {
    variant: 'text.xl'
  }),
  h5: _extends$1({}, heading, {
    variant: 'text.lg'
  }),
  h6: _extends$1({}, heading, {
    variant: 'text.sm',
    mb: 2
  }),
  code: {},
  pre: {},
  hr: {
    backgroundColor: 'gray.300',
    border: 0,
    height: '1px',
    mt: 3,
    mb: 3
  }
};
const transitions = {
  property: {
    none: 'none',
    all: 'all',
    default: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
    colors: 'background-color, border-color, color, fill, stroke',
    opacity: 'opacity',
    shadow: 'box-shadow',
    transform: 'transform'
  },
  timingFunction: {
    linear: 'linear',
    in: 'cubic-bezier(0.4, 0, 1, 1)',
    out: 'cubic-bezier(0, 0, 0.2, 1)',
    'in-out': 'cubic-bezier(0.4, 0, 0.2, 1)'
  },
  duration: {
    '75': '75ms',
    '100': '100ms',
    '150': '150ms',
    '200': '200ms',
    '300': '300ms',
    '500': '500ms',
    '700': '700ms',
    '1000': '1000ms'
  }
};
const borderWidths = {
  px: '1px',
  '0': '0',
  '1': '1px',
  '2': '2px',
  '4': '4px',
  '8': '8px'
};
const baseColors = {
  transparent: 'transparent',
  black: '#000',
  white: '#fff',
  gray: {
    50: '#FAFAFB',
    100: '#FAFAFB',
    200: '#ECEDEE',
    300: '#D8D9DB',
    400: '#7D8088',
    500: '#6A6D77',
    600: '#373A44',
    700: '#292C33',
    800: '#1C1D22',
    900: '#0E0F11'
  },
  red: {
    100: '#FAEAEB',
    200: '#F5D4D7',
    300: '#EBA9AF',
    400: '#E07F86',
    500: '#D6545E',
    600: '#CC2936',
    700: '#A3212B',
    800: '#7A1920',
    900: '#521016'
  },
  orange: {
    100: '#FFF3E7',
    200: '#FFE7CF',
    300: '#FFCFA0',
    400: '#FFB870',
    500: '#FFA041',
    600: '#FF8811',
    700: '#CC6D0E',
    800: '#99520A',
    900: '#663607'
  },
  yellow: {
    100: '#FFFAED',
    200: '#FFF6DA',
    300: '#FFECB5',
    400: '#FFE390',
    500: '#FFD96B',
    600: '#FFD046',
    700: '#CCA638',
    800: '#997D2A',
    900: '#66531C'
  },
  green: {
    100: '#EAF8EF',
    200: '#D4F1E0',
    300: '#A9E3C0',
    400: '#7ED6A1',
    500: '#53C881',
    600: '#19C535',
    700: '#20954E',
    800: '#18703B',
    900: '#104A27'
  },
  teal: {
    100: '#E6F8F9',
    200: '#CDF2F3',
    300: '#9BE4E6',
    400: '#6AD7DA',
    500: '#38C9CD',
    600: '#06BCC1',
    700: '#048487',
    800: '#035E61',
    900: '#02383A'
  },
  blue: {
    100: '#E6F2FF',
    200: '#CCE5FF',
    300: '#99CCFF',
    400: '#66B2FF',
    500: '#3399FF',
    600: '#007FFF',
    700: '#0066CC',
    800: '#004C99',
    900: '#003366'
  },
  indigo: {
    100: '#ebf4ff',
    200: '#c3dafe',
    300: '#a3bffa',
    400: '#7f9cf5',
    500: '#667eea',
    600: '#5a67d8',
    700: '#4c51bf',
    800: '#434190',
    900: '#3c366b'
  },
  purple: {
    100: '#EDEBF5',
    200: '#DCD7EB',
    300: '#B9AED7',
    400: '#9586C3',
    500: '#725DAF',
    600: '#4F359B',
    700: '#3F2A7C',
    800: '#2F205D',
    900: '#20153E'
  },
  pink: {
    100: '#FAEBF9',
    200: '#F6D7F2',
    300: '#EDAFE5',
    400: '#E388D9',
    500: '#DA60CC',
    600: '#D138BF',
    700: '#A72D99',
    800: '#7D2273',
    900: '#54164C'
  }
};
const colors = _extends$1({}, baseColors, {
  background: baseColors.white,
  current: 'currentColor',
  text: 'gray.700',
  awning: {
    primary: baseColors.green['600'],
    success: baseColors.green['700'],
    baseText: baseColors.gray['700'],
    critical: baseColors.red['600'],
    warning: baseColors.orange['600']
  }
});
const theme = {
  colors,
  borderWidths,
  breakpoints,
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
  sizes,
  shadows,
  space,
  radii,
  zIndices,
  styles,
  transitions,
  text
};

const BaseStyles = ({
  children
}) => {
  const _base = css$1(theme.styles)(theme);

  return React.createElement(React.Fragment, null, React.createElement(CSSReset, null), React.createElement(FontAndStuff, null), React.createElement(Global, {
    styles: _base
  }), children);
};

const FontAndStuff = () => {
  return React.createElement(Global, {
    styles: `
              @font-face {
                /* Medium */
                font-family: 'Benton Sans';
                font-display: swap;
                font-weight: 700;
                font-style: normal;
              
                src: url("//cloud.typenetwork.com/projectLicenseWeb/18616/fontfile/eot/?c796544939a67974ecc99fa2e82af00fe5827c2d");
                src: url("//cloud.typenetwork.com/projectLicenseWeb/18616/fontfile/eot/?c796544939a67974ecc99fa2e82af00fe5827c2d#iefix") format("embedded-opentype"),
                     url("//cloud.typenetwork.com/projectLicenseWeb/18616/fontfile/woff2/?c796544939a67974ecc99fa2e82af00fe5827c2d") format("woff2"),
                     url("//cloud.typenetwork.com/projectLicenseWeb/18616/fontfile/woff/?c796544939a67974ecc99fa2e82af00fe5827c2d") format("woff");
              }
              
              @font-face {
                font-family: 'Benton Sans';
                font-display: swap;
                font-weight: normal;
                font-style: normal;
              
                src: url("//cloud.typenetwork.com/projectLicenseWeb/18615/fontfile/eot/?c796544939a67974ecc99fa2e82af00fe5827c2d");
                src: url("//cloud.typenetwork.com/projectLicenseWeb/18615/fontfile/eot/?c796544939a67974ecc99fa2e82af00fe5827c2d#iefix") format("embedded-opentype"),
                     url("//cloud.typenetwork.com/projectLicenseWeb/18615/fontfile/woff2/?c796544939a67974ecc99fa2e82af00fe5827c2d") format("woff2"),
                     url("//cloud.typenetwork.com/projectLicenseWeb/18615/fontfile/woff/?c796544939a67974ecc99fa2e82af00fe5827c2d") format("woff");        
              }
              
              html {
                font-size: 16px;
                scroll-behavior: smooth;
              }
              
              html,
              body {
                height: 100%;
                width: 100%;
              }
              
              *,
              *:after,
              *:before {
                box-sizing: border-box;
              }
              
              body {
                margin: 0;
              }
              
        `
  });
};

function forwardRef(comp) {
  return React.forwardRef(comp);
} // import { ComponentProps, JSXElementConstructor } from 'react';
// // goes one step further and resolves with propTypes and defaultProps properties
// type ApparentComponentProps<
//   C extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>
// > = C extends JSXElementConstructor<infer P>
//   ? JSX.LibraryManagedAttributes<C, P>
//   : ComponentProps<C>;

const useVariant = (key, variant) => {
  const theme = React.useContext(ThemeContext);

  if (variant) {
    const variantStyle = get$2(theme, key + '.' + variant);

    if (variantStyle) {
      return variantStyle;
    }
  }

  return {};
};

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    } // Add event listener


    window.addEventListener('resize', handleResize); // Call handler right away so state gets updated with initial window size

    handleResize(); // Remove event listener on cleanup

    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}

const useCollapse = (collapsed = true, {
  duration: _duration = 1000,
  initialHeight: _initialHeight = 0
} = {}) => {
  const [_collapsed, setCollapsed] = React.useState(collapsed);
  const toggle = React.useCallback(event => {
    event.stopPropagation();
    setCollapsed(!_collapsed);
  }, [_collapsed]);
  React.useEffect(() => {
    setCollapsed(prev => prev && collapsed); // only change if it was previously closed
  }, [collapsed]);
  const Collapse = React.useCallback(({
    collapsed,
    children
  }) => React.createElement(AnimateHeight, {
    duration: _duration,
    easing: 'ease-in-out',
    height: collapsed ? _initialHeight : 'auto',
    style: {
      flexShrink: 0,
      position: 'relative',
      overflow: 'hidden'
    }
  }, children), []);
  return {
    collapsed: _collapsed,
    Collapse,
    toggle
  };
};

const _excluded$p = ["as", "text", "sx"];
const customProps = ['text', 'variant'];

const getProps = test => props => {
  const next = {};

  for (const key in props) {
    if (test(key || '')) next[key] = props[key];
  }

  return next;
};

const PRE = new RegExp(`^(${customProps.join('|')})$`);
const getSystemProps = getProps(k => PRE.test(k));
const getNonSystemProps = getProps(k => !PRE.test(k)); // for now
// https://github.com/system-ui/theme-ui/issues/333
// look into the actual code for this - it only handle the array case but seems easy enough to add support for object

const parseResponsiveObjects = obj => {
  if (obj === null || obj === undefined) return obj;
  const breakpointKeys = ['base', // ...Object.keys(theme.breakpoints).filter(key => isNaN(parseInt(key))),
  'sm', 'md', 'lg', 'xl']; // Found object that needs updated

  if (Object.keys(obj).filter(x => breakpointKeys.includes(x)).length > 0) {
    return breakpointKeys.map(bp => {
      var _obj$bp;

      return (_obj$bp = obj[bp]) != null ? _obj$bp : null;
    });
  } else {
    // Iterate over the properties
    for (var propertyName in obj) {
      // Any object that is not a simple value
      if (obj[propertyName] !== null && typeof obj[propertyName] === 'object') {
        // Recurse into the object and write back the result to the object
        obj[propertyName] = parseResponsiveObjects(obj[propertyName]);
      }
    }
  }

  return obj;
};
const textVariantStyles = variant({
  variants: theme.text
});
const Box = forwardRef((props, ref) => {
  const {
    as = 'div',
    text,
    sx = {}
  } = props,
        rest = _objectWithoutPropertiesLoose$2(props, _excluded$p);

  const themeProps = getSystemProps(rest);
  const textVariant = textVariantStyles({
    variant: text || sx.text || ''
  });
  return jsx(as, _extends$1({
    sx: parseResponsiveObjects(_extends$1({
      boxSizing: 'border-box',
      margin: 0
    }, themeProps, textVariant, sx))
  }, rest, {
    ref
  }));
});

const Text = forwardRef$1((props, ref) => {
  return React__default.createElement(Box, _extends$1({
    ref: ref,
    as: "span"
  }, props));
});

function toVal(mix) {
  var k,
      y,
      str = '';

  if (typeof mix === 'string' || typeof mix === 'number') {
    str += mix;
  } else if (typeof mix === 'object') {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if (y = toVal(mix[k])) {
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (mix[k]) {
          str && (str += ' ');
          str += k;
        }
      }
    }
  }

  return str;
}

function _clsx () {
  var i = 0,
      tmp,
      x,
      str = '';

  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += ' ');
        str += x;
      }
    }
  }

  return str;
}

// Since neither useLayoutEffect nor useEffect run on the server,
// we can suppress this by replace it with a noop on the server.

const useLayoutEffect = typeof window !== 'undefined' ? React__default.useLayoutEffect : () => {};
let $f8b5fdd96fb429d7102983f777c41307$var$idsUpdaterMap = new Map();
/**
 * Merges two ids.
 * Different ids will trigger a side-effect and re-render components hooked up with `useId`.
 */

function mergeIds(idA, idB) {
  if (idA === idB) {
    return idA;
  }

  let setIdA = $f8b5fdd96fb429d7102983f777c41307$var$idsUpdaterMap.get(idA);

  if (setIdA) {
    setIdA(idB);
    return idB;
  }

  let setIdB = $f8b5fdd96fb429d7102983f777c41307$var$idsUpdaterMap.get(idB);

  if (setIdB) {
    setIdB(idA);
    return idA;
  }

  return idB;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/**
 * Calls all functions in the order they were chained with the same arguments.
 */

function chain() {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }

  return function () {
    for (let callback of callbacks) {
      if (typeof callback === 'function') {
        callback(...arguments);
      }
    }
  };
}
/**
 * Merges multiple props objects together. Event handlers are chained,
 * classNames are combined, and ids are deduplicated - different ids
 * will trigger a side-effect and re-render components hooked up with `useId`.
 * For all other props, the last prop object overrides all previous ones.
 * @param args - Multiple sets of props to merge together.
 */

function mergeProps() {
  let result = {};

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  for (let props of args) {
    for (let key in result) {
      // Chain events
      if (/^on[A-Z]/.test(key) && typeof result[key] === 'function' && typeof props[key] === 'function') {
        result[key] = chain(result[key], props[key]); // Merge classnames, sometimes classNames are empty string which eval to false, so we just need to do a type check
      } else if (key === 'className' && typeof result.className === 'string' && typeof props.className === 'string') {
        result[key] = _clsx(result.className, props.className);
      } else if (key === 'UNSAFE_className' && typeof result.UNSAFE_className === 'string' && typeof props.UNSAFE_className === 'string') {
        result[key] = _clsx(result.UNSAFE_className, props.UNSAFE_className);
      } else if (key === 'id' && result.id && props.id) {
        result.id = mergeIds(result.id, props.id); // Override others
      } else {
        result[key] = props[key] !== undefined ? props[key] : result[key];
      }
    } // Add props from b that are not in a


    for (let key in props) {
      if (result[key] === undefined) {
        result[key] = props[key];
      }
    }
  }

  return result;
}
const $f6a965352cabf1a7c37e8c1337e5eab$var$DOMPropNames = new Set(['id']);
const $f6a965352cabf1a7c37e8c1337e5eab$var$labelablePropNames = new Set(['aria-label', 'aria-labelledby', 'aria-describedby', 'aria-details']);
const $f6a965352cabf1a7c37e8c1337e5eab$var$propRe = /^(data-.*)$/;
/**
 * Filters out all props that aren't valid DOM props or defined via override prop obj.
 * @param props - The component props to be filtered.
 * @param opts - Props to override.
 */

function filterDOMProps(props, opts) {
  if (opts === void 0) {
    opts = {};
  }

  let {
    labelable,
    propNames
  } = opts;
  let filteredProps = {};

  for (const prop in props) {
    if (Object.prototype.hasOwnProperty.call(props, prop) && ($f6a965352cabf1a7c37e8c1337e5eab$var$DOMPropNames.has(prop) || labelable && $f6a965352cabf1a7c37e8c1337e5eab$var$labelablePropNames.has(prop) || (propNames == null ? void 0 : propNames.has(prop)) || $f6a965352cabf1a7c37e8c1337e5eab$var$propRe.test(prop))) {
      filteredProps[prop] = props[prop];
    }
  }

  return filteredProps;
} // Currently necessary for Safari and old Edge:
// https://caniuse.com/#feat=mdn-api_htmlelement_focus_preventscroll_option
// See https://bugs.webkit.org/show_bug.cgi?id=178583
//
// Original licensing for the following methods can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/calvellido/focus-options-polyfill

function focusWithoutScrolling(element) {
  if ($bc7c9c3af78f5218ff72cecce15730$var$supportsPreventScroll()) {
    element.focus({
      preventScroll: true
    });
  } else {
    let scrollableElements = $bc7c9c3af78f5218ff72cecce15730$var$getScrollableElements(element);
    element.focus();
    $bc7c9c3af78f5218ff72cecce15730$var$restoreScrollPosition(scrollableElements);
  }
}
let $bc7c9c3af78f5218ff72cecce15730$var$supportsPreventScrollCached = null;

function $bc7c9c3af78f5218ff72cecce15730$var$supportsPreventScroll() {
  if ($bc7c9c3af78f5218ff72cecce15730$var$supportsPreventScrollCached == null) {
    $bc7c9c3af78f5218ff72cecce15730$var$supportsPreventScrollCached = false;

    try {
      var focusElem = document.createElement('div');
      focusElem.focus({
        get preventScroll() {
          $bc7c9c3af78f5218ff72cecce15730$var$supportsPreventScrollCached = true;
          return true;
        }

      });
    } catch (e) {// Ignore
    }
  }

  return $bc7c9c3af78f5218ff72cecce15730$var$supportsPreventScrollCached;
}

function $bc7c9c3af78f5218ff72cecce15730$var$getScrollableElements(element) {
  var parent = element.parentNode;
  var scrollableElements = [];
  var rootScrollingElement = document.scrollingElement || document.documentElement;

  while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) {
      scrollableElements.push({
        element: parent,
        scrollTop: parent.scrollTop,
        scrollLeft: parent.scrollLeft
      });
    }

    parent = parent.parentNode;
  }

  if (rootScrollingElement instanceof HTMLElement) {
    scrollableElements.push({
      element: rootScrollingElement,
      scrollTop: rootScrollingElement.scrollTop,
      scrollLeft: rootScrollingElement.scrollLeft
    });
  }

  return scrollableElements;
}

function $bc7c9c3af78f5218ff72cecce15730$var$restoreScrollPosition(scrollableElements) {
  for (let {
    element,
    scrollTop,
    scrollLeft
  } of scrollableElements) {
    element.scrollTop = scrollTop;
    element.scrollLeft = scrollLeft;
  }
}
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.

let $b3e8d5c5f32fa26afa6df1b81f09b6b8$var$transitionsByElement = new Map(); // A list of callbacks to call once there are no transitioning elements.

let $b3e8d5c5f32fa26afa6df1b81f09b6b8$var$transitionCallbacks = new Set();

function $b3e8d5c5f32fa26afa6df1b81f09b6b8$var$setupGlobalEvents() {
  if (typeof window === 'undefined') {
    return;
  }

  let onTransitionStart = e => {
    // Add the transitioning property to the list for this element.
    let transitions = $b3e8d5c5f32fa26afa6df1b81f09b6b8$var$transitionsByElement.get(e.target);

    if (!transitions) {
      transitions = new Set();
      $b3e8d5c5f32fa26afa6df1b81f09b6b8$var$transitionsByElement.set(e.target, transitions); // The transitioncancel event must be registered on the element itself, rather than as a global
      // event. This enables us to handle when the node is deleted from the document while it is transitioning.
      // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.

      e.target.addEventListener('transitioncancel', onTransitionEnd);
    }

    transitions.add(e.propertyName);
  };

  let onTransitionEnd = e => {
    // Remove property from list of transitioning properties.
    let properties = $b3e8d5c5f32fa26afa6df1b81f09b6b8$var$transitionsByElement.get(e.target);

    if (!properties) {
      return;
    }

    properties.delete(e.propertyName); // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.

    if (properties.size === 0) {
      e.target.removeEventListener('transitioncancel', onTransitionEnd);
      $b3e8d5c5f32fa26afa6df1b81f09b6b8$var$transitionsByElement.delete(e.target);
    } // If no transitioning elements, call all of the queued callbacks.


    if ($b3e8d5c5f32fa26afa6df1b81f09b6b8$var$transitionsByElement.size === 0) {
      for (let cb of $b3e8d5c5f32fa26afa6df1b81f09b6b8$var$transitionCallbacks) {
        cb();
      }

      $b3e8d5c5f32fa26afa6df1b81f09b6b8$var$transitionCallbacks.clear();
    }
  };

  document.body.addEventListener('transitionrun', onTransitionStart);
  document.body.addEventListener('transitionend', onTransitionEnd);
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') {
    $b3e8d5c5f32fa26afa6df1b81f09b6b8$var$setupGlobalEvents();
  } else {
    document.addEventListener('DOMContentLoaded', $b3e8d5c5f32fa26afa6df1b81f09b6b8$var$setupGlobalEvents);
  }
}

function runAfterTransition(fn) {
  // Wait one frame to see if an animation starts, e.g. a transition on mount.
  requestAnimationFrame(() => {
    // If no transitions are running, call the function immediately.
    // Otherwise, add it to a list of callbacks to run at the end of the animation.
    if ($b3e8d5c5f32fa26afa6df1b81f09b6b8$var$transitionsByElement.size === 0) {
      fn();
    } else {
      $b3e8d5c5f32fa26afa6df1b81f09b6b8$var$transitionCallbacks.add(fn);
    }
  });
} // Keep track of elements that we are currently handling dragging for via useDrag1D.
function useGlobalListeners() {
  let globalListeners = useRef(new Map());
  let addGlobalListener = useCallback((eventTarget, type, listener, options) => {
    globalListeners.current.set(listener, {
      type,
      eventTarget,
      options
    });
    eventTarget.addEventListener(type, listener, options);
  }, []);
  let removeGlobalListener = useCallback((eventTarget, type, listener, options) => {
    eventTarget.removeEventListener(type, listener, options);
    globalListeners.current.delete(listener);
  }, []);
  let removeAllGlobalListeners = useCallback(() => {
    globalListeners.current.forEach((value, key) => {
      removeGlobalListener(value.eventTarget, value.type, key, value.options);
    });
  }, [removeGlobalListener]); // eslint-disable-next-line arrow-body-style

  useEffect(() => {
    return removeAllGlobalListeners;
  }, [removeAllGlobalListeners]);
  return {
    addGlobalListener,
    removeGlobalListener,
    removeAllGlobalListeners
  };
}

function useSyncRef(context, ref) {
  useLayoutEffect(() => {
    if (context && context.ref) {
      context.ref.current = ref.current;
      return () => {
        context.ref.current = null;
      };
    }
  }, [context, ref]);
}

function $b0986c1243f71db8e992f67117a1ed9$var$testPlatform(re) {
  return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator.platform) : false;
}

function isMac() {
  return $b0986c1243f71db8e992f67117a1ed9$var$testPlatform(/^Mac/);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

let $e17c9db826984f8ab8e5d837bf0b8$var$state = 'default';
let $e17c9db826984f8ab8e5d837bf0b8$var$savedUserSelect = '';

function $e17c9db826984f8ab8e5d837bf0b8$export$disableTextSelection() {
  if ($e17c9db826984f8ab8e5d837bf0b8$var$state === 'default') {
    $e17c9db826984f8ab8e5d837bf0b8$var$savedUserSelect = document.documentElement.style.webkitUserSelect;
    document.documentElement.style.webkitUserSelect = 'none';
  }

  $e17c9db826984f8ab8e5d837bf0b8$var$state = 'disabled';
}

function $e17c9db826984f8ab8e5d837bf0b8$export$restoreTextSelection() {
  // If the state is already default, there's nothing to do.
  // If it is restoring, then there's no need to queue a second restore.
  if ($e17c9db826984f8ab8e5d837bf0b8$var$state !== 'disabled') {
    return;
  }

  $e17c9db826984f8ab8e5d837bf0b8$var$state = 'restoring'; // There appears to be a delay on iOS where selection still might occur
  // after pointer up, so wait a bit before removing user-select.

  setTimeout(() => {
    // Wait for any CSS transitions to complete so we don't recompute style
    // for the whole page in the middle of the animation and cause jank.
    runAfterTransition(() => {
      // Avoid race conditions
      if ($e17c9db826984f8ab8e5d837bf0b8$var$state === 'restoring') {
        if (document.documentElement.style.webkitUserSelect === 'none') {
          document.documentElement.style.webkitUserSelect = $e17c9db826984f8ab8e5d837bf0b8$var$savedUserSelect || '';
        }

        $e17c9db826984f8ab8e5d837bf0b8$var$savedUserSelect = '';
        $e17c9db826984f8ab8e5d837bf0b8$var$state = 'default';
      }
    });
  }, 300);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// Original licensing for the following method can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/blob/3c713d513195a53788b3f8bb4b70279d68b15bcc/packages/react-interactions/events/src/dom/shared/index.js#L74-L87
// Keyboards, Assistive Technologies, and element.click() all produce a "virtual"
// click event. This is a method of inferring such clicks. Every browser except
// IE 11 only sets a zero value of "detail" for click events that are "virtual".
// However, IE 11 uses a zero value for all click events. For IE 11 we rely on
// the quirk that it produces click events that are of type PointerEvent, and
// where only the "virtual" click lacks a pointerType field.


function $f67ef9f1b8ed09b4b00fd0840cd8b94b$export$isVirtualClick(event) {
  // JAWS/NVDA with Firefox.
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }

  return event.detail === 0 && !event.pointerType;
}

const $a3ff51240de6f955c79cf17a88e349$export$PressResponderContext = /*#__PURE__*/React__default.createContext(null);

$a3ff51240de6f955c79cf17a88e349$export$PressResponderContext.displayName = 'PressResponderContext';

function $ffc54430b1dbeee65879852feaaff07d$var$usePressResponderContext(props) {
  // Consume context from <PressResponder> and merge with props.
  let context = useContext($a3ff51240de6f955c79cf17a88e349$export$PressResponderContext);

  if (context) {
    let {
      register
    } = context,
        contextProps = _objectWithoutPropertiesLoose$1(context, ["register"]);

    props = mergeProps(contextProps, props);
    register();
  }

  useSyncRef(context, props.ref);
  return props;
}
/**
 * Handles press interactions across mouse, touch, keyboard, and screen readers.
 * It normalizes behavior across browsers and platforms, and handles many nuances
 * of dealing with pointer and keyboard events.
 */


function usePress(props) {
  let _usePressResponderCon = $ffc54430b1dbeee65879852feaaff07d$var$usePressResponderContext(props),
      {
    onPress,
    onPressChange,
    onPressStart,
    onPressEnd,
    onPressUp,
    isDisabled,
    isPressed: isPressedProp,
    preventFocusOnPress
  } = _usePressResponderCon,
      domProps = _objectWithoutPropertiesLoose$1(_usePressResponderCon, ["onPress", "onPressChange", "onPressStart", "onPressEnd", "onPressUp", "isDisabled", "isPressed", "preventFocusOnPress", "ref"]);

  let propsRef = useRef(null);
  propsRef.current = {
    onPress,
    onPressChange,
    onPressStart,
    onPressEnd,
    onPressUp,
    isDisabled
  };
  let [isPressed, setPressed] = useState(false);
  let ref = useRef({
    isPressed: false,
    ignoreEmulatedMouseEvents: false,
    ignoreClickAfterPress: false,
    didFirePressStart: false,
    activePointerId: null,
    target: null,
    isOverTarget: false,
    pointerType: null
  });
  let {
    addGlobalListener,
    removeAllGlobalListeners
  } = useGlobalListeners();
  let pressProps = useMemo(() => {
    let state = ref.current;

    let triggerPressStart = (originalEvent, pointerType) => {
      let {
        onPressStart,
        onPressChange,
        isDisabled
      } = propsRef.current;

      if (isDisabled || state.didFirePressStart) {
        return;
      }

      if (onPressStart) {
        onPressStart({
          type: 'pressstart',
          pointerType,
          target: originalEvent.currentTarget,
          shiftKey: originalEvent.shiftKey,
          metaKey: originalEvent.metaKey,
          ctrlKey: originalEvent.ctrlKey
        });
      }

      if (onPressChange) {
        onPressChange(true);
      }

      state.didFirePressStart = true;
      setPressed(true);
    };

    let triggerPressEnd = function triggerPressEnd(originalEvent, pointerType, wasPressed) {
      if (wasPressed === void 0) {
        wasPressed = true;
      }

      let {
        onPressEnd,
        onPressChange,
        onPress,
        isDisabled
      } = propsRef.current;

      if (!state.didFirePressStart) {
        return;
      }

      state.ignoreClickAfterPress = true;
      state.didFirePressStart = false;

      if (onPressEnd) {
        onPressEnd({
          type: 'pressend',
          pointerType,
          target: originalEvent.currentTarget,
          shiftKey: originalEvent.shiftKey,
          metaKey: originalEvent.metaKey,
          ctrlKey: originalEvent.ctrlKey
        });
      }

      if (onPressChange) {
        onPressChange(false);
      }

      setPressed(false);

      if (onPress && wasPressed && !isDisabled) {
        onPress({
          type: 'press',
          pointerType,
          target: originalEvent.currentTarget,
          shiftKey: originalEvent.shiftKey,
          metaKey: originalEvent.metaKey,
          ctrlKey: originalEvent.ctrlKey
        });
      }
    };

    let triggerPressUp = (originalEvent, pointerType) => {
      let {
        onPressUp,
        isDisabled
      } = propsRef.current;

      if (isDisabled) {
        return;
      }

      if (onPressUp) {
        onPressUp({
          type: 'pressup',
          pointerType,
          target: originalEvent.currentTarget,
          shiftKey: originalEvent.shiftKey,
          metaKey: originalEvent.metaKey,
          ctrlKey: originalEvent.ctrlKey
        });
      }
    };

    let cancel = e => {
      if (state.isPressed) {
        if (state.isOverTarget) {
          triggerPressEnd($ffc54430b1dbeee65879852feaaff07d$var$createEvent(state.target, e), state.pointerType, false);
        }

        state.isPressed = false;
        state.isOverTarget = false;
        state.activePointerId = null;
        state.pointerType = null;
        removeAllGlobalListeners();
        $e17c9db826984f8ab8e5d837bf0b8$export$restoreTextSelection();
      }
    };

    let pressProps = {
      onKeyDown(e) {
        if ($ffc54430b1dbeee65879852feaaff07d$var$isValidKeyboardEvent(e.nativeEvent)) {
          e.preventDefault();
          e.stopPropagation(); // If the event is repeating, it may have started on a different element
          // after which focus moved to the current element. Ignore these events and
          // only handle the first key down event.

          if (!state.isPressed && !e.repeat) {
            state.target = e.currentTarget;
            state.isPressed = true;
            triggerPressStart(e, 'keyboard'); // Focus may move before the key up event, so register the event on the document
            // instead of the same element where the key down event occurred.

            addGlobalListener(document, 'keyup', onKeyUp, false);
          }
        }
      },

      onKeyUp(e) {
        if ($ffc54430b1dbeee65879852feaaff07d$var$isValidKeyboardEvent(e.nativeEvent) && !e.repeat) {
          triggerPressUp($ffc54430b1dbeee65879852feaaff07d$var$createEvent(state.target, e), 'keyboard');
        }
      },

      onClick(e) {
        if (e && e.button === 0) {
          e.stopPropagation();

          if (isDisabled) {
            e.preventDefault();
          } // If triggered from a screen reader or by using element.click(),
          // trigger as if it were a keyboard click.


          if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && $f67ef9f1b8ed09b4b00fd0840cd8b94b$export$isVirtualClick(e.nativeEvent)) {
            // Ensure the element receives focus (VoiceOver on iOS does not do this)
            if (!isDisabled && !preventFocusOnPress) {
              focusWithoutScrolling(e.currentTarget);
            }

            triggerPressStart(e, 'virtual');
            triggerPressUp(e, 'virtual');
            triggerPressEnd(e, 'virtual');
          }

          state.ignoreEmulatedMouseEvents = false;
          state.ignoreClickAfterPress = false;
        }
      }

    };

    let onKeyUp = e => {
      if (state.isPressed && $ffc54430b1dbeee65879852feaaff07d$var$isValidKeyboardEvent(e)) {
        e.preventDefault();
        e.stopPropagation();
        state.isPressed = false;
        triggerPressEnd($ffc54430b1dbeee65879852feaaff07d$var$createEvent(state.target, e), 'keyboard', e.target === state.target);
        removeAllGlobalListeners(); // If the target is a link, trigger the click method to open the URL,
        // but defer triggering pressEnd until onClick event handler.

        if (e.target === state.target && $ffc54430b1dbeee65879852feaaff07d$var$isHTMLAnchorLink(state.target) || state.target.getAttribute('role') === 'link') {
          state.target.click();
        }
      }
    };

    if (typeof PointerEvent !== 'undefined') {
      pressProps.onPointerDown = e => {
        // Only handle left clicks
        if (e.button !== 0) {
          return;
        } // Due to browser inconsistencies, especially on mobile browsers, we prevent
        // default on pointer down and handle focusing the pressable element ourselves.


        if ($ffc54430b1dbeee65879852feaaff07d$var$shouldPreventDefault(e.target)) {
          e.preventDefault();
        } // iOS safari fires pointer events from VoiceOver (but only when outside an iframe...)
        // https://bugs.webkit.org/show_bug.cgi?id=222627


        state.pointerType = $ffc54430b1dbeee65879852feaaff07d$var$isVirtualPointerEvent(e.nativeEvent) ? 'virtual' : e.pointerType;
        e.stopPropagation();

        if (!state.isPressed) {
          state.isPressed = true;
          state.isOverTarget = true;
          state.activePointerId = e.pointerId;
          state.target = e.currentTarget;

          if (!isDisabled && !preventFocusOnPress) {
            focusWithoutScrolling(e.currentTarget);
          }

          $e17c9db826984f8ab8e5d837bf0b8$export$disableTextSelection();
          triggerPressStart(e, state.pointerType);
          addGlobalListener(document, 'pointermove', onPointerMove, false);
          addGlobalListener(document, 'pointerup', onPointerUp, false);
          addGlobalListener(document, 'pointercancel', onPointerCancel, false);
        }
      };

      pressProps.onMouseDown = e => {
        if (e.button === 0) {
          // Chrome and Firefox on touch Windows devices require mouse down events
          // to be canceled in addition to pointer events, or an extra asynchronous
          // focus event will be fired.
          if ($ffc54430b1dbeee65879852feaaff07d$var$shouldPreventDefault(e.target)) {
            e.preventDefault();
          }

          e.stopPropagation();
        }
      };

      pressProps.onPointerUp = e => {
        // Only handle left clicks
        // Safari on iOS sometimes fires pointerup events, even
        // when the touch isn't over the target, so double check.
        if (e.button === 0 && $ffc54430b1dbeee65879852feaaff07d$var$isOverTarget(e, e.currentTarget)) {
          triggerPressUp(e, state.pointerType);
        }
      }; // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
      // Use pointer move events instead to implement our own hit testing.
      // See https://bugs.webkit.org/show_bug.cgi?id=199803


      let onPointerMove = e => {
        if (e.pointerId !== state.activePointerId) {
          return;
        }

        if ($ffc54430b1dbeee65879852feaaff07d$var$isOverTarget(e, state.target)) {
          if (!state.isOverTarget) {
            state.isOverTarget = true;
            triggerPressStart($ffc54430b1dbeee65879852feaaff07d$var$createEvent(state.target, e), state.pointerType);
          }
        } else if (state.isOverTarget) {
          state.isOverTarget = false;
          triggerPressEnd($ffc54430b1dbeee65879852feaaff07d$var$createEvent(state.target, e), state.pointerType, false);
        }
      };

      let onPointerUp = e => {
        if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0) {
          if ($ffc54430b1dbeee65879852feaaff07d$var$isOverTarget(e, state.target)) {
            triggerPressEnd($ffc54430b1dbeee65879852feaaff07d$var$createEvent(state.target, e), state.pointerType);
          } else if (state.isOverTarget) {
            triggerPressEnd($ffc54430b1dbeee65879852feaaff07d$var$createEvent(state.target, e), state.pointerType, false);
          }

          state.isPressed = false;
          state.isOverTarget = false;
          state.activePointerId = null;
          state.pointerType = null;
          removeAllGlobalListeners();
          $e17c9db826984f8ab8e5d837bf0b8$export$restoreTextSelection();
        }
      };

      let onPointerCancel = e => {
        cancel(e);
      };

      pressProps.onDragStart = e => {
        // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
        cancel(e);
      };
    } else {
      pressProps.onMouseDown = e => {
        // Only handle left clicks
        if (e.button !== 0) {
          return;
        } // Due to browser inconsistencies, especially on mobile browsers, we prevent
        // default on mouse down and handle focusing the pressable element ourselves.


        if ($ffc54430b1dbeee65879852feaaff07d$var$shouldPreventDefault(e.target)) {
          e.preventDefault();
        }

        e.stopPropagation();

        if (state.ignoreEmulatedMouseEvents) {
          return;
        }

        state.isPressed = true;
        state.isOverTarget = true;
        state.target = e.currentTarget;
        state.pointerType = $f67ef9f1b8ed09b4b00fd0840cd8b94b$export$isVirtualClick(e.nativeEvent) ? 'virtual' : 'mouse';

        if (!isDisabled && !preventFocusOnPress) {
          focusWithoutScrolling(e.currentTarget);
        }

        triggerPressStart(e, state.pointerType);
        addGlobalListener(document, 'mouseup', onMouseUp, false);
      };

      pressProps.onMouseEnter = e => {
        e.stopPropagation();

        if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
          state.isOverTarget = true;
          triggerPressStart(e, state.pointerType);
        }
      };

      pressProps.onMouseLeave = e => {
        e.stopPropagation();

        if (state.isPressed && !state.ignoreEmulatedMouseEvents) {
          state.isOverTarget = false;
          triggerPressEnd(e, state.pointerType, false);
        }
      };

      pressProps.onMouseUp = e => {
        if (!state.ignoreEmulatedMouseEvents && e.button === 0) {
          triggerPressUp(e, state.pointerType);
        }
      };

      let onMouseUp = e => {
        // Only handle left clicks
        if (e.button !== 0) {
          return;
        }

        state.isPressed = false;
        removeAllGlobalListeners();

        if (state.ignoreEmulatedMouseEvents) {
          state.ignoreEmulatedMouseEvents = false;
          return;
        }

        if ($ffc54430b1dbeee65879852feaaff07d$var$isOverTarget(e, state.target)) {
          triggerPressEnd($ffc54430b1dbeee65879852feaaff07d$var$createEvent(state.target, e), state.pointerType);
        } else if (state.isOverTarget) {
          triggerPressEnd($ffc54430b1dbeee65879852feaaff07d$var$createEvent(state.target, e), state.pointerType, false);
        }

        state.isOverTarget = false;
      };

      pressProps.onTouchStart = e => {
        e.stopPropagation();
        let touch = $ffc54430b1dbeee65879852feaaff07d$var$getTouchFromEvent(e.nativeEvent);

        if (!touch) {
          return;
        }

        state.activePointerId = touch.identifier;
        state.ignoreEmulatedMouseEvents = true;
        state.isOverTarget = true;
        state.isPressed = true;
        state.target = e.currentTarget;
        state.pointerType = 'touch'; // Due to browser inconsistencies, especially on mobile browsers, we prevent default
        // on the emulated mouse event and handle focusing the pressable element ourselves.

        if (!isDisabled && !preventFocusOnPress) {
          focusWithoutScrolling(e.currentTarget);
        }

        $e17c9db826984f8ab8e5d837bf0b8$export$disableTextSelection();
        triggerPressStart(e, state.pointerType);
        addGlobalListener(window, 'scroll', onScroll, true);
      };

      pressProps.onTouchMove = e => {
        e.stopPropagation();

        if (!state.isPressed) {
          return;
        }

        let touch = $ffc54430b1dbeee65879852feaaff07d$var$getTouchById(e.nativeEvent, state.activePointerId);

        if (touch && $ffc54430b1dbeee65879852feaaff07d$var$isOverTarget(touch, e.currentTarget)) {
          if (!state.isOverTarget) {
            state.isOverTarget = true;
            triggerPressStart(e, state.pointerType);
          }
        } else if (state.isOverTarget) {
          state.isOverTarget = false;
          triggerPressEnd(e, state.pointerType, false);
        }
      };

      pressProps.onTouchEnd = e => {
        e.stopPropagation();

        if (!state.isPressed) {
          return;
        }

        let touch = $ffc54430b1dbeee65879852feaaff07d$var$getTouchById(e.nativeEvent, state.activePointerId);

        if (touch && $ffc54430b1dbeee65879852feaaff07d$var$isOverTarget(touch, e.currentTarget)) {
          triggerPressUp(e, state.pointerType);
          triggerPressEnd(e, state.pointerType);
        } else if (state.isOverTarget) {
          triggerPressEnd(e, state.pointerType, false);
        }

        state.isPressed = false;
        state.activePointerId = null;
        state.isOverTarget = false;
        state.ignoreEmulatedMouseEvents = true;
        $e17c9db826984f8ab8e5d837bf0b8$export$restoreTextSelection();
        removeAllGlobalListeners();
      };

      pressProps.onTouchCancel = e => {
        e.stopPropagation();

        if (state.isPressed) {
          cancel(e);
        }
      };

      let onScroll = e => {
        if (state.isPressed && e.target.contains(state.target)) {
          cancel({
            currentTarget: state.target,
            shiftKey: false,
            ctrlKey: false,
            metaKey: false
          });
        }
      };

      pressProps.onDragStart = e => {
        cancel(e);
      };
    }

    return pressProps;
  }, [addGlobalListener, isDisabled, preventFocusOnPress, removeAllGlobalListeners]); // Remove user-select: none in case component unmounts immediately after pressStart
  // eslint-disable-next-line arrow-body-style

  useEffect(() => {
    return () => $e17c9db826984f8ab8e5d837bf0b8$export$restoreTextSelection();
  }, []);
  return {
    isPressed: isPressedProp || isPressed,
    pressProps: mergeProps(domProps, pressProps)
  };
}

function $ffc54430b1dbeee65879852feaaff07d$var$isHTMLAnchorLink(target) {
  return target.tagName === 'A' && target.hasAttribute('href');
}

function $ffc54430b1dbeee65879852feaaff07d$var$isValidKeyboardEvent(event) {
  const {
    key,
    target
  } = event;
  const element = target;
  const {
    tagName,
    isContentEditable
  } = element;
  const role = element.getAttribute('role'); // Accessibility for keyboards. Space and Enter only.
  // "Spacebar" is for IE 11

  return (key === 'Enter' || key === ' ' || key === 'Spacebar') && tagName !== 'INPUT' && tagName !== 'TEXTAREA' && isContentEditable !== true && ( // A link with a valid href should be handled natively,
  // unless it also has role='button' and was triggered using Space.
  !$ffc54430b1dbeee65879852feaaff07d$var$isHTMLAnchorLink(element) || role === 'button' && key !== 'Enter') && // An element with role='link' should only trigger with Enter key
  !(role === 'link' && key !== 'Enter');
}

function $ffc54430b1dbeee65879852feaaff07d$var$getTouchFromEvent(event) {
  const {
    targetTouches
  } = event;

  if (targetTouches.length > 0) {
    return targetTouches[0];
  }

  return null;
}

function $ffc54430b1dbeee65879852feaaff07d$var$getTouchById(event, pointerId) {
  const changedTouches = event.changedTouches;

  for (let i = 0; i < changedTouches.length; i++) {
    const touch = changedTouches[i];

    if (touch.identifier === pointerId) {
      return touch;
    }
  }

  return null;
}

function $ffc54430b1dbeee65879852feaaff07d$var$createEvent(target, e) {
  return {
    currentTarget: target,
    shiftKey: e.shiftKey,
    ctrlKey: e.ctrlKey,
    metaKey: e.metaKey
  };
}

function $ffc54430b1dbeee65879852feaaff07d$var$isOverTarget(point, target) {
  let rect = target.getBoundingClientRect();
  return (point.clientX || 0) >= (rect.left || 0) && (point.clientX || 0) <= (rect.right || 0) && (point.clientY || 0) >= (rect.top || 0) && (point.clientY || 0) <= (rect.bottom || 0);
}

function $ffc54430b1dbeee65879852feaaff07d$var$shouldPreventDefault(target) {
  // We cannot prevent default if the target is inside a draggable element.
  return !target.closest('[draggable="true"]');
}

function $ffc54430b1dbeee65879852feaaff07d$var$isVirtualPointerEvent(event) {
  // If the pointer size is zero, then we assume it's from a screen reader.
  return event.width === 0 && event.height === 0;
}
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions

/**
 * Handles focus events for the immediate target.
 * Focus events on child elements will be ignored.
 */

function useFocus(props) {
  if (props.isDisabled) {
    return {
      focusProps: {}
    };
  }

  let onFocus, onBlur;

  if (props.onFocus || props.onFocusChange) {
    onFocus = e => {
      if (e.target === e.currentTarget) {
        if (props.onFocus) {
          props.onFocus(e);
        }

        if (props.onFocusChange) {
          props.onFocusChange(true);
        }
      }
    };
  }

  if (props.onBlur || props.onFocusChange) {
    onBlur = e => {
      if (e.target === e.currentTarget) {
        if (props.onBlur) {
          props.onBlur(e);
        }

        if (props.onFocusChange) {
          props.onFocusChange(false);
        }
      }
    };
  }

  return {
    focusProps: {
      onFocus,
      onBlur
    }
  };
}
let $d01f69bb2ab5f70dfd0005370a2a2cbc$var$changeHandlers = new Set();
let $d01f69bb2ab5f70dfd0005370a2a2cbc$var$hasSetupGlobalListeners = false;
let $d01f69bb2ab5f70dfd0005370a2a2cbc$var$hasEventBeforeFocus = false; // Only Tab or Esc keys will make focus visible on text input elements

function $d01f69bb2ab5f70dfd0005370a2a2cbc$var$triggerChangeHandlers(modality, e) {
  for (let handler of $d01f69bb2ab5f70dfd0005370a2a2cbc$var$changeHandlers) {
    handler(modality, e);
  }
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */


function $d01f69bb2ab5f70dfd0005370a2a2cbc$var$isValidKey(e) {
  return !(e.metaKey || !isMac() && e.altKey || e.ctrlKey);
}

function $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handleKeyboardEvent(e) {
  $d01f69bb2ab5f70dfd0005370a2a2cbc$var$hasEventBeforeFocus = true;

  if ($d01f69bb2ab5f70dfd0005370a2a2cbc$var$isValidKey(e)) {
    $d01f69bb2ab5f70dfd0005370a2a2cbc$var$triggerChangeHandlers('keyboard', e);
  }
}

function $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handlePointerEvent(e) {

  if (e.type === 'mousedown' || e.type === 'pointerdown') {
    $d01f69bb2ab5f70dfd0005370a2a2cbc$var$hasEventBeforeFocus = true;
    $d01f69bb2ab5f70dfd0005370a2a2cbc$var$triggerChangeHandlers('pointer', e);
  }
}

function $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handleClickEvent(e) {
  if ($f67ef9f1b8ed09b4b00fd0840cd8b94b$export$isVirtualClick(e)) {
    $d01f69bb2ab5f70dfd0005370a2a2cbc$var$hasEventBeforeFocus = true;
  }
}

function $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handleFocusEvent(e) {
  // Firefox fires two extra focus events when the user first clicks into an iframe:
  // first on the window, then on the document. We ignore these events so they don't
  // cause keyboard focus rings to appear.
  if (e.target === window || e.target === document) {
    return;
  } // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
  // This occurs, for example, when navigating a form with the next/previous buttons on iOS.


  if (!$d01f69bb2ab5f70dfd0005370a2a2cbc$var$hasEventBeforeFocus) {
    $d01f69bb2ab5f70dfd0005370a2a2cbc$var$triggerChangeHandlers('virtual', e);
  }

  $d01f69bb2ab5f70dfd0005370a2a2cbc$var$hasEventBeforeFocus = false;
}

function $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handleWindowBlur() {
  // When the window is blurred, reset state. This is necessary when tabbing out of the window,
  // for example, since a subsequent focus event won't be fired.
  $d01f69bb2ab5f70dfd0005370a2a2cbc$var$hasEventBeforeFocus = false;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */


function $d01f69bb2ab5f70dfd0005370a2a2cbc$var$setupGlobalFocusEvents() {
  if (typeof window === 'undefined' || $d01f69bb2ab5f70dfd0005370a2a2cbc$var$hasSetupGlobalListeners) {
    return;
  } // Programmatic focus() calls shouldn't affect the current input modality.
  // However, we need to detect other cases when a focus event occurs without
  // a preceding user event (e.g. screen reader focus). Overriding the focus
  // method on HTMLElement.prototype is a bit hacky, but works.


  let focus = HTMLElement.prototype.focus;

  HTMLElement.prototype.focus = function () {
    $d01f69bb2ab5f70dfd0005370a2a2cbc$var$hasEventBeforeFocus = true;
    focus.apply(this, arguments);
  };

  document.addEventListener('keydown', $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handleKeyboardEvent, true);
  document.addEventListener('keyup', $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handleKeyboardEvent, true);
  document.addEventListener('click', $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handleClickEvent, true); // Register focus events on the window so they are sure to happen
  // before React's event listeners (registered on the document).

  window.addEventListener('focus', $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handleFocusEvent, true);
  window.addEventListener('blur', $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handleWindowBlur, false);

  if (typeof PointerEvent !== 'undefined') {
    document.addEventListener('pointerdown', $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handlePointerEvent, true);
    document.addEventListener('pointermove', $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handlePointerEvent, true);
    document.addEventListener('pointerup', $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handlePointerEvent, true);
  } else {
    document.addEventListener('mousedown', $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handlePointerEvent, true);
    document.addEventListener('mousemove', $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handlePointerEvent, true);
    document.addEventListener('mouseup', $d01f69bb2ab5f70dfd0005370a2a2cbc$var$handlePointerEvent, true);
  }

  $d01f69bb2ab5f70dfd0005370a2a2cbc$var$hasSetupGlobalListeners = true;
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') {
    $d01f69bb2ab5f70dfd0005370a2a2cbc$var$setupGlobalFocusEvents();
  } else {
    document.addEventListener('DOMContentLoaded', $d01f69bb2ab5f70dfd0005370a2a2cbc$var$setupGlobalFocusEvents);
  }
}
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.

let $b1a784c66b81d90efa4f74e05b$var$globalIgnoreEmulatedMouseEvents = false;
let $b1a784c66b81d90efa4f74e05b$var$hoverCount = 0;

function $b1a784c66b81d90efa4f74e05b$var$setGlobalIgnoreEmulatedMouseEvents() {
  $b1a784c66b81d90efa4f74e05b$var$globalIgnoreEmulatedMouseEvents = true; // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
  // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
  // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
  // the distant future because a user previously touched the element.

  setTimeout(() => {
    $b1a784c66b81d90efa4f74e05b$var$globalIgnoreEmulatedMouseEvents = false;
  }, 50);
}

function $b1a784c66b81d90efa4f74e05b$var$handleGlobalPointerEvent(e) {
  if (e.pointerType === 'touch') {
    $b1a784c66b81d90efa4f74e05b$var$setGlobalIgnoreEmulatedMouseEvents();
  }
}

function $b1a784c66b81d90efa4f74e05b$var$setupGlobalTouchEvents() {
  if (typeof document === 'undefined') {
    return;
  }

  if (typeof PointerEvent !== 'undefined') {
    document.addEventListener('pointerup', $b1a784c66b81d90efa4f74e05b$var$handleGlobalPointerEvent);
  } else {
    document.addEventListener('touchend', $b1a784c66b81d90efa4f74e05b$var$setGlobalIgnoreEmulatedMouseEvents);
  }

  $b1a784c66b81d90efa4f74e05b$var$hoverCount++;
  return () => {
    $b1a784c66b81d90efa4f74e05b$var$hoverCount--;

    if ($b1a784c66b81d90efa4f74e05b$var$hoverCount > 0) {
      return;
    }

    if (typeof PointerEvent !== 'undefined') {
      document.removeEventListener('pointerup', $b1a784c66b81d90efa4f74e05b$var$handleGlobalPointerEvent);
    } else {
      document.removeEventListener('touchend', $b1a784c66b81d90efa4f74e05b$var$setGlobalIgnoreEmulatedMouseEvents);
    }
  };
}
/**
 * Handles pointer hover interactions for an element. Normalizes behavior
 * across browsers and platforms, and ignores emulated mouse events on touch devices.
 */


function useHover(props) {
  let {
    onHoverStart,
    onHoverChange,
    onHoverEnd,
    isDisabled
  } = props;
  let [isHovered, setHovered] = useState(false);
  let state = useRef({
    isHovered: false,
    ignoreEmulatedMouseEvents: false
  }).current;
  useEffect($b1a784c66b81d90efa4f74e05b$var$setupGlobalTouchEvents, []);
  let hoverProps = useMemo(() => {
    let triggerHoverStart = (event, pointerType) => {
      if (isDisabled || pointerType === 'touch' || state.isHovered) {
        return;
      }

      state.isHovered = true;
      let target = event.target;

      if (onHoverStart) {
        onHoverStart({
          type: 'hoverstart',
          target,
          pointerType
        });
      }

      if (onHoverChange) {
        onHoverChange(true);
      }

      setHovered(true);
    };

    let triggerHoverEnd = (event, pointerType) => {
      if (pointerType === 'touch' || !state.isHovered) {
        return;
      }

      state.isHovered = false;
      let target = event.target;

      if (onHoverEnd) {
        onHoverEnd({
          type: 'hoverend',
          target,
          pointerType
        });
      }

      if (onHoverChange) {
        onHoverChange(false);
      }

      setHovered(false);
    };

    let hoverProps = {};

    if (typeof PointerEvent !== 'undefined') {
      hoverProps.onPointerEnter = e => {
        if ($b1a784c66b81d90efa4f74e05b$var$globalIgnoreEmulatedMouseEvents && e.pointerType === 'mouse') {
          return;
        }

        triggerHoverStart(e, e.pointerType);
      };

      hoverProps.onPointerLeave = e => {
        triggerHoverEnd(e, e.pointerType);
      };
    } else {
      hoverProps.onTouchStart = () => {
        state.ignoreEmulatedMouseEvents = true;
      };

      hoverProps.onMouseEnter = e => {
        if (!state.ignoreEmulatedMouseEvents && !$b1a784c66b81d90efa4f74e05b$var$globalIgnoreEmulatedMouseEvents) {
          triggerHoverStart(e, 'mouse');
        }

        state.ignoreEmulatedMouseEvents = false;
      };

      hoverProps.onMouseLeave = e => {
        triggerHoverEnd(e, 'mouse');
      };
    }

    return hoverProps;
  }, [onHoverStart, onHoverChange, onHoverEnd, isDisabled, state]);
  return {
    hoverProps,
    isHovered
  };
}
/**
 * This function wraps a React event handler to make stopPropagation the default, and support continuePropagation instead.
 */


function $dc0d75166de722fbf58eb6c3552$export$createEventHandler(handler) {
  if (!handler) {
    return;
  }

  let shouldStopPropagation = true;
  return e => {
    let event = _extends$4({}, e, {
      preventDefault() {
        e.preventDefault();
      },

      isDefaultPrevented() {
        return e.isDefaultPrevented();
      },

      stopPropagation() {
        console.error('stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.');
      },

      continuePropagation() {
        shouldStopPropagation = false;
      }

    });

    handler(event);

    if (shouldStopPropagation) {
      e.stopPropagation();
    }
  };
}
/**
 * Handles keyboard interactions for a focusable element.
 */


function useKeyboard(props) {
  return {
    keyboardProps: props.isDisabled ? {} : {
      onKeyDown: $dc0d75166de722fbf58eb6c3552$export$createEventHandler(props.onKeyDown),
      onKeyUp: $dc0d75166de722fbf58eb6c3552$export$createEventHandler(props.onKeyUp)
    }
  };
}

let $e11539c8317b2d21639df611cb5658f$var$FocusableContext = /*#__PURE__*/React__default.createContext(null);

function $e11539c8317b2d21639df611cb5658f$var$useFocusableContext(ref) {
  let context = useContext($e11539c8317b2d21639df611cb5658f$var$FocusableContext) || {};
  useSyncRef(context, ref);
  return context;
}
/**
 * Used to make an element focusable and capable of auto focus.
 */

function useFocusable(props, domRef) {
  let {
    focusProps
  } = useFocus(props);
  let {
    keyboardProps
  } = useKeyboard(props);
  let interactions = mergeProps(focusProps, keyboardProps);
  let domProps = $e11539c8317b2d21639df611cb5658f$var$useFocusableContext(domRef);
  let interactionProps = props.isDisabled ? {} : domProps;
  useEffect(() => {
    if (props.autoFocus && domRef.current) {
      domRef.current.focus();
    }
  }, [props.autoFocus, domRef]);
  return {
    focusableProps: mergeProps(_extends$4({}, interactions, {
      tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
    }), interactionProps)
  };
}

/**
 * Provides the behavior and accessibility implementation for a button component. Handles mouse, keyboard, and touch interactions,
 * focus behavior, and ARIA props for both native button elements and custom element types.
 * @param props - Props to be applied to the button.
 * @param ref - A ref to a DOM element for the button.
 */

function useButton(props, ref) {
  /* eslint-enable no-redeclare */
  let {
    elementType = 'button',
    isDisabled,
    onPress,
    onPressStart,
    onPressEnd,
    onPressChange,
    // @ts-ignore - undocumented
    preventFocusOnPress,
    // @ts-ignore
    onClick: deprecatedOnClick,
    href,
    target,
    rel,
    type = 'button'
  } = props;
  let additionalProps;

  if (elementType === 'button') {
    additionalProps = {
      type,
      disabled: isDisabled
    };
  } else {
    additionalProps = {
      role: 'button',
      tabIndex: isDisabled ? undefined : 0,
      href: elementType === 'a' && isDisabled ? undefined : href,
      target: elementType === 'a' ? target : undefined,
      type: elementType === 'input' ? type : undefined,
      disabled: elementType === 'input' ? isDisabled : undefined,
      'aria-disabled': !isDisabled || elementType === 'input' ? undefined : isDisabled,
      rel: elementType === 'a' ? rel : undefined
    };
  }

  let {
    pressProps,
    isPressed
  } = usePress({
    onPressStart,
    onPressEnd,
    onPressChange,
    onPress,
    isDisabled,
    preventFocusOnPress,
    ref
  });
  let {
    focusableProps
  } = useFocusable(props, ref);
  let buttonProps = mergeProps(focusableProps, pressProps);
  buttonProps = mergeProps(buttonProps, filterDOMProps(props, {
    labelable: true
  }));
  return {
    isPressed,
    // Used to indicate press state for visual
    buttonProps: mergeProps(additionalProps, buttonProps, {
      'aria-haspopup': props['aria-haspopup'],
      'aria-expanded': props['aria-expanded'],
      'aria-controls': props['aria-controls'],
      'aria-pressed': props['aria-pressed'],
      onClick: e => {
        if (deprecatedOnClick) {
          deprecatedOnClick(e);
          console.warn('onClick is deprecated, please use onPress');
        }
      }
    })
  };
}

const _excluded$o = ["as", "variant", "size", "isDisabled", "onPress", "sx"];
const Button = forwardRef((props, ref) => {
  const {
    as = 'button',
    variant = 'primary',
    size = 'lg',
    isDisabled = false,
    onPress,
    sx = {}
  } = props,
        rest = _objectWithoutPropertiesLoose$2(props, _excluded$o);

  const {
    hoverProps,
    isHovered
  } = useHover({});
  const {
    buttonProps,
    isPressed
  } = useButton(_extends$1({}, rest, {
    elementType: as
  }), ref);

  const css = _extends$1({
    appearance: 'none',
    userSelect: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 'lg',
    justifyContent: 'center',
    textAlign: 'center',
    textDecoration: 'none',
    fontSize: 'inherit',
    fontFamily: 'inherit',
    fontWeight: 'bold',
    transform: !isDisabled && isPressed ? 'translateY(2px)' : '',
    transition: 'transform 0.15s ease-in-out 0s',
    px: size === 'lg' ? 20 : 4,
    py: 2,
    outline: 0,
    lineHeight: '1.625rem',
    '&:focus': {
      outline: 0
    },
    width: 'inherit'
  }, variantStyles({
    type: variant,
    isHovered,
    isPressed,
    isDisabled
  }), sx);

  const _onPress = isDisabled ? null : onPress;

  return React__default.createElement(Box, _extends$1({
    ref: ref,
    as: as
  }, rest, buttonProps, hoverProps, {
    sx: css,
    onClick: _onPress
  }), props.children);
});

const variantStyles = ({
  isHovered,
  isPressed,
  isDisabled,
  type
}) => variant({
  variants: {
    primary: {
      color: 'white',
      // borderColor: isPressed ? 'purple.300' : isHovered ? 'purple.700' : 'transparent',
      // bg: isPressed ? 'purple.800' : isHovered ? 'purple.700' : 'purple.600',
      // boxShadow: isPressed ? 'none' : '0px 2px 0px #B9AED7',
      background: 'linear-gradient(90deg, #15BA30 0%, #20954E 100%)'
    },
    secondary: {
      color: 'green.700',
      // bg: isPressed ? 'gray.200' : isHovered ? 'gray.100' : 'white',
      border: '1px solid',
      borderColor: 'green.700',
      boxShadow: isPressed ? 'none' : '0px 1px 0px #D8D9DB'
    },
    tertiary: {
      color: 'gray.600',
      border: '1px solid',
      // borderColor: isPressed ? 'purple.200' : 'transparent',
      borderColor: 'gray.600',
      background: 'white' // bg: isPressed ? 'purple.300' : isHovered ? 'purple.100' : 'transparent',

    },
    success: {
      color: 'white',
      bg: isPressed ? 'green.800' : isHovered ? 'green.700' : 'green.600',
      border: '1px solid' // borderColor: isPressed ? 'green.700' : 'transparent',
      // boxShadow: isPressed ? 'none' : ' 0px 2px 0px #20954E',

    },
    danger: {
      color: 'white',
      bg: isPressed ? 'red.800' : isHovered ? 'red.700' : 'red.600',
      border: '1px solid' // borderColor: isPressed ? 'red.400' : 'transparent',
      // boxShadow: isPressed ? 'none' : ' 0px 2px 0px #E07F86',

    },
    disabled: {
      color: 'gray.400',
      bg: 'gray.300',
      boxShadow: '0px 1px 0px #D8D9DB',
      cursor: 'not-allowed'
    }
  }
})({
  variant: isDisabled ? 'disabled' : type
});

const LinkButton = forwardRef((props, ref) => React__default.createElement(Button, _extends$1({
  as: "a",
  ref: ref
}, props)));

const _excluded$n = ["sx"];
const Flex = forwardRef((_ref, ref) => {
  let {
    sx = {}
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$n);

  return React__default.createElement(Box, _extends$1({
    ref: ref,
    sx: _extends$1({
      display: 'flex'
    }, sx)
  }, props));
});

const _excluded$m = ["links", "children", "tippyProps", "sx", "variant"];
const ActionButton = forwardRef((_ref, ref) => {
  let {
    links,
    children,
    tippyProps,
    sx,
    variant = 'tertiary'
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$m);

  const [hovered, setHovered] = React__default.useState(-1);
  return React__default.createElement(Tippy, _extends$1({
    ref: ref,
    arrow: true,
    interactive: true,
    placement: "bottom",
    trigger: "click",
    render: (attrs, content) => {
      return React__default.createElement(Flex, _extends$1({
        sx: {
          background: 'white',
          border: '1px solid',
          borderColor: 'gray.200',
          borderRadius: 'lg',
          boxShadow: 'lg',
          color: 'gray.700',
          flexDirection: 'column',
          minWidth: '200px',
          overflow: 'hidden',
          'a': {
            fontWeight: 'normal',
            textDecoration: 'none'
          }
        }
      }, attrs), links.map(({
        label,
        href,
        linkOptions
      }, idx) => {
        return React__default.createElement("a", _extends$1({
          href: href
        }, linkOptions), React__default.createElement(Flex, {
          sx: {
            backgroundColor: hovered === idx ? 'gray.700' : 'white',
            borderBottom: idx < links.length - 1 ? '1px solid' : 'none',
            borderColor: 'gray.200',
            color: hovered === idx ? 'white' : 'inherit',
            paddingLeft: 3,
            paddingY: 3
          },
          onMouseEnter: () => {
            setHovered(idx);
          }
        }, label));
      }));
    }
  }, tippyProps), React__default.createElement(Button, _extends$1({
    sx: _extends$1({
      backgroundColor: 'black',
      color: 'white'
    }, sx),
    variant: variant
  }, props), children));
});

const _excluded$l = ["width", "columns", "gap", "sx"];
/**
 * CSS grid layout component to arrange direct child elements in a tiled grid layout.
 * @see https://theme-ui.com/components/grid
 */

const px = n => typeof n === 'number' ? n + 'px' : n;

const widthToColumns = width => Array.isArray(width) ? width.map(widthToColumns) : !!width && `repeat(auto-fit, minmax(${px(width)}, 1fr))`;

const countToColumns = n => Array.isArray(n) ? n.map(countToColumns) : !!n && (typeof n === 'number' ? `repeat(${n}, 1fr)` : n);

const Grid = forwardRef(function Grid(_ref, ref) {
  let {
    width,
    columns,
    gap = 3,
    sx = {}
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$l);

  const gridTemplateColumns = !!width ? widthToColumns(width) : countToColumns(columns);
  return React__default.createElement(Box, _extends$1({
    ref: ref,
    sx: _extends$1({
      display: 'grid',
      gridGap: gap,
      gridTemplateColumns
    }, sx)
  }, props));
});

const Divider = forwardRef((props, ref) => React__default.createElement(Box, _extends$1({
  ref: ref,
  as: "hr"
}, props)));

const InformationCircle = () => React.createElement("svg", {
  fill: "#6A6D77",
  width: "1em",
  height: "1em",
  viewBox: "0 0 510 510"
}, React.createElement("g", null, React.createElement("path", {
  d: "M229.5,382.5h51v-153h-51V382.5z M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z\n\t\t\t M255,459c-112.2,0-204-91.8-204-204S142.8,51,255,51s204,91.8,204,204S367.2,459,255,459z M229.5,178.5h51v-51h-51V178.5z"
})));

const Tooltip = ({
  content,
  children,
  placement: _placement = 'auto',
  appendTo: _appendTo = 'parent'
}) => {
  return React.createElement(Flex, {
    sx: {
      alignItems: 'center'
    }
  }, children, content && React.createElement(Tippy, {
    appendTo: _appendTo,
    placement: _placement,
    render: attrs => React.createElement(Flex, _extends$1({
      sx: {
        width: 'fit-content',
        maxWidth: '250px',
        bg: 'gray.700',
        boxShadow: 'lg',
        color: 'white',
        text: {
          base: 'xs',
          md: 'sm'
        },
        p: 2,
        position: 'relative'
      }
    }, attrs), content)
  }, React.createElement(Box, {
    as: "span",
    sx: {
      cursor: 'pointer',
      ml: 2,
      mt: '-2px',
      float: 'right'
    }
  }, React.createElement(Box, {
    as: InformationCircle
  }))));
};

const _excluded$k = ["sx", "tooltip"];
const Label = _ref => {
  let {
    sx = {},
    tooltip
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$k);

  return React__default.createElement(Tooltip, {
    content: tooltip
  }, React__default.createElement(Box, _extends$1({
    as: "label",
    sx: _extends$1({
      width: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      alignContent: 'center'
    }, sx)
  }, props)));
};

const _excluded$j = ["as", "left", "right", "hasErrors", "isReadOnly", "isDisabled", "required", "onFocus", "onBlur", "sxInput", "sx"];
const BaseInput = forwardRef((props, ref) => {
  const {
    as = 'input',
    left = null,
    right = null,
    hasErrors = false,
    isReadOnly = false,
    isDisabled = false,
    required = false,
    onFocus = null,
    onBlur = null,
    sxInput = {},
    sx = {}
  } = props,
        rest = _objectWithoutPropertiesLoose$2(props, _excluded$j);

  const [isFocused, setFocused] = useState(false);
  const borderColor = hasErrors ? 'red.500' : isFocused ? 'gray.500' : 'gray.300';
  return React__default.createElement(Box, {
    sx: _extends$1({
      alignItems: 'center',
      bg: 'white',
      border: '1px solid',
      borderColor,
      borderRadius: 'lg',
      boxShadow: '0px 1px 0px #D8D9DB',
      color: 'gray.700',
      display: 'inline-flex',
      flexShrink: 1,
      justifyContent: 'space-between',
      lineHeight: '1.625rem',
      px: 3,
      py: 2,
      width: '100%'
    }, sx)
  }, left && React__default.createElement(Box, {
    as: "span",
    sx: {
      py: 1,
      px: 1,
      textAlign: 'right',
      color: 'gray.700',
      whiteSpace: 'nowrap'
    }
  }, left), React__default.createElement(Box, _extends$1({
    ref: ref,
    as: as,
    disabled: isDisabled,
    readOnly: isReadOnly,
    required: required,
    sx: _extends$1({
      display: 'inline-flex',
      width: '100%',
      appearance: 'none',
      outline: 0,
      fontSize: 'inherit',
      lineHeight: 'inherit',
      color: 'inherit',
      // padding: 1,
      flexShrink: 1,
      minWidth: 0
    }, sxInput)
  }, rest, {
    onFocus: e => {
      setFocused(true);
      onFocus && onFocus(e);
    },
    onBlur: e => {
      setFocused(false);
      onBlur && onBlur(e);
    }
  })), right && React__default.createElement(Box, {
    as: "span",
    sx: {
      py: 1,
      px: 1,
      textAlign: 'right',
      color: 'gray.500',
      whiteSpace: 'nowrap'
    }
  }, right));
});

const Input = BaseInput;
const InputWithAdornment = forwardRef((props, ref) => React__default.createElement(BaseInput, _extends$1({}, props, {
  ref: ref
})));

/**
 * react-number-format - 4.6.0
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2021 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */

function createCommonjsModule$1(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$1;

function emptyFunction$1() {}

function emptyFunctionWithReset$1() {}

emptyFunctionWithReset$1.resetWarningCache = emptyFunction$1;

var factoryWithThrowingShims$1 = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1$1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset$1,
    resetWarningCache: emptyFunction$1
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes$1 = createCommonjsModule$1(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims$1();
  }
}); //     
// basic noop function

function noop() {}

function returnTrue() {
  return true;
}

function charIsNumber(char) {
  return !!(char || '').match(/\d/);
}

function isNil(val) {
  return val === null || val === undefined;
}

function escapeRegExp(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

function getThousandsGroupRegex(thousandsGroupStyle) {
  switch (thousandsGroupStyle) {
    case 'lakh':
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;

    case 'wan':
      return /(\d)(?=(\d{4})+(?!\d))/g;

    case 'thousand':
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}

function applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
  var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
  var index = str.search(/[1-9]/);
  index = index === -1 ? str.length : index;
  return str.substring(0, index) + str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator);
} //spilt a float number into different parts beforeDecimal, afterDecimal, and negation


function splitDecimal(numStr, allowNegative) {
  if (allowNegative === void 0) allowNegative = true;
  var hasNagation = numStr[0] === '-';
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace('-', '');
  var parts = numStr.split('.');
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || '';
  return {
    beforeDecimal: beforeDecimal,
    afterDecimal: afterDecimal,
    hasNagation: hasNagation,
    addNegation: addNegation
  };
}

function fixLeadingZero(numStr) {
  if (!numStr) {
    return numStr;
  }

  var isNegative = numStr[0] === '-';

  if (isNegative) {
    numStr = numStr.substring(1, numStr.length);
  }

  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';
  return "" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? "." + afterDecimal : '');
}
/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */


function limitToScale(numStr, scale, fixedDecimalScale) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';

  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }

  return str;
}

function repeat(str, count) {
  return Array(count + 1).join(str);
}

function toNumericString(num) {
  num += ''; // typecast number to string
  // store the sign and remove it from the number.

  var sign = num[0] === '-' ? '-' : '';

  if (sign) {
    num = num.substring(1);
  } // split the number into cofficient and exponent


  var ref = num.split(/[eE]/g);
  var coefficient = ref[0];
  var exponent = ref[1]; // covert exponent to number;

  exponent = Number(exponent); // if there is no exponent part or its 0, return the coffiecient with sign

  if (!exponent) {
    return sign + coefficient;
  }

  coefficient = coefficient.replace('.', '');
  /**
   * for scientific notation the current decimal index will be after first number (index 0)
   * So effective decimal index will always be 1 + exponent value
   */

  var decimalIndex = 1 + exponent;
  var coffiecientLn = coefficient.length;

  if (decimalIndex < 0) {
    // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = '0.' + repeat('0', Math.abs(decimalIndex)) + coefficient;
  } else if (decimalIndex >= coffiecientLn) {
    // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + repeat('0', decimalIndex - coffiecientLn);
  } else {
    // else add decimal point at proper index
    coefficient = (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
  }

  return sign + coefficient;
}
/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */


function roundToPrecision(numStr, scale, fixedDecimalScale) {
  //if number is empty don't do anything return empty string
  if (['', '-'].indexOf(numStr) !== -1) {
    return numStr;
  }

  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;
  var ref = splitDecimal(numStr);
  var beforeDecimal = ref.beforeDecimal;
  var afterDecimal = ref.afterDecimal;
  var hasNagation = ref.hasNagation;
  var floatValue = parseFloat("0." + (afterDecimal || '0'));
  var floatValueStr = afterDecimal.length <= scale ? toNumericString(floatValue) : floatValue.toFixed(scale);
  var roundedDecimalParts = floatValueStr.split('.');
  var intPart = beforeDecimal.split('').reverse().reduce(function (roundedStr, current, idx) {
    if (roundedStr.length > idx) {
      return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
    }

    return current + roundedStr;
  }, roundedDecimalParts[0]);
  var decimalPart = limitToScale(roundedDecimalParts[1] || '', Math.min(scale, afterDecimal.length), fixedDecimalScale);
  var negation = hasNagation ? '-' : '';
  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
  return "" + negation + intPart + decimalSeparator + decimalPart;
}

function omit(obj, keyMaps) {
  var filteredObj = {};
  Object.keys(obj).forEach(function (key) {
    if (!keyMaps[key]) {
      filteredObj[key] = obj[key];
    }
  });
  return filteredObj;
}
/** set the caret positon in an input field **/


function setCaretPosition(el, caretPos) {
  el.value = el.value; // ^ this is used to not only get 'focus', but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)

  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    } // (el.selectionStart === 0 added for Firefox bug)


    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    } // fail city, fortunately this never happens (as far as I've tested) :)


    el.focus();
    return false;
  }
}
/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/


function findChangedIndex(prevValue, newValue) {
  var i = 0,
      j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;

  while (prevValue[i] === newValue[i] && i < prevLength) {
    i++;
  } //check what has been changed from last


  while (prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i) {
    j++;
  }

  return {
    start: i,
    end: prevLength - j
  };
}
/*
  Returns a number whose value is limited to the given range
*/


function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

function getCurrentCaretPosition(el) {
  /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
  return Math.max(el.selectionStart, el.selectionEnd);
}

function addInputMode(format) {
  return format || !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
} //     


var propTypes$1$1 = {
  thousandSeparator: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.oneOf([true])]),
  decimalSeparator: propTypes$1.string,
  allowedDecimalSeparators: propTypes$1.arrayOf(propTypes$1.string),
  thousandsGroupStyle: propTypes$1.oneOf(['thousand', 'lakh', 'wan']),
  decimalScale: propTypes$1.number,
  fixedDecimalScale: propTypes$1.bool,
  displayType: propTypes$1.oneOf(['input', 'text']),
  prefix: propTypes$1.string,
  suffix: propTypes$1.string,
  format: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]),
  removeFormatting: propTypes$1.func,
  mask: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.arrayOf(propTypes$1.string)]),
  value: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  defaultValue: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  isNumericString: propTypes$1.bool,
  customInput: propTypes$1.elementType,
  allowNegative: propTypes$1.bool,
  allowEmptyFormatting: propTypes$1.bool,
  allowLeadingZeros: propTypes$1.bool,
  onValueChange: propTypes$1.func,
  onKeyDown: propTypes$1.func,
  onMouseUp: propTypes$1.func,
  onChange: propTypes$1.func,
  onFocus: propTypes$1.func,
  onBlur: propTypes$1.func,
  type: propTypes$1.oneOf(['text', 'tel', 'password']),
  isAllowed: propTypes$1.func,
  renderText: propTypes$1.func,
  getInputRef: propTypes$1.oneOfType([propTypes$1.func, // for legacy refs
  propTypes$1.shape({
    current: propTypes$1.any
  })])
};
var defaultProps = {
  displayType: 'input',
  decimalSeparator: '.',
  thousandsGroupStyle: 'thousand',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  allowEmptyFormatting: false,
  allowLeadingZeros: false,
  isNumericString: false,
  type: 'text',
  onValueChange: noop,
  onChange: noop,
  onKeyDown: noop,
  onMouseUp: noop,
  onFocus: noop,
  onBlur: noop,
  isAllowed: returnTrue
};

var NumberFormat = /*@__PURE__*/function (superclass) {
  function NumberFormat(props) {
    superclass.call(this, props);
    var defaultValue = props.defaultValue; //validate props

    this.validateProps();
    var formattedValue = this.formatValueProp(defaultValue);
    this.state = {
      value: formattedValue,
      numAsString: this.removeFormatting(formattedValue),
      mounted: false
    };
    this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0
    };
    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  if (superclass) NumberFormat.__proto__ = superclass;
  NumberFormat.prototype = Object.create(superclass && superclass.prototype);
  NumberFormat.prototype.constructor = NumberFormat;

  NumberFormat.prototype.componentDidMount = function componentDidMount() {
    // set mounted state
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      mounted: true
    });
  };

  NumberFormat.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    this.updateValueIfRequired(prevProps);
  };

  NumberFormat.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.focusTimeout);
  };

  NumberFormat.prototype.updateValueIfRequired = function updateValueIfRequired(prevProps) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var focusedElm = ref.focusedElm;
    var stateValue = state.value;
    var lastNumStr = state.numAsString;
    if (lastNumStr === void 0) lastNumStr = ''; // If only state changed no need to do any thing

    if (prevProps !== props) {
      //validate props
      this.validateProps();
      var lastValueWithNewFormat = this.formatNumString(lastNumStr);
      var formattedValue = isNil(props.value) ? lastValueWithNewFormat : this.formatValueProp();
      var numAsString = this.removeFormatting(formattedValue);
      var floatValue = parseFloat(numAsString);
      var lastFloatValue = parseFloat(lastNumStr);

      if ( //while typing set state only when float value changes
      (!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue || //can also set state when float value is same and the format props changes
      lastValueWithNewFormat !== stateValue || //set state always when not in focus and formatted value is changed
      focusedElm === null && formattedValue !== stateValue) {
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: focusedElm
        });
      }
    }
  };
  /** Misc methods **/


  NumberFormat.prototype.getFloatString = function getFloatString(num) {
    if (num === void 0) num = '';
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var numRegex = this.getNumberRegex(true); //remove negation for regex check

    var hasNegation = num[0] === '-';

    if (hasNegation) {
      num = num.replace('-', '');
    } //if decimal scale is zero remove decimal and number after decimalSeparator


    if (decimalSeparator && decimalScale === 0) {
      num = num.split(decimalSeparator)[0];
    }

    num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.'); //remove extra decimals

    var firstDecimalIndex = num.indexOf('.');

    if (firstDecimalIndex !== -1) {
      num = num.substring(0, firstDecimalIndex) + "." + num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), '');
    } //add negation back


    if (hasNegation) {
      num = '-' + num;
    }

    return num;
  }; //returned regex assumes decimalSeparator is as per prop


  NumberFormat.prototype.getNumberRegex = function getNumberRegex(g, ignoreDecimalSeparator) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    return new RegExp('\\d' + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? '|' + escapeRegExp(decimalSeparator) : ''), g ? 'g' : undefined);
  };

  NumberFormat.prototype.getSeparators = function getSeparators() {
    var ref = this.props;
    var decimalSeparator = ref.decimalSeparator;
    var ref$1 = this.props;
    var thousandSeparator = ref$1.thousandSeparator;
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;

    if (thousandSeparator === true) {
      thousandSeparator = ',';
    }

    if (!allowedDecimalSeparators) {
      allowedDecimalSeparators = [decimalSeparator, '.'];
    }

    return {
      decimalSeparator: decimalSeparator,
      thousandSeparator: thousandSeparator,
      allowedDecimalSeparators: allowedDecimalSeparators
    };
  };

  NumberFormat.prototype.getMaskAtIndex = function getMaskAtIndex(index) {
    var ref = this.props;
    var mask = ref.mask;
    if (mask === void 0) mask = ' ';

    if (typeof mask === 'string') {
      return mask;
    }

    return mask[index] || ' ';
  };

  NumberFormat.prototype.getValueObject = function getValueObject(formattedValue, numAsString) {
    var floatValue = parseFloat(numAsString);
    return {
      formattedValue: formattedValue,
      value: numAsString,
      floatValue: isNaN(floatValue) ? undefined : floatValue
    };
  };

  NumberFormat.prototype.validateProps = function validateProps() {
    var ref = this.props;
    var mask = ref.mask; //validate decimalSeparator and thousandSeparator

    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var thousandSeparator = ref$1.thousandSeparator;

    if (decimalSeparator === thousandSeparator) {
      throw new Error("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n       ");
    } //validate mask


    if (mask) {
      var maskAsStr = mask === 'string' ? mask : mask.toString();

      if (maskAsStr.match(/\d/g)) {
        throw new Error("\n          Mask " + mask + " should not contain numeric character;\n        ");
      }
    }
  };
  /** Misc methods end **/

  /** caret specific methods **/


  NumberFormat.prototype.setPatchedCaretPosition = function setPatchedCaretPosition(el, caretPos, currentValue) {
    /* setting caret position within timeout of 0ms is required for mobile chrome,
    otherwise browser resets the caret position after we set it
    We are also setting it without timeout so that in normal browser we don't see the flickering */
    setCaretPosition(el, caretPos);
    setTimeout(function () {
      if (el.value === currentValue) {
        setCaretPosition(el, caretPos);
      }
    }, 0);
  };
  /* This keeps the caret within typing area so people can't type in between prefix or suffix */


  NumberFormat.prototype.correctCaretPosition = function correctCaretPosition(value, caretPos, direction) {
    var ref = this.props;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format; //if value is empty return 0

    if (value === '') {
      return 0;
    } //caret position should be between 0 and value length


    caretPos = clamp(caretPos, 0, value.length); //in case of format as number limit between prefix and suffix

    if (!format) {
      var hasNegation = value[0] === '-';
      return clamp(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
    } //in case if custom format method don't do anything


    if (typeof format === 'function') {
      return caretPos;
    }
    /* in case format is string find the closest # position from the caret position */
    //in case the caretPos have input value on it don't do anything


    if (format[caretPos] === '#' && charIsNumber(value[caretPos])) {
      return caretPos;
    } //if caretPos is just after input value don't do anything


    if (format[caretPos - 1] === '#' && charIsNumber(value[caretPos - 1])) {
      return caretPos;
    } //find the nearest caret position


    var firstHashPosition = format.indexOf('#');
    var lastHashPosition = format.lastIndexOf('#'); //limit the cursor between the first # position and the last # position

    caretPos = clamp(caretPos, firstHashPosition, lastHashPosition + 1);
    var nextPos = format.substring(caretPos, format.length).indexOf('#');
    var caretLeftBound = caretPos;
    var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos); //get the position where the last number is present

    while (caretLeftBound > firstHashPosition && (format[caretLeftBound] !== '#' || !charIsNumber(value[caretLeftBound]))) {
      caretLeftBound -= 1;
    }

    var goToLeft = !charIsNumber(value[caretRightBound]) || direction === 'left' && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBound - caretPos;

    if (goToLeft) {
      //check if number should be taken after the bound or after it
      //if number preceding a valid number keep it after
      return charIsNumber(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
    }

    return caretRightBound;
  };

  NumberFormat.prototype.getCaretPosition = function getCaretPosition(inputValue, formattedValue, caretPos) {
    var ref = this.props;
    var format = ref.format;
    var stateValue = this.state.value;
    var numRegex = this.getNumberRegex(true);
    var inputNumber = (inputValue.match(numRegex) || []).join('');
    var formattedNumber = (formattedValue.match(numRegex) || []).join('');
    var j, i;
    j = 0;

    for (i = 0; i < caretPos; i++) {
      var currentInputChar = inputValue[i] || '';
      var currentFormatChar = formattedValue[j] || ''; //no need to increase new cursor position if formatted value does not have those characters
      //case inputValue = 1a23 and formattedValue =  123

      if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) {
        continue;
      } //When we are striping out leading zeros maintain the new cursor position
      //Case inputValue = 00023 and formattedValue = 23;


      if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) {
        continue;
      } //we are not using currentFormatChar because j can change here


      while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
        j++;
      }

      j++;
    }

    if (typeof format === 'string' && !stateValue) {
      //set it to the maximum value so it goes after the last number
      j = formattedValue.length;
    } //correct caret position if its outside of editable area


    j = this.correctCaretPosition(formattedValue, j);
    return j;
  };
  /** caret specific methods ends **/

  /** methods to remove formattting **/


  NumberFormat.prototype.removePrefixAndSuffix = function removePrefixAndSuffix(val) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix; //remove prefix and suffix

    if (!format && val) {
      var isNegative = val[0] === '-'; //remove negation sign

      if (isNegative) {
        val = val.substring(1, val.length);
      } //remove prefix


      val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val; //remove suffix

      var suffixLastIndex = val.lastIndexOf(suffix);
      val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val; //add negation sign back

      if (isNegative) {
        val = '-' + val;
      }
    }

    return val;
  };

  NumberFormat.prototype.removePatternFormatting = function removePatternFormatting(val) {
    var ref = this.props;
    var format = ref.format;
    var formatArray = format.split('#').filter(function (str) {
      return str !== '';
    });
    var start = 0;
    var numStr = '';

    for (var i = 0, ln = formatArray.length; i <= ln; i++) {
      var part = formatArray[i] || ''; //if i is the last fragment take the index of end of the value
      //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##

      var index = i === ln ? val.length : val.indexOf(part, start);
      /* in any case if we don't find the pattern part in the value assume the val as numeric string
      This will be also in case if user has started typing, in any other case it will not be -1
      unless wrong prop value is provided */

      if (index === -1) {
        numStr = val;
        break;
      } else {
        numStr += val.substring(start, index);
        start = index + part.length;
      }
    }

    return (numStr.match(/\d/g) || []).join('');
  };

  NumberFormat.prototype.removeFormatting = function removeFormatting(val) {
    var ref = this.props;
    var format = ref.format;
    var removeFormatting = ref.removeFormatting;

    if (!val) {
      return val;
    }

    if (!format) {
      val = this.removePrefixAndSuffix(val);
      val = this.getFloatString(val);
    } else if (typeof format === 'string') {
      val = this.removePatternFormatting(val);
    } else if (typeof removeFormatting === 'function') {
      //condition need to be handled if format method is provide,
      val = removeFormatting(val);
    } else {
      val = (val.match(/\d/g) || []).join('');
    }

    return val;
  };
  /** methods to remove formattting end **/

  /*** format specific methods start ***/

  /**
   * Format when # based string is provided
   * @param  {string} numStr Numeric String
   * @return {string}        formatted Value
   */


  NumberFormat.prototype.formatWithPattern = function formatWithPattern(numStr) {
    var ref = this.props;
    var format = ref.format;
    var hashCount = 0;
    var formattedNumberAry = format.split('');

    for (var i = 0, ln = format.length; i < ln; i++) {
      if (format[i] === '#') {
        formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
        hashCount += 1;
      }
    }

    return formattedNumberAry.join('');
  };
  /**
   * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
   * @return {string} formatted Value
   */


  NumberFormat.prototype.formatAsNumber = function formatAsNumber(numStr) {
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var allowNegative = ref.allowNegative;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var ref$1 = this.getSeparators();
    var thousandSeparator = ref$1.thousandSeparator;
    var decimalSeparator = ref$1.decimalSeparator;
    var hasDecimalSeparator = numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;
    var ref$2 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const
    //apply decimal precision if its defined

    if (decimalScale !== undefined) {
      afterDecimal = limitToScale(afterDecimal, decimalScale, fixedDecimalScale);
    }

    if (thousandSeparator) {
      beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    } //add prefix and suffix


    if (prefix) {
      beforeDecimal = prefix + beforeDecimal;
    }

    if (suffix) {
      afterDecimal = afterDecimal + suffix;
    } //restore negation sign


    if (addNegation) {
      beforeDecimal = '-' + beforeDecimal;
    }

    numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
    return numStr;
  };

  NumberFormat.prototype.formatNumString = function formatNumString(numStr) {
    if (numStr === void 0) numStr = '';
    var ref = this.props;
    var format = ref.format;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var formattedValue = numStr;

    if (numStr === '' && !allowEmptyFormatting) {
      formattedValue = '';
    } else if (numStr === '-' && !format) {
      formattedValue = '-';
    } else if (typeof format === 'string') {
      formattedValue = this.formatWithPattern(formattedValue);
    } else if (typeof format === 'function') {
      formattedValue = format(formattedValue);
    } else {
      formattedValue = this.formatAsNumber(formattedValue);
    }

    return formattedValue;
  };

  NumberFormat.prototype.formatValueProp = function formatValueProp(defaultValue) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var ref$1 = this.props;
    var value = ref$1.value;
    var isNumericString = ref$1.isNumericString; // if value is undefined or null, use defaultValue instead

    value = isNil(value) ? defaultValue : value;
    var isNonNumericFalsy = !value && value !== 0;

    if (isNonNumericFalsy && allowEmptyFormatting) {
      value = '';
    } // if value is not defined return empty string


    if (isNonNumericFalsy && !allowEmptyFormatting) {
      return '';
    }

    if (typeof value === 'number') {
      value = toNumericString(value);
      isNumericString = true;
    } //change infinity value to empty string


    if (value === 'Infinity' && isNumericString) {
      value = '';
    } //round the number based on decimalScale
    //format only if non formatted value is provided


    if (isNumericString && !format && typeof decimalScale === 'number') {
      value = roundToPrecision(value, decimalScale, fixedDecimalScale);
    }

    var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);
    return formattedValue;
  };

  NumberFormat.prototype.formatNegation = function formatNegation(value) {
    if (value === void 0) value = '';
    var ref = this.props;
    var allowNegative = ref.allowNegative;
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)'); // Check number has '-' value

    var hasNegation = negationRegex.test(value); // Check number has 2 or more '-' values

    var removeNegation = doubleNegationRegex.test(value); //remove negation

    value = value.replace(/-/g, '');

    if (hasNegation && !removeNegation && allowNegative) {
      value = '-' + value;
    }

    return value;
  };

  NumberFormat.prototype.formatInput = function formatInput(value) {
    if (value === void 0) value = '';
    var ref = this.props;
    var format = ref.format; //format negation only if we are formatting as number

    if (!format) {
      value = this.removePrefixAndSuffix(value);
      value = this.formatNegation(value);
    } //remove formatting from number


    value = this.removeFormatting(value);
    return this.formatNumString(value);
  };
  /*** format specific methods end ***/


  NumberFormat.prototype.isCharacterAFormat = function isCharacterAFormat(caretPos, value) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator; //check within format pattern

    if (typeof format === 'string' && format[caretPos] !== '#') {
      return true;
    } //check in number format


    if (!format && (caretPos < prefix.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) {
      return true;
    }

    return false;
  };

  NumberFormat.prototype.checkIfFormatGotDeleted = function checkIfFormatGotDeleted(start, end, value) {
    for (var i = start; i < end; i++) {
      if (this.isCharacterAFormat(i, value)) {
        return true;
      }
    }

    return false;
  };
  /**
   * This will check if any formatting got removed by the delete or backspace and reset the value
   * It will also work as fallback if android chome keyDown handler does not work
   **/


  NumberFormat.prototype.correctInputValue = function correctInputValue(caretPos, lastValue, value) {
    var ref = this.props;
    var format = ref.format;
    var allowNegative = ref.allowNegative;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
    var decimalSeparator = ref$1.decimalSeparator;
    var lastNumStr = this.state.numAsString || '';
    var ref$2 = this.selectionBeforeInput;
    var selectionStart = ref$2.selectionStart;
    var selectionEnd = ref$2.selectionEnd;
    var ref$3 = findChangedIndex(lastValue, value);
    var start = ref$3.start;
    var end = ref$3.end;
    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */

    if (!format && start === end && allowedDecimalSeparators.indexOf(value[selectionStart]) !== -1) {
      var separator = decimalScale === 0 ? '' : decimalSeparator;
      return value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length);
    }

    var leftBound = !!format ? 0 : prefix.length;
    var rightBound = lastValue.length - (!!format ? 0 : suffix.length);

    if ( // don't do anything if something got added
    value.length > lastValue.length || // or if the new value is an empty string
    !value.length || // or if nothing has changed, in which case start will be same as end
    start === end || // or in case if whole input is selected and new value is typed
    selectionStart === 0 && selectionEnd === lastValue.length || // or in case if the whole content is replaced by browser, example (autocomplete)
    start === 0 && end === lastValue.length || // or if charcters between prefix and suffix is selected.
    // For numeric inputs we apply the format so, prefix and suffix can be ignored
    selectionStart === leftBound && selectionEnd === rightBound) {
      return value;
    } //if format got deleted reset the value to last value


    if (this.checkIfFormatGotDeleted(start, end, lastValue)) {
      value = lastValue;
    } //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign


    if (!format) {
      var numericString = this.removeFormatting(value);
      var ref$4 = splitDecimal(numericString, allowNegative);
      var beforeDecimal = ref$4.beforeDecimal;
      var afterDecimal = ref$4.afterDecimal;
      var addNegation = ref$4.addNegation; // eslint-disable-line prefer-const
      //clear only if something got deleted

      var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;

      if (numericString.length < lastNumStr.length && isBeforeDecimalPoint && beforeDecimal === '' && !parseFloat(afterDecimal)) {
        return addNegation ? '-' : '';
      }
    }

    return value;
  };
  /** Update value and caret position */


  NumberFormat.prototype.updateValue = function updateValue(params) {
    var formattedValue = params.formattedValue;
    var input = params.input;
    var setCaretPosition = params.setCaretPosition;
    if (setCaretPosition === void 0) setCaretPosition = true;
    var numAsString = params.numAsString;
    var caretPos = params.caretPos;
    var ref = this.props;
    var onValueChange = ref.onValueChange;
    var ref$1 = this.state;
    var lastValue = ref$1.value;

    if (input) {
      //set caret position, and value imperatively when element is provided
      if (setCaretPosition) {
        //calculate caret position if not defined
        if (!caretPos) {
          var inputValue = params.inputValue || input.value;
          var currentCaretPosition = getCurrentCaretPosition(input);
          /**
           * set the value imperatively, this is required for IE fix
           * This is also required as if new caret position is beyond the previous value.
           * Caret position will not be set correctly
           */

          input.value = formattedValue; //get the caret position

          caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
        } //set caret position


        this.setPatchedCaretPosition(input, caretPos, formattedValue);
      } else {
        /**
         * if we are not setting caret position set the value imperatively.
         * This is required on onBlur method
         */
        input.value = formattedValue;
      }
    } //calculate numeric string if not passed


    if (numAsString === undefined) {
      numAsString = this.removeFormatting(formattedValue);
    } //update state if value is changed


    if (formattedValue !== lastValue) {
      this.setState({
        value: formattedValue,
        numAsString: numAsString
      }); // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287

      onValueChange(this.getValueObject(formattedValue, numAsString));
    }
  };

  NumberFormat.prototype.onChange = function onChange(e) {
    var el = e.target;
    var inputValue = el.value;
    var ref = this;
    var state = ref.state;
    var props = ref.props;
    var isAllowed = props.isAllowed;
    var lastValue = state.value || '';
    var currentCaretPosition = getCurrentCaretPosition(el);
    inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);
    var formattedValue = this.formatInput(inputValue) || '';
    var numAsString = this.removeFormatting(formattedValue);
    var valueObj = this.getValueObject(formattedValue, numAsString);
    var isChangeAllowed = isAllowed(valueObj);

    if (!isChangeAllowed) {
      formattedValue = lastValue;
    }

    this.updateValue({
      formattedValue: formattedValue,
      numAsString: numAsString,
      inputValue: inputValue,
      input: el
    });

    if (isChangeAllowed) {
      props.onChange(e);
    }
  };

  NumberFormat.prototype.onBlur = function onBlur(e) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var format = props.format;
    var onBlur = props.onBlur;
    var allowLeadingZeros = props.allowLeadingZeros;
    var numAsString = state.numAsString;
    var lastValue = state.value;
    this.focusedElm = null;
    clearTimeout(this.focusTimeout);

    if (!format) {
      // if the numAsString is not a valid number reset it to empty
      if (isNaN(parseFloat(numAsString))) {
        numAsString = '';
      }

      if (!allowLeadingZeros) {
        numAsString = fixLeadingZero(numAsString);
      }

      var formattedValue = this.formatNumString(numAsString); //change the state

      if (formattedValue !== lastValue) {
        // the event needs to be persisted because its properties can be accessed in an asynchronous way
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: e.target,
          setCaretPosition: false
        });
        onBlur(e);
        return;
      }
    }

    onBlur(e);
  };

  NumberFormat.prototype.onKeyDown = function onKeyDown(e) {
    var el = e.target;
    var key = e.key;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value;
    if (value === void 0) value = '';
    var expectedCaretPosition;
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;
    var onKeyDown = ref.onKeyDown;
    var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
    var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
    var negativeRegex = new RegExp('-');
    var isPatternFormat = typeof format === 'string';
    this.selectionBeforeInput = {
      selectionStart: selectionStart,
      selectionEnd: selectionEnd
    }; //Handle backspace and delete against non numerical/decimal characters or arrow keys

    if (key === 'ArrowLeft' || key === 'Backspace') {
      expectedCaretPosition = selectionStart - 1;
    } else if (key === 'ArrowRight') {
      expectedCaretPosition = selectionStart + 1;
    } else if (key === 'Delete') {
      expectedCaretPosition = selectionStart;
    } //if expectedCaretPosition is not set it means we don't want to Handle keyDown
    //also if multiple characters are selected don't handle


    if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
      onKeyDown(e);
      return;
    }

    var newCaretPosition = expectedCaretPosition;
    var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
    var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

    if (key === 'ArrowLeft' || key === 'ArrowRight') {
      var direction = key === 'ArrowLeft' ? 'left' : 'right';
      newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
    } else if (key === 'Delete' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
      while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
        newCaretPosition++;
      }
    } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
      /* NOTE: This is special case when backspace is pressed on a
      negative value while the cursor position is after prefix. We can't handle it on onChange because
      we will not have any information of keyPress
      */
      if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
        var newValue = value.substring(1);
        this.updateValue({
          formattedValue: newValue,
          caretPos: newCaretPosition,
          input: el
        });
      } else if (!negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
          newCaretPosition--;
        }

        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
      }
    }

    if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
      e.preventDefault();
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }
    /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
            Remove this when you find different solution */


    if (e.isUnitTestRun) {
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    onKeyDown(e);
  };
  /** required to handle the caret position when click anywhere within the input **/


  NumberFormat.prototype.onMouseUp = function onMouseUp(e) {
    var el = e.target;
    /**
     * NOTE: we have to give default value for value as in case when custom input is provided
     * value can come as undefined when nothing is provided on value prop.
     */

    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value;
    if (value === void 0) value = '';

    if (selectionStart === selectionEnd) {
      var caretPosition = this.correctCaretPosition(value, selectionStart);

      if (caretPosition !== selectionStart) {
        this.setPatchedCaretPosition(el, caretPosition, value);
      }
    }

    this.props.onMouseUp(e);
  };

  NumberFormat.prototype.onFocus = function onFocus(e) {
    var this$1$1 = this; // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
    // (onFocus event target selectionStart is always 0 before setTimeout)

    e.persist();
    this.focusedElm = e.target;
    this.focusTimeout = setTimeout(function () {
      var el = e.target;
      var selectionStart = el.selectionStart;
      var selectionEnd = el.selectionEnd;
      var value = el.value;
      if (value === void 0) value = '';
      var caretPosition = this$1$1.correctCaretPosition(value, selectionStart); //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)

      if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) {
        this$1$1.setPatchedCaretPosition(el, caretPosition, value);
      }

      this$1$1.props.onFocus(e);
    }, 0);
  };

  NumberFormat.prototype.render = function render() {
    var ref = this.props;
    var type = ref.type;
    var displayType = ref.displayType;
    var customInput = ref.customInput;
    var renderText = ref.renderText;
    var getInputRef = ref.getInputRef;
    var format = ref.format;
    var ref$1 = this.state;
    var value = ref$1.value;
    var mounted = ref$1.mounted;
    var otherProps = omit(this.props, propTypes$1$1); // add input mode on element based on format prop and device once the component is mounted

    var inputMode = mounted && addInputMode(format) ? 'numeric' : undefined;
    var inputProps = Object.assign({
      inputMode: inputMode
    }, otherProps, {
      type: type,
      value: value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur
    });

    if (displayType === 'text') {
      return renderText ? renderText(value, otherProps) || null : React__default.createElement('span', Object.assign({}, otherProps, {
        ref: getInputRef
      }), value);
    } else if (customInput) {
      var CustomInput = customInput;
      return React__default.createElement(CustomInput, Object.assign({}, inputProps, {
        ref: getInputRef
      }));
    }

    return React__default.createElement('input', Object.assign({}, inputProps, {
      ref: getInputRef
    }));
  };

  return NumberFormat;
}(React__default.Component);

NumberFormat.propTypes = propTypes$1$1;
NumberFormat.defaultProps = defaultProps;

const _excluded$i = ["onChange", "decimalScale"],
      _excluded2$3 = ["onChange", "value", "min", "max", "left", "right", "decimalScale"];
const DollarFormat = forwardRef((props, ref) => {
  const {
    onChange,
    decimalScale
  } = props,
        other = _objectWithoutPropertiesLoose$2(props, _excluded$i);

  return React__default.createElement(NumberFormat, _extends$1({}, other, {
    type: "text",
    getInputRef: ref,
    onValueChange: values => {
      onChange({
        formattedValue: values.formattedValue,
        value: values.floatValue
      });
    },
    isAllowed: values => {
      const {
        formattedValue,
        floatValue
      } = values;

      if (floatValue == null) {
        return formattedValue === '';
      } else {
        return floatValue >= props.min && floatValue <= props.max;
      }
    },
    thousandSeparator: true,
    decimalScale: decimalScale,
    isNumericString: true
  }));
});
const InputCurrency = forwardRef((_ref, ref) => {
  let {
    onChange,
    value,
    min = 0,
    max = Infinity,
    left = '$',
    right = 'USD',
    decimalScale = 0
  } = _ref,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded2$3);

  const [internalValue, setInternalValue] = useState(value || min || 0);

  const _onChange = ({
    value
  }) => {
    setInternalValue(value);
    onChange(value);
  };

  const debounced = React__default.useMemo(() => debounce$1(500, setInternalValue), [setInternalValue]);
  useEffect(() => {
    debounced(value);
  }, [value]);
  return React__default.createElement(BaseInput, _extends$1({
    ref: ref,
    left: left,
    right: right,
    decimalScale: decimalScale,
    onChange: _onChange,
    as: DollarFormat
  }, rest, {
    min: min,
    max: max,
    type: "text",
    value: internalValue
  }));
});

const _excluded$h = ["onChange", "decimalScale"],
      _excluded2$2 = ["onChange", "value", "min", "max", "right", "left", "decimalScale"];
const PercentageFormat = forwardRef((props, ref) => {
  const {
    onChange,
    decimalScale
  } = props,
        other = _objectWithoutPropertiesLoose$2(props, _excluded$h);

  return React__default.createElement(NumberFormat, _extends$1({
    ref: ref
  }, other, {
    type: "text",
    onValueChange: values => {
      onChange({
        formattedValue: values.formattedValue,
        value: values.floatValue
      });
    },
    isAllowed: values => {
      const {
        formattedValue,
        floatValue
      } = values;

      if (floatValue === null || floatValue === undefined) {
        return formattedValue === '';
      } else {
        return floatValue >= props.min && floatValue <= props.max;
      }
    },
    isNumericString: true,
    allowLeadingZeros: true,
    fixedDecimalScale: true,
    decimalScale: decimalScale,
    allowEmptyFormatting: true
  }));
});
const InputPercent = forwardRef((_ref, ref) => {
  let {
    onChange,
    value,
    min = 0,
    max = 100,
    right = '%',
    left = null,
    decimalScale = 1
  } = _ref,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded2$2);

  const [internalValue, setInternalValue] = useState(`${value || min}`);

  const _onChange = ({
    formattedValue,
    value
  }) => {
    setInternalValue(formattedValue);
    onChange(value);
  };

  const debounced = React__default.useMemo(() => debounce$1(500, setInternalValue), [setInternalValue]);
  useEffect(() => {
    debounced(`${value}`);
  }, [value]); //eslint-disable-line

  return React__default.createElement(BaseInput, _extends$1({
    ref: ref,
    left: left,
    right: right,
    decimalScale: decimalScale,
    onChange: _onChange,
    onBlur: () => {
      if (!value) setInternalValue('0');
    },
    as: PercentageFormat
  }, rest, {
    min: min,
    max: max,
    type: "number",
    inputMode: "decimal",
    value: internalValue
  }));
});

const InputDual = React__default.memo(forwardRef(({
  baseValue: _baseValue = 0,
  amount: _amount = 0,
  sx: _sx = {},
  onChange,
  onChangePercent,
  onChangeDecimal,
  hasErrors,
  required
}, ref) => {
  const [dollars, setDollars] = useState(_amount / 100 * _baseValue);
  const [percent, setPercent] = useState(_amount);

  const onDollarChange = (value = 0) => setDollars(value);

  const onDollarBlur = () => {
    const percent = dollars / _baseValue * 100;
    if (onChange) onChange({
      percent,
      decimal: dollars
    });
    if (onChangeDecimal) onChangeDecimal(dollars);
    if (onChangePercent) onChangePercent(percent);
  };

  const onPercentChange = (value = 0) => {
    setPercent(value);
  };

  const onBlur = () => {
    const value = percent / 100 * _baseValue;
    setDollars(value);
    if (onChange) onChange({
      percent: percent,
      decimal: value
    });
    if (onChangeDecimal) onChangeDecimal(dollars);
    if (onChangePercent) onChangePercent(percent);
  };

  const debounceSetPercent = React__default.useMemo(() => debounce$1(500, setPercent), [setPercent]);
  const debounceSetDollars = React__default.useMemo(() => debounce$1(500, setDollars), [setDollars]);
  useEffect(() => {
    debounceSetPercent(_amount);
    debounceSetDollars(_amount / 100 * _baseValue);
  }, [_baseValue, _amount]);
  return React__default.createElement(Flex, {
    ref: ref,
    sx: _extends$1({
      width: '100%'
    }, _sx)
  }, React__default.createElement(Grid, {
    sx: {
      width: '100%',
      gap: 0,
      gridTemplateColumns: {
        base: '1fr 1fr',
        xl: 'minmax(auto, 60%) minmax(auto, 40%)'
      }
    }
  }, React__default.createElement(InputCurrency, {
    min: 0,
    max: _baseValue,
    right: null,
    value: dollars,
    onChange: onDollarChange,
    onBlur: onDollarBlur,
    sx: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    hasErrors: hasErrors,
    required: required
  }), React__default.createElement(InputPercent, {
    min: 0,
    max: 100,
    value: percent,
    onChange: onPercentChange,
    onBlur: onBlur,
    sx: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },
    hasErrors: hasErrors,
    required: required
  })));
}));

const _excluded$g = ["onChange"];

const EyeOnIcon = props => React__default.createElement("svg", _extends$1({
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, props), React__default.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
}), React__default.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
}));

const EyeOffIcon = props => React__default.createElement("svg", _extends$1({
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, props), React__default.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
}));

const InputPassword = forwardRef((_ref, ref) => {
  let {
    onChange
  } = _ref,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$g);

  const [showPassword, toggleShowPassword] = useState(false);
  return React__default.createElement(BaseInput, _extends$1({
    ref: ref,
    right: React__default.createElement(Box, {
      as: showPassword ? EyeOnIcon : EyeOffIcon,
      onClick: () => toggleShowPassword(!showPassword),
      sx: {
        flexShrink: 0,
        width: '18px',
        height: '18px',
        display: 'inline-flex',
        color: 'gray.400',
        cursor: 'pointer',
        '&:hover': {
          color: 'gray.700'
        }
      }
    }),
    onChange: onChange
  }, rest, {
    type: showPassword ? 'text' : 'password'
  }));
});

const _excluded$f = ["as", "type", "label", "name", "errors", "formatErrors", "sx", "required", "tooltip", "helperText"];
const Field = forwardRef((_ref, ref) => {
  let {
    as: Control = InputWithAdornment,
    type,
    label,
    name,
    errors,
    formatErrors = errors => errors.map((e, i) => React__default.createElement(Box, {
      key: i
    }, "* ", e)),
    sx = {},
    required = false,
    tooltip,
    helperText
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$f);

  return React__default.createElement(Box, {
    sx: _extends$1({
      mb: 4,
      width: '100%'
    }, sx)
  }, React__default.createElement(Label, {
    htmlFor: name,
    tooltip: tooltip,
    sx: {
      mb: tooltip ? 0 : 2,
      fontWeight: 'bold',
      text: {
        base: 'sm',
        sm: 'base'
      },
      width: 'auto'
    }
  }, label, required && React__default.createElement(Text, {
    sx: {
      ml: 1,
      color: 'red.500'
    }
  }, "*")), React__default.createElement(Control, _extends$1({
    ref: ref,
    id: name,
    type: type,
    name: name,
    required: required,
    hasErrors: !!errors,
    sx: {
      marginTop: tooltip ? 2 : 0
    }
  }, props)), helperText && !(errors != null && errors.length) && React__default.createElement(Box, {
    text: "xs",
    sx: {
      color: 'gray.500',
      mt: 2
    }
  }, helperText), errors && React__default.createElement(Box, {
    text: "xs",
    sx: {
      color: 'red.600',
      mt: 2
    }
  }, formatErrors(errors)));
});

const _excluded$e = ["size"],
      _excluded2$1 = ["width", "height"];
const SVG = _ref => {
  let {
    size = '24px'
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$e);

  const {
    width = size,
    height = size
  } = props,
        rest = _objectWithoutPropertiesLoose$2(props, _excluded2$1);

  return (//@ts-ignore
    React__default.createElement(Box, _extends$1({
      as: "svg",
      xmlns: "http://www.w3.org/2000/svg",
      width: width,
      height: height,
      viewBox: "0 0 24 24",
      fill: "currentColor"
    }, rest))
  );
};

const _excluded$d = ["children", "checked", "sx", "checkedSx", "variant"];

const RadioChecked = props => React__default.createElement(SVG, _extends$1({}, props), React__default.createElement("path", {
  d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}));

const RadioUnchecked = props => React__default.createElement(SVG, _extends$1({}, props), React__default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}));

const RadioIcon = props => React__default.createElement(React__default.Fragment, null, React__default.createElement(RadioChecked, _extends$1({}, props, {
  sx: {
    display: 'none',
    'input:checked ~ &': {
      display: 'inline-block'
    }
  }
})), React__default.createElement(RadioUnchecked, _extends$1({}, props, {
  sx: {
    display: 'inline-block',
    'input:checked ~ &': {
      display: 'none'
    }
  }
})));

const Radio = forwardRef(function Radio(props, ref) {
  return React__default.createElement(Box, {
    sx: {
      cursor: 'pointer',
      display: 'inline-flex'
    }
  }, React__default.createElement(Box, _extends$1({
    ref: ref,
    as: "input"
  }, props, {
    type: "radio",
    sx: {
      position: 'absolute',
      opacity: 0,
      zIndex: -1,
      width: 1,
      height: 1,
      overflow: 'hidden'
    }
  })), React__default.createElement(Box, {
    as: RadioIcon,
    "aria-hidden": "true",
    sx: {
      mr: 2,
      borderRadius: 9999,
      color: 'black',
      'input:checked ~ &': {
        color: 'green.700'
      },
      'input:focus ~ &': {
        bg: 'white'
      }
    }
  }));
});
const RadioGroup = ({
  onChange,
  value,
  children
}) => {
  return React__default.createElement(React__default.Fragment, null, React__default.Children.map(children, child => {
    // @ts-ignore
    const el = React__default.cloneElement(child, {
      onChange: onChange,
      // @ts-ignore
      checked: child.props.value === value
    });
    return el;
  }));
};
const RadioButton = forwardRef(function RadioButton(_ref, ref) {
  let {
    children,
    checked,
    sx,
    checkedSx = {
      backgroundColor: 'gray.100',
      borderColor: 'gray.700'
    },
    variant = 'tertiary'
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$d);

  return React__default.createElement(Button, _extends$1({
    ref: ref,
    sx: _extends$1({
      borderColor: 'gray.300',
      color: 'gray.700',
      fontWeight: 'normal'
    }, sx, checked && checkedSx),
    variant: variant
  }, props), children);
});

const _excluded$c = ["children"],
      _excluded2 = ["hasErrors", "onFocus", "onBlur", "onChange", "sxSelect", "sx"];

const DownArrow = props => React__default.createElement("svg", _extends$1({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "24px",
  width: "24px",
  fill: "none",
  stroke: "currentColor"
}, props), React__default.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M19 9l-7 7-7-7"
}));

const SelectItem = _ref => {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$c);

  return React__default.createElement(Box, _extends$1({
    as: "option"
  }, props), children);
};
const Select = forwardRef((props, ref) => {
  const {
    hasErrors = false,
    onFocus = null,
    onBlur = null,
    onChange = () => {},
    sxSelect = {},
    sx = {}
  } = props,
        rest = _objectWithoutPropertiesLoose$2(props, _excluded2);

  const [isFocused, setFocused] = React__default.useState(false);
  const borderColor = hasErrors ? 'red.500' : isFocused ? 'green.500' : 'gray.300';
  return React__default.createElement(Box, {
    sx: _extends$1({
      display: 'inline-flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      py: 1,
      px: 3,
      border: '1px solid',
      borderColor,
      bg: 'white',
      boxShadow: '0px 1px 0px #D8D9DB',
      borderRadius: 'lg',
      position: 'relative'
    }, sx),
    onFocus: e => {
      setFocused(true);
      onFocus && onFocus(e);
    },
    onBlur: e => {
      setFocused(false);
      onBlur && onBlur(e);
    }
  }, React__default.createElement(Box, _extends$1({
    ref: ref,
    as: "select",
    sx: _extends$1({
      appearance: 'none',
      bg: 'white',
      borderRadius: 'lg',
      color: 'gray.700',
      cursor: 'pointer',
      display: 'block',
      fontSize: 'inherit',
      lineHeight: '1.625rem',
      outline: 0,
      p: 2,
      width: '100%'
    }, sxSelect, {
      paddingRight: 8 // so the down arrow is 'clickable'

    }),
    onChange: onChange
  }, rest)), React__default.createElement(Box, {
    as: DownArrow,
    sx: {
      alignSelf: 'center',
      pointerEvents: 'none',
      color: 'gray.500',
      display: 'inline-flex',
      position: 'absolute',
      right: 3,
      cursor: 'pointer'
    }
  }));
});

const _excluded$b = ["sx"];
const Textarea = forwardRef((_ref, ref) => {
  let {
    sx = {}
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$b);

  return React__default.createElement(Box, _extends$1({
    ref: ref,
    as: "textarea"
  }, props, {
    sx: _extends$1({
      display: 'block',
      width: '100%',
      p: 2,
      my: 2,
      appearance: 'none',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      border: '1px solid',
      borderColor: '#c4c4c4',
      borderRadius: 'lg',
      color: 'inherit',
      bg: 'transparent',
      resize: 'none'
    }, sx)
  }));
});

const CheckboxChecked = props => React__default.createElement(SVG, _extends$1({}, props), React__default.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}));

const CheckboxUnchecked = props => React__default.createElement(SVG, _extends$1({}, props), React__default.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}));

const CheckboxIcon = props => React__default.createElement(React__default.Fragment, null, React__default.createElement(CheckboxChecked, _extends$1({}, props, {
  sx: {
    display: 'none',
    'input:checked ~ &': {
      display: 'inline-block'
    }
  }
})), React__default.createElement(CheckboxUnchecked, _extends$1({}, props, {
  sx: {
    display: 'inline-block',
    'input:checked ~ &': {
      display: 'none'
    }
  }
})));

const Checkbox = forwardRef((props, ref) => {
  return React__default.createElement(Box, {
    sx: {
      display: 'inline-flex',
      cursor: 'pointer'
    }
  }, React__default.createElement(Box, _extends$1({
    ref: ref,
    as: "input",
    type: "checkbox"
  }, props, {
    sx: {
      position: 'absolute',
      opacity: 0,
      zIndex: -1,
      width: 1,
      height: 1,
      overflow: 'hidden'
    }
  })), React__default.createElement(Box, {
    as: CheckboxIcon,
    "aria-hidden": "true",
    sx: {
      mr: 2,
      mt: -1,
      borderRadius: 4,
      color: 'black',
      'input:checked ~ &': {
        // color: 'awning.primary',
        color: 'green.700'
      },
      'input:focus ~ &': {
        bg: 'white' // color: 'purple.600',

      }
    }
  }));
});

const getPercentage = (current, max) => 100 * current / max;

const getValue = (percentage, max) => max / 100 * percentage;

const getLeft = (percentage, offset = '0px') => `calc(${percentage}% + ${offset})`;

const Slider = forwardRef(function Slider(props, ref) {
  const {
    min,
    max,
    value,
    onChange
  } = props;
  const sliderRef = useRef(null);
  const thumbRef = useRef(null);
  const trackRef = useRef(null);
  const diff = useRef(0);

  const handleMouseMove = e => {
    e.stopPropagation();
    e.preventDefault();
    if (!sliderRef.current || !thumbRef.current || !trackRef.current) return;
    const values = getValues(e.clientX);
    if (!values) return;
    let [newPercentage, newValue] = values;
    setPositions({
      thumbLeft: getLeft(newPercentage, '-14px'),
      trackWidth: getLeft(newPercentage)
    });
    onChange(`${newValue}`);
  };

  const handleTouchMove = e => {
    e.stopPropagation();
    e.preventDefault();
    if (!sliderRef.current || !thumbRef.current || !trackRef.current) return;
    const values = getValues(e.touches[0].clientX);
    if (!values) return;
    let [newPercentage, newValue] = values;
    setPositions({
      thumbLeft: getLeft(newPercentage, '-14px'),
      trackWidth: getLeft(newPercentage)
    });
    onChange(`${newValue}`);
  };

  const handleMouseUp = () => {
    document.removeEventListener('mouseup', handleMouseUp);
    document.removeEventListener('mousemove', handleMouseMove);
  };

  const handleMouseDown = e => {
    e.stopPropagation();
    e.preventDefault();
    if (!thumbRef.current) return;
    diff.current = e.clientX - thumbRef.current.getBoundingClientRect().left;
    document.addEventListener('mousemove', handleMouseMove, false);
    document.addEventListener('mouseup', handleMouseUp, false);
  };

  const handleTouchEnd = () => {
    document.removeEventListener('touchend', handleMouseUp);
    document.removeEventListener('touchmove', handleTouchMove);
  };

  const handleTouchStart = e => {
    e.stopPropagation();
    e.preventDefault();
    if (!thumbRef.current) return;
    diff.current = e.touches[0].clientX - thumbRef.current.getBoundingClientRect().left;
    document.addEventListener('touchmove', handleTouchMove, false);
    document.addEventListener('touchend', handleTouchEnd, false);
  };

  const getValues = clientX => {
    if (!sliderRef.current || !thumbRef.current || !trackRef.current) return;
    let newX = clientX - diff.current - sliderRef.current.getBoundingClientRect().left;
    const end = sliderRef.current.offsetWidth - thumbRef.current.offsetWidth;
    const start = sliderRef.current.offsetWidth * min / 100;
    if (newX < start) newX = start;
    if (newX > end) newX = end;
    const newPercentage = getPercentage(newX, end);
    const newValue = getValue(newPercentage, max);
    return [newPercentage, newValue];
  };

  const handleSliderClick = e => {
    var _thumbRef$current;

    e.stopPropagation();
    e.preventDefault();
    if (!sliderRef.current || !thumbRef.current || !trackRef.current) return;
    const values = getValues(e.clientX);
    if (!values) return;
    let [newPercentage, newValue] = values;
    setPositions({
      thumbLeft: getLeft(newPercentage, `-${((_thumbRef$current = thumbRef.current) == null ? void 0 : _thumbRef$current.offsetWidth) - 2}px`),
      trackWidth: getLeft(newPercentage)
    });
    onChange(`${newValue}`);
  };

  const [positions, setPositions] = React__default.useState({
    trackWidth: getLeft(getPercentage(value, max)),
    thumbLeft: getLeft(getPercentage(value, max), '-14px')
  });
  React__default.useEffect(() => {
    setPositions(() => ({
      trackWidth: getLeft(getPercentage(value, max)),
      thumbLeft: getLeft(getPercentage(value, max), '-14px')
    }));
  }, [value, max]);
  return React__default.createElement(Flex, {
    sx: {
      flexDirection: 'column'
    }
  }, React__default.createElement(Flex, {
    sx: {
      width: '100%',
      position: 'relative',
      alignItems: 'center',
      alignContent: 'center'
    },
    ref: sliderRef,
    onMouseDown: handleSliderClick
  }, React__default.createElement(Box, {
    ref: trackRef,
    sx: {
      display: 'inline-flex',
      position: 'absolute',
      width: positions.trackWidth,
      height: '10px',
      cursor: 'pointer',
      appearance: 'none',
      borderBottomLeftRadius: 9999,
      borderTopLeftRadius: 9999,
      bg: 'green.700'
    }
  }), React__default.createElement(Box, {
    sx: {
      display: 'inline-flex',
      width: '100%',
      height: '10px',
      cursor: 'pointer',
      appearance: 'none',
      borderRadius: 9999,
      bg: 'green.200'
    }
  }), React__default.createElement(Box, {
    sx: {
      cursor: 'pointer',
      appearance: 'none',
      width: '28px',
      height: '28px',
      bg: 'white',
      border: '3px solid',
      borderColor: 'gray.300',
      borderRadius: 9999,
      position: 'absolute',
      left: positions.thumbLeft
    },
    ref: thumbRef,
    onMouseDown: handleMouseDown,
    onTouchStart: handleTouchStart
  }, React__default.createElement(Box, {
    ref: ref,
    as: "input",
    name: props.name,
    min: min,
    max: max,
    type: "range",
    defaultValue: value,
    sx: {
      appearance: 'none',
      width: '10px',
      height: '10px',
      position: 'absolute',
      left: 0,
      visibility: 'hidden'
    }
  }))), React__default.createElement(Flex, {
    sx: {
      justifyContent: 'space-between',
      mt: 3
    }
  }, React__default.createElement(Box, null, min, "%"), React__default.createElement(Box, null, max, "%")));
});

const _excluded$a = ["checked"];
const Switch = forwardRef((_ref, ref) => {
  let {
    checked
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$a);

  return React__default.createElement(Box, _extends$1({
    ref: ref,
    as: "button",
    type: "button",
    role: "switch",
    variant: "switch",
    "aria-checked": checked
  }, props, {
    sx: {
      appearance: 'none',
      m: 0,
      p: 0,
      width: 40,
      height: 24,
      color: 'primary',
      bg: 'transparent',
      border: '1px solid',
      borderColor: 'primary',
      borderRadius: 9999,
      '&[aria-checked=true]': {
        bg: 'primary'
      },
      ':focus': {
        outline: 'none',
        boxShadow: '0 0 0 2px'
      }
    }
  }), React__default.createElement(Box, {
    "aria-hidden": true,
    sx: {
      mt: '-1px',
      ml: '-1px',
      width: 24,
      height: 24,
      borderRadius: 9999,
      border: '1px solid',
      borderColor: 'primary',
      bg: 'background',
      transform: checked ? 'translateX(16px)' : 'translateX(0)',
      transitionProperty: 'transform',
      transitionTimingFunction: 'ease-out',
      transitionDuration: '0.1s',
      variant: 'forms.switch.thumb'
    }
  }));
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function isAsyncMode(a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k;
};

var isContextProvider = function isContextProvider(a) {
  return z(a) === h;
};

var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};

var isFragment = function isFragment(a) {
  return z(a) === e;
};

var isLazy = function isLazy(a) {
  return z(a) === t;
};

var isMemo = function isMemo(a) {
  return z(a) === r;
};

var isPortal = function isPortal(a) {
  return z(a) === d;
};

var isProfiler = function isProfiler(a) {
  return z(a) === g;
};

var isStrictMode = function isStrictMode(a) {
  return z(a) === f;
};

var isSuspense = function isSuspense(a) {
  return z(a) === p;
};

var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
createCommonjsModule(function (module, exports) {
});

createCommonjsModule(function (module) {

  {
    module.exports = reactIs_production_min;
  }
});

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var propTypes = createCommonjsModule(function (module) {
  {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
var classnames = createCommonjsModule(function (module) {
  /* global define */
  (function () {

    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);

            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf$1(subClass, superClass);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
/**
* Check whether some DOM node is our Component's node.
*/


function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */


function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */


function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in


var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();
var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose$1(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return findDOMNode(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized$1(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized$1(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };
    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */


    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;
    /**
     * Pass-through render
     */


    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;

      var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return createElement(WrappedComponent, props);
    };

    return onClickOutside;
  }(Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}

var reactOnclickoutside_es = {
	__proto__: null,
	'default': onClickOutsideHOC,
	IGNORE_CLASS_NAME: IGNORE_CLASS_NAME
};

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var toStr$4 = Object.prototype.toString;

var isArguments$1 = function isArguments(value) {
  var str = toStr$4.call(value);
  var isArgs = str === '[object Arguments]';

  if (!isArgs) {
    isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr$4.call(value.callee) === '[object Function]';
  }

  return isArgs;
};

var keysShim$1;

if (!Object.keys) {
  // modified from https://github.com/es-shims/es5-shim
  var has$1 = Object.prototype.hasOwnProperty;
  var toStr$3 = Object.prototype.toString;
  var isArgs = isArguments$1; // eslint-disable-line global-require

  var isEnumerable = Object.prototype.propertyIsEnumerable;
  var hasDontEnumBug = !isEnumerable.call({
    toString: null
  }, 'toString');
  var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
  var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];

  var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
    var ctor = o.constructor;
    return ctor && ctor.prototype === o;
  };

  var excludedKeys = {
    $applicationCache: true,
    $console: true,
    $external: true,
    $frame: true,
    $frameElement: true,
    $frames: true,
    $innerHeight: true,
    $innerWidth: true,
    $onmozfullscreenchange: true,
    $onmozfullscreenerror: true,
    $outerHeight: true,
    $outerWidth: true,
    $pageXOffset: true,
    $pageYOffset: true,
    $parent: true,
    $scrollLeft: true,
    $scrollTop: true,
    $scrollX: true,
    $scrollY: true,
    $self: true,
    $webkitIndexedDB: true,
    $webkitStorageInfo: true,
    $window: true
  };

  var hasAutomationEqualityBug = function () {
    /* global window */
    if (typeof window === 'undefined') {
      return false;
    }

    for (var k in window) {
      try {
        if (!excludedKeys['$' + k] && has$1.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
          try {
            equalsConstructorPrototype(window[k]);
          } catch (e) {
            return true;
          }
        }
      } catch (e) {
        return true;
      }
    }

    return false;
  }();

  var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
    /* global window */
    if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
      return equalsConstructorPrototype(o);
    }

    try {
      return equalsConstructorPrototype(o);
    } catch (e) {
      return false;
    }
  };

  keysShim$1 = function keys(object) {
    var isObject = object !== null && typeof object === 'object';
    var isFunction = toStr$3.call(object) === '[object Function]';
    var isArguments = isArgs(object);
    var isString = isObject && toStr$3.call(object) === '[object String]';
    var theKeys = [];

    if (!isObject && !isFunction && !isArguments) {
      throw new TypeError('Object.keys called on a non-object');
    }

    var skipProto = hasProtoEnumBug && isFunction;

    if (isString && object.length > 0 && !has$1.call(object, 0)) {
      for (var i = 0; i < object.length; ++i) {
        theKeys.push(String(i));
      }
    }

    if (isArguments && object.length > 0) {
      for (var j = 0; j < object.length; ++j) {
        theKeys.push(String(j));
      }
    } else {
      for (var name in object) {
        if (!(skipProto && name === 'prototype') && has$1.call(object, name)) {
          theKeys.push(String(name));
        }
      }
    }

    if (hasDontEnumBug) {
      var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

      for (var k = 0; k < dontEnums.length; ++k) {
        if (!(skipConstructor && dontEnums[k] === 'constructor') && has$1.call(object, dontEnums[k])) {
          theKeys.push(dontEnums[k]);
        }
      }
    }

    return theKeys;
  };
}

var implementation$4 = keysShim$1;

var slice$1 = Array.prototype.slice;
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
  return origKeys(o);
} : implementation$4;
var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
  if (Object.keys) {
    var keysWorksWithArguments = function () {
      // Safari 5.0 bug
      var args = Object.keys(arguments);
      return args && args.length === arguments.length;
    }(1, 2);

    if (!keysWorksWithArguments) {
      Object.keys = function keys(object) {
        // eslint-disable-line func-name-matching
        if (isArguments$1(object)) {
          return originalKeys(slice$1.call(object));
        }

        return originalKeys(object);
      };
    }
  } else {
    Object.keys = keysShim;
  }

  return Object.keys || keysShim;
};

var objectKeys = keysShim;

/* eslint complexity: [2, 18], max-statements: [2, 33] */

var shams = function hasSymbols() {
  if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
    return false;
  }

  if (typeof Symbol.iterator === 'symbol') {
    return true;
  }

  var obj = {};
  var sym = Symbol('test');
  var symObj = Object(sym);

  if (typeof sym === 'string') {
    return false;
  }

  if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
    return false;
  }

  if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
    return false;
  } // temp disabled per https://github.com/ljharb/object.assign/issues/17
  // if (sym instanceof Symbol) { return false; }
  // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
  // if (!(symObj instanceof Symbol)) { return false; }
  // if (typeof Symbol.prototype.toString !== 'function') { return false; }
  // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }


  var symVal = 42;
  obj[sym] = symVal;

  for (sym in obj) {
    return false;
  } // eslint-disable-line no-restricted-syntax, no-unreachable-loop


  if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
    return false;
  }

  if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }

  var syms = Object.getOwnPropertySymbols(obj);

  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }

  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }

  if (typeof Object.getOwnPropertyDescriptor === 'function') {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);

    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }

  return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;

var hasSymbols$3 = function hasNativeSymbols() {
  if (typeof origSymbol !== 'function') {
    return false;
  }

  if (typeof Symbol !== 'function') {
    return false;
  }

  if (typeof origSymbol('foo') !== 'symbol') {
    return false;
  }

  if (typeof Symbol('bar') !== 'symbol') {
    return false;
  }

  return shams();
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr$2 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$3 = function bind(that) {
  var target = this;

  if (typeof target !== 'function' || toStr$2.call(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }

  var args = slice.call(arguments, 1);
  var bound;

  var binder = function binder() {
    if (this instanceof bound) {
      var result = target.apply(this, args.concat(slice.call(arguments)));

      if (Object(result) === result) {
        return result;
      }

      return this;
    } else {
      return target.apply(that, args.concat(slice.call(arguments)));
    }
  };

  var boundLength = Math.max(0, target.length - args.length);
  var boundArgs = [];

  for (var i = 0; i < boundLength; i++) {
    boundArgs.push('$' + i);
  }

  bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

  if (target.prototype) {
    var Empty = function Empty() {};

    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }

  return bound;
};

var functionBind = Function.prototype.bind || implementation$3;

var src = functionBind.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$2 = TypeError; // eslint-disable-next-line consistent-return

var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
  } catch (e) {}
};

var $gOPD$1 = Object.getOwnPropertyDescriptor;

if ($gOPD$1) {
  try {
    $gOPD$1({}, '');
  } catch (e) {
    $gOPD$1 = null; // this is IE 8, which has a broken gOPD
  }
}

var throwTypeError = function throwTypeError() {
  throw new $TypeError$2();
};

var ThrowTypeError = $gOPD$1 ? function () {
  try {
    // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
    arguments.callee; // IE 8 does not throw here

    return throwTypeError;
  } catch (calleeThrows) {
    try {
      // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
      return $gOPD$1(arguments, 'callee').get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols$2 = hasSymbols$3();

var getProto$1 = Object.getPrototypeOf || function (x) {
  return x.__proto__;
}; // eslint-disable-line no-proto


var needsEval = {};
var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto$1(Uint8Array);
var INTRINSICS = {
  '%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
  '%Array%': Array,
  '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
  '%ArrayIteratorPrototype%': hasSymbols$2 ? getProto$1([][Symbol.iterator]()) : undefined$1,
  '%AsyncFromSyncIteratorPrototype%': undefined$1,
  '%AsyncFunction%': needsEval,
  '%AsyncGenerator%': needsEval,
  '%AsyncGeneratorFunction%': needsEval,
  '%AsyncIteratorPrototype%': needsEval,
  '%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
  '%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
  '%Boolean%': Boolean,
  '%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
  '%Date%': Date,
  '%decodeURI%': decodeURI,
  '%decodeURIComponent%': decodeURIComponent,
  '%encodeURI%': encodeURI,
  '%encodeURIComponent%': encodeURIComponent,
  '%Error%': Error,
  '%eval%': eval,
  // eslint-disable-line no-eval
  '%EvalError%': EvalError,
  '%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
  '%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
  '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
  '%Function%': $Function,
  '%GeneratorFunction%': needsEval,
  '%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
  '%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
  '%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
  '%isFinite%': isFinite,
  '%isNaN%': isNaN,
  '%IteratorPrototype%': hasSymbols$2 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
  '%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
  '%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
  '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto$1(new Map()[Symbol.iterator]()),
  '%Math%': Math,
  '%Number%': Number,
  '%Object%': Object,
  '%parseFloat%': parseFloat,
  '%parseInt%': parseInt,
  '%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
  '%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
  '%RangeError%': RangeError,
  '%ReferenceError%': ReferenceError,
  '%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
  '%RegExp%': RegExp,
  '%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
  '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto$1(new Set()[Symbol.iterator]()),
  '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
  '%String%': String,
  '%StringIteratorPrototype%': hasSymbols$2 ? getProto$1(''[Symbol.iterator]()) : undefined$1,
  '%Symbol%': hasSymbols$2 ? Symbol : undefined$1,
  '%SyntaxError%': $SyntaxError,
  '%ThrowTypeError%': ThrowTypeError,
  '%TypedArray%': TypedArray,
  '%TypeError%': $TypeError$2,
  '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
  '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
  '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
  '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
  '%URIError%': URIError,
  '%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
  '%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
  '%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var doEval = function doEval(name) {
  var value;

  if (name === '%AsyncFunction%') {
    value = getEvalledConstructor('async function () {}');
  } else if (name === '%GeneratorFunction%') {
    value = getEvalledConstructor('function* () {}');
  } else if (name === '%AsyncGeneratorFunction%') {
    value = getEvalledConstructor('async function* () {}');
  } else if (name === '%AsyncGenerator%') {
    var fn = doEval('%AsyncGeneratorFunction%');

    if (fn) {
      value = fn.prototype;
    }
  } else if (name === '%AsyncIteratorPrototype%') {
    var gen = doEval('%AsyncGenerator%');

    if (gen) {
      value = getProto$1(gen.prototype);
    }
  }

  INTRINSICS[name] = value;
  return value;
};

var LEGACY_ALIASES = {
  '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
  '%ArrayPrototype%': ['Array', 'prototype'],
  '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
  '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
  '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
  '%ArrayProto_values%': ['Array', 'prototype', 'values'],
  '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
  '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
  '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
  '%BooleanPrototype%': ['Boolean', 'prototype'],
  '%DataViewPrototype%': ['DataView', 'prototype'],
  '%DatePrototype%': ['Date', 'prototype'],
  '%ErrorPrototype%': ['Error', 'prototype'],
  '%EvalErrorPrototype%': ['EvalError', 'prototype'],
  '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
  '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
  '%FunctionPrototype%': ['Function', 'prototype'],
  '%Generator%': ['GeneratorFunction', 'prototype'],
  '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
  '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
  '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
  '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
  '%JSONParse%': ['JSON', 'parse'],
  '%JSONStringify%': ['JSON', 'stringify'],
  '%MapPrototype%': ['Map', 'prototype'],
  '%NumberPrototype%': ['Number', 'prototype'],
  '%ObjectPrototype%': ['Object', 'prototype'],
  '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
  '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
  '%PromisePrototype%': ['Promise', 'prototype'],
  '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
  '%Promise_all%': ['Promise', 'all'],
  '%Promise_reject%': ['Promise', 'reject'],
  '%Promise_resolve%': ['Promise', 'resolve'],
  '%RangeErrorPrototype%': ['RangeError', 'prototype'],
  '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
  '%RegExpPrototype%': ['RegExp', 'prototype'],
  '%SetPrototype%': ['Set', 'prototype'],
  '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
  '%StringPrototype%': ['String', 'prototype'],
  '%SymbolPrototype%': ['Symbol', 'prototype'],
  '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
  '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
  '%TypeErrorPrototype%': ['TypeError', 'prototype'],
  '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
  '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
  '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
  '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
  '%URIErrorPrototype%': ['URIError', 'prototype'],
  '%WeakMapPrototype%': ['WeakMap', 'prototype'],
  '%WeakSetPrototype%': ['WeakSet', 'prototype']
};
var $concat = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply = functionBind.call(Function.apply, Array.prototype.splice);
var $replace = functionBind.call(Function.call, String.prototype.replace);
var $strSlice = functionBind.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */

var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g;
/** Used to match backslashes in property paths. */

var stringToPath = function stringToPath(string) {
  var first = $strSlice(string, 0, 1);
  var last = $strSlice(string, -1);

  if (first === '%' && last !== '%') {
    throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
  } else if (last === '%' && first !== '%') {
    throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
  }

  var result = [];
  $replace(string, rePropName, function (match, number, quote, subString) {
    result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
  });
  return result;
};
/* end adaptation */


var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
  var intrinsicName = name;
  var alias;

  if (src(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = '%' + alias[0] + '%';
  }

  if (src(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];

    if (value === needsEval) {
      value = doEval(intrinsicName);
    }

    if (typeof value === 'undefined' && !allowMissing) {
      throw new $TypeError$2('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
    }

    return {
      alias: alias,
      name: intrinsicName,
      value: value
    };
  }

  throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== 'string' || name.length === 0) {
    throw new $TypeError$2('intrinsic name must be a non-empty string');
  }

  if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
    throw new $TypeError$2('"allowMissing" argument must be a boolean');
  }

  var parts = stringToPath(name);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
  var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;

  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat([0, 1], alias));
  }

  for (var i = 1, isOwn = true; i < parts.length; i += 1) {
    var part = parts[i];
    var first = $strSlice(part, 0, 1);
    var last = $strSlice(part, -1);

    if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
      throw new $SyntaxError('property names with quotes must have matching quotes');
    }

    if (part === 'constructor' || !isOwn) {
      skipFurtherCaching = true;
    }

    intrinsicBaseName += '.' + part;
    intrinsicRealName = '%' + intrinsicBaseName + '%';

    if (src(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError$2('base intrinsic for ' + name + ' exists, but the property is not available.');
        }

        return void undefined$1;
      }

      if ($gOPD$1 && i + 1 >= parts.length) {
        var desc = $gOPD$1(value, part);
        isOwn = !!desc; // By convention, when a data property is converted to an accessor
        // property to emulate a data property that does not suffer from
        // the override mistake, that accessor's getter is marked with
        // an `originalValue` property. Here, when we detect this, we
        // uphold the illusion by pretending to see that original data
        // property, i.e., returning the value rather than the getter
        // itself.

        if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = src(value, part);
        value = value[part];
      }

      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }

  return value;
};

var callBind = createCommonjsModule(function (module) {

  var $apply = getIntrinsic('%Function.prototype.apply%');
  var $call = getIntrinsic('%Function.prototype.call%');
  var $reflectApply = getIntrinsic('%Reflect.apply%', true) || functionBind.call($call, $apply);
  var $gOPD = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);
  var $defineProperty = getIntrinsic('%Object.defineProperty%', true);
  var $max = getIntrinsic('%Math.max%');

  if ($defineProperty) {
    try {
      $defineProperty({}, 'a', {
        value: 1
      });
    } catch (e) {
      // IE 8 has a broken defineProperty
      $defineProperty = null;
    }
  }

  module.exports = function callBind(originalFunction) {
    var func = $reflectApply(functionBind, $call, arguments);

    if ($gOPD && $defineProperty) {
      var desc = $gOPD(func, 'length');

      if (desc.configurable) {
        // original length, plus the receiver, minus any additional arguments (after the receiver)
        $defineProperty(func, 'length', {
          value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
        });
      }
    }

    return func;
  };

  var applyBind = function applyBind() {
    return $reflectApply(functionBind, $apply, arguments);
  };

  if ($defineProperty) {
    $defineProperty(module.exports, 'apply', {
      value: applyBind
    });
  } else {
    module.exports.apply = applyBind;
  }
});

var $indexOf = callBind(getIntrinsic('String.prototype.indexOf'));

var callBound = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = getIntrinsic(name, !!allowMissing);

  if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
    return callBind(intrinsic);
  }

  return intrinsic;
};

var hasToStringTag$2 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var $toString$1 = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
  if (hasToStringTag$2 && value && typeof value === 'object' && Symbol.toStringTag in value) {
    return false;
  }

  return $toString$1(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
  if (isStandardArguments(value)) {
    return true;
  }

  return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $toString$1(value) !== '[object Array]' && $toString$1(value.callee) === '[object Function]';
};

var supportsStandardArguments = function () {
  return isStandardArguments(arguments);
}();

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

var isArguments = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

var hasSymbols$1 = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var toStr$1 = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction$1 = function isFunction(fn) {
  return typeof fn === 'function' && toStr$1.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
  var obj = {};

  try {
    origDefineProperty(obj, 'x', {
      enumerable: false,
      value: obj
    }); // eslint-disable-next-line no-unused-vars, no-restricted-syntax

    for (var _ in obj) {
      // jscs:ignore disallowUnusedVariables
      return false;
    }

    return obj.x === obj;
  } catch (e) {
    /* this is IE 8. */
    return false;
  }
};

var supportsDescriptors$2 = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty$2 = function defineProperty(object, name, value, predicate) {
  if (name in object && (!isFunction$1(predicate) || !predicate())) {
    return;
  }

  if (supportsDescriptors$2) {
    origDefineProperty(object, name, {
      configurable: true,
      enumerable: false,
      value: value,
      writable: true
    });
  } else {
    object[name] = value;
  }
};

var defineProperties = function defineProperties(object, map) {
  var predicates = arguments.length > 2 ? arguments[2] : {};
  var props = objectKeys(map);

  if (hasSymbols$1) {
    props = concat.call(props, Object.getOwnPropertySymbols(map));
  }

  for (var i = 0; i < props.length; i += 1) {
    defineProperty$2(object, props[i], map[props[i]], predicates[props[i]]);
  }
};

defineProperties.supportsDescriptors = !!supportsDescriptors$2;
var defineProperties_1 = defineProperties;

var numberIsNaN = function numberIsNaN(value) {
  return value !== value;
};

var implementation$2 = function is(a, b) {
  if (a === 0 && b === 0) {
    return 1 / a === 1 / b;
  }

  if (a === b) {
    return true;
  }

  if (numberIsNaN(a) && numberIsNaN(b)) {
    return true;
  }

  return false;
};

var polyfill$2 = function getPolyfill() {
  return typeof Object.is === 'function' ? Object.is : implementation$2;
};

var shim$1 = function shimObjectIs() {
  var polyfill = polyfill$2();
  defineProperties_1(Object, {
    is: polyfill
  }, {
    is: function testObjectIs() {
      return Object.is !== polyfill;
    }
  });
  return polyfill;
};

var polyfill$1 = callBind(polyfill$2(), Object);
defineProperties_1(polyfill$1, {
  getPolyfill: polyfill$2,
  implementation: implementation$2,
  shim: shim$1
});
var objectIs = polyfill$1;

var hasSymbols = shams();
var hasToStringTag$1 = hasSymbols && !!Symbol.toStringTag;
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag$1) {
  has = callBound('Object.prototype.hasOwnProperty');
  $exec = callBound('RegExp.prototype.exec');
  isRegexMarker = {};

  var throwRegexMarker = function throwRegexMarker() {
    throw isRegexMarker;
  };

  badStringifier = {
    toString: throwRegexMarker,
    valueOf: throwRegexMarker
  };

  if (typeof Symbol.toPrimitive === 'symbol') {
    badStringifier[Symbol.toPrimitive] = throwRegexMarker;
  }
}

var $toString = callBound('Object.prototype.toString');
var gOPD$1 = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';
var isRegex = hasToStringTag$1 // eslint-disable-next-line consistent-return
? function isRegex(value) {
  if (!value || typeof value !== 'object') {
    return false;
  }

  var descriptor = gOPD$1(value, 'lastIndex');
  var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');

  if (!hasLastIndexDataProperty) {
    return false;
  }

  try {
    $exec(value, badStringifier);
  } catch (e) {
    return e === isRegexMarker;
  }
} : function isRegex(value) {
  // In older browsers, typeof regex incorrectly returns 'function'
  if (!value || typeof value !== 'object' && typeof value !== 'function') {
    return false;
  }

  return $toString(value) === regexClass;
};

var $Object = Object;
var $TypeError$1 = TypeError;

var implementation$1 = function flags() {
  if (this != null && this !== $Object(this)) {
    throw new $TypeError$1('RegExp.prototype.flags getter called on non-object');
  }

  var result = '';

  if (this.global) {
    result += 'g';
  }

  if (this.ignoreCase) {
    result += 'i';
  }

  if (this.multiline) {
    result += 'm';
  }

  if (this.dotAll) {
    result += 's';
  }

  if (this.unicode) {
    result += 'u';
  }

  if (this.sticky) {
    result += 'y';
  }

  return result;
};

var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var $TypeError = TypeError;

var polyfill = function getPolyfill() {
  if (!supportsDescriptors$1) {
    throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
  }

  if (/a/mig.flags === 'gim') {
    var descriptor = $gOPD(RegExp.prototype, 'flags');

    if (descriptor && typeof descriptor.get === 'function' && typeof /a/.dotAll === 'boolean') {
      return descriptor.get;
    }
  }

  return implementation$1;
};

var supportsDescriptors = defineProperties_1.supportsDescriptors;
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty$1 = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

var shim = function shimFlags() {
  if (!supportsDescriptors || !getProto) {
    throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
  }

  var polyfill$1 = polyfill();
  var proto = getProto(regex);
  var descriptor = gOPD(proto, 'flags');

  if (!descriptor || descriptor.get !== polyfill$1) {
    defineProperty$1(proto, 'flags', {
      configurable: true,
      enumerable: false,
      get: polyfill$1
    });
  }

  return polyfill$1;
};

var flagsBound = callBind(implementation$1);
defineProperties_1(flagsBound, {
  getPolyfill: polyfill,
  implementation: implementation$1,
  shim: shim
});
var regexp_prototype_flags = flagsBound;

var getDay = Date.prototype.getDay;

var tryDateObject = function tryDateGetDayCall(value) {
  try {
    getDay.call(value);
    return true;
  } catch (e) {
    return false;
  }
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag;

var isDateObject = function isDateObject(value) {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {}; // 7.1. All identical values are equivalent, as determined by ===.

  if (opts.strict ? objectIs(actual, expected) : actual === expected) {
    return true;
  } // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.


  if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') {
    return opts.strict ? objectIs(actual, expected) : actual == expected;
  }
  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define


  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }

  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }

  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }

  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;

  if (typeof a !== typeof b) {
    return false;
  }

  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) {
    return false;
  } // an identical 'prototype' property.


  if (a.prototype !== b.prototype) {
    return false;
  }

  if (isArguments(a) !== isArguments(b)) {
    return false;
  }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);

  if (aIsRegex !== bIsRegex) {
    return false;
  }

  if (aIsRegex || bIsRegex) {
    return a.source === b.source && regexp_prototype_flags(a) === regexp_prototype_flags(b);
  }

  if (isDateObject(a) && isDateObject(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);

  if (aIsBuffer !== bIsBuffer) {
    return false;
  }

  if (aIsBuffer || bIsBuffer) {
    // && would work too, because both are true or both false here
    if (a.length !== b.length) {
      return false;
    }

    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }

    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) {
    // happens when one is a string literal and the other isn't
    return false;
  } // having the same number of owned properties (keys incorporates hasOwnProperty)


  if (ka.length !== kb.length) {
    return false;
  } // the same set of keys (although not necessarily the same order),


  ka.sort();
  kb.sort(); // ~~~cheap key test

  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) {
      return false;
    }
  } // equivalent values for every corresponding key, and ~~~possibly expensive deep test


  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];

    if (!deepEqual(a[key], b[key], opts)) {
      return false;
    }
  }

  return true;
}

var deepEqual_1 = deepEqual;

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];

  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }

  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/

var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */

function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */


function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  } // NOTE: 1 DOM access here


  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */


function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }

  return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */


function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;

    case '#document':
      return element.body;
  } // Firefox want us to check `-x` and `-y` variations as well


  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */


function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */

function isIE(version) {
  if (version === 11) {
    return isIE11;
  }

  if (version === 10) {
    return isIE10;
  }

  return isIE11 || isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */


function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null; // NOTE: 1 DOM access here

  var offsetParent = element.offsetParent || null; // Skip hidden elements which don't have an offsetParent

  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  } // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...


  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }

  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */


function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */


function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  } // Here we make sure to give as "start" the element that comes first in the DOM


  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1; // Get common ancestor container

  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer; // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  } // one of the nodes is inside shadowDOM, find which one


  var element1root = getRoot(element1);

  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */


function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */


function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */


function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);
  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */


function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */


function getBoundingClientRect(element) {
  var rect = {}; // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11

  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  }; // subtract scrollbar size from sizes

  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;
  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height; // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons

  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');
    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);
  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth); // In cases where the parent is fixed, we must ignore negative scroll in offset calc

  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0; // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.

  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);
    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft; // Attach marginTop and marginLeft because in some circumstances we may need them

    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);
  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };
  return getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */


function isFixed(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }

  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }

  var parentNode = getParentNode(element);

  if (!parentNode) {
    return false;
  }

  return isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */


function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }

  var el = element.parentElement;

  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }

  return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */


function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false; // NOTE: 1 DOM access here

  var boundaries = {
    top: 0,
    left: 0
  };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference)); // Handle viewport case

  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;

    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));

      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition); // In case of HTML, we need a different computation

    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  } // Add paddings


  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };
  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });
  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });
  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
  var variation = placement.split('-')[1];
  return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */


function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */


function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */


function getOppositePlacement(placement) {
  var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */


function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0]; // Get popper node sizes

  var popperRect = getOuterSizes(popper); // Add position, width and height to our offsets object

  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  }; // depending by the popper placement we have to compute its offsets slightly differently

  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;

  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */


function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  } // use `filter` to obtain the same behavior of `find`


  return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */


function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  } // use `find` + `indexOf` if `findIndex` isn't supported


  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */


function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }

    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation

    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);
      data = fn(data, modifier);
    }
  });
  return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */


function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  }; // compute reference element offsets

  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed); // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value

  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding); // store the computed placement inside `originalPlacement`

  data.originalPlacement = data.placement;
  data.positionFixed = this.options.positionFixed; // compute the popper offsets

  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute'; // run the modifiers

  data = runModifiers(this.modifiers, data); // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback

  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */


function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */


function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;

    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }

  return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */


function destroy() {
  this.state.isDestroyed = true; // touch DOM only if `applyStyle` modifier is enabled

  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners(); // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it

  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }

  return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */


function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, {
    passive: true
  });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }

  scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */


function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, {
    passive: true
  }); // Scroll event listener on scroll parents

  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;
  return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */


function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */


function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound); // Remove scroll event listener on scroll parents

  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  }); // Reset state

  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */


function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */


function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */


function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = ''; // add unit if the value is numeric and is one of the following

    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }

    element.style[prop] = styles[prop] + unit;
  });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */


function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];

    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */


function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles); // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element

  setAttributes(data.instance.popper, data.attributes); // if arrowElement is defined and arrowStyles has some properties

  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */


function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed); // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value

  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
  popper.setAttribute('x-placement', placement); // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations

  setStyles(popper, {
    position: options.positionFixed ? 'fixed' : 'absolute'
  });
  return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */


function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);
  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;
  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */

function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper; // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;

  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }

  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent); // Styles

  var styles = {
    position: popper.position
  };
  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right'; // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed

  var prefixedProperty = getSupportedPropertyName('transform'); // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.

  var left = void 0,
      top = void 0;

  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }

  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }

  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  } // Attributes


  var attributes = {
    'x-placement': data.placement
  }; // Update `data` attributes, styles and arrowStyles

  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
  return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */


function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });
  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';

    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }

  return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function arrow(data, options) {
  var _data$offsets$arrow; // arrow depends on keepTogether in order to work


  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element; // if arrowElement is a string, suppose it's a CSS selector

  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement); // if arrowElement is not found, don't run the modifier

    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len]; //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //
  // top/left side

  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  } // bottom/right side


  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }

  data.offsets.popper = getClientRect(data.offsets.popper); // compute center of the popper

  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2; // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available

  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide; // prevent arrowElement from being placed not contiguously to its popper

  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
  return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */


function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }

  return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */


var placements$1 = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']; // Get rid of `auto` `auto-start` and `auto-end`

var validPlacements = placements$1.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */

function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */

function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';
  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;

    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;

    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;

    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);
    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference; // using floor because the reference offsets may contain decimals we are not going to consider here

    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom; // flip the variation if required

    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1; // flips variation if reference element overflows boundaries

    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom); // flips variation if popper content overflows boundaries

    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : ''); // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future

      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }

  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */


function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2]; // If it's not a number it's an operator, I guess

  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;

    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;

      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;

    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }

    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */


function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0]; // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one

  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1; // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)

  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  }); // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space

  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  } // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.


  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments]; // Convert the values with units to absolute pixels to allow our computations

  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, []) // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  }); // Loop trough the offsets arrays and execute the operations

  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */


function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var basePlacement = placement.split('-')[0];
  var offsets = void 0;

  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper); // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken

  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  } // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself


  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification

  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];
  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed); // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed

  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;
  options.boundaries = boundaries;
  var order = options.priority;
  var popper = data.offsets.popper;
  var check = {
    primary: function primary(placement) {
      var value = popper[placement];

      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }

      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];

      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }

      return defineProperty({}, mainSide, value);
    }
  };
  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });
  data.offsets.popper = popper;
  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1]; // if shift shiftvariation is specified, run the modifier

  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;
    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };
    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */


function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);
  return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */


var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: offset,

    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: preventOverflow,

    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],

    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,

    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: arrow,

    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: flip,

    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',

    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,

    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',

    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,

    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,

    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,

    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: computeStyle,

    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,

    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',

    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,

    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,

    /** @prop {ModifierFn} */
    fn: applyStyle,

    /** @prop {Function} */
    onLoad: applyStyleOnLoad,

    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */

var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */
// Utils
// Methods

var Popper$1 = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    }; // make update() debounced, so that it only runs at most once-per-tick


    this.update = debounce(this.update.bind(this)); // with {} we create a new object with the options inside it

    this.options = _extends({}, Popper.Defaults, options); // init state

    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    }; // get reference and popper elements (allow jQuery wrappers)

    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper; // Deep merge modifiers options

    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    }); // Refactoring modifiers' list (Object => Array)

    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    }) // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    }); // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!

    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    }); // fire the first update to position the popper in the right place

    this.update();
    var eventsEnabled = this.options.eventsEnabled;

    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  } // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper$1.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper$1.placements = placements$1;
Popper$1.Defaults = Defaults;

var key = '__global_unique_id__';

var gud = function gud() {
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
};

var implementation = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;

  var _propTypes2 = _interopRequireDefault(propTypes);

  var _gud2 = _interopRequireDefault(gud);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var MAX_SIGNED_31_BIT_INT = 1073741823; // Inlined Object.is polyfill.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is

  function objectIs(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }

  function createEventEmitter(value) {
    var handlers = [];
    return {
      on: function on(handler) {
        handlers.push(handler);
      },
      off: function off(handler) {
        handlers = handlers.filter(function (h) {
          return h !== handler;
        });
      },
      get: function get() {
        return value;
      },
      set: function set(newValue, changedBits) {
        value = newValue;
        handlers.forEach(function (handler) {
          return handler(value, changedBits);
        });
      }
    };
  }

  function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
  }

  function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;

    var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

    var Provider = function (_Component) {
      _inherits(Provider, _Component);

      function Provider() {
        var _temp, _this, _ret;

        _classCallCheck(this, Provider);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
      }

      Provider.prototype.getChildContext = function getChildContext() {
        var _ref;

        return _ref = {}, _ref[contextProp] = this.emitter, _ref;
      };

      Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
          var oldValue = this.props.value;
          var newValue = nextProps.value;
          var changedBits = void 0;

          if (objectIs(oldValue, newValue)) {
            changedBits = 0; // No change
          } else {
            changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

            changedBits |= 0;

            if (changedBits !== 0) {
              this.emitter.set(nextProps.value, changedBits);
            }
          }
        }
      };

      Provider.prototype.render = function render() {
        return this.props.children;
      };

      return Provider;
    }(React__default.Component);

    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

    var Consumer = function (_Component2) {
      _inherits(Consumer, _Component2);

      function Consumer() {
        var _temp2, _this2, _ret2;

        _classCallCheck(this, Consumer);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
          value: _this2.getValue()
        }, _this2.onUpdate = function (newValue, changedBits) {
          var observedBits = _this2.observedBits | 0;

          if ((observedBits & changedBits) !== 0) {
            _this2.setState({
              value: _this2.getValue()
            });
          }
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
      }

      Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var observedBits = nextProps.observedBits;
        this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
        : observedBits;
      };

      Consumer.prototype.componentDidMount = function componentDidMount() {
        if (this.context[contextProp]) {
          this.context[contextProp].on(this.onUpdate);
        }

        var observedBits = this.props.observedBits;
        this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
        : observedBits;
      };

      Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.context[contextProp]) {
          this.context[contextProp].off(this.onUpdate);
        }
      };

      Consumer.prototype.getValue = function getValue() {
        if (this.context[contextProp]) {
          return this.context[contextProp].get();
        } else {
          return defaultValue;
        }
      };

      Consumer.prototype.render = function render() {
        return onlyChild(this.props.children)(this.state.value);
      };

      return Consumer;
    }(React__default.Component);

    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
    return {
      Provider: Provider,
      Consumer: Consumer
    };
  }

  exports.default = createReactContext;
  module.exports = exports['default'];
});

var lib = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;

  var _react2 = _interopRequireDefault(React__default);

  var _implementation2 = _interopRequireDefault(implementation);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _react2.default.createContext || _implementation2.default;
  module.exports = exports['default'];
});
var createContext = /*@__PURE__*/getDefaultExportFromCjs(lib);

var ManagerReferenceNodeContext = createContext();
var ManagerReferenceNodeSetterContext = createContext();

var Manager = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "referenceNode", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return React.createElement(ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, React.createElement(ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(React.Component);

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      data: undefined,
      placement: undefined
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popperInstance", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popperNode", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "arrowNode", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      setRef(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: _extends$4({}, _this.props.modifiers, {
          arrow: _extends$4({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : _extends$4({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new Popper$1(referenceElement, popperNode, _this.getOptions());
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !deepEqual_1(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return unwrapArray(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(React.Component);

_defineProperty(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var placements = Popper$1.placements;
function Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = _objectWithoutPropertiesLoose$1(_ref, ["referenceElement"]);

  return React.createElement(ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
    return React.createElement(InnerPopper, _extends$4({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

var InnerReference = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "refHandler", function (node) {
      setRef(_this.props.innerRef, node);
      safeInvoke(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
  };

  _proto.render = function render() {
    return unwrapArray(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(React.Component);

function Reference(props) {
  return React.createElement(ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
    return React.createElement(InnerReference, _extends$4({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

// Public components
 // Public types

var esm = {
	__proto__: null,
	Popper: Popper,
	placements: placements,
	Manager: Manager,
	Reference: Reference
};

var reactDatepicker_min = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    t(exports, React__default, propTypes, classnames, require$$3, require$$4, require$$5, require$$6, require$$7, require$$8, require$$9, require$$10, require$$11, require$$12, require$$13, require$$14, require$$15, require$$16, require$$17, require$$18, require$$19, require$$20, require$$21, require$$22, require$$23, require$$24, require$$25, require$$26, require$$27, require$$28, require$$29, require$$30, require$$31, require$$32, require$$33, require$$34, require$$35, require$$36, require$$37, require$$38, require$$39, require$$40, require$$41, require$$42, require$$43, require$$44, require$$45, require$$46, require$$47, require$$48, require$$49, require$$50, require$$51, require$$52, require$$53, require$$54, require$$55, require$$56, require$$57, require$$58, reactOnclickoutside_es, esm, require$$61) ;
  }(commonjsGlobal, function (e, t, r, a, n, o, s, i, p, l, d, c, u, f, h, m, y, v, D, w, k, g, b, C, S, _, M, P, E, N, O, Y, x, T, I, L, F, R, q, A, W, B, j, H, K, Q, V, U, $, z, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe) {

    function le(e) {
      return e && "object" == typeof e && "default" in e ? e : {
        default: e
      };
    }

    var de = le(t),
        ce = le(a),
        ue = le(n),
        fe = le(o),
        he = le(s),
        me = le(i),
        ye = le(p),
        ve = le(l),
        De = le(d),
        we = le(c),
        ke = le(u),
        ge = le(m),
        be = le(y),
        Ce = le(v),
        Se = le(D),
        _e = le(w),
        Me = le(k),
        Pe = le(g),
        Ee = le(b),
        Ne = le(C),
        Oe = le(S),
        Ye = le(_),
        xe = le(M),
        Te = le(P),
        Ie = le(E),
        Le = le(N),
        Fe = le(O),
        Re = le(Y),
        qe = le(x),
        Ae = le(T),
        We = le(I),
        Be = le(L),
        je = le(F),
        He = le(R),
        Ke = le(q),
        Qe = le(W),
        Ve = le(B),
        Ue = le(j),
        $e = le(H),
        ze = le(K),
        Ge = le(Q),
        Je = le(V),
        Xe = le(z),
        Ze = le(G),
        et = le(J),
        tt = le(X),
        rt = le(Z),
        at = le(ee),
        nt = le(te),
        ot = le(re),
        st = le(ae),
        it = le(ne),
        pt = le(oe),
        lt = le(se),
        dt = le(pe);

    function ct(e) {
      return (ct = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function ut(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function ft(e, t) {
      for (var r = 0; r < t.length; r++) {
        var a = t[r];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
      }
    }

    function ht(e, t, r) {
      return t && ft(e.prototype, t), r && ft(e, r), e;
    }

    function mt(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function yt() {
      return (yt = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
        }

        return e;
      }).apply(this, arguments);
    }

    function vt(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        t && (a = a.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, a);
      }

      return r;
    }

    function Dt(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? vt(Object(r), !0).forEach(function (t) {
          mt(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vt(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function wt(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && gt(e, t);
    }

    function kt(e) {
      return (kt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function gt(e, t) {
      return (gt = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function bt(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function Ct(e, t) {
      return !t || "object" != typeof t && "function" != typeof t ? bt(e) : t;
    }

    function St(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            a = kt(e);

        if (t) {
          var n = kt(this).constructor;
          r = Reflect.construct(a, arguments, n);
        } else r = a.apply(this, arguments);

        return Ct(this, r);
      };
    }

    function _t(e) {
      return function (e) {
        if (Array.isArray(e)) return Mt(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return Mt(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Mt(e, t);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Mt(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, a = new Array(t); r < t; r++) a[r] = e[r];

      return a;
    }

    function Pt(e, t) {
      switch (e) {
        case "P":
          return t.date({
            width: "short"
          });

        case "PP":
          return t.date({
            width: "medium"
          });

        case "PPP":
          return t.date({
            width: "long"
          });

        case "PPPP":
        default:
          return t.date({
            width: "full"
          });
      }
    }

    function Et(e, t) {
      switch (e) {
        case "p":
          return t.time({
            width: "short"
          });

        case "pp":
          return t.time({
            width: "medium"
          });

        case "ppp":
          return t.time({
            width: "long"
          });

        case "pppp":
        default:
          return t.time({
            width: "full"
          });
      }
    }

    var Nt = {
      p: Et,
      P: function (e, t) {
        var r,
            a = e.match(/(P+)(p+)?/),
            n = a[1],
            o = a[2];
        if (!o) return Pt(e, t);

        switch (n) {
          case "P":
            r = t.dateTime({
              width: "short"
            });
            break;

          case "PP":
            r = t.dateTime({
              width: "medium"
            });
            break;

          case "PPP":
            r = t.dateTime({
              width: "long"
            });
            break;

          case "PPPP":
          default:
            r = t.dateTime({
              width: "full"
            });
        }

        return r.replace("{{date}}", Pt(n, t)).replace("{{time}}", Et(o, t));
      }
    },
        Ot = 12,
        Yt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

    function xt(e) {
      var t = e ? "string" == typeof e || e instanceof String ? pt.default(e) : st.default(e) : new Date();
      return It(t) ? t : null;
    }

    function Tt(e, t, r, a) {
      var n = null,
          o = Jt(r) || Jt(Gt()),
          s = !0;
      return Array.isArray(t) ? (t.forEach(function (t) {
        var r = it.default(e, t, new Date(), {
          locale: o
        });
        a && (s = It(r) && e === he.default(r, t, {
          awareOfUnicodeTokens: !0
        })), It(r) && s && (n = r);
      }), n) : (n = it.default(e, t, new Date(), {
        locale: o
      }), a ? s = It(n) && e === he.default(n, t, {
        awareOfUnicodeTokens: !0
      }) : It(n) || (t = t.match(Yt).map(function (e) {
        var t = e[0];
        return "p" === t || "P" === t ? o ? (0, Nt[t])(e, o.formatLong) : t : e;
      }).join(""), e.length > 0 && (n = it.default(e, t.slice(0, e.length), new Date())), It(n) || (n = new Date(e))), It(n) && s ? n : null);
    }

    function It(e) {
      return fe.default(e) && at.default(e, new Date("1/1/1000"));
    }

    function Lt(e, t, r) {
      if ("en" === r) return he.default(e, t, {
        awareOfUnicodeTokens: !0
      });
      var a = Jt(r);
      return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !a && Gt() && Jt(Gt()) && (a = Jt(Gt())), he.default(e, t, {
        locale: a || null,
        awareOfUnicodeTokens: !0
      });
    }

    function Ft(e, t) {
      var r = t.hour,
          a = void 0 === r ? 0 : r,
          n = t.minute,
          o = void 0 === n ? 0 : n,
          s = t.second,
          i = void 0 === s ? 0 : s;
      return Re.default(Fe.default(Le.default(e, i), o), a);
    }

    function Rt(e, t) {
      var r = t && Jt(t) || Gt() && Jt(Gt());
      return Oe.default(e, r ? {
        locale: r
      } : null);
    }

    function qt(e, t) {
      return Lt(e, "ddd", t);
    }

    function At(e) {
      return Ve.default(e);
    }

    function Wt(e, t) {
      var r = Jt(t || Gt());
      return Ue.default(e, {
        locale: r
      });
    }

    function Bt(e) {
      return $e.default(e);
    }

    function jt(e) {
      return Ge.default(e);
    }

    function Ht(e) {
      return ze.default(e);
    }

    function Kt(e, t) {
      return e && t ? tt.default(e, t) : !e && !t;
    }

    function Qt(e, t) {
      return e && t ? et.default(e, t) : !e && !t;
    }

    function Vt(e, t) {
      return e && t ? rt.default(e, t) : !e && !t;
    }

    function Ut(e, t) {
      return e && t ? Ze.default(e, t) : !e && !t;
    }

    function $t(e, t) {
      return e && t ? Xe.default(e, t) : !e && !t;
    }

    function zt(e, t, r) {
      var a,
          n = Ve.default(t),
          o = Je.default(r);

      try {
        a = ot.default(e, {
          start: n,
          end: o
        });
      } catch (e) {
        a = !1;
      }

      return a;
    }

    function Gt() {
      return ("undefined" != typeof window ? window : commonjsGlobal).__localeId__;
    }

    function Jt(e) {
      if ("string" == typeof e) {
        var t = "undefined" != typeof window ? window : commonjsGlobal;
        return t.__localeData__ ? t.__localeData__[e] : null;
      }

      return e;
    }

    function Xt(e, t) {
      return Lt(qe.default(xt(), e), "LLLL", t);
    }

    function Zt(e, t) {
      return Lt(qe.default(xt(), e), "LLL", t);
    }

    function er(e, t) {
      return Lt(Ae.default(xt(), e), "QQQ", t);
    }

    function tr(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.minDate,
          a = t.maxDate,
          n = t.excludeDates,
          o = t.includeDates,
          s = t.filterDate;
      return pr(e, {
        minDate: r,
        maxDate: a
      }) || n && n.some(function (t) {
        return Ut(e, t);
      }) || o && !o.some(function (t) {
        return Ut(e, t);
      }) || s && !s(xt(e)) || !1;
    }

    function rr(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.excludeDates;
      return r && r.some(function (t) {
        return Ut(e, t);
      }) || !1;
    }

    function ar(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.minDate,
          a = t.maxDate,
          n = t.excludeDates,
          o = t.includeDates,
          s = t.filterDate;
      return pr(e, {
        minDate: r,
        maxDate: a
      }) || n && n.some(function (t) {
        return Qt(e, t);
      }) || o && !o.some(function (t) {
        return Qt(e, t);
      }) || s && !s(xt(e)) || !1;
    }

    function nr(e, t, r, a) {
      var n = Te.default(e),
          o = Ye.default(e),
          s = Te.default(t),
          i = Ye.default(t),
          p = Te.default(a);
      return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }

    function or(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.minDate,
          a = t.maxDate,
          n = t.excludeDates,
          o = t.includeDates,
          s = t.filterDate;
      return pr(e, {
        minDate: r,
        maxDate: a
      }) || n && n.some(function (t) {
        return Vt(e, t);
      }) || o && !o.some(function (t) {
        return Vt(e, t);
      }) || s && !s(xt(e)) || !1;
    }

    function sr(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.minDate,
          a = t.maxDate,
          n = new Date(e, 0, 1);
      return pr(n, {
        minDate: r,
        maxDate: a
      }) || !1;
    }

    function ir(e, t, r, a) {
      var n = Te.default(e),
          o = xe.default(e),
          s = Te.default(t),
          i = xe.default(t),
          p = Te.default(a);
      return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }

    function pr(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.minDate,
          a = t.maxDate;
      return r && He.default(e, r) < 0 || a && He.default(e, a) > 0;
    }

    function lr(e, t) {
      return t.some(function (t) {
        return Pe.default(t) === Pe.default(e) && Me.default(t) === Me.default(e);
      });
    }

    function dr(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.excludeTimes,
          a = t.includeTimes,
          n = t.filterTime;
      return r && lr(e, r) || a && !lr(e, a) || n && !n(e) || !1;
    }

    function cr(e, t) {
      var r = t.minTime,
          a = t.maxTime;
      if (!r || !a) throw new Error("Both minTime and maxTime props required");
      var n,
          o = xt(),
          s = Re.default(Fe.default(o, Me.default(e)), Pe.default(e)),
          i = Re.default(Fe.default(o, Me.default(r)), Pe.default(r)),
          p = Re.default(Fe.default(o, Me.default(a)), Pe.default(a));

      try {
        n = !ot.default(s, {
          start: i,
          end: p
        });
      } catch (e) {
        n = !1;
      }

      return n;
    }

    function ur(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.minDate,
          a = t.includeDates,
          n = Ce.default(e, 1);
      return r && Ke.default(r, n) > 0 || a && a.every(function (e) {
        return Ke.default(e, n) > 0;
      }) || !1;
    }

    function fr(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.maxDate,
          a = t.includeDates,
          n = we.default(e, 1);
      return r && Ke.default(n, r) > 0 || a && a.every(function (e) {
        return Ke.default(n, e) > 0;
      }) || !1;
    }

    function hr(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.minDate,
          a = t.includeDates,
          n = Se.default(e, 1);
      return r && Qe.default(r, n) > 0 || a && a.every(function (e) {
        return Qe.default(e, n) > 0;
      }) || !1;
    }

    function mr(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.maxDate,
          a = t.includeDates,
          n = ke.default(e, 1);
      return r && Qe.default(n, r) > 0 || a && a.every(function (e) {
        return Qe.default(n, e) > 0;
      }) || !1;
    }

    function yr(e) {
      var t = e.minDate,
          r = e.includeDates;

      if (r && t) {
        var a = r.filter(function (e) {
          return He.default(e, t) >= 0;
        });
        return Be.default(a);
      }

      return r ? Be.default(r) : t;
    }

    function vr(e) {
      var t = e.maxDate,
          r = e.includeDates;

      if (r && t) {
        var a = r.filter(function (e) {
          return He.default(e, t) <= 0;
        });
        return je.default(a);
      }

      return r ? je.default(r) : t;
    }

    function Dr() {
      for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map(), a = 0, n = e.length; a < n; a++) {
        var o = e[a];

        if (ue.default(o)) {
          var s = Lt(o, "MM.dd.yyyy"),
              i = r.get(s) || [];
          i.includes(t) || (i.push(t), r.set(s, i));
        } else if ("object" === ct(o)) {
          var p = Object.keys(o),
              l = p[0],
              d = o[p[0]];
          if ("string" == typeof l && d.constructor === Array) for (var c = 0, u = d.length; c < u; c++) {
            var f = Lt(d[c], "MM.dd.yyyy"),
                h = r.get(f) || [];
            h.includes(l) || (h.push(l), r.set(f, h));
          }
        }
      }

      return r;
    }

    function wr(e, t, r, a, n) {
      for (var o = n.length, s = [], i = 0; i < o; i++) {
        var p = me.default(ye.default(e, Pe.default(n[i])), Me.default(n[i])),
            l = me.default(e, (r + 1) * a);
        at.default(p, t) && nt.default(p, l) && s.push(n[i]);
      }

      return s;
    }

    function kr(e) {
      return e < 10 ? "0".concat(e) : "".concat(e);
    }

    function gr(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Ot,
          r = Math.ceil(Te.default(e) / t) * t,
          a = r - (t - 1);
      return {
        startPeriod: a,
        endPeriod: r
      };
    }

    function br(e, t, r, a) {
      for (var n = [], o = 0; o < 2 * t + 1; o++) {
        var s = e + t - o,
            i = !0;
        r && (i = Te.default(r) <= s), a && i && (i = Te.default(a) >= s), i && n.push(s);
      }

      return n;
    }

    var Cr = function (e) {
      wt(r, e);
      var t = St(r);

      function r(e) {
        var a;
        ut(this, r), mt(bt(a = t.call(this, e)), "renderOptions", function () {
          var e = a.props.year,
              t = a.state.yearsList.map(function (t) {
            return de.default.createElement("div", {
              className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
              key: t,
              onClick: a.onChange.bind(bt(a), t)
            }, e === t ? de.default.createElement("span", {
              className: "react-datepicker__year-option--selected"
            }, "✓") : "", t);
          }),
              r = a.props.minDate ? Te.default(a.props.minDate) : null,
              n = a.props.maxDate ? Te.default(a.props.maxDate) : null;
          return n && a.state.yearsList.find(function (e) {
            return e === n;
          }) || t.unshift(de.default.createElement("div", {
            className: "react-datepicker__year-option",
            key: "upcoming",
            onClick: a.incrementYears
          }, de.default.createElement("a", {
            className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
          }))), r && a.state.yearsList.find(function (e) {
            return e === r;
          }) || t.push(de.default.createElement("div", {
            className: "react-datepicker__year-option",
            key: "previous",
            onClick: a.decrementYears
          }, de.default.createElement("a", {
            className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
          }))), t;
        }), mt(bt(a), "onChange", function (e) {
          a.props.onChange(e);
        }), mt(bt(a), "handleClickOutside", function () {
          a.props.onCancel();
        }), mt(bt(a), "shiftYears", function (e) {
          var t = a.state.yearsList.map(function (t) {
            return t + e;
          });
          a.setState({
            yearsList: t
          });
        }), mt(bt(a), "incrementYears", function () {
          return a.shiftYears(1);
        }), mt(bt(a), "decrementYears", function () {
          return a.shiftYears(-1);
        });
        var n = e.yearDropdownItemNumber,
            o = e.scrollableYearDropdown,
            s = n || (o ? 10 : 5);
        return a.state = {
          yearsList: br(a.props.year, s, a.props.minDate, a.props.maxDate)
        }, a;
      }

      return ht(r, [{
        key: "render",
        value: function () {
          var e = ce.default({
            "react-datepicker__year-dropdown": !0,
            "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
          });
          return de.default.createElement("div", {
            className: e
          }, this.renderOptions());
        }
      }]), r;
    }(de.default.Component),
        Sr = lt.default(Cr),
        _r = function (e) {
      wt(r, e);
      var t = St(r);

      function r() {
        var e;
        ut(this, r);

        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

        return mt(bt(e = t.call.apply(t, [this].concat(n))), "state", {
          dropdownVisible: !1
        }), mt(bt(e), "renderSelectOptions", function () {
          for (var t = e.props.minDate ? Te.default(e.props.minDate) : 1900, r = e.props.maxDate ? Te.default(e.props.maxDate) : 2100, a = [], n = t; n <= r; n++) a.push(de.default.createElement("option", {
            key: n,
            value: n
          }, n));

          return a;
        }), mt(bt(e), "onSelectChange", function (t) {
          e.onChange(t.target.value);
        }), mt(bt(e), "renderSelectMode", function () {
          return de.default.createElement("select", {
            value: e.props.year,
            className: "react-datepicker__year-select",
            onChange: e.onSelectChange
          }, e.renderSelectOptions());
        }), mt(bt(e), "renderReadView", function (t) {
          return de.default.createElement("div", {
            key: "read",
            style: {
              visibility: t ? "visible" : "hidden"
            },
            className: "react-datepicker__year-read-view",
            onClick: function (t) {
              return e.toggleDropdown(t);
            }
          }, de.default.createElement("span", {
            className: "react-datepicker__year-read-view--down-arrow"
          }), de.default.createElement("span", {
            className: "react-datepicker__year-read-view--selected-year"
          }, e.props.year));
        }), mt(bt(e), "renderDropdown", function () {
          return de.default.createElement(Sr, {
            key: "dropdown",
            year: e.props.year,
            onChange: e.onChange,
            onCancel: e.toggleDropdown,
            minDate: e.props.minDate,
            maxDate: e.props.maxDate,
            scrollableYearDropdown: e.props.scrollableYearDropdown,
            yearDropdownItemNumber: e.props.yearDropdownItemNumber
          });
        }), mt(bt(e), "renderScrollMode", function () {
          var t = e.state.dropdownVisible,
              r = [e.renderReadView(!t)];
          return t && r.unshift(e.renderDropdown()), r;
        }), mt(bt(e), "onChange", function (t) {
          e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
        }), mt(bt(e), "toggleDropdown", function (t) {
          e.setState({
            dropdownVisible: !e.state.dropdownVisible
          }, function () {
            e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
          });
        }), mt(bt(e), "handleYearChange", function (t, r) {
          e.onSelect(t, r), e.setOpen();
        }), mt(bt(e), "onSelect", function (t, r) {
          e.props.onSelect && e.props.onSelect(t, r);
        }), mt(bt(e), "setOpen", function () {
          e.props.setOpen && e.props.setOpen(!0);
        }), e;
      }

      return ht(r, [{
        key: "render",
        value: function () {
          var e;

          switch (this.props.dropdownMode) {
            case "scroll":
              e = this.renderScrollMode();
              break;

            case "select":
              e = this.renderSelectMode();
          }

          return de.default.createElement("div", {
            className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
          }, e);
        }
      }]), r;
    }(de.default.Component),
        Mr = function (e) {
      wt(r, e);
      var t = St(r);

      function r() {
        var e;
        ut(this, r);

        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

        return mt(bt(e = t.call.apply(t, [this].concat(n))), "renderOptions", function () {
          return e.props.monthNames.map(function (t, r) {
            return de.default.createElement("div", {
              className: e.props.month === r ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
              key: t,
              onClick: e.onChange.bind(bt(e), r)
            }, e.props.month === r ? de.default.createElement("span", {
              className: "react-datepicker__month-option--selected"
            }, "✓") : "", t);
          });
        }), mt(bt(e), "onChange", function (t) {
          return e.props.onChange(t);
        }), mt(bt(e), "handleClickOutside", function () {
          return e.props.onCancel();
        }), e;
      }

      return ht(r, [{
        key: "render",
        value: function () {
          return de.default.createElement("div", {
            className: "react-datepicker__month-dropdown"
          }, this.renderOptions());
        }
      }]), r;
    }(de.default.Component),
        Pr = lt.default(Mr),
        Er = function (e) {
      wt(r, e);
      var t = St(r);

      function r() {
        var e;
        ut(this, r);

        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

        return mt(bt(e = t.call.apply(t, [this].concat(n))), "state", {
          dropdownVisible: !1
        }), mt(bt(e), "renderSelectOptions", function (e) {
          return e.map(function (e, t) {
            return de.default.createElement("option", {
              key: t,
              value: t
            }, e);
          });
        }), mt(bt(e), "renderSelectMode", function (t) {
          return de.default.createElement("select", {
            value: e.props.month,
            className: "react-datepicker__month-select",
            onChange: function (t) {
              return e.onChange(t.target.value);
            }
          }, e.renderSelectOptions(t));
        }), mt(bt(e), "renderReadView", function (t, r) {
          return de.default.createElement("div", {
            key: "read",
            style: {
              visibility: t ? "visible" : "hidden"
            },
            className: "react-datepicker__month-read-view",
            onClick: e.toggleDropdown
          }, de.default.createElement("span", {
            className: "react-datepicker__month-read-view--down-arrow"
          }), de.default.createElement("span", {
            className: "react-datepicker__month-read-view--selected-month"
          }, r[e.props.month]));
        }), mt(bt(e), "renderDropdown", function (t) {
          return de.default.createElement(Pr, {
            key: "dropdown",
            month: e.props.month,
            monthNames: t,
            onChange: e.onChange,
            onCancel: e.toggleDropdown
          });
        }), mt(bt(e), "renderScrollMode", function (t) {
          var r = e.state.dropdownVisible,
              a = [e.renderReadView(!r, t)];
          return r && a.unshift(e.renderDropdown(t)), a;
        }), mt(bt(e), "onChange", function (t) {
          e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
        }), mt(bt(e), "toggleDropdown", function () {
          return e.setState({
            dropdownVisible: !e.state.dropdownVisible
          });
        }), e;
      }

      return ht(r, [{
        key: "render",
        value: function () {
          var e,
              t = this,
              r = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (e) {
            return Zt(e, t.props.locale);
          } : function (e) {
            return Xt(e, t.props.locale);
          });

          switch (this.props.dropdownMode) {
            case "scroll":
              e = this.renderScrollMode(r);
              break;

            case "select":
              e = this.renderSelectMode(r);
          }

          return de.default.createElement("div", {
            className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
          }, e);
        }
      }]), r;
    }(de.default.Component);

    function Nr(e, t) {
      for (var r = [], a = Bt(e), n = Bt(t); !at.default(a, n);) r.push(xt(a)), a = we.default(a, 1);

      return r;
    }

    var Or = function (e) {
      wt(r, e);
      var t = St(r);

      function r(e) {
        var a;
        return ut(this, r), mt(bt(a = t.call(this, e)), "renderOptions", function () {
          return a.state.monthYearsList.map(function (e) {
            var t = Ie.default(e),
                r = Kt(a.props.date, e) && Qt(a.props.date, e);
            return de.default.createElement("div", {
              className: r ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
              key: t,
              onClick: a.onChange.bind(bt(a), t)
            }, r ? de.default.createElement("span", {
              className: "react-datepicker__month-year-option--selected"
            }, "✓") : "", Lt(e, a.props.dateFormat, a.props.locale));
          });
        }), mt(bt(a), "onChange", function (e) {
          return a.props.onChange(e);
        }), mt(bt(a), "handleClickOutside", function () {
          a.props.onCancel();
        }), a.state = {
          monthYearsList: Nr(a.props.minDate, a.props.maxDate)
        }, a;
      }

      return ht(r, [{
        key: "render",
        value: function () {
          var e = ce.default({
            "react-datepicker__month-year-dropdown": !0,
            "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
          });
          return de.default.createElement("div", {
            className: e
          }, this.renderOptions());
        }
      }]), r;
    }(de.default.Component),
        Yr = lt.default(Or),
        xr = function (e) {
      wt(r, e);
      var t = St(r);

      function r() {
        var e;
        ut(this, r);

        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

        return mt(bt(e = t.call.apply(t, [this].concat(n))), "state", {
          dropdownVisible: !1
        }), mt(bt(e), "renderSelectOptions", function () {
          for (var t = Bt(e.props.minDate), r = Bt(e.props.maxDate), a = []; !at.default(t, r);) {
            var n = Ie.default(t);
            a.push(de.default.createElement("option", {
              key: n,
              value: n
            }, Lt(t, e.props.dateFormat, e.props.locale))), t = we.default(t, 1);
          }

          return a;
        }), mt(bt(e), "onSelectChange", function (t) {
          e.onChange(t.target.value);
        }), mt(bt(e), "renderSelectMode", function () {
          return de.default.createElement("select", {
            value: Ie.default(Bt(e.props.date)),
            className: "react-datepicker__month-year-select",
            onChange: e.onSelectChange
          }, e.renderSelectOptions());
        }), mt(bt(e), "renderReadView", function (t) {
          var r = Lt(e.props.date, e.props.dateFormat, e.props.locale);
          return de.default.createElement("div", {
            key: "read",
            style: {
              visibility: t ? "visible" : "hidden"
            },
            className: "react-datepicker__month-year-read-view",
            onClick: function (t) {
              return e.toggleDropdown(t);
            }
          }, de.default.createElement("span", {
            className: "react-datepicker__month-year-read-view--down-arrow"
          }), de.default.createElement("span", {
            className: "react-datepicker__month-year-read-view--selected-month-year"
          }, r));
        }), mt(bt(e), "renderDropdown", function () {
          return de.default.createElement(Yr, {
            key: "dropdown",
            date: e.props.date,
            dateFormat: e.props.dateFormat,
            onChange: e.onChange,
            onCancel: e.toggleDropdown,
            minDate: e.props.minDate,
            maxDate: e.props.maxDate,
            scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
            locale: e.props.locale
          });
        }), mt(bt(e), "renderScrollMode", function () {
          var t = e.state.dropdownVisible,
              r = [e.renderReadView(!t)];
          return t && r.unshift(e.renderDropdown()), r;
        }), mt(bt(e), "onChange", function (t) {
          e.toggleDropdown();
          var r = xt(parseInt(t));
          Kt(e.props.date, r) && Qt(e.props.date, r) || e.props.onChange(r);
        }), mt(bt(e), "toggleDropdown", function () {
          return e.setState({
            dropdownVisible: !e.state.dropdownVisible
          });
        }), e;
      }

      return ht(r, [{
        key: "render",
        value: function () {
          var e;

          switch (this.props.dropdownMode) {
            case "scroll":
              e = this.renderScrollMode();
              break;

            case "select":
              e = this.renderSelectMode();
          }

          return de.default.createElement("div", {
            className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
          }, e);
        }
      }]), r;
    }(de.default.Component),
        Tr = function (e) {
      wt(r, e);
      var t = St(r);

      function r() {
        var e;
        ut(this, r);

        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

        return mt(bt(e = t.call.apply(t, [this].concat(n))), "dayEl", de.default.createRef()), mt(bt(e), "handleClick", function (t) {
          !e.isDisabled() && e.props.onClick && e.props.onClick(t);
        }), mt(bt(e), "handleMouseEnter", function (t) {
          !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
        }), mt(bt(e), "handleOnKeyDown", function (t) {
          " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
        }), mt(bt(e), "isSameDay", function (t) {
          return Ut(e.props.day, t);
        }), mt(bt(e), "isKeyboardSelected", function () {
          return !e.props.disabledKeyboardNavigation && !e.isSameDay(e.props.selected) && e.isSameDay(e.props.preSelection);
        }), mt(bt(e), "isDisabled", function () {
          return tr(e.props.day, e.props);
        }), mt(bt(e), "isExcluded", function () {
          return rr(e.props.day, e.props);
        }), mt(bt(e), "getHighLightedClass", function (t) {
          var r = e.props,
              a = r.day,
              n = r.highlightDates;
          if (!n) return !1;
          var o = Lt(a, "MM.dd.yyyy");
          return n.get(o);
        }), mt(bt(e), "isInRange", function () {
          var t = e.props,
              r = t.day,
              a = t.startDate,
              n = t.endDate;
          return !(!a || !n) && zt(r, a, n);
        }), mt(bt(e), "isInSelectingRange", function () {
          var t = e.props,
              r = t.day,
              a = t.selectsStart,
              n = t.selectsEnd,
              o = t.selectsRange,
              s = t.selectingDate,
              i = t.startDate,
              p = t.endDate;
          return !(!(a || n || o) || !s || e.isDisabled()) && (a && p && (nt.default(s, p) || $t(s, p)) ? zt(r, s, p) : (n && i && (at.default(s, i) || $t(s, i)) || !(!o || !i || p || !at.default(s, i) && !$t(s, i))) && zt(r, i, s));
        }), mt(bt(e), "isSelectingRangeStart", function () {
          if (!e.isInSelectingRange()) return !1;
          var t = e.props,
              r = t.day,
              a = t.selectingDate,
              n = t.startDate;
          return Ut(r, t.selectsStart ? a : n);
        }), mt(bt(e), "isSelectingRangeEnd", function () {
          if (!e.isInSelectingRange()) return !1;
          var t = e.props,
              r = t.day,
              a = t.selectingDate,
              n = t.endDate;
          return Ut(r, t.selectsEnd ? a : n);
        }), mt(bt(e), "isRangeStart", function () {
          var t = e.props,
              r = t.day,
              a = t.startDate,
              n = t.endDate;
          return !(!a || !n) && Ut(a, r);
        }), mt(bt(e), "isRangeEnd", function () {
          var t = e.props,
              r = t.day,
              a = t.startDate,
              n = t.endDate;
          return !(!a || !n) && Ut(n, r);
        }), mt(bt(e), "isWeekend", function () {
          var t = Ee.default(e.props.day);
          return 0 === t || 6 === t;
        }), mt(bt(e), "isOutsideMonth", function () {
          return void 0 !== e.props.month && e.props.month !== Ye.default(e.props.day);
        }), mt(bt(e), "getClassNames", function (t) {
          var r = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
          return ce.default("react-datepicker__day", r, "react-datepicker__day--" + qt(e.props.day), {
            "react-datepicker__day--disabled": e.isDisabled(),
            "react-datepicker__day--excluded": e.isExcluded(),
            "react-datepicker__day--selected": e.isSameDay(e.props.selected),
            "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
            "react-datepicker__day--range-start": e.isRangeStart(),
            "react-datepicker__day--range-end": e.isRangeEnd(),
            "react-datepicker__day--in-range": e.isInRange(),
            "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
            "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
            "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
            "react-datepicker__day--today": e.isSameDay(xt()),
            "react-datepicker__day--weekend": e.isWeekend(),
            "react-datepicker__day--outside-month": e.isOutsideMonth()
          }, e.getHighLightedClass("react-datepicker__day--highlighted"));
        }), mt(bt(e), "getAriaLabel", function () {
          var t = e.props,
              r = t.day,
              a = t.ariaLabelPrefixWhenEnabled,
              n = void 0 === a ? "Choose" : a,
              o = t.ariaLabelPrefixWhenDisabled,
              s = void 0 === o ? "Not available" : o,
              i = e.isDisabled() || e.isExcluded() ? s : n;
          return "".concat(i, " ").concat(Lt(r, "PPPP"));
        }), mt(bt(e), "getTabIndex", function (t, r) {
          var a = t || e.props.selected,
              n = r || e.props.preSelection;
          return e.isKeyboardSelected() || e.isSameDay(a) && Ut(n, a) ? 0 : -1;
        }), mt(bt(e), "handleFocusDay", function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = !1;
          0 === e.getTabIndex() && !t.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (r = !0)), r && e.dayEl.current.focus({
            preventScroll: !0
          });
        }), mt(bt(e), "renderDayContents", function () {
          if (e.isOutsideMonth()) {
            if (e.props.monthShowsDuplicateDaysEnd && Ne.default(e.props.day) < 10) return null;
            if (e.props.monthShowsDuplicateDaysStart && Ne.default(e.props.day) > 20) return null;
          }

          return e.props.renderDayContents ? e.props.renderDayContents(Ne.default(e.props.day), e.props.day) : Ne.default(e.props.day);
        }), mt(bt(e), "render", function () {
          return de.default.createElement("div", {
            ref: e.dayEl,
            className: e.getClassNames(e.props.day),
            onKeyDown: e.handleOnKeyDown,
            onClick: e.handleClick,
            onMouseEnter: e.handleMouseEnter,
            tabIndex: e.getTabIndex(),
            "aria-label": e.getAriaLabel(),
            role: "button",
            "aria-disabled": e.isDisabled()
          }, e.renderDayContents());
        }), e;
      }

      return ht(r, [{
        key: "componentDidMount",
        value: function () {
          this.handleFocusDay();
        }
      }, {
        key: "componentDidUpdate",
        value: function (e) {
          this.handleFocusDay(e);
        }
      }]), r;
    }(de.default.Component),
        Ir = function (e) {
      wt(r, e);
      var t = St(r);

      function r() {
        var e;
        ut(this, r);

        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

        return mt(bt(e = t.call.apply(t, [this].concat(n))), "handleClick", function (t) {
          e.props.onClick && e.props.onClick(t);
        }), e;
      }

      return ht(r, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.weekNumber,
              r = e.ariaLabelPrefix,
              a = void 0 === r ? "week " : r,
              n = {
            "react-datepicker__week-number": !0,
            "react-datepicker__week-number--clickable": !!e.onClick
          };
          return de.default.createElement("div", {
            className: ce.default(n),
            "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
            onClick: this.handleClick
          }, t);
        }
      }]), r;
    }(de.default.Component),
        Lr = function (e) {
      wt(r, e);
      var t = St(r);

      function r() {
        var e;
        ut(this, r);

        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

        return mt(bt(e = t.call.apply(t, [this].concat(n))), "handleDayClick", function (t, r) {
          e.props.onDayClick && e.props.onDayClick(t, r);
        }), mt(bt(e), "handleDayMouseEnter", function (t) {
          e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
        }), mt(bt(e), "handleWeekClick", function (t, r, a) {
          "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, a), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
        }), mt(bt(e), "formatWeekNumber", function (t) {
          return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : Rt(t);
        }), mt(bt(e), "renderDays", function () {
          var t = Wt(e.props.day, e.props.locale),
              r = [],
              a = e.formatWeekNumber(t);

          if (e.props.showWeekNumber) {
            var n = e.props.onWeekSelect ? e.handleWeekClick.bind(bt(e), t, a) : void 0;
            r.push(de.default.createElement(Ir, {
              key: "W",
              weekNumber: a,
              onClick: n,
              ariaLabelPrefix: e.props.ariaLabelPrefix
            }));
          }

          return r.concat([0, 1, 2, 3, 4, 5, 6].map(function (r) {
            var a = ve.default(t, r);
            return de.default.createElement(Tr, {
              ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
              ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
              key: a.valueOf(),
              day: a,
              month: e.props.month,
              onClick: e.handleDayClick.bind(bt(e), a),
              onMouseEnter: e.handleDayMouseEnter.bind(bt(e), a),
              minDate: e.props.minDate,
              maxDate: e.props.maxDate,
              excludeDates: e.props.excludeDates,
              includeDates: e.props.includeDates,
              highlightDates: e.props.highlightDates,
              selectingDate: e.props.selectingDate,
              filterDate: e.props.filterDate,
              preSelection: e.props.preSelection,
              selected: e.props.selected,
              selectsStart: e.props.selectsStart,
              selectsEnd: e.props.selectsEnd,
              selectsRange: e.props.selectsRange,
              startDate: e.props.startDate,
              endDate: e.props.endDate,
              dayClassName: e.props.dayClassName,
              renderDayContents: e.props.renderDayContents,
              disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
              handleOnKeyDown: e.props.handleOnKeyDown,
              isInputFocused: e.props.isInputFocused,
              containerRef: e.props.containerRef,
              inline: e.props.inline,
              shouldFocusDayInline: e.props.shouldFocusDayInline,
              monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
              monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
            });
          }));
        }), e;
      }

      return ht(r, [{
        key: "render",
        value: function () {
          return de.default.createElement("div", {
            className: "react-datepicker__week"
          }, this.renderDays());
        }
      }], [{
        key: "defaultProps",
        get: function () {
          return {
            shouldCloseOnSelect: !0
          };
        }
      }]), r;
    }(de.default.Component),
        Fr = function (e) {
      wt(r, e);
      var t = St(r);

      function r() {
        var e;
        ut(this, r);

        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

        return mt(bt(e = t.call.apply(t, [this].concat(n))), "MONTH_REFS", _t(Array(12)).map(function () {
          return de.default.createRef();
        })), mt(bt(e), "isDisabled", function (t) {
          return tr(t, e.props);
        }), mt(bt(e), "isExcluded", function (t) {
          return rr(t, e.props);
        }), mt(bt(e), "handleDayClick", function (t, r) {
          e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
        }), mt(bt(e), "handleDayMouseEnter", function (t) {
          e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
        }), mt(bt(e), "handleMouseLeave", function () {
          e.props.onMouseLeave && e.props.onMouseLeave();
        }), mt(bt(e), "isRangeStartMonth", function (t) {
          var r = e.props,
              a = r.day,
              n = r.startDate,
              o = r.endDate;
          return !(!n || !o) && Qt(qe.default(a, t), n);
        }), mt(bt(e), "isRangeStartQuarter", function (t) {
          var r = e.props,
              a = r.day,
              n = r.startDate,
              o = r.endDate;
          return !(!n || !o) && Vt(Ae.default(a, t), n);
        }), mt(bt(e), "isRangeEndMonth", function (t) {
          var r = e.props,
              a = r.day,
              n = r.startDate,
              o = r.endDate;
          return !(!n || !o) && Qt(qe.default(a, t), o);
        }), mt(bt(e), "isRangeEndQuarter", function (t) {
          var r = e.props,
              a = r.day,
              n = r.startDate,
              o = r.endDate;
          return !(!n || !o) && Vt(Ae.default(a, t), o);
        }), mt(bt(e), "isWeekInMonth", function (t) {
          var r = e.props.day,
              a = ve.default(t, 6);
          return Qt(t, r) || Qt(a, r);
        }), mt(bt(e), "renderWeeks", function () {
          for (var t = [], r = e.props.fixedHeight, a = Wt(Bt(e.props.day), e.props.locale), n = 0, o = !1; t.push(de.default.createElement(Lr, {
            ariaLabelPrefix: e.props.weekAriaLabelPrefix,
            chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
            disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
            key: n,
            day: a,
            month: Ye.default(e.props.day),
            onDayClick: e.handleDayClick,
            onDayMouseEnter: e.handleDayMouseEnter,
            onWeekSelect: e.props.onWeekSelect,
            formatWeekNumber: e.props.formatWeekNumber,
            locale: e.props.locale,
            minDate: e.props.minDate,
            maxDate: e.props.maxDate,
            excludeDates: e.props.excludeDates,
            includeDates: e.props.includeDates,
            inline: e.props.inline,
            shouldFocusDayInline: e.props.shouldFocusDayInline,
            highlightDates: e.props.highlightDates,
            selectingDate: e.props.selectingDate,
            filterDate: e.props.filterDate,
            preSelection: e.props.preSelection,
            selected: e.props.selected,
            selectsStart: e.props.selectsStart,
            selectsEnd: e.props.selectsEnd,
            selectsRange: e.props.selectsRange,
            showWeekNumber: e.props.showWeekNumbers,
            startDate: e.props.startDate,
            endDate: e.props.endDate,
            dayClassName: e.props.dayClassName,
            setOpen: e.props.setOpen,
            shouldCloseOnSelect: e.props.shouldCloseOnSelect,
            disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
            renderDayContents: e.props.renderDayContents,
            handleOnKeyDown: e.props.handleOnKeyDown,
            isInputFocused: e.props.isInputFocused,
            containerRef: e.props.containerRef,
            monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
            monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
          })), !o;) {
            n++, a = De.default(a, 1);
            var s = r && n >= 6,
                i = !r && !e.isWeekInMonth(a);

            if (s || i) {
              if (!e.props.peekNextMonth) break;
              o = !0;
            }
          }

          return t;
        }), mt(bt(e), "onMonthClick", function (t, r) {
          e.handleDayClick(Bt(qe.default(e.props.day, r)), t);
        }), mt(bt(e), "handleMonthNavigation", function (t, r) {
          e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
        }), mt(bt(e), "onMonthKeyDown", function (t, r) {
          var a = t.key;
          if (!e.props.disabledKeyboardNavigation) switch (a) {
            case "Enter":
              e.onMonthClick(t, r), e.props.setPreSelection(e.props.selected);
              break;

            case "ArrowRight":
              e.handleMonthNavigation(11 === r ? 0 : r + 1, we.default(e.props.preSelection, 1));
              break;

            case "ArrowLeft":
              e.handleMonthNavigation(0 === r ? 11 : r - 1, Ce.default(e.props.preSelection, 1));
          }
        }), mt(bt(e), "onQuarterClick", function (t, r) {
          e.handleDayClick(Ht(Ae.default(e.props.day, r)), t);
        }), mt(bt(e), "getMonthClassNames", function (t) {
          var r = e.props,
              a = r.day,
              n = r.startDate,
              o = r.endDate,
              s = r.selected,
              i = r.minDate,
              p = r.maxDate,
              l = r.preSelection,
              d = r.monthClassName,
              c = d ? d(a) : void 0;
          return ce.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), c, {
            "react-datepicker__month--disabled": (i || p) && ar(qe.default(a, t), e.props),
            "react-datepicker__month--selected": Ye.default(a) === t && Te.default(a) === Te.default(s),
            "react-datepicker__month-text--keyboard-selected": Ye.default(l) === t,
            "react-datepicker__month--in-range": nr(n, o, t, a),
            "react-datepicker__month--range-start": e.isRangeStartMonth(t),
            "react-datepicker__month--range-end": e.isRangeEndMonth(t)
          });
        }), mt(bt(e), "getTabIndex", function (t) {
          var r = Ye.default(e.props.preSelection);
          return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
        }), mt(bt(e), "getAriaLabel", function (t) {
          var r = e.props,
              a = r.ariaLabelPrefix,
              n = void 0 === a ? "Choose" : a,
              o = r.disabledDayAriaLabelPrefix,
              s = void 0 === o ? "Not available" : o,
              i = r.day,
              p = qe.default(i, t),
              l = e.isDisabled(p) || e.isExcluded(p) ? s : n;
          return "".concat(l, " ").concat(Lt(p, "MMMM yyyy"));
        }), mt(bt(e), "getQuarterClassNames", function (t) {
          var r = e.props,
              a = r.day,
              n = r.startDate,
              o = r.endDate,
              s = r.selected,
              i = r.minDate,
              p = r.maxDate;
          return ce.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
            "react-datepicker__quarter--disabled": (i || p) && or(Ae.default(a, t), e.props),
            "react-datepicker__quarter--selected": xe.default(a) === t && Te.default(a) === Te.default(s),
            "react-datepicker__quarter--in-range": ir(n, o, t, a),
            "react-datepicker__quarter--range-start": e.isRangeStartQuarter(t),
            "react-datepicker__quarter--range-end": e.isRangeEndQuarter(t)
          });
        }), mt(bt(e), "renderMonths", function () {
          var t = e.props,
              r = t.showFullMonthYearPicker,
              a = t.showTwoColumnMonthYearPicker,
              n = t.showFourColumnMonthYearPicker,
              o = t.locale;
          return (n ? [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]] : a ? [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]] : [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]).map(function (t, a) {
            return de.default.createElement("div", {
              className: "react-datepicker__month-wrapper",
              key: a
            }, t.map(function (t, a) {
              return de.default.createElement("div", {
                ref: e.MONTH_REFS[t],
                key: a,
                onClick: function (r) {
                  e.onMonthClick(r, t);
                },
                onKeyDown: function (r) {
                  e.onMonthKeyDown(r, t);
                },
                tabIndex: e.getTabIndex(t),
                className: e.getMonthClassNames(t),
                role: "button",
                "aria-label": e.getAriaLabel(t)
              }, r ? Xt(t, o) : Zt(t, o));
            }));
          });
        }), mt(bt(e), "renderQuarters", function () {
          return de.default.createElement("div", {
            className: "react-datepicker__quarter-wrapper"
          }, [1, 2, 3, 4].map(function (t, r) {
            return de.default.createElement("div", {
              key: r,
              onClick: function (r) {
                e.onQuarterClick(r, t);
              },
              className: e.getQuarterClassNames(t)
            }, er(t, e.props.locale));
          }));
        }), mt(bt(e), "getClassNames", function () {
          var t = e.props;
          var r = t.selectingDate,
              a = t.selectsStart,
              n = t.selectsEnd,
              o = t.showMonthYearPicker,
              s = t.showQuarterYearPicker;
          return ce.default("react-datepicker__month", {
            "react-datepicker__month--selecting-range": r && (a || n)
          }, {
            "react-datepicker__monthPicker": o
          }, {
            "react-datepicker__quarterPicker": s
          });
        }), e;
      }

      return ht(r, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.showMonthYearPicker,
              r = e.showQuarterYearPicker,
              a = e.day,
              n = e.ariaLabelPrefix,
              o = void 0 === n ? "month " : n;
          return de.default.createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: this.handleMouseLeave,
            "aria-label": "".concat(o, " ").concat(Lt(a, "yyyy-MM"))
          }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
        }
      }]), r;
    }(de.default.Component),
        Rr = function (e) {
      wt(r, e);
      var t = St(r);

      function r() {
        var e;
        ut(this, r);

        for (var a = arguments.length, n = new Array(a), o = 0; o < a; o++) n[o] = arguments[o];

        return mt(bt(e = t.call.apply(t, [this].concat(n))), "state", {
          height: null
        }), mt(bt(e), "handleClick", function (t) {
          (e.props.minTime || e.props.maxTime) && cr(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && dr(t, e.props) || e.props.onChange(t);
        }), mt(bt(e), "liClasses", function (t, r, a) {
          var n = ["react-datepicker__time-list-item", e.props.timeClassName ? e.props.timeClassName(t, r, a) : void 0];
          return e.props.selected && r === Pe.default(t) && a === Me.default(t) && n.push("react-datepicker__time-list-item--selected"), ((e.props.minTime || e.props.maxTime) && cr(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && dr(t, e.props)) && n.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * Pe.default(t) + Me.default(t)) % e.props.intervals != 0 && n.push("react-datepicker__time-list-item--injected"), n.join(" ");
        }), mt(bt(e), "renderTimes", function () {
          for (var t = [], r = e.props.format ? e.props.format : "p", a = e.props.intervals, n = At(xt(e.props.selected)), o = 1440 / a, s = e.props.injectTimes && e.props.injectTimes.sort(function (e, t) {
            return e - t;
          }), i = e.props.selected || e.props.openToDate || xt(), p = Pe.default(i), l = Me.default(i), d = Re.default(Fe.default(n, l), p), c = 0; c < o; c++) {
            var u = me.default(n, c * a);

            if (t.push(u), s) {
              var f = wr(n, u, c, a, s);
              t = t.concat(f);
            }
          }

          return t.map(function (t, a) {
            return de.default.createElement("li", {
              key: a,
              onClick: e.handleClick.bind(bt(e), t),
              className: e.liClasses(t, p, l),
              ref: function (r) {
                (nt.default(t, d) || $t(t, d)) && (e.centerLi = r);
              },
              tabIndex: "0"
            }, Lt(t, r, e.props.locale));
          });
        }), e;
      }

      return ht(r, [{
        key: "componentDidMount",
        value: function () {
          this.list.scrollTop = r.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({
            height: this.props.monthRef.clientHeight - this.header.clientHeight
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.state.height;
          return de.default.createElement("div", {
            className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
          }, de.default.createElement("div", {
            className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
            ref: function (t) {
              e.header = t;
            }
          }, de.default.createElement("div", {
            className: "react-datepicker-time__header"
          }, this.props.timeCaption)), de.default.createElement("div", {
            className: "react-datepicker__time"
          }, de.default.createElement("div", {
            className: "react-datepicker__time-box"
          }, de.default.createElement("ul", {
            className: "react-datepicker__time-list",
            ref: function (t) {
              e.list = t;
            },
            style: t ? {
              height: t
            } : {},
            tabIndex: "0"
          }, this.renderTimes()))));
        }
      }], [{
        key: "defaultProps",
        get: function () {
          return {
            intervals: 30,
            onTimeChange: function () {},
            todayButton: null,
            timeCaption: "Time"
          };
        }
      }]), r;
    }(de.default.Component);

    mt(Rr, "calcCenterPosition", function (e, t) {
      return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });

    var qr = function (e) {
      wt(r, e);
      var t = St(r);

      function r(e) {
        var a;
        return ut(this, r), mt(bt(a = t.call(this, e)), "handleYearClick", function (e, t) {
          a.props.onDayClick && a.props.onDayClick(e, t);
        }), mt(bt(a), "isSameDay", function (e, t) {
          return Ut(e, t);
        }), mt(bt(a), "isKeyboardSelected", function (e) {
          var t = jt(We.default(a.props.date, e));
          return !a.props.disabledKeyboardNavigation && !a.props.inline && !Ut(t, jt(a.props.selected)) && Ut(t, jt(a.props.preSelection));
        }), mt(bt(a), "onYearClick", function (e, t) {
          var r = a.props.date;
          a.handleYearClick(jt(We.default(r, t)), e);
        }), mt(bt(a), "getYearClassNames", function (e) {
          var t = a.props,
              r = t.minDate,
              n = t.maxDate,
              o = t.selected;
          return ce.default("react-datepicker__year-text", {
            "react-datepicker__year-text--selected": e === Te.default(o),
            "react-datepicker__year-text--disabled": (r || n) && sr(e, a.props),
            "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
            "react-datepicker__year-text--today": e === Te.default(xt())
          });
        }), a;
      }

      return ht(r, [{
        key: "render",
        value: function () {
          for (var e = this, t = [], r = this.props, a = gr(r.date, r.yearItemNumber), n = a.startPeriod, o = a.endPeriod, s = function s(r) {
            t.push(de.default.createElement("div", {
              onClick: function (t) {
                e.onYearClick(t, r);
              },
              className: e.getYearClassNames(r),
              key: r
            }, r));
          }, i = n; i <= o; i++) s(i);

          return de.default.createElement("div", {
            className: "react-datepicker__year"
          }, de.default.createElement("div", {
            className: "react-datepicker__year-wrapper"
          }, t));
        }
      }]), r;
    }(de.default.Component),
        Ar = function (e) {
      wt(r, e);
      var t = St(r);

      function r(e) {
        var a;
        return ut(this, r), mt(bt(a = t.call(this, e)), "onTimeChange", function (e) {
          a.setState({
            time: e
          });
          var t = new Date();
          t.setHours(e.split(":")[0]), t.setMinutes(e.split(":")[1]), a.props.onChange(t);
        }), mt(bt(a), "renderTimeInput", function () {
          var e = a.state.time,
              t = a.props,
              r = t.date,
              n = t.timeString,
              o = t.customTimeInput;
          return o ? de.default.cloneElement(o, {
            date: r,
            value: e,
            onChange: a.onTimeChange
          }) : de.default.createElement("input", {
            type: "time",
            className: "react-datepicker-time__input",
            placeholder: "Time",
            name: "time-input",
            required: !0,
            value: e,
            onChange: function (e) {
              a.onTimeChange(e.target.value || n);
            }
          });
        }), a.state = {
          time: a.props.timeString
        }, a;
      }

      return ht(r, [{
        key: "render",
        value: function () {
          return de.default.createElement("div", {
            className: "react-datepicker__input-time-container"
          }, de.default.createElement("div", {
            className: "react-datepicker-time__caption"
          }, this.props.timeInputLabel), de.default.createElement("div", {
            className: "react-datepicker-time__input-container"
          }, de.default.createElement("div", {
            className: "react-datepicker-time__input"
          }, this.renderTimeInput())));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function (e, t) {
          return e.timeString !== t.time ? {
            time: e.timeString
          } : null;
        }
      }]), r;
    }(de.default.Component);

    function Wr(e) {
      var t = e.className,
          r = e.children,
          a = e.showPopperArrow,
          n = e.arrowProps,
          o = void 0 === n ? {} : n;
      return de.default.createElement("div", {
        className: t
      }, a && de.default.createElement("div", yt({
        className: "react-datepicker__triangle"
      }, o)), r);
    }

    var Br = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"],
        jr = function (e) {
      wt(r, e);
      var t = St(r);

      function r(e) {
        var a;
        return ut(this, r), mt(bt(a = t.call(this, e)), "handleClickOutside", function (e) {
          a.props.onClickOutside(e);
        }), mt(bt(a), "setClickOutsideRef", function () {
          return a.containerRef.current;
        }), mt(bt(a), "handleDropdownFocus", function (e) {
          (function () {
            var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
            return Br.some(function (t) {
              return e.indexOf(t) >= 0;
            });
          })(e.target) && a.props.onDropdownFocus();
        }), mt(bt(a), "getDateInView", function () {
          var e = a.props,
              t = e.preSelection,
              r = e.selected,
              n = e.openToDate,
              o = yr(a.props),
              s = vr(a.props),
              i = xt(),
              p = n || r || t;
          return p || (o && nt.default(i, o) ? o : s && at.default(i, s) ? s : i);
        }), mt(bt(a), "increaseMonth", function () {
          a.setState(function (e) {
            var t = e.date;
            return {
              date: we.default(t, 1)
            };
          }, function () {
            return a.handleMonthChange(a.state.date);
          });
        }), mt(bt(a), "decreaseMonth", function () {
          a.setState(function (e) {
            var t = e.date;
            return {
              date: Ce.default(t, 1)
            };
          }, function () {
            return a.handleMonthChange(a.state.date);
          });
        }), mt(bt(a), "handleDayClick", function (e, t, r) {
          a.props.onSelect(e, t, r), a.props.setPreSelection && a.props.setPreSelection(e);
        }), mt(bt(a), "handleDayMouseEnter", function (e) {
          a.setState({
            selectingDate: e
          }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
        }), mt(bt(a), "handleMonthMouseLeave", function () {
          a.setState({
            selectingDate: null
          }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
        }), mt(bt(a), "handleYearChange", function (e) {
          a.props.onYearChange && a.props.onYearChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
        }), mt(bt(a), "handleMonthChange", function (e) {
          a.props.onMonthChange && a.props.onMonthChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
        }), mt(bt(a), "handleMonthYearChange", function (e) {
          a.handleYearChange(e), a.handleMonthChange(e);
        }), mt(bt(a), "changeYear", function (e) {
          a.setState(function (t) {
            var r = t.date;
            return {
              date: We.default(r, e)
            };
          }, function () {
            return a.handleYearChange(a.state.date);
          });
        }), mt(bt(a), "changeMonth", function (e) {
          a.setState(function (t) {
            var r = t.date;
            return {
              date: qe.default(r, e)
            };
          }, function () {
            return a.handleMonthChange(a.state.date);
          });
        }), mt(bt(a), "changeMonthYear", function (e) {
          a.setState(function (t) {
            var r = t.date;
            return {
              date: We.default(qe.default(r, Ye.default(e)), Te.default(e))
            };
          }, function () {
            return a.handleMonthYearChange(a.state.date);
          });
        }), mt(bt(a), "header", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date,
              t = Wt(e, a.props.locale),
              r = [];
          return a.props.showWeekNumbers && r.push(de.default.createElement("div", {
            key: "W",
            className: "react-datepicker__day-name"
          }, a.props.weekLabel || "#")), r.concat([0, 1, 2, 3, 4, 5, 6].map(function (e) {
            var r = ve.default(t, e),
                n = a.formatWeekday(r, a.props.locale),
                o = a.props.weekDayClassName ? a.props.weekDayClassName(r) : void 0;
            return de.default.createElement("div", {
              key: e,
              className: ce.default("react-datepicker__day-name", o)
            }, n);
          }));
        }), mt(bt(a), "formatWeekday", function (e, t) {
          return a.props.formatWeekDay ? function (e, t, r) {
            return t(Lt(e, "EEEE", r));
          }(e, a.props.formatWeekDay, t) : a.props.useWeekdaysShort ? function (e, t) {
            return Lt(e, "EEE", t);
          }(e, t) : function (e, t) {
            return Lt(e, "EEEEEE", t);
          }(e, t);
        }), mt(bt(a), "decreaseYear", function () {
          a.setState(function (e) {
            var t = e.date;
            return {
              date: Se.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
            };
          }, function () {
            return a.handleYearChange(a.state.date);
          });
        }), mt(bt(a), "renderPreviousButton", function () {
          if (!a.props.renderCustomHeader) {
            var e;

            switch (!0) {
              case a.props.showMonthYearPicker:
                e = hr(a.state.date, a.props);
                break;

              case a.props.showYearPicker:
                e = function (e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                      r = t.minDate,
                      a = t.yearItemNumber,
                      n = void 0 === a ? Ot : a,
                      o = gr(jt(Se.default(e, n)), n).endPeriod,
                      s = r && Te.default(r);
                  return s && s > o || !1;
                }(a.state.date, a.props);

                break;

              default:
                e = ur(a.state.date, a.props);
            }

            if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
              var t = ["react-datepicker__navigation", "react-datepicker__navigation--previous"],
                  r = a.decreaseMonth;
              (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.decreaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), r = null);
              var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker,
                  o = a.props,
                  s = o.previousMonthAriaLabel,
                  i = void 0 === s ? "Previous Month" : s,
                  p = o.previousYearAriaLabel,
                  l = void 0 === p ? "Previous Year" : p;
              return de.default.createElement("button", {
                type: "button",
                className: t.join(" "),
                onClick: r,
                "aria-label": n ? l : i
              }, n ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel);
            }
          }
        }), mt(bt(a), "increaseYear", function () {
          a.setState(function (e) {
            var t = e.date;
            return {
              date: ke.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
            };
          }, function () {
            return a.handleYearChange(a.state.date);
          });
        }), mt(bt(a), "renderNextButton", function () {
          if (!a.props.renderCustomHeader) {
            var e;

            switch (!0) {
              case a.props.showMonthYearPicker:
                e = mr(a.state.date, a.props);
                break;

              case a.props.showYearPicker:
                e = function (e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                      r = t.maxDate,
                      a = t.yearItemNumber,
                      n = void 0 === a ? Ot : a,
                      o = gr(ke.default(e, n), n).startPeriod,
                      s = r && Te.default(r);
                  return s && s < o || !1;
                }(a.state.date, a.props);

                break;

              default:
                e = fr(a.state.date, a.props);
            }

            if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
              var t = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
              a.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
              var r = a.increaseMonth;
              (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.increaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), r = null);
              var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker,
                  o = a.props,
                  s = o.nextMonthAriaLabel,
                  i = void 0 === s ? "Next Month" : s,
                  p = o.nextYearAriaLabel,
                  l = void 0 === p ? "Next Year" : p;
              return de.default.createElement("button", {
                type: "button",
                className: t.join(" "),
                onClick: r,
                "aria-label": n ? l : i
              }, n ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel);
            }
          }
        }), mt(bt(a), "renderCurrentMonth", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date,
              t = ["react-datepicker__current-month"];
          return a.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), de.default.createElement("div", {
            className: t.join(" ")
          }, Lt(e, a.props.dateFormat, a.props.locale));
        }), mt(bt(a), "renderYearDropdown", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (a.props.showYearDropdown && !e) return de.default.createElement(_r, {
            adjustDateOnChange: a.props.adjustDateOnChange,
            date: a.state.date,
            onSelect: a.props.onSelect,
            setOpen: a.props.setOpen,
            dropdownMode: a.props.dropdownMode,
            onChange: a.changeYear,
            minDate: a.props.minDate,
            maxDate: a.props.maxDate,
            year: Te.default(a.state.date),
            scrollableYearDropdown: a.props.scrollableYearDropdown,
            yearDropdownItemNumber: a.props.yearDropdownItemNumber
          });
        }), mt(bt(a), "renderMonthDropdown", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (a.props.showMonthDropdown && !e) return de.default.createElement(Er, {
            dropdownMode: a.props.dropdownMode,
            locale: a.props.locale,
            onChange: a.changeMonth,
            month: Ye.default(a.state.date),
            useShortMonthInDropdown: a.props.useShortMonthInDropdown
          });
        }), mt(bt(a), "renderMonthYearDropdown", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          if (a.props.showMonthYearDropdown && !e) return de.default.createElement(xr, {
            dropdownMode: a.props.dropdownMode,
            locale: a.props.locale,
            dateFormat: a.props.dateFormat,
            onChange: a.changeMonthYear,
            minDate: a.props.minDate,
            maxDate: a.props.maxDate,
            date: a.state.date,
            scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown
          });
        }), mt(bt(a), "renderTodayButton", function () {
          if (a.props.todayButton && !a.props.showTimeSelectOnly) return de.default.createElement("div", {
            className: "react-datepicker__today-button",
            onClick: function (e) {
              return a.props.onSelect(Ve.default(xt()), e);
            }
          }, a.props.todayButton);
        }), mt(bt(a), "renderDefaultHeader", function (e) {
          var t = e.monthDate,
              r = e.i;
          return de.default.createElement("div", {
            className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
          }, a.renderCurrentMonth(t), de.default.createElement("div", {
            className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),
            onFocus: a.handleDropdownFocus
          }, a.renderMonthDropdown(0 !== r), a.renderMonthYearDropdown(0 !== r), a.renderYearDropdown(0 !== r)), de.default.createElement("div", {
            className: "react-datepicker__day-names"
          }, a.header(t)));
        }), mt(bt(a), "renderCustomHeader", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = e.monthDate,
              r = e.i;
          if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly) return null;
          var n = ur(a.state.date, a.props),
              o = fr(a.state.date, a.props),
              s = hr(a.state.date, a.props),
              i = mr(a.state.date, a.props),
              p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
          return de.default.createElement("div", {
            className: "react-datepicker__header react-datepicker__header--custom",
            onFocus: a.props.onDropdownFocus
          }, a.props.renderCustomHeader(Dt(Dt({}, a.state), {}, {
            customHeaderCount: r,
            changeMonth: a.changeMonth,
            changeYear: a.changeYear,
            decreaseMonth: a.decreaseMonth,
            increaseMonth: a.increaseMonth,
            decreaseYear: a.decreaseYear,
            increaseYear: a.increaseYear,
            prevMonthButtonDisabled: n,
            nextMonthButtonDisabled: o,
            prevYearButtonDisabled: s,
            nextYearButtonDisabled: i
          })), p && de.default.createElement("div", {
            className: "react-datepicker__day-names"
          }, a.header(t)));
        }), mt(bt(a), "renderYearHeader", function () {
          var e = a.state.date,
              t = a.props,
              r = t.showYearPicker,
              n = gr(e, t.yearItemNumber),
              o = n.startPeriod,
              s = n.endPeriod;
          return de.default.createElement("div", {
            className: "react-datepicker__header react-datepicker-year-header"
          }, r ? "".concat(o, " - ").concat(s) : Te.default(e));
        }), mt(bt(a), "renderHeader", function (e) {
          switch (!0) {
            case void 0 !== a.props.renderCustomHeader:
              return a.renderCustomHeader(e);

            case a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker:
              return a.renderYearHeader(e);

            default:
              return a.renderDefaultHeader(e);
          }
        }), mt(bt(a), "renderMonths", function () {
          if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
            for (var e = [], t = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, r = Ce.default(a.state.date, t), n = 0; n < a.props.monthsShown; ++n) {
              var o = n - a.props.monthSelectedIn,
                  s = we.default(r, o),
                  i = "month-".concat(n),
                  p = n < a.props.monthsShown - 1,
                  l = n > 0;
              e.push(de.default.createElement("div", {
                key: i,
                ref: function (e) {
                  a.monthContainer = e;
                },
                className: "react-datepicker__month-container"
              }, a.renderHeader({
                monthDate: s,
                i: n
              }), de.default.createElement(Fr, {
                chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                onChange: a.changeMonthYear,
                day: s,
                dayClassName: a.props.dayClassName,
                monthClassName: a.props.monthClassName,
                onDayClick: a.handleDayClick,
                handleOnKeyDown: a.props.handleOnKeyDown,
                onDayMouseEnter: a.handleDayMouseEnter,
                onMouseLeave: a.handleMonthMouseLeave,
                onWeekSelect: a.props.onWeekSelect,
                orderInDisplay: n,
                formatWeekNumber: a.props.formatWeekNumber,
                locale: a.props.locale,
                minDate: a.props.minDate,
                maxDate: a.props.maxDate,
                excludeDates: a.props.excludeDates,
                highlightDates: a.props.highlightDates,
                selectingDate: a.state.selectingDate,
                includeDates: a.props.includeDates,
                inline: a.props.inline,
                shouldFocusDayInline: a.props.shouldFocusDayInline,
                fixedHeight: a.props.fixedHeight,
                filterDate: a.props.filterDate,
                preSelection: a.props.preSelection,
                setPreSelection: a.props.setPreSelection,
                selected: a.props.selected,
                selectsStart: a.props.selectsStart,
                selectsEnd: a.props.selectsEnd,
                selectsRange: a.props.selectsRange,
                showWeekNumbers: a.props.showWeekNumbers,
                startDate: a.props.startDate,
                endDate: a.props.endDate,
                peekNextMonth: a.props.peekNextMonth,
                setOpen: a.props.setOpen,
                shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                renderDayContents: a.props.renderDayContents,
                disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                showMonthYearPicker: a.props.showMonthYearPicker,
                showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                showYearPicker: a.props.showYearPicker,
                showQuarterYearPicker: a.props.showQuarterYearPicker,
                isInputFocused: a.props.isInputFocused,
                containerRef: a.containerRef,
                monthShowsDuplicateDaysEnd: p,
                monthShowsDuplicateDaysStart: l
              })));
            }

            return e;
          }
        }), mt(bt(a), "renderYears", function () {
          if (!a.props.showTimeSelectOnly) return a.props.showYearPicker ? de.default.createElement("div", {
            className: "react-datepicker__year--container"
          }, a.renderHeader(), de.default.createElement(qr, yt({
            onDayClick: a.handleDayClick,
            date: a.state.date
          }, a.props))) : void 0;
        }), mt(bt(a), "renderTimeSection", function () {
          if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly)) return de.default.createElement(Rr, {
            selected: a.props.selected,
            openToDate: a.props.openToDate,
            onChange: a.props.onTimeChange,
            timeClassName: a.props.timeClassName,
            format: a.props.timeFormat,
            includeTimes: a.props.includeTimes,
            intervals: a.props.timeIntervals,
            minTime: a.props.minTime,
            maxTime: a.props.maxTime,
            excludeTimes: a.props.excludeTimes,
            filterTime: a.props.filterTime,
            timeCaption: a.props.timeCaption,
            todayButton: a.props.todayButton,
            showMonthDropdown: a.props.showMonthDropdown,
            showMonthYearDropdown: a.props.showMonthYearDropdown,
            showYearDropdown: a.props.showYearDropdown,
            withPortal: a.props.withPortal,
            monthRef: a.state.monthContainer,
            injectTimes: a.props.injectTimes,
            locale: a.props.locale,
            showTimeSelectOnly: a.props.showTimeSelectOnly
          });
        }), mt(bt(a), "renderInputTimeSection", function () {
          var e = new Date(a.props.selected),
              t = It(e) && Boolean(a.props.selected) ? "".concat(kr(e.getHours()), ":").concat(kr(e.getMinutes())) : "";
          if (a.props.showTimeInput) return de.default.createElement(Ar, {
            date: e,
            timeString: t,
            timeInputLabel: a.props.timeInputLabel,
            onChange: a.props.onTimeChange,
            customTimeInput: a.props.customTimeInput
          });
        }), a.containerRef = de.default.createRef(), a.state = {
          date: a.getDateInView(),
          selectingDate: null,
          monthContainer: null
        }, a;
      }

      return ht(r, [{
        key: "componentDidMount",
        value: function () {
          var e = this;
          this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
            monthContainer: e.monthContainer
          }));
        }
      }, {
        key: "componentDidUpdate",
        value: function (e) {
          this.props.preSelection && !Ut(this.props.preSelection, e.preSelection) ? this.setState({
            date: this.props.preSelection
          }) : this.props.openToDate && !Ut(this.props.openToDate, e.openToDate) && this.setState({
            date: this.props.openToDate
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.container || Wr;
          return de.default.createElement("div", {
            ref: this.containerRef
          }, de.default.createElement(e, {
            className: ce.default("react-datepicker", this.props.className, {
              "react-datepicker--time-only": this.props.showTimeSelectOnly
            }),
            showPopperArrow: this.props.showPopperArrow,
            arrowProps: this.props.arrowProps
          }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.props.children));
        }
      }], [{
        key: "defaultProps",
        get: function () {
          return {
            onDropdownFocus: function () {},
            monthsShown: 1,
            monthSelectedIn: 0,
            forceShowMonthNavigation: !1,
            timeCaption: "Time",
            previousYearButtonLabel: "Previous Year",
            nextYearButtonLabel: "Next Year",
            previousMonthButtonLabel: "Previous Month",
            nextMonthButtonLabel: "Next Month",
            customTimeInput: null,
            yearItemNumber: Ot
          };
        }
      }]), r;
    }(de.default.Component),
        Hr = function Hr(e) {
      return !e.disabled && -1 !== e.tabIndex;
    },
        Kr = function (e) {
      wt(r, e);
      var t = St(r);

      function r(e) {
        var a;
        return ut(this, r), mt(bt(a = t.call(this, e)), "getTabChildren", function () {
          return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(Hr);
        }), mt(bt(a), "handleFocusStart", function (e) {
          var t = a.getTabChildren();
          t && t.length > 1 && t[t.length - 1].focus();
        }), mt(bt(a), "handleFocusEnd", function (e) {
          var t = a.getTabChildren();
          t && t.length > 1 && t[0].focus();
        }), a.tabLoopRef = de.default.createRef(), a;
      }

      return ht(r, [{
        key: "render",
        value: function () {
          return this.props.enableTabLoop ? de.default.createElement("div", {
            className: "react-datepicker__tab-loop",
            ref: this.tabLoopRef
          }, de.default.createElement("div", {
            className: "react-datepicker__tab-loop__start",
            tabIndex: "0",
            onFocus: this.handleFocusStart
          }), this.props.children, de.default.createElement("div", {
            className: "react-datepicker__tab-loop__end",
            tabIndex: "0",
            onFocus: this.handleFocusEnd
          })) : this.props.children;
        }
      }], [{
        key: "defaultProps",
        get: function () {
          return {
            enableTabLoop: !0
          };
        }
      }]), r;
    }(de.default.Component),
        Qr = function (e) {
      wt(r, e);
      var t = St(r);

      function r(e) {
        var a;
        return ut(this, r), (a = t.call(this, e)).el = document.createElement("div"), a;
      }

      return ht(r, [{
        key: "componentDidMount",
        value: function () {
          this.portalRoot = document.getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), document.body.appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.portalRoot.removeChild(this.el);
        }
      }, {
        key: "render",
        value: function () {
          return dt.default.createPortal(this.props.children, this.el);
        }
      }]), r;
    }(de.default.Component),
        Vr = function (e) {
      wt(r, e);
      var t = St(r);

      function r() {
        return ut(this, r), t.apply(this, arguments);
      }

      return ht(r, [{
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.className,
              a = t.wrapperClassName,
              n = t.hidePopper,
              o = t.popperComponent,
              s = t.popperModifiers,
              i = t.popperPlacement,
              p = t.popperProps,
              l = t.targetComponent,
              d = t.enableTabLoop,
              c = t.popperOnKeyDown,
              u = t.portalId;

          if (!n) {
            var f = ce.default("react-datepicker-popper", r);
            e = de.default.createElement(ie.Popper, yt({
              modifiers: s,
              placement: i
            }, p), function (e) {
              var t = e.ref,
                  r = e.style,
                  a = e.placement,
                  n = e.arrowProps;
              return de.default.createElement(Kr, {
                enableTabLoop: d
              }, de.default.createElement("div", {
                ref: t,
                style: r,
                className: f,
                "data-placement": a,
                onKeyDown: c
              }, de.default.cloneElement(o, {
                arrowProps: n
              })));
            });
          }

          this.props.popperContainer && (e = de.default.createElement(this.props.popperContainer, {}, e)), u && !n && (e = de.default.createElement(Qr, {
            portalId: u
          }, e));
          var h = ce.default("react-datepicker-wrapper", a);
          return de.default.createElement(ie.Manager, {
            className: "react-datepicker-manager"
          }, de.default.createElement(ie.Reference, null, function (e) {
            var t = e.ref;
            return de.default.createElement("div", {
              ref: t,
              className: h
            }, l);
          }), e);
        }
      }], [{
        key: "defaultProps",
        get: function () {
          return {
            hidePopper: !0,
            popperModifiers: {
              preventOverflow: {
                enabled: !0,
                escapeWithReference: !0,
                boundariesElement: "viewport"
              }
            },
            popperProps: {},
            popperPlacement: "bottom-start"
          };
        }
      }]), r;
    }(de.default.Component),
        Ur = "react-datepicker-ignore-onclickoutside",
        $r = lt.default(jr);

    var zr = "Date input not valid.",
        Gr = function (e) {
      wt(r, e);
      var t = St(r);

      function r(e) {
        var a;
        return ut(this, r), mt(bt(a = t.call(this, e)), "getPreSelection", function () {
          return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : xt();
        }), mt(bt(a), "calcInitialState", function () {
          var e = a.getPreSelection(),
              t = yr(a.props),
              r = vr(a.props),
              n = t && nt.default(e, Ve.default(t)) ? t : r && at.default(e, Je.default(r)) ? r : e;
          return {
            open: a.props.startOpen || !1,
            preventFocus: !1,
            preSelection: a.props.selected ? a.props.selected : n,
            highlightDates: Dr(a.props.highlightDates),
            focused: !1,
            shouldFocusDayInline: !1
          };
        }), mt(bt(a), "clearPreventFocusTimeout", function () {
          a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
        }), mt(bt(a), "setFocus", function () {
          a.input && a.input.focus && a.input.focus({
            preventScroll: !0
          });
        }), mt(bt(a), "setBlur", function () {
          a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
        }), mt(bt(a), "setOpen", function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          a.setState({
            open: e,
            preSelection: e && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection,
            lastPreSelectChange: Xr
          }, function () {
            e || a.setState(function (e) {
              return {
                focused: !!t && e.focused
              };
            }, function () {
              !t && a.setBlur(), a.setState({
                inputValue: null
              });
            });
          });
        }), mt(bt(a), "inputOk", function () {
          return ue.default(a.state.preSelection);
        }), mt(bt(a), "isCalendarOpen", function () {
          return void 0 === a.props.open ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
        }), mt(bt(a), "handleFocus", function (e) {
          a.state.preventFocus || (a.props.onFocus(e), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({
            focused: !0
          });
        }), mt(bt(a), "cancelFocusInput", function () {
          clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
        }), mt(bt(a), "deferFocusInput", function () {
          a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function () {
            return a.setFocus();
          }, 1);
        }), mt(bt(a), "handleDropdownFocus", function () {
          a.cancelFocusInput();
        }), mt(bt(a), "handleBlur", function (e) {
          (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(e), a.setState({
            focused: !1
          });
        }), mt(bt(a), "handleCalendarClickOutside", function (e) {
          a.props.inline || a.setOpen(!1), a.props.onClickOutside(e), a.props.withPortal && e.preventDefault();
        }), mt(bt(a), "handleChange", function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

          var n = t[0];

          if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(bt(a), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
            a.setState({
              inputValue: n.target.value,
              lastPreSelectChange: Jr
            });
            var o = Tt(n.target.value, a.props.dateFormat, a.props.locale, a.props.strictParsing);
            !o && n.target.value || a.setSelected(o, n, !0);
          }
        }), mt(bt(a), "handleSelect", function (e, t, r) {
          a.setState({
            preventFocus: !0
          }, function () {
            return a.preventFocusTimeout = setTimeout(function () {
              return a.setState({
                preventFocus: !1
              });
            }, 50), a.preventFocusTimeout;
          }), a.props.onChangeRaw && a.props.onChangeRaw(t), a.setSelected(e, t, !1, r), !a.props.shouldCloseOnSelect || a.props.showTimeSelect ? a.setPreSelection(e) : a.props.inline || a.setOpen(!1);
        }), mt(bt(a), "setSelected", function (e, t, r, n) {
          var o = e;

          if (null === o || !tr(o, a.props)) {
            var s = a.props,
                i = s.onChange,
                p = s.selectsRange,
                l = s.startDate,
                d = s.endDate;
            if (!$t(a.props.selected, o) || a.props.allowSameDay || p) if (null !== o && (!a.props.selected || r && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (o = Ft(o, {
              hour: Pe.default(a.props.selected),
              minute: Me.default(a.props.selected),
              second: _e.default(a.props.selected)
            })), a.props.inline || a.setState({
              preSelection: o
            }), a.props.focusSelectedMonth || a.setState({
              monthSelectedIn: n
            })), p) {
              var c = l && !d,
                  u = l && d;
              !l && !d ? i([o, null], t) : c && (nt.default(o, l) ? i([o, null], t) : i([l, o], t)), u && i([o, null], t);
            } else i(o, t);
            r || (a.props.onSelect(o, t), a.setState({
              inputValue: null
            }));
          }
        }), mt(bt(a), "setPreSelection", function (e) {
          var t = void 0 !== a.props.minDate,
              r = void 0 !== a.props.maxDate,
              n = !0;

          if (e) {
            var o = Ve.default(e);
            if (t && r) n = zt(e, a.props.minDate, a.props.maxDate);else if (t) {
              var s = Ve.default(a.props.minDate);
              n = at.default(e, s) || $t(o, s);
            } else if (r) {
              var i = Je.default(a.props.maxDate);
              n = nt.default(e, i) || $t(o, i);
            }
          }

          n && a.setState({
            preSelection: e
          });
        }), mt(bt(a), "handleTimeChange", function (e) {
          var t = Ft(a.props.selected ? a.props.selected : a.getPreSelection(), {
            hour: Pe.default(e),
            minute: Me.default(e)
          });
          a.setState({
            preSelection: t
          }), a.props.onChange(t), a.props.shouldCloseOnSelect && a.setOpen(!1), a.props.showTimeInput && a.setOpen(!0), a.setState({
            inputValue: null
          });
        }), mt(bt(a), "onInputClick", function () {
          a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
        }), mt(bt(a), "onInputKeyDown", function (e) {
          a.props.onKeyDown(e);
          var t = e.key;

          if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
            if (a.state.open) {
              if ("ArrowDown" === t || "ArrowUp" === t) {
                e.preventDefault();
                var r = a.calendar.componentNode && a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
                return void (r && r.focus({
                  preventScroll: !0
                }));
              }

              var n = xt(a.state.preSelection);
              "Enter" === t ? (e.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === Xr ? (a.handleSelect(n, e), !a.props.shouldCloseOnSelect && a.setPreSelection(n)) : a.setOpen(!1)) : "Escape" === t && (e.preventDefault(), a.setOpen(!1)), a.inputOk() || a.props.onInputError({
                code: 1,
                msg: zr
              });
            }
          } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || a.onInputClick();
        }), mt(bt(a), "onDayKeyDown", function (e) {
          a.props.onKeyDown(e);
          var t = e.key,
              r = xt(a.state.preSelection);
          if ("Enter" === t) e.preventDefault(), a.handleSelect(r, e), !a.props.shouldCloseOnSelect && a.setPreSelection(r);else if ("Escape" === t) e.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({
            code: 1,
            msg: zr
          });else if (!a.props.disabledKeyboardNavigation) {
            var n;

            switch (t) {
              case "ArrowLeft":
                n = ge.default(r, 1);
                break;

              case "ArrowRight":
                n = ve.default(r, 1);
                break;

              case "ArrowUp":
                n = be.default(r, 1);
                break;

              case "ArrowDown":
                n = De.default(r, 1);
                break;

              case "PageUp":
                n = Ce.default(r, 1);
                break;

              case "PageDown":
                n = we.default(r, 1);
                break;

              case "Home":
                n = Se.default(r, 1);
                break;

              case "End":
                n = ke.default(r, 1);
            }

            if (!n) return void (a.props.onInputError && a.props.onInputError({
              code: 1,
              msg: zr
            }));

            if (e.preventDefault(), a.setState({
              lastPreSelectChange: Xr
            }), a.props.adjustDateOnChange && a.setSelected(n), a.setPreSelection(n), a.props.inline) {
              var o = Ye.default(r),
                  s = Ye.default(n),
                  i = Te.default(r),
                  p = Te.default(n);
              o !== s || i !== p ? a.setState({
                shouldFocusDayInline: !0
              }) : a.setState({
                shouldFocusDayInline: !1
              });
            }
          }
        }), mt(bt(a), "onPopperKeyDown", function (e) {
          "Escape" === e.key && (e.preventDefault(), a.setState({
            preventFocus: !0
          }, function () {
            a.setOpen(!1), setTimeout(function () {
              a.setFocus(), a.setState({
                preventFocus: !1
              });
            });
          }));
        }), mt(bt(a), "onClearClick", function (e) {
          e && e.preventDefault && e.preventDefault(), a.props.onChange(null, e), a.setState({
            inputValue: null
          });
        }), mt(bt(a), "clear", function () {
          a.onClearClick();
        }), mt(bt(a), "onScroll", function (e) {
          "boolean" == typeof a.props.closeOnScroll && a.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || a.setOpen(!1) : "function" == typeof a.props.closeOnScroll && a.props.closeOnScroll(e) && a.setOpen(!1);
        }), mt(bt(a), "renderCalendar", function () {
          return a.props.inline || a.isCalendarOpen() ? de.default.createElement($r, {
            ref: function (e) {
              a.calendar = e;
            },
            locale: a.props.locale,
            chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
            disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
            weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
            adjustDateOnChange: a.props.adjustDateOnChange,
            setOpen: a.setOpen,
            shouldCloseOnSelect: a.props.shouldCloseOnSelect,
            dateFormat: a.props.dateFormatCalendar,
            useWeekdaysShort: a.props.useWeekdaysShort,
            formatWeekDay: a.props.formatWeekDay,
            dropdownMode: a.props.dropdownMode,
            selected: a.props.selected,
            preSelection: a.state.preSelection,
            onSelect: a.handleSelect,
            onWeekSelect: a.props.onWeekSelect,
            openToDate: a.props.openToDate,
            minDate: a.props.minDate,
            maxDate: a.props.maxDate,
            selectsStart: a.props.selectsStart,
            selectsEnd: a.props.selectsEnd,
            selectsRange: a.props.selectsRange,
            startDate: a.props.startDate,
            endDate: a.props.endDate,
            excludeDates: a.props.excludeDates,
            filterDate: a.props.filterDate,
            onClickOutside: a.handleCalendarClickOutside,
            formatWeekNumber: a.props.formatWeekNumber,
            highlightDates: a.state.highlightDates,
            includeDates: a.props.includeDates,
            includeTimes: a.props.includeTimes,
            injectTimes: a.props.injectTimes,
            inline: a.props.inline,
            shouldFocusDayInline: a.state.shouldFocusDayInline,
            peekNextMonth: a.props.peekNextMonth,
            showMonthDropdown: a.props.showMonthDropdown,
            showPreviousMonths: a.props.showPreviousMonths,
            useShortMonthInDropdown: a.props.useShortMonthInDropdown,
            showMonthYearDropdown: a.props.showMonthYearDropdown,
            showWeekNumbers: a.props.showWeekNumbers,
            showYearDropdown: a.props.showYearDropdown,
            withPortal: a.props.withPortal,
            forceShowMonthNavigation: a.props.forceShowMonthNavigation,
            showDisabledMonthNavigation: a.props.showDisabledMonthNavigation,
            scrollableYearDropdown: a.props.scrollableYearDropdown,
            scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
            todayButton: a.props.todayButton,
            weekLabel: a.props.weekLabel,
            outsideClickIgnoreClass: Ur,
            fixedHeight: a.props.fixedHeight,
            monthsShown: a.props.monthsShown,
            monthSelectedIn: a.state.monthSelectedIn,
            onDropdownFocus: a.handleDropdownFocus,
            onMonthChange: a.props.onMonthChange,
            onYearChange: a.props.onYearChange,
            dayClassName: a.props.dayClassName,
            weekDayClassName: a.props.weekDayClassName,
            monthClassName: a.props.monthClassName,
            timeClassName: a.props.timeClassName,
            showTimeSelect: a.props.showTimeSelect,
            showTimeSelectOnly: a.props.showTimeSelectOnly,
            onTimeChange: a.handleTimeChange,
            timeFormat: a.props.timeFormat,
            timeIntervals: a.props.timeIntervals,
            minTime: a.props.minTime,
            maxTime: a.props.maxTime,
            excludeTimes: a.props.excludeTimes,
            filterTime: a.props.filterTime,
            timeCaption: a.props.timeCaption,
            className: a.props.calendarClassName,
            container: a.props.calendarContainer,
            yearItemNumber: a.props.yearItemNumber,
            yearDropdownItemNumber: a.props.yearDropdownItemNumber,
            previousMonthButtonLabel: a.props.previousMonthButtonLabel,
            nextMonthButtonLabel: a.props.nextMonthButtonLabel,
            previousYearButtonLabel: a.props.previousYearButtonLabel,
            nextYearButtonLabel: a.props.nextYearButtonLabel,
            timeInputLabel: a.props.timeInputLabel,
            disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
            renderCustomHeader: a.props.renderCustomHeader,
            popperProps: a.props.popperProps,
            renderDayContents: a.props.renderDayContents,
            onDayMouseEnter: a.props.onDayMouseEnter,
            onMonthMouseLeave: a.props.onMonthMouseLeave,
            showTimeInput: a.props.showTimeInput,
            showMonthYearPicker: a.props.showMonthYearPicker,
            showFullMonthYearPicker: a.props.showFullMonthYearPicker,
            showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
            showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
            showYearPicker: a.props.showYearPicker,
            showQuarterYearPicker: a.props.showQuarterYearPicker,
            showPopperArrow: a.props.showPopperArrow,
            excludeScrollbar: a.props.excludeScrollbar,
            handleOnKeyDown: a.onDayKeyDown,
            isInputFocused: a.state.focused,
            customTimeInput: a.props.customTimeInput,
            setPreSelection: a.setPreSelection
          }, a.props.children) : null;
        }), mt(bt(a), "renderDateInput", function () {
          var e,
              t,
              r,
              n,
              o,
              s = ce.default(a.props.className, mt({}, Ur, a.state.open)),
              i = a.props.customInput || de.default.createElement("input", {
            type: "text"
          }),
              p = a.props.customInputRef || "ref",
              l = "string" == typeof a.props.value ? a.props.value : "string" == typeof a.state.inputValue ? a.state.inputValue : (t = a.props.selected, r = a.props, n = r.dateFormat, o = r.locale, t && Lt(t, Array.isArray(n) ? n[0] : n, o) || "");
          return de.default.cloneElement(i, (mt(e = {}, p, function (e) {
            a.input = e;
          }), mt(e, "value", l), mt(e, "onBlur", a.handleBlur), mt(e, "onChange", a.handleChange), mt(e, "onClick", a.onInputClick), mt(e, "onFocus", a.handleFocus), mt(e, "onKeyDown", a.onInputKeyDown), mt(e, "id", a.props.id), mt(e, "name", a.props.name), mt(e, "autoFocus", a.props.autoFocus), mt(e, "placeholder", a.props.placeholderText), mt(e, "disabled", a.props.disabled), mt(e, "autoComplete", a.props.autoComplete), mt(e, "className", ce.default(i.props.className, s)), mt(e, "title", a.props.title), mt(e, "readOnly", a.props.readOnly), mt(e, "required", a.props.required), mt(e, "tabIndex", a.props.tabIndex), mt(e, "aria-describedby", a.props.ariaDescribedBy), mt(e, "aria-invalid", a.props.ariaInvalid), mt(e, "aria-labelledby", a.props.ariaLabelledBy), mt(e, "aria-required", a.props.ariaRequired), e));
        }), mt(bt(a), "renderClearButton", function () {
          var e = a.props,
              t = e.isClearable,
              r = e.selected,
              n = e.clearButtonTitle,
              o = e.clearButtonClassName,
              s = e.ariaLabelClose,
              i = void 0 === s ? "Close" : s;
          return t && null != r ? de.default.createElement("button", {
            type: "button",
            className: "react-datepicker__close-icon ".concat(o),
            "aria-label": i,
            onClick: a.onClearClick,
            title: n,
            tabIndex: -1
          }) : null;
        }), a.state = a.calcInitialState(), a;
      }

      return ht(r, [{
        key: "componentDidMount",
        value: function () {
          window.addEventListener("scroll", this.onScroll, !0);
        }
      }, {
        key: "componentDidUpdate",
        value: function (e, t) {
          var r, a;
          e.inline && (r = e.selected, a = this.props.selected, r && a ? Ye.default(r) !== Ye.default(a) || Te.default(r) !== Te.default(a) : r !== a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
            monthSelectedIn: 0
          }), e.highlightDates !== this.props.highlightDates && this.setState({
            highlightDates: Dr(this.props.highlightDates)
          }), t.focused || $t(e.selected, this.props.selected) || this.setState({
            inputValue: null
          }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.renderCalendar();
          return this.props.inline && !this.props.withPortal ? e : this.props.withPortal ? de.default.createElement("div", null, this.props.inline ? null : de.default.createElement("div", {
            className: "react-datepicker__input-container"
          }, this.renderDateInput(), this.renderClearButton()), this.state.open || this.props.inline ? de.default.createElement("div", {
            className: "react-datepicker__portal"
          }, e) : null) : de.default.createElement(Vr, {
            className: this.props.popperClassName,
            wrapperClassName: this.props.wrapperClassName,
            hidePopper: !this.isCalendarOpen(),
            portalId: this.props.portalId,
            popperModifiers: this.props.popperModifiers,
            targetComponent: de.default.createElement("div", {
              className: "react-datepicker__input-container"
            }, this.renderDateInput(), this.renderClearButton()),
            popperContainer: this.props.popperContainer,
            popperComponent: e,
            popperPlacement: this.props.popperPlacement,
            popperProps: this.props.popperProps,
            popperOnKeyDown: this.onPopperKeyDown,
            enableTabLoop: this.props.enableTabLoop
          });
        }
      }], [{
        key: "defaultProps",
        get: function () {
          return {
            allowSameDay: !1,
            dateFormat: "MM/dd/yyyy",
            dateFormatCalendar: "LLLL yyyy",
            onChange: function () {},
            disabled: !1,
            disabledKeyboardNavigation: !1,
            dropdownMode: "scroll",
            onFocus: function () {},
            onBlur: function () {},
            onKeyDown: function () {},
            onInputClick: function () {},
            onSelect: function () {},
            onClickOutside: function () {},
            onMonthChange: function () {},
            onCalendarOpen: function () {},
            onCalendarClose: function () {},
            preventOpenOnFocus: !1,
            onYearChange: function () {},
            onInputError: function () {},
            monthsShown: 1,
            readOnly: !1,
            withPortal: !1,
            shouldCloseOnSelect: !0,
            showTimeSelect: !1,
            showTimeInput: !1,
            showPreviousMonths: !1,
            showMonthYearPicker: !1,
            showFullMonthYearPicker: !1,
            showTwoColumnMonthYearPicker: !1,
            showFourColumnMonthYearPicker: !1,
            showYearPicker: !1,
            showQuarterYearPicker: !1,
            strictParsing: !1,
            timeIntervals: 30,
            timeCaption: "Time",
            previousMonthButtonLabel: "Previous Month",
            nextMonthButtonLabel: "Next Month",
            previousYearButtonLabel: "Previous Year",
            nextYearButtonLabel: "Next Year",
            timeInputLabel: "Time",
            enableTabLoop: !0,
            yearItemNumber: Ot,
            renderDayContents: function (e) {
              return e;
            },
            focusSelectedMonth: !1,
            showPopperArrow: !0,
            excludeScrollbar: !0,
            customTimeInput: null
          };
        }
      }]), r;
    }(de.default.Component),
        Jr = "input",
        Xr = "navigate";

    e.CalendarContainer = Wr, e.default = Gr, e.getDefaultLocale = Gt, e.registerLocale = function (e, t) {
      var r = "undefined" != typeof window ? window : commonjsGlobal;
      r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function (e) {
      ("undefined" != typeof window ? window : commonjsGlobal).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
      value: !0
    });
  });
});
var RDP = /*@__PURE__*/getDefaultExportFromCjs(reactDatepicker_min);

function CalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
  }));
}

const MemoCalendarIcon = React.memo(CalendarIcon);

const _excluded$9 = ["children", "customInput", "dateFormatCalendar", "defaultOpen", "formatWeekDay", "isMobile", "minDate", "monthsShown", "onChange", "placeholderText", "popperModifiers", "selected", "showFooter"];

const DatePicker = forwardRef((_ref, ref) => {
  let {
    customInput = null,
    dateFormatCalendar = 'MMM yyyy',
    defaultOpen = false,
    formatWeekDay = nameOfDay => nameOfDay.substr(0, 3),
    isMobile = false,
    minDate = new Date(),
    monthsShown = 1,
    onChange,
    placeholderText = 'MM/DD/YYYY',
    popperModifiers,
    selected = null,
    showFooter = true
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$9);

  const [isOpen, setIsOpen] = useState(defaultOpen);
  const Control = customInput ? customInput : React__default.createElement(BaseInput, {
    type: "text",
    right: (!isMobile || !selected) && React__default.createElement(MemoCalendarIcon, {
      width: "22px",
      height: "22px"
    })
  });
  const defaultPopperMods = {
    flip: {
      enabled: false
    },
    preventOverflow: {
      enabled: true,
      escapeWithReference: false
    }
  };
  return React__default.createElement(RDP, _extends$1({
    customInput: Control,
    dateFormatCalendar: dateFormatCalendar,
    formatWeekDay: formatWeekDay,
    isClearable: isMobile || !showFooter,
    minDate: minDate,
    monthsShown: isMobile ? 2 : monthsShown,
    onCalendarClose: () => setIsOpen(false),
    onCalendarOpen: () => setIsOpen(true),
    onChange: onChange,
    onInputClick: () => setIsOpen(true),
    open: isOpen,
    placeholderText: placeholderText,
    popperModifiers: popperModifiers || defaultPopperMods,
    ref: ref,
    selected: selected,
    shouldCloseOnSelect: !showFooter || isMobile,
    showPopperArrow: false,
    withPortal: isMobile
  }, props), showFooter && !isMobile && React__default.createElement(Footer, {
    onClear: () => onChange(null, undefined),
    onSave: () => setIsOpen(false),
    hasSelectedDate: selected
  }));
});

const Footer = ({
  onClear,
  onSave,
  hasSelectedDate
}) => {
  return React__default.createElement(Flex, {
    sx: {
      alignItems: 'center',
      borderTop: '1px solid',
      borderColor: 'gray.300',
      justifyContent: 'flex-end',
      px: 5,
      py: 4
    }
  }, React__default.createElement(Button, {
    onPress: onClear,
    isDisabled: !hasSelectedDate,
    sx: {
      background: 'transparent',
      border: 'none',
      '&:hover': {
        textDecoration: !!hasSelectedDate ? 'underline' : 'none'
      },
      boxShadow: 'none',
      color: !!hasSelectedDate ? 'black' : 'gray.400',
      padding: 0,
      transform: 'none'
    }
  }, "Clear Date"), React__default.createElement(Button, {
    sx: {
      marginLeft: 6,
      width: '75px'
    },
    onPress: onSave
  }, !!hasSelectedDate ? 'Save' : 'Close'));
};

const ClampText = ({
  linesVisible: _linesVisible = 5,
  showFade: _showFade = false,
  animationDuration: _animationDuration = 500,
  children
}) => {
  const lineHeight = 1.5 * 16; //  1.5rem * 16px manually doing the conversion

  const initialHeight = lineHeight * _linesVisible;
  const {
    toggle,
    collapsed,
    Collapse
  } = useCollapse(true, {
    initialHeight,
    duration: _animationDuration
  });
  const text = !collapsed ? 'Read less' : 'Read more';
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Box, {
    sx: {
      position: 'relative'
    }
  }, React__default.createElement(Collapse, {
    collapsed: collapsed
  }, children), collapsed && _showFade && React__default.createElement(Box, {
    sx: {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      width: '100%',
      height: '3rem',
      backgroundImage: 'linear-gradient(180deg, rgba(255, 255, 255, 0), #fff 90%, #fff 100%)',
      zIndex: 999
    }
  })), React__default.createElement(Box, {
    sx: {
      marginTop: 2
    }
  }, React__default.createElement(Box, {
    as: "a",
    href: "#",
    sx: {
      cursor: 'pointer',
      textDecoration: 'underline',
      fontWeight: 'bold',
      alignItems: 'center'
    },
    onClick: toggle
  }, text)));
};

var reactTable_production_min = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    t(exports, React__default) ;
  }(commonjsGlobal, function (e, t) {

    function n(e, t, n, o, r, i, u) {
      try {
        var l = e[i](u),
            s = l.value;
      } catch (e) {
        return void n(e);
      }

      l.done ? t(s) : Promise.resolve(s).then(o, r);
    }

    function o(e) {
      return function () {
        var t = this,
            o = arguments;
        return new Promise(function (r, i) {
          var u = e.apply(t, o);

          function l(e) {
            n(u, r, i, l, s, "next", e);
          }

          function s(e) {
            n(u, r, i, l, s, "throw", e);
          }

          l(void 0);
        });
      };
    }

    function r() {
      return (r = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }

        return e;
      }).apply(this, arguments);
    }

    function i(e, t) {
      if (null == e) return {};
      var n,
          o,
          r = {},
          i = Object.keys(e);

      for (o = 0; o < i.length; o++) n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);

      return r;
    }

    function u(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var n = e[Symbol.toPrimitive];

        if (void 0 !== n) {
          var o = n.call(e, t || "default");
          if ("object" != typeof o) return o;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;

    var l = {
      init: "init"
    },
        s = function s(e) {
      var t = e.value;
      return void 0 === t ? "" : t;
    },
        a = function a() {
      return t.createElement(t.Fragment, null, " ");
    },
        c = {
      Cell: s,
      width: 150,
      minWidth: 0,
      maxWidth: Number.MAX_SAFE_INTEGER
    };

    function d() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];

      return t.reduce(function (e, t) {
        var n = t.style,
            o = t.className;
        return e = r({}, e, {}, i(t, ["style", "className"])), n && (e.style = e.style ? r({}, e.style || {}, {}, n || {}) : n), o && (e.className = e.className ? e.className + " " + o : o), "" === e.className && delete e.className, e;
      }, {});
    }

    var f = function f(e, t) {
      return void 0 === t && (t = {}), function (n) {
        return void 0 === n && (n = {}), [].concat(e, [n]).reduce(function (e, o) {
          return function e(t, n, o) {
            return "function" == typeof n ? e({}, n(t, o)) : Array.isArray(n) ? d.apply(void 0, [t].concat(n)) : d(t, n);
          }(e, o, r({}, t, {
            userProps: n
          }));
        }, {});
      };
    },
        p = function p(e, t, n, o) {
      return void 0 === n && (n = {}), e.reduce(function (e, t) {
        return t(e, n);
      }, t);
    },
        g = function g(e, t, n) {
      return void 0 === n && (n = {}), e.forEach(function (e) {
        e(t, n);
      });
    };

    function v(e, t, n, o) {
      e.findIndex(function (e) {
        return e.pluginName === n;
      });
      t.forEach(function (t) {
        e.findIndex(function (e) {
          return e.pluginName === t;
        });
      });
    }

    function m(e, t) {
      return "function" == typeof e ? e(t) : e;
    }

    function h(e) {
      var n = t.useRef();
      return n.current = e, t.useCallback(function () {
        return n.current;
      }, []);
    }

    var y = "undefined" != typeof document ? t.useLayoutEffect : t.useEffect;

    function w(e, n) {
      var o = t.useRef(!1);
      y(function () {
        o.current && e(), o.current = !0;
      }, n);
    }

    function R(e, t, n) {
      return void 0 === n && (n = {}), function (o, i) {
        void 0 === i && (i = {});
        var u = "string" == typeof o ? t[o] : o;
        if (void 0 === u) throw console.info(t), new Error("Renderer Error ☝️");
        return b(u, r({}, e, {
          column: t
        }, n, {}, i));
      };
    }

    function b(e, n) {
      return function (e) {
        return "function" == typeof e && (t = Object.getPrototypeOf(e)).prototype && t.prototype.isReactComponent;
        var t;
      }(o = e) || "function" == typeof o || function (e) {
        return "object" == typeof e && "symbol" == typeof e.$$typeof && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
      }(o) ? t.createElement(e, n) : e;
      var o;
    }

    function S(e, t, n) {
      return void 0 === n && (n = 0), e.map(function (e) {
        return x(e = r({}, e, {
          parent: t,
          depth: n
        })), e.columns && (e.columns = S(e.columns, e, n + 1)), e;
      });
    }

    function C(e) {
      return G(e, "columns");
    }

    function x(e) {
      var t = e.id,
          n = e.accessor,
          o = e.Header;

      if ("string" == typeof n) {
        t = t || n;
        var r = n.split(".");

        n = function (e) {
          return function (e, t, n) {
            if (!t) return e;

            var o,
                r = "function" == typeof t ? t : JSON.stringify(t),
                i = E.get(r) || function () {
              var e = function (e) {
                return function e(t, n) {
                  void 0 === n && (n = []);
                  if (Array.isArray(t)) for (var o = 0; o < t.length; o += 1) e(t[o], n);else n.push(t);
                  return n;
                }(e).map(function (e) {
                  return String(e).replace(".", "_");
                }).join(".").replace(W, ".").replace(O, "").split(".");
              }(t);

              return E.set(r, e), e;
            }();

            try {
              o = i.reduce(function (e, t) {
                return e[t];
              }, e);
            } catch (e) {}

            return void 0 !== o ? o : n;
          }(e, r);
        };
      }

      if (!t && "string" == typeof o && o && (t = o), !t && e.columns) throw console.error(e), new Error('A column ID (or unique "Header" value) is required!');
      if (!t) throw console.error(e), new Error("A column ID (or string accessor) is required!");
      return Object.assign(e, {
        id: t,
        accessor: n
      }), e;
    }

    function P(e, t) {
      if (!t) throw new Error();
      return Object.assign(e, r({
        Header: a,
        Footer: a
      }, c, {}, t, {}, e)), Object.assign(e, {
        originalWidth: e.width
      }), e;
    }

    function B(e, t, n) {
      void 0 === n && (n = function () {
        return {};
      });

      for (var o = [], i = e, u = 0, l = function l() {
        return u++;
      }, s = function s() {
        var e = {
          headers: []
        },
            u = [],
            s = i.some(function (e) {
          return e.parent;
        });
        i.forEach(function (o) {
          var i,
              a = [].concat(u).reverse()[0];

          if (s) {
            if (o.parent) i = r({}, o.parent, {
              originalId: o.parent.id,
              id: o.parent.id + "_" + l(),
              headers: [o]
            }, n(o));else i = P(r({
              originalId: o.id + "_placeholder",
              id: o.id + "_placeholder_" + l(),
              placeholderOf: o,
              headers: [o]
            }, n(o)), t);
            a && a.originalId === i.originalId ? a.headers.push(o) : u.push(i);
          }

          e.headers.push(o);
        }), o.push(e), i = u;
      }; i.length;) s();

      return o.reverse();
    }

    var E = new Map();

    function I() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];

      for (var o = 0; o < t.length; o += 1) if (void 0 !== t[o]) return t[o];
    }

    function F(e) {
      if ("function" == typeof e) return e;
    }

    function G(e, t) {
      var n = [];
      return function e(o) {
        o.forEach(function (o) {
          o[t] ? e(o[t]) : n.push(o);
        });
      }(e), n;
    }

    function A(e, t) {
      var n = t.manualExpandedKey,
          o = t.expanded,
          r = t.expandSubRows,
          i = void 0 === r || r,
          u = [];
      return e.forEach(function (e) {
        return function e(t, r) {
          void 0 === r && (r = !0), t.isExpanded = t.original && t.original[n] || o[t.id], t.canExpand = t.subRows && !!t.subRows.length, r && u.push(t), t.subRows && t.subRows.length && t.isExpanded && t.subRows.forEach(function (t) {
            return e(t, i);
          });
        }(e);
      }), u;
    }

    function k(e, t, n) {
      return F(e) || t[e] || n[e] || n.text;
    }

    function H(e, t, n) {
      return e ? e(t, n) : void 0 === t;
    }

    function T() {
      throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
    }

    var z = null;
    var W = /\[/g,
        O = /\]/g;

    var M = function M(e) {
      return r({
        role: "table"
      }, e);
    },
        j = function j(e) {
      return r({
        role: "rowgroup"
      }, e);
    },
        N = function N(e, t) {
      var n = t.column;
      return r({
        key: "header_" + n.id,
        colSpan: n.totalVisibleHeaderCount,
        role: "columnheader"
      }, e);
    },
        L = function L(e, t) {
      var n = t.column;
      return r({
        key: "footer_" + n.id,
        colSpan: n.totalVisibleHeaderCount
      }, e);
    },
        D = function D(e, t) {
      return r({
        key: "headerGroup_" + t.index,
        role: "row"
      }, e);
    },
        V = function V(e, t) {
      return r({
        key: "footerGroup_" + t.index
      }, e);
    },
        _ = function _(e, t) {
      return r({
        key: "row_" + t.row.id,
        role: "row"
      }, e);
    },
        X = function X(e, t) {
      var n = t.cell;
      return r({
        key: "cell_" + n.row.id + "_" + n.column.id,
        role: "cell"
      }, e);
    };

    function q() {
      return {
        useOptions: [],
        stateReducers: [],
        useControlledState: [],
        columns: [],
        columnsDeps: [],
        allColumns: [],
        allColumnsDeps: [],
        accessValue: [],
        materializedColumns: [],
        materializedColumnsDeps: [],
        useInstanceAfterData: [],
        visibleColumns: [],
        visibleColumnsDeps: [],
        headerGroups: [],
        headerGroupsDeps: [],
        useInstanceBeforeDimensions: [],
        useInstance: [],
        prepareRow: [],
        getTableProps: [M],
        getTableBodyProps: [j],
        getHeaderGroupProps: [D],
        getFooterGroupProps: [V],
        getHeaderProps: [N],
        getFooterProps: [L],
        getRowProps: [_],
        getCellProps: [X],
        useFinalInstance: []
      };
    }

    l.resetHiddenColumns = "resetHiddenColumns", l.toggleHideColumn = "toggleHideColumn", l.setHiddenColumns = "setHiddenColumns", l.toggleHideAllColumns = "toggleHideAllColumns";

    var K = function K(e) {
      e.getToggleHiddenProps = [U], e.getToggleHideAllColumnsProps = [$], e.stateReducers.push(J), e.useInstanceBeforeDimensions.push(Y), e.headerGroupsDeps.push(function (e, t) {
        var n = t.instance;
        return [].concat(e, [n.state.hiddenColumns]);
      }), e.useInstance.push(Q);
    };

    K.pluginName = "useColumnVisibility";

    var U = function U(e, t) {
      var n = t.column;
      return [e, {
        onChange: function (e) {
          n.toggleHidden(!e.target.checked);
        },
        style: {
          cursor: "pointer"
        },
        checked: n.isVisible,
        title: "Toggle Column Visible"
      }];
    },
        $ = function $(e, t) {
      var n = t.instance;
      return [e, {
        onChange: function (e) {
          n.toggleHideAllColumns(!e.target.checked);
        },
        style: {
          cursor: "pointer"
        },
        checked: !n.allColumnsHidden && !n.state.hiddenColumns.length,
        title: "Toggle All Columns Hidden",
        indeterminate: !n.allColumnsHidden && n.state.hiddenColumns.length
      }];
    };

    function J(e, t, n, o) {
      if (t.type === l.init) return r({
        hiddenColumns: []
      }, e);
      if (t.type === l.resetHiddenColumns) return r({}, e, {
        hiddenColumns: o.initialState.hiddenColumns || []
      });

      if (t.type === l.toggleHideColumn) {
        var i = (void 0 !== t.value ? t.value : !e.hiddenColumns.includes(t.columnId)) ? [].concat(e.hiddenColumns, [t.columnId]) : e.hiddenColumns.filter(function (e) {
          return e !== t.columnId;
        });
        return r({}, e, {
          hiddenColumns: i
        });
      }

      return t.type === l.setHiddenColumns ? r({}, e, {
        hiddenColumns: m(t.value, e.hiddenColumns)
      }) : t.type === l.toggleHideAllColumns ? r({}, e, {
        hiddenColumns: (void 0 !== t.value ? t.value : !e.hiddenColumns.length) ? o.allColumns.map(function (e) {
          return e.id;
        }) : []
      }) : void 0;
    }

    function Y(e) {
      var n = e.headers,
          o = e.state.hiddenColumns;
      t.useRef(!1).current;
      var r = 0;
      n.forEach(function (e) {
        return r += function e(t, n) {
          t.isVisible = n && !o.includes(t.id);
          var r = 0;
          return t.headers && t.headers.length ? t.headers.forEach(function (n) {
            return r += e(n, t.isVisible);
          }) : r = t.isVisible ? 1 : 0, t.totalVisibleHeaderCount = r, r;
        }(e, !0);
      });
    }

    function Q(e) {
      var n = e.columns,
          o = e.flatHeaders,
          r = e.dispatch,
          i = e.allColumns,
          u = e.getHooks,
          s = e.state.hiddenColumns,
          a = e.autoResetHiddenColumns,
          c = void 0 === a || a,
          d = h(e),
          p = i.length === s.length,
          g = t.useCallback(function (e, t) {
        return r({
          type: l.toggleHideColumn,
          columnId: e,
          value: t
        });
      }, [r]),
          v = t.useCallback(function (e) {
        return r({
          type: l.setHiddenColumns,
          value: e
        });
      }, [r]),
          m = t.useCallback(function (e) {
        return r({
          type: l.toggleHideAllColumns,
          value: e
        });
      }, [r]),
          y = f(u().getToggleHideAllColumnsProps, {
        instance: d()
      });
      o.forEach(function (e) {
        e.toggleHidden = function (t) {
          r({
            type: l.toggleHideColumn,
            columnId: e.id,
            value: t
          });
        }, e.getToggleHiddenProps = f(u().getToggleHiddenProps, {
          instance: d(),
          column: e
        });
      });
      var R = h(c);
      w(function () {
        R() && r({
          type: l.resetHiddenColumns
        });
      }, [r, n]), Object.assign(e, {
        allColumnsHidden: p,
        toggleHideColumn: g,
        setHiddenColumns: v,
        toggleHideAllColumns: m,
        getToggleHideAllColumnsProps: y
      });
    }

    var Z = {},
        ee = {},
        te = function te(e, t, n) {
      return e;
    },
        ne = function ne(e, t) {
      return e.subRows || [];
    },
        oe = function oe(e, t, n) {
      return "" + (n ? [n.id, t].join(".") : t);
    },
        re = function re(e) {
      return e;
    };

    function ie(e) {
      var t = e.initialState,
          n = void 0 === t ? Z : t,
          o = e.defaultColumn,
          u = void 0 === o ? ee : o,
          l = e.getSubRows,
          s = void 0 === l ? ne : l,
          a = e.getRowId,
          c = void 0 === a ? oe : a,
          d = e.stateReducer,
          f = void 0 === d ? te : d,
          p = e.useControlledState,
          g = void 0 === p ? re : p;
      return r({}, i(e, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]), {
        initialState: n,
        defaultColumn: u,
        getSubRows: s,
        getRowId: c,
        stateReducer: f,
        useControlledState: g
      });
    }

    function ue(e, t) {
      void 0 === t && (t = 0);
      var n = 0,
          o = 0,
          r = 0,
          i = 0;
      return e.forEach(function (e) {
        var u = e.headers;

        if (e.totalLeft = t, u && u.length) {
          var l = ue(u, t),
              s = l[0],
              a = l[1],
              c = l[2],
              d = l[3];
          e.totalMinWidth = s, e.totalWidth = a, e.totalMaxWidth = c, e.totalFlexWidth = d;
        } else e.totalMinWidth = e.minWidth, e.totalWidth = Math.min(Math.max(e.minWidth, e.width), e.maxWidth), e.totalMaxWidth = e.maxWidth, e.totalFlexWidth = e.canResize ? e.totalWidth : 0;

        e.isVisible && (t += e.totalWidth, n += e.totalMinWidth, o += e.totalWidth, r += e.totalMaxWidth, i += e.totalFlexWidth);
      }), [n, o, r, i];
    }

    function le(e) {
      var t = e.data,
          n = e.rows,
          o = e.flatRows,
          r = e.rowsById,
          i = e.column,
          u = e.getRowId,
          l = e.getSubRows,
          s = e.accessValueHooks,
          a = e.getInstance;
      t.forEach(function (e, c) {
        return function e(n, c, d, f, g) {
          void 0 === d && (d = 0);
          var v = n,
              m = u(n, c, f),
              h = r[m];
          if (h) h.subRows && h.originalSubRows.forEach(function (t, n) {
            return e(t, n, d + 1, h);
          });else if ((h = {
            id: m,
            original: v,
            index: c,
            depth: d,
            cells: [{}]
          }).cells.map = T, h.cells.filter = T, h.cells.forEach = T, h.cells[0].getCellProps = T, h.values = {}, g.push(h), o.push(h), r[m] = h, h.originalSubRows = l(n, c), h.originalSubRows) {
            var y = [];
            h.originalSubRows.forEach(function (t, n) {
              return e(t, n, d + 1, h, y);
            }), h.subRows = y;
          }
          i.accessor && (h.values[i.id] = i.accessor(n, c, h, g, t)), h.values[i.id] = p(s, h.values[i.id], {
            row: h,
            column: i,
            instance: a()
          });
        }(e, c, 0, void 0, n);
      });
    }

    l.resetExpanded = "resetExpanded", l.toggleRowExpanded = "toggleRowExpanded", l.toggleAllRowsExpanded = "toggleAllRowsExpanded";

    var se = function se(e) {
      e.getToggleAllRowsExpandedProps = [ae], e.getToggleRowExpandedProps = [ce], e.stateReducers.push(de), e.useInstance.push(fe), e.prepareRow.push(pe);
    };

    se.pluginName = "useExpanded";

    var ae = function ae(e, t) {
      var n = t.instance;
      return [e, {
        onClick: function (e) {
          n.toggleAllRowsExpanded();
        },
        style: {
          cursor: "pointer"
        },
        title: "Toggle All Rows Expanded"
      }];
    },
        ce = function ce(e, t) {
      var n = t.row;
      return [e, {
        onClick: function () {
          n.toggleRowExpanded();
        },
        style: {
          cursor: "pointer"
        },
        title: "Toggle Row Expanded"
      }];
    };

    function de(e, t, n, o) {
      if (t.type === l.init) return r({
        expanded: {}
      }, e);
      if (t.type === l.resetExpanded) return r({}, e, {
        expanded: o.initialState.expanded || {}
      });

      if (t.type === l.toggleAllRowsExpanded) {
        var s = t.value,
            a = o.isAllRowsExpanded,
            c = o.rowsById;

        if (void 0 !== s ? s : !a) {
          var d = {};
          return Object.keys(c).forEach(function (e) {
            d[e] = !0;
          }), r({}, e, {
            expanded: d
          });
        }

        return r({}, e, {
          expanded: {}
        });
      }

      if (t.type === l.toggleRowExpanded) {
        var f,
            p = t.id,
            g = t.value,
            v = e.expanded[p],
            m = void 0 !== g ? g : !v;
        if (!v && m) return r({}, e, {
          expanded: r({}, e.expanded, (f = {}, f[p] = !0, f))
        });

        if (v && !m) {
          var h = e.expanded;
          return r({}, e, {
            expanded: i(h, [p].map(u))
          });
        }

        return e;
      }
    }

    function fe(e) {
      var n = e.data,
          o = e.rows,
          r = e.rowsById,
          i = e.manualExpandedKey,
          u = void 0 === i ? "expanded" : i,
          s = e.paginateExpandedRows,
          a = void 0 === s || s,
          c = e.expandSubRows,
          d = void 0 === c || c,
          p = e.autoResetExpanded,
          g = void 0 === p || p,
          m = e.getHooks,
          y = e.plugins,
          R = e.state.expanded,
          b = e.dispatch;
      v(y, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
      var S = h(g),
          C = Boolean(Object.keys(r).length && Object.keys(R).length);
      C && Object.keys(r).some(function (e) {
        return !R[e];
      }) && (C = !1), w(function () {
        S() && b({
          type: l.resetExpanded
        });
      }, [b, n]);
      var x = t.useCallback(function (e, t) {
        b({
          type: l.toggleRowExpanded,
          id: e,
          value: t
        });
      }, [b]),
          P = t.useCallback(function (e) {
        return b({
          type: l.toggleAllRowsExpanded,
          value: e
        });
      }, [b]),
          B = t.useMemo(function () {
        return a ? A(o, {
          manualExpandedKey: u,
          expanded: R,
          expandSubRows: d
        }) : o;
      }, [a, o, u, R, d]),
          E = t.useMemo(function () {
        return function (e) {
          var t = 0;
          return Object.keys(e).forEach(function (e) {
            var n = e.split(".");
            t = Math.max(t, n.length);
          }), t;
        }(R);
      }, [R]),
          I = h(e),
          F = f(m().getToggleAllRowsExpandedProps, {
        instance: I()
      });
      Object.assign(e, {
        preExpandedRows: o,
        expandedRows: B,
        rows: B,
        expandedDepth: E,
        isAllRowsExpanded: C,
        toggleRowExpanded: x,
        toggleAllRowsExpanded: P,
        getToggleAllRowsExpandedProps: F
      });
    }

    function pe(e, t) {
      var n = t.instance.getHooks,
          o = t.instance;
      e.toggleRowExpanded = function (t) {
        return o.toggleRowExpanded(e.id, t);
      }, e.getToggleRowExpandedProps = f(n().getToggleRowExpandedProps, {
        instance: o,
        row: e
      });
    }

    var ge = function ge(e, t, n) {
      return e = e.filter(function (e) {
        return t.some(function (t) {
          var o = e.values[t];
          return String(o).toLowerCase().includes(String(n).toLowerCase());
        });
      });
    };

    ge.autoRemove = function (e) {
      return !e;
    };

    var ve = function ve(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          var o = e.values[t];
          return void 0 === o || String(o).toLowerCase() === String(n).toLowerCase();
        });
      });
    };

    ve.autoRemove = function (e) {
      return !e;
    };

    var me = function me(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          var o = e.values[t];
          return void 0 === o || String(o) === String(n);
        });
      });
    };

    me.autoRemove = function (e) {
      return !e;
    };

    var he = function he(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          return e.values[t].includes(n);
        });
      });
    };

    he.autoRemove = function (e) {
      return !e || !e.length;
    };

    var ye = function ye(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          var o = e.values[t];
          return o && o.length && n.every(function (e) {
            return o.includes(e);
          });
        });
      });
    };

    ye.autoRemove = function (e) {
      return !e || !e.length;
    };

    var we = function we(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          var o = e.values[t];
          return o && o.length && n.some(function (e) {
            return o.includes(e);
          });
        });
      });
    };

    we.autoRemove = function (e) {
      return !e || !e.length;
    };

    var Re = function Re(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          var o = e.values[t];
          return n.includes(o);
        });
      });
    };

    Re.autoRemove = function (e) {
      return !e || !e.length;
    };

    var be = function be(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          return e.values[t] === n;
        });
      });
    };

    be.autoRemove = function (e) {
      return void 0 === e;
    };

    var Se = function Se(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          return e.values[t] == n;
        });
      });
    };

    Se.autoRemove = function (e) {
      return null == e;
    };

    var Ce = function Ce(e, t, n) {
      var o = n || [],
          r = o[0],
          i = o[1];

      if ((r = "number" == typeof r ? r : -1 / 0) > (i = "number" == typeof i ? i : 1 / 0)) {
        var u = r;
        r = i, i = u;
      }

      return e.filter(function (e) {
        return t.some(function (t) {
          var n = e.values[t];
          return n >= r && n <= i;
        });
      });
    };

    Ce.autoRemove = function (e) {
      return !e || "number" != typeof e[0] && "number" != typeof e[1];
    };

    var xe = Object.freeze({
      __proto__: null,
      text: ge,
      exactText: ve,
      exactTextCase: me,
      includes: he,
      includesAll: ye,
      includesSome: we,
      includesValue: Re,
      exact: be,
      equals: Se,
      between: Ce
    });
    l.resetFilters = "resetFilters", l.setFilter = "setFilter", l.setAllFilters = "setAllFilters";

    var Pe = function Pe(e) {
      e.stateReducers.push(Be), e.useInstance.push(Ee);
    };

    function Be(e, t, n, o) {
      if (t.type === l.init) return r({
        filters: []
      }, e);
      if (t.type === l.resetFilters) return r({}, e, {
        filters: o.initialState.filters || []
      });

      if (t.type === l.setFilter) {
        var i = t.columnId,
            u = t.filterValue,
            s = o.allColumns,
            a = o.filterTypes,
            c = s.find(function (e) {
          return e.id === i;
        });
        if (!c) throw new Error("React-Table: Could not find a column with id: " + i);
        var d = k(c.filter, a || {}, xe),
            f = e.filters.find(function (e) {
          return e.id === i;
        }),
            p = m(u, f && f.value);
        return H(d.autoRemove, p, c) ? r({}, e, {
          filters: e.filters.filter(function (e) {
            return e.id !== i;
          })
        }) : r({}, e, f ? {
          filters: e.filters.map(function (e) {
            return e.id === i ? {
              id: i,
              value: p
            } : e;
          })
        } : {
          filters: [].concat(e.filters, [{
            id: i,
            value: p
          }])
        });
      }

      if (t.type === l.setAllFilters) {
        var g = t.filters,
            v = o.allColumns,
            h = o.filterTypes;
        return r({}, e, {
          filters: m(g, e.filters).filter(function (e) {
            var t = v.find(function (t) {
              return t.id === e.id;
            });
            return !H(k(t.filter, h || {}, xe).autoRemove, e.value, t);
          })
        });
      }
    }

    function Ee(e) {
      var n = e.data,
          o = e.rows,
          r = e.flatRows,
          i = e.rowsById,
          u = e.allColumns,
          s = e.filterTypes,
          a = e.manualFilters,
          c = e.defaultCanFilter,
          d = void 0 !== c && c,
          f = e.disableFilters,
          p = e.state.filters,
          g = e.dispatch,
          v = e.autoResetFilters,
          m = void 0 === v || v,
          y = t.useCallback(function (e, t) {
        g({
          type: l.setFilter,
          columnId: e,
          filterValue: t
        });
      }, [g]),
          R = t.useCallback(function (e) {
        g({
          type: l.setAllFilters,
          filters: e
        });
      }, [g]);
      u.forEach(function (e) {
        var t = e.id,
            n = e.accessor,
            o = e.defaultCanFilter,
            r = e.disableFilters;
        e.canFilter = n ? I(!0 !== r && void 0, !0 !== f && void 0, !0) : I(o, d, !1), e.setFilter = function (t) {
          return y(e.id, t);
        };
        var i = p.find(function (e) {
          return e.id === t;
        });
        e.filterValue = i && i.value;
      });
      var b = t.useMemo(function () {
        if (a || !p.length) return [o, r, i];
        var e = [],
            t = {};
        return [function n(o, r) {
          void 0 === r && (r = 0);
          var i = o;
          return (i = p.reduce(function (e, t) {
            var n = t.id,
                o = t.value,
                i = u.find(function (e) {
              return e.id === n;
            });
            if (!i) return e;
            0 === r && (i.preFilteredRows = e);
            var l = k(i.filter, s || {}, xe);
            return l ? (i.filteredRows = l(e, [n], o), i.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i.id + "."), e);
          }, o)).forEach(function (o) {
            e.push(o), t[o.id] = o, o.subRows && (o.subRows = o.subRows && o.subRows.length > 0 ? n(o.subRows, r + 1) : o.subRows);
          }), i;
        }(o), e, t];
      }, [a, p, o, r, i, u, s]),
          S = b[0],
          C = b[1],
          x = b[2];
      t.useMemo(function () {
        u.filter(function (e) {
          return !p.find(function (t) {
            return t.id === e.id;
          });
        }).forEach(function (e) {
          e.preFilteredRows = S, e.filteredRows = S;
        });
      }, [S, p, u]);
      var P = h(m);
      w(function () {
        P() && g({
          type: l.resetFilters
        });
      }, [g, a ? null : n]), Object.assign(e, {
        preFilteredRows: o,
        preFilteredFlatRows: r,
        preFilteredRowsById: i,
        filteredRows: S,
        filteredFlatRows: C,
        filteredRowsById: x,
        rows: S,
        flatRows: C,
        rowsById: x,
        setFilter: y,
        setAllFilters: R
      });
    }

    Pe.pluginName = "useFilters", l.resetGlobalFilter = "resetGlobalFilter", l.setGlobalFilter = "setGlobalFilter";

    var Ie = function Ie(e) {
      e.stateReducers.push(Fe), e.useInstance.push(Ge);
    };

    function Fe(e, t, n, o) {
      if (t.type === l.resetGlobalFilter) return r({}, e, {
        globalFilter: o.initialState.globalFilter || void 0
      });

      if (t.type === l.setGlobalFilter) {
        var u = t.filterValue,
            s = o.userFilterTypes,
            a = k(o.globalFilter, s || {}, xe),
            c = m(u, e.globalFilter);

        if (H(a.autoRemove, c)) {
          return i(e, ["globalFilter"]);
        }

        return r({}, e, {
          globalFilter: c
        });
      }
    }

    function Ge(e) {
      var n = e.data,
          o = e.rows,
          r = e.flatRows,
          i = e.rowsById,
          u = e.allColumns,
          s = e.filterTypes,
          a = e.globalFilter,
          c = e.manualGlobalFilter,
          d = e.state.globalFilter,
          f = e.dispatch,
          p = e.autoResetGlobalFilter,
          g = void 0 === p || p,
          v = e.disableGlobalFilter,
          m = t.useCallback(function (e) {
        f({
          type: l.setGlobalFilter,
          filterValue: e
        });
      }, [f]),
          y = t.useMemo(function () {
        if (c || void 0 === d) return [o, r, i];
        var e = [],
            t = {},
            n = k(a, s || {}, xe);
        if (!n) return console.warn("Could not find a valid 'globalFilter' option."), o;
        u.forEach(function (e) {
          var t = e.disableGlobalFilter;
          e.canFilter = I(!0 !== t && void 0, !0 !== v && void 0, !0);
        });
        var l = u.filter(function (e) {
          return !0 === e.canFilter;
        });
        return [function o(r) {
          return (r = n(r, l.map(function (e) {
            return e.id;
          }), d)).forEach(function (n) {
            e.push(n), t[n.id] = n, n.subRows = n.subRows && n.subRows.length ? o(n.subRows) : n.subRows;
          }), r;
        }(o), e, t];
      }, [c, d, a, s, u, o, r, i, v]),
          R = y[0],
          b = y[1],
          S = y[2],
          C = h(g);
      w(function () {
        C() && f({
          type: l.resetGlobalFilter
        });
      }, [f, c ? null : n]), Object.assign(e, {
        preGlobalFilteredRows: o,
        preGlobalFilteredFlatRows: r,
        preGlobalFilteredRowsById: i,
        globalFilteredRows: R,
        globalFilteredFlatRows: b,
        globalFilteredRowsById: S,
        rows: R,
        flatRows: b,
        rowsById: S,
        setGlobalFilter: m,
        disableGlobalFilter: v
      });
    }

    function Ae(e, t) {
      return t.reduce(function (e, t) {
        return e + ("number" == typeof t ? t : 0);
      }, 0);
    }

    Ie.pluginName = "useGlobalFilter";
    var ke = Object.freeze({
      __proto__: null,
      sum: Ae,
      min: function (e) {
        var t = e[0] || 0;
        return e.forEach(function (e) {
          "number" == typeof e && (t = Math.min(t, e));
        }), t;
      },
      max: function (e) {
        var t = e[0] || 0;
        return e.forEach(function (e) {
          "number" == typeof e && (t = Math.max(t, e));
        }), t;
      },
      minMax: function (e) {
        var t = e[0] || 0,
            n = e[0] || 0;
        return e.forEach(function (e) {
          "number" == typeof e && (t = Math.min(t, e), n = Math.max(n, e));
        }), t + ".." + n;
      },
      average: function (e) {
        return Ae(0, e) / e.length;
      },
      median: function (e) {
        if (!e.length) return null;
        var t = Math.floor(e.length / 2),
            n = [].concat(e).sort(function (e, t) {
          return e - t;
        });
        return e.length % 2 != 0 ? n[t] : (n[t - 1] + n[t]) / 2;
      },
      unique: function (e) {
        return Array.from(new Set(e).values());
      },
      uniqueCount: function (e) {
        return new Set(e).size;
      },
      count: function (e) {
        return e.length;
      }
    }),
        He = [],
        Te = {};
    l.resetGroupBy = "resetGroupBy", l.setGroupBy = "setGroupBy", l.toggleGroupBy = "toggleGroupBy";

    var ze = function ze(e) {
      e.getGroupByToggleProps = [We], e.stateReducers.push(Oe), e.visibleColumnsDeps.push(function (e, t) {
        var n = t.instance;
        return [].concat(e, [n.state.groupBy]);
      }), e.visibleColumns.push(Me), e.useInstance.push(Ne), e.prepareRow.push(Le);
    };

    ze.pluginName = "useGroupBy";

    var We = function We(e, t) {
      var n = t.header;
      return [e, {
        onClick: n.canGroupBy ? function (e) {
          e.persist(), n.toggleGroupBy();
        } : void 0,
        style: {
          cursor: n.canGroupBy ? "pointer" : void 0
        },
        title: "Toggle GroupBy"
      }];
    };

    function Oe(e, t, n, o) {
      if (t.type === l.init) return r({
        groupBy: []
      }, e);
      if (t.type === l.resetGroupBy) return r({}, e, {
        groupBy: o.initialState.groupBy || []
      });
      if (t.type === l.setGroupBy) return r({}, e, {
        groupBy: t.value
      });

      if (t.type === l.toggleGroupBy) {
        var i = t.columnId,
            u = t.value,
            s = void 0 !== u ? u : !e.groupBy.includes(i);
        return r({}, e, s ? {
          groupBy: [].concat(e.groupBy, [i])
        } : {
          groupBy: e.groupBy.filter(function (e) {
            return e !== i;
          })
        });
      }
    }

    function Me(e, t) {
      var n = t.instance.state.groupBy,
          o = n.map(function (t) {
        return e.find(function (e) {
          return e.id === t;
        });
      }).filter(Boolean),
          r = e.filter(function (e) {
        return !n.includes(e.id);
      });
      return (e = [].concat(o, r)).forEach(function (e) {
        e.isGrouped = n.includes(e.id), e.groupedIndex = n.indexOf(e.id);
      }), e;
    }

    var je = {};

    function Ne(e) {
      var n = e.data,
          o = e.rows,
          r = e.flatRows,
          i = e.rowsById,
          u = e.allColumns,
          s = e.flatHeaders,
          a = e.groupByFn,
          c = void 0 === a ? De : a,
          d = e.manualGroupBy,
          p = e.aggregations,
          g = void 0 === p ? je : p,
          m = e.plugins,
          y = e.state.groupBy,
          R = e.dispatch,
          b = e.autoResetGroupBy,
          S = void 0 === b || b,
          C = e.disableGroupBy,
          x = e.defaultCanGroupBy,
          P = e.getHooks;
      v(m, ["useColumnOrder", "useFilters"], "useGroupBy");
      var B = h(e);
      u.forEach(function (t) {
        var n = t.accessor,
            o = t.defaultGroupBy,
            r = t.disableGroupBy;
        t.canGroupBy = n ? I(t.canGroupBy, !0 !== r && void 0, !0 !== C && void 0, !0) : I(t.canGroupBy, o, x, !1), t.canGroupBy && (t.toggleGroupBy = function () {
          return e.toggleGroupBy(t.id);
        }), t.Aggregated = t.Aggregated || t.Cell;
      });
      var E = t.useCallback(function (e, t) {
        R({
          type: l.toggleGroupBy,
          columnId: e,
          value: t
        });
      }, [R]),
          F = t.useCallback(function (e) {
        R({
          type: l.setGroupBy,
          value: e
        });
      }, [R]);
      s.forEach(function (e) {
        e.getGroupByToggleProps = f(P().getGroupByToggleProps, {
          instance: B(),
          header: e
        });
      });
      var A = t.useMemo(function () {
        if (d || !y.length) return [o, r, i, He, Te, r, i];

        var e = y.filter(function (e) {
          return u.find(function (t) {
            return t.id === e;
          });
        }),
            t = [],
            n = {},
            l = [],
            s = {},
            a = [],
            f = {},
            p = function o(r, i, d) {
          if (void 0 === i && (i = 0), i === e.length) return r;
          var p = e[i],
              v = c(r, p);
          return Object.entries(v).map(function (r, c) {
            var v = r[0],
                m = r[1],
                h = p + ":" + v,
                y = o(m, i + 1, h = d ? d + ">" + h : h),
                w = i ? G(m, "leafRows") : m,
                R = function (t, n, o) {
              var r = {};
              return u.forEach(function (i) {
                if (e.includes(i.id)) r[i.id] = n[0] ? n[0].values[i.id] : null;else {
                  var u = "function" == typeof i.aggregate ? i.aggregate : g[i.aggregate] || ke[i.aggregate];

                  if (u) {
                    var l = n.map(function (e) {
                      return e.values[i.id];
                    }),
                        s = t.map(function (e) {
                      var t = e.values[i.id];

                      if (!o && i.aggregateValue) {
                        var n = "function" == typeof i.aggregateValue ? i.aggregateValue : g[i.aggregateValue] || ke[i.aggregateValue];
                        if (!n) throw console.info({
                          column: i
                        }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                        t = n(t, e, i);
                      }

                      return t;
                    });
                    r[i.id] = u(s, l);
                  } else {
                    if (i.aggregate) throw console.info({
                      column: i
                    }), new Error("React Table: Invalid column.aggregate option for column listed above");
                    r[i.id] = null;
                  }
                }
              }), r;
            }(w, m, i),
                b = {
              id: h,
              isGrouped: !0,
              groupByID: p,
              groupByVal: v,
              values: R,
              subRows: y,
              leafRows: w,
              depth: i,
              index: c
            };

            return y.forEach(function (e) {
              t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), s[e.id] = e) : (a.push(e), f[e.id] = e);
            }), b;
          });
        }(o);

        return p.forEach(function (e) {
          t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), s[e.id] = e) : (a.push(e), f[e.id] = e);
        }), [p, t, n, l, s, a, f];
      }, [d, y, o, r, i, u, g, c]),
          k = A[0],
          H = A[1],
          T = A[2],
          z = A[3],
          W = A[4],
          O = A[5],
          M = A[6],
          j = h(S);
      w(function () {
        j() && R({
          type: l.resetGroupBy
        });
      }, [R, d ? null : n]), Object.assign(e, {
        preGroupedRows: o,
        preGroupedFlatRow: r,
        preGroupedRowsById: i,
        groupedRows: k,
        groupedFlatRows: H,
        groupedRowsById: T,
        onlyGroupedFlatRows: z,
        onlyGroupedRowsById: W,
        nonGroupedFlatRows: O,
        nonGroupedRowsById: M,
        rows: k,
        flatRows: H,
        rowsById: T,
        toggleGroupBy: E,
        setGroupBy: F
      });
    }

    function Le(e) {
      e.allCells.forEach(function (t) {
        var n;
        t.isGrouped = t.column.isGrouped && t.column.id === e.groupByID, t.isPlaceholder = !t.isGrouped && t.column.isGrouped, t.isAggregated = !t.isGrouped && !t.isPlaceholder && (null == (n = e.subRows) ? void 0 : n.length);
      });
    }

    function De(e, t) {
      return e.reduce(function (e, n, o) {
        var r = "" + n.values[t];
        return e[r] = Array.isArray(e[r]) ? e[r] : [], e[r].push(n), e;
      }, {});
    }

    var Ve = /([0-9]+)/gm;

    function _e(e, t) {
      return e === t ? 0 : e > t ? 1 : -1;
    }

    function Xe(e, t, n) {
      return [e.values[n], t.values[n]];
    }

    function qe(e) {
      return "number" == typeof e ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : "string" == typeof e ? e : "";
    }

    var Ke = Object.freeze({
      __proto__: null,
      alphanumeric: function (e, t, n) {
        var o = Xe(e, t, n),
            r = o[0],
            i = o[1];

        for (r = qe(r), i = qe(i), r = r.split(Ve).filter(Boolean), i = i.split(Ve).filter(Boolean); r.length && i.length;) {
          var u = r.shift(),
              l = i.shift(),
              s = parseInt(u, 10),
              a = parseInt(l, 10),
              c = [s, a].sort();

          if (isNaN(c[0])) {
            if (u > l) return 1;
            if (l > u) return -1;
          } else {
            if (isNaN(c[1])) return isNaN(s) ? -1 : 1;
            if (s > a) return 1;
            if (a > s) return -1;
          }
        }

        return r.length - i.length;
      },
      datetime: function (e, t, n) {
        var o = Xe(e, t, n),
            r = o[0],
            i = o[1];
        return _e(r = r.getTime(), i = i.getTime());
      },
      basic: function (e, t, n) {
        var o = Xe(e, t, n);
        return _e(o[0], o[1]);
      },
      string: function (e, t, n) {
        var o = Xe(e, t, n),
            r = o[0],
            i = o[1];

        for (r = r.split("").filter(Boolean), i = i.split("").filter(Boolean); r.length && i.length;) {
          var u = r.shift(),
              l = i.shift(),
              s = u.toLowerCase(),
              a = l.toLowerCase();
          if (s > a) return 1;
          if (a > s) return -1;
          if (u > l) return 1;
          if (l > u) return -1;
        }

        return r.length - i.length;
      },
      number: function (e, t, n) {
        var o = Xe(e, t, n),
            r = o[0],
            i = o[1],
            u = /[^0-9.]/gi;
        return _e(r = Number(String(r).replace(u, "")), i = Number(String(i).replace(u, "")));
      }
    });
    l.resetSortBy = "resetSortBy", l.setSortBy = "setSortBy", l.toggleSortBy = "toggleSortBy", l.clearSortBy = "clearSortBy", c.sortType = "alphanumeric", c.sortDescFirst = !1;

    var Ue = function Ue(e) {
      e.getSortByToggleProps = [$e], e.stateReducers.push(Je), e.useInstance.push(Ye);
    };

    Ue.pluginName = "useSortBy";

    var $e = function $e(e, t) {
      var n = t.instance,
          o = t.column,
          r = n.isMultiSortEvent,
          i = void 0 === r ? function (e) {
        return e.shiftKey;
      } : r;
      return [e, {
        onClick: o.canSort ? function (e) {
          e.persist(), o.toggleSortBy(void 0, !n.disableMultiSort && i(e));
        } : void 0,
        style: {
          cursor: o.canSort ? "pointer" : void 0
        },
        title: o.canSort ? "Toggle SortBy" : void 0
      }];
    };

    function Je(e, t, n, o) {
      if (t.type === l.init) return r({
        sortBy: []
      }, e);
      if (t.type === l.resetSortBy) return r({}, e, {
        sortBy: o.initialState.sortBy || []
      });
      if (t.type === l.clearSortBy) return r({}, e, {
        sortBy: e.sortBy.filter(function (e) {
          return e.id !== t.columnId;
        })
      });
      if (t.type === l.setSortBy) return r({}, e, {
        sortBy: t.sortBy
      });

      if (t.type === l.toggleSortBy) {
        var i,
            u = t.columnId,
            s = t.desc,
            a = t.multi,
            c = o.allColumns,
            d = o.disableMultiSort,
            f = o.disableSortRemove,
            p = o.disableMultiRemove,
            g = o.maxMultiSortColCount,
            v = void 0 === g ? Number.MAX_SAFE_INTEGER : g,
            m = e.sortBy,
            h = c.find(function (e) {
          return e.id === u;
        }).sortDescFirst,
            y = m.find(function (e) {
          return e.id === u;
        }),
            w = m.findIndex(function (e) {
          return e.id === u;
        }),
            R = null != s,
            b = [];
        return "toggle" !== (i = !d && a ? y ? "toggle" : "add" : w !== m.length - 1 || 1 !== m.length ? "replace" : y ? "toggle" : "replace") || f || R || a && p || !(y && y.desc && !h || !y.desc && h) || (i = "remove"), "replace" === i ? b = [{
          id: u,
          desc: R ? s : h
        }] : "add" === i ? (b = [].concat(m, [{
          id: u,
          desc: R ? s : h
        }])).splice(0, b.length - v) : "toggle" === i ? b = m.map(function (e) {
          return e.id === u ? r({}, e, {
            desc: R ? s : !y.desc
          }) : e;
        }) : "remove" === i && (b = m.filter(function (e) {
          return e.id !== u;
        })), r({}, e, {
          sortBy: b
        });
      }
    }

    function Ye(e) {
      var n = e.data,
          o = e.rows,
          r = e.flatRows,
          i = e.allColumns,
          u = e.orderByFn,
          s = void 0 === u ? Qe : u,
          a = e.sortTypes,
          c = e.manualSortBy,
          d = e.defaultCanSort,
          p = e.disableSortBy,
          g = e.flatHeaders,
          m = e.state.sortBy,
          y = e.dispatch,
          R = e.plugins,
          b = e.getHooks,
          S = e.autoResetSortBy,
          C = void 0 === S || S;
      v(R, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
      var x = t.useCallback(function (e) {
        y({
          type: l.setSortBy,
          sortBy: e
        });
      }, [y]),
          P = t.useCallback(function (e, t, n) {
        y({
          type: l.toggleSortBy,
          columnId: e,
          desc: t,
          multi: n
        });
      }, [y]),
          B = h(e);
      g.forEach(function (e) {
        var t = e.accessor,
            n = e.canSort,
            o = e.disableSortBy,
            r = e.id,
            i = t ? I(!0 !== o && void 0, !0 !== p && void 0, !0) : I(d, n, !1);
        e.canSort = i, e.canSort && (e.toggleSortBy = function (t, n) {
          return P(e.id, t, n);
        }, e.clearSortBy = function () {
          y({
            type: l.clearSortBy,
            columnId: e.id
          });
        }), e.getSortByToggleProps = f(b().getSortByToggleProps, {
          instance: B(),
          column: e
        });
        var u = m.find(function (e) {
          return e.id === r;
        });
        e.isSorted = !!u, e.sortedIndex = m.findIndex(function (e) {
          return e.id === r;
        }), e.isSortedDesc = e.isSorted ? u.desc : void 0;
      });
      var E = t.useMemo(function () {
        if (c || !m.length) return [o, r];
        var e = [],
            t = m.filter(function (e) {
          return i.find(function (t) {
            return t.id === e.id;
          });
        });
        return [function n(o) {
          var r = s(o, t.map(function (e) {
            var t = i.find(function (t) {
              return t.id === e.id;
            });
            if (!t) throw new Error("React-Table: Could not find a column with id: " + e.id + " while sorting");
            var n = t.sortType,
                o = F(n) || (a || {})[n] || Ke[n];
            if (!o) throw new Error("React-Table: Could not find a valid sortType of '" + n + "' for column '" + e.id + "'.");
            return function (t, n) {
              return o(t, n, e.id, e.desc);
            };
          }), t.map(function (e) {
            var t = i.find(function (t) {
              return t.id === e.id;
            });
            return t && t.sortInverted ? e.desc : !e.desc;
          }));
          return r.forEach(function (t) {
            e.push(t), t.subRows && 0 !== t.subRows.length && (t.subRows = n(t.subRows));
          }), r;
        }(o), e];
      }, [c, m, o, r, i, s, a]),
          G = E[0],
          A = E[1],
          k = h(C);
      w(function () {
        k() && y({
          type: l.resetSortBy
        });
      }, [c ? null : n]), Object.assign(e, {
        preSortedRows: o,
        preSortedFlatRows: r,
        sortedRows: G,
        sortedFlatRows: A,
        rows: G,
        flatRows: A,
        setSortBy: x,
        toggleSortBy: P
      });
    }

    function Qe(e, t, n) {
      return [].concat(e).sort(function (e, o) {
        for (var r = 0; r < t.length; r += 1) {
          var i = t[r],
              u = !1 === n[r] || "desc" === n[r],
              l = i(e, o);
          if (0 !== l) return u ? -l : l;
        }

        return n[0] ? e.index - o.index : o.index - e.index;
      });
    }

    l.resetPage = "resetPage", l.gotoPage = "gotoPage", l.setPageSize = "setPageSize";

    var Ze = function Ze(e) {
      e.stateReducers.push(et), e.useInstance.push(tt);
    };

    function et(e, t, n, o) {
      if (t.type === l.init) return r({
        pageSize: 10,
        pageIndex: 0
      }, e);
      if (t.type === l.resetPage) return r({}, e, {
        pageIndex: o.initialState.pageIndex || 0
      });

      if (t.type === l.gotoPage) {
        var i = o.pageCount,
            u = o.page,
            s = m(t.pageIndex, e.pageIndex),
            a = !1;
        return s > e.pageIndex ? a = -1 === i ? u.length >= e.pageSize : s < i : s < e.pageIndex && (a = s > -1), a ? r({}, e, {
          pageIndex: s
        }) : e;
      }

      if (t.type === l.setPageSize) {
        var c = t.pageSize,
            d = e.pageSize * e.pageIndex;
        return r({}, e, {
          pageIndex: Math.floor(d / c),
          pageSize: c
        });
      }
    }

    function tt(e) {
      var n = e.rows,
          o = e.autoResetPage,
          r = void 0 === o || o,
          i = e.manualExpandedKey,
          u = void 0 === i ? "expanded" : i,
          s = e.plugins,
          a = e.pageCount,
          c = e.paginateExpandedRows,
          d = void 0 === c || c,
          f = e.expandSubRows,
          p = void 0 === f || f,
          g = e.state,
          m = g.pageSize,
          y = g.pageIndex,
          R = g.expanded,
          b = g.globalFilter,
          S = g.filters,
          C = g.groupBy,
          x = g.sortBy,
          P = e.dispatch,
          B = e.data,
          E = e.manualPagination;
      v(s, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
      var I = h(r);
      w(function () {
        I() && P({
          type: l.resetPage
        });
      }, [P, E ? null : B, b, S, C, x]);
      var F = E ? a : Math.ceil(n.length / m),
          G = t.useMemo(function () {
        return F > 0 ? [].concat(new Array(F)).fill(null).map(function (e, t) {
          return t;
        }) : [];
      }, [F]),
          k = t.useMemo(function () {
        var e;
        if (E) e = n;else {
          var t = m * y,
              o = t + m;
          e = n.slice(t, o);
        }
        return d ? e : A(e, {
          manualExpandedKey: u,
          expanded: R,
          expandSubRows: p
        });
      }, [p, R, u, E, y, m, d, n]),
          H = y > 0,
          T = -1 === F ? k.length >= m : y < F - 1,
          z = t.useCallback(function (e) {
        P({
          type: l.gotoPage,
          pageIndex: e
        });
      }, [P]),
          W = t.useCallback(function () {
        return z(function (e) {
          return e - 1;
        });
      }, [z]),
          O = t.useCallback(function () {
        return z(function (e) {
          return e + 1;
        });
      }, [z]),
          M = t.useCallback(function (e) {
        P({
          type: l.setPageSize,
          pageSize: e
        });
      }, [P]);
      Object.assign(e, {
        pageOptions: G,
        pageCount: F,
        page: k,
        canPreviousPage: H,
        canNextPage: T,
        gotoPage: z,
        previousPage: W,
        nextPage: O,
        setPageSize: M
      });
    }

    Ze.pluginName = "usePagination", l.resetPivot = "resetPivot", l.togglePivot = "togglePivot";

    var nt = function nt(e) {
      e.getPivotToggleProps = [rt], e.stateReducers.push(it), e.useInstanceAfterData.push(ut), e.allColumns.push(lt), e.accessValue.push(st), e.materializedColumns.push(at), e.materializedColumnsDeps.push(ct), e.visibleColumns.push(dt), e.visibleColumnsDeps.push(ft), e.useInstance.push(pt), e.prepareRow.push(gt);
    };

    nt.pluginName = "usePivotColumns";

    var ot = [],
        rt = function rt(e, t) {
      var n = t.header;
      return [e, {
        onClick: n.canPivot ? function (e) {
          e.persist(), n.togglePivot();
        } : void 0,
        style: {
          cursor: n.canPivot ? "pointer" : void 0
        },
        title: "Toggle Pivot"
      }];
    };

    function it(e, t, n, o) {
      if (t.type === l.init) return r({
        pivotColumns: ot
      }, e);
      if (t.type === l.resetPivot) return r({}, e, {
        pivotColumns: o.initialState.pivotColumns || ot
      });

      if (t.type === l.togglePivot) {
        var i = t.columnId,
            u = t.value,
            s = void 0 !== u ? u : !e.pivotColumns.includes(i);
        return r({}, e, s ? {
          pivotColumns: [].concat(e.pivotColumns, [i])
        } : {
          pivotColumns: e.pivotColumns.filter(function (e) {
            return e !== i;
          })
        });
      }
    }

    function ut(e) {
      e.allColumns.forEach(function (t) {
        t.isPivotSource = e.state.pivotColumns.includes(t.id);
      });
    }

    function lt(e, t) {
      var n = t.instance;
      return e.forEach(function (e) {
        e.isPivotSource = n.state.pivotColumns.includes(e.id), e.uniqueValues = new Set();
      }), e;
    }

    function st(e, t) {
      var n = t.column;
      return n.uniqueValues && void 0 !== e && n.uniqueValues.add(e), e;
    }

    function at(e, t) {
      var n = t.instance,
          o = n.allColumns,
          i = n.state;
      if (!i.pivotColumns.length || !i.groupBy || !i.groupBy.length) return e;
      var u = i.pivotColumns.map(function (e) {
        return o.find(function (t) {
          return t.id === e;
        });
      }).filter(Boolean),
          l = o.filter(function (e) {
        return !e.isPivotSource && !i.groupBy.includes(e.id) && !i.pivotColumns.includes(e.id);
      }),
          s = C(function e(t, n, o) {
        void 0 === t && (t = 0), void 0 === o && (o = []);
        var i = u[t];
        return i ? Array.from(i.uniqueValues).sort().map(function (u) {
          var l = r({}, i, {
            Header: i.PivotHeader || "string" == typeof i.header ? i.Header + ": " + u : u,
            isPivotGroup: !0,
            parent: n,
            depth: t,
            id: n ? n.id + "." + i.id + "." + u : i.id + "." + u,
            pivotValue: u
          });
          return l.columns = e(t + 1, l, [].concat(o, [function (e) {
            return e.values[i.id] === u;
          }])), l;
        }) : l.map(function (e) {
          return r({}, e, {
            canPivot: !1,
            isPivoted: !0,
            parent: n,
            depth: t,
            id: "" + (n ? n.id + "." + e.id : e.id),
            accessor: function (t, n, r) {
              if (o.every(function (e) {
                return e(r);
              })) return r.values[e.id];
            }
          });
        });
      }());
      return [].concat(e, s);
    }

    function ct(e, t) {
      var n = t.instance.state,
          o = n.pivotColumns,
          r = n.groupBy;
      return [].concat(e, [o, r]);
    }

    function dt(e, t) {
      var n = t.instance.state;
      return e = e.filter(function (e) {
        return !e.isPivotSource;
      }), n.pivotColumns.length && n.groupBy && n.groupBy.length && (e = e.filter(function (e) {
        return e.isGrouped || e.isPivoted;
      })), e;
    }

    function ft(e, t) {
      var n = t.instance;
      return [].concat(e, [n.state.pivotColumns, n.state.groupBy]);
    }

    function pt(e) {
      var t = e.columns,
          n = e.allColumns,
          o = e.flatHeaders,
          r = e.getHooks,
          i = e.plugins,
          u = e.dispatch,
          s = e.autoResetPivot,
          a = void 0 === s || s,
          c = e.manaulPivot,
          d = e.disablePivot,
          p = e.defaultCanPivot;
      v(i, ["useGroupBy"], "usePivotColumns");
      var g = h(e);
      n.forEach(function (t) {
        var n = t.accessor,
            o = t.defaultPivot,
            r = t.disablePivot;
        t.canPivot = n ? I(t.canPivot, !0 !== r && void 0, !0 !== d && void 0, !0) : I(t.canPivot, o, p, !1), t.canPivot && (t.togglePivot = function () {
          return e.togglePivot(t.id);
        }), t.Aggregated = t.Aggregated || t.Cell;
      });
      o.forEach(function (e) {
        e.getPivotToggleProps = f(r().getPivotToggleProps, {
          instance: g(),
          header: e
        });
      });
      var m = h(a);
      w(function () {
        m() && u({
          type: l.resetPivot
        });
      }, [u, c ? null : t]), Object.assign(e, {
        togglePivot: function (e, t) {
          u({
            type: l.togglePivot,
            columnId: e,
            value: t
          });
        }
      });
    }

    function gt(e) {
      e.allCells.forEach(function (e) {
        e.isPivoted = e.column.isPivoted;
      });
    }

    l.resetSelectedRows = "resetSelectedRows", l.toggleAllRowsSelected = "toggleAllRowsSelected", l.toggleRowSelected = "toggleRowSelected", l.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";

    var vt = function vt(e) {
      e.getToggleRowSelectedProps = [mt], e.getToggleAllRowsSelectedProps = [ht], e.getToggleAllPageRowsSelectedProps = [yt], e.stateReducers.push(wt), e.useInstance.push(Rt), e.prepareRow.push(bt);
    };

    vt.pluginName = "useRowSelect";

    var mt = function mt(e, t) {
      var n = t.instance,
          o = t.row,
          r = n.manualRowSelectedKey,
          i = void 0 === r ? "isSelected" : r;
      return [e, {
        onChange: function (e) {
          o.toggleRowSelected(e.target.checked);
        },
        style: {
          cursor: "pointer"
        },
        checked: !(!o.original || !o.original[i]) || o.isSelected,
        title: "Toggle Row Selected",
        indeterminate: o.isSomeSelected
      }];
    },
        ht = function ht(e, t) {
      var n = t.instance;
      return [e, {
        onChange: function (e) {
          n.toggleAllRowsSelected(e.target.checked);
        },
        style: {
          cursor: "pointer"
        },
        checked: n.isAllRowsSelected,
        title: "Toggle All Rows Selected",
        indeterminate: Boolean(!n.isAllRowsSelected && Object.keys(n.state.selectedRowIds).length)
      }];
    },
        yt = function yt(e, t) {
      var n = t.instance;
      return [e, {
        onChange: function (e) {
          n.toggleAllPageRowsSelected(e.target.checked);
        },
        style: {
          cursor: "pointer"
        },
        checked: n.isAllPageRowsSelected,
        title: "Toggle All Current Page Rows Selected",
        indeterminate: Boolean(!n.isAllPageRowsSelected && n.page.some(function (e) {
          var t = e.id;
          return n.state.selectedRowIds[t];
        }))
      }];
    };

    function wt(e, t, n, o) {
      if (t.type === l.init) return r({
        selectedRowIds: {}
      }, e);
      if (t.type === l.resetSelectedRows) return r({}, e, {
        selectedRowIds: o.initialState.selectedRowIds || {}
      });

      if (t.type === l.toggleAllRowsSelected) {
        var i = t.value,
            u = o.isAllRowsSelected,
            s = o.rowsById,
            a = o.nonGroupedRowsById,
            c = void 0 === a ? s : a,
            d = void 0 !== i ? i : !u,
            f = Object.assign({}, e.selectedRowIds);
        return d ? Object.keys(c).forEach(function (e) {
          f[e] = !0;
        }) : Object.keys(c).forEach(function (e) {
          delete f[e];
        }), r({}, e, {
          selectedRowIds: f
        });
      }

      if (t.type === l.toggleRowSelected) {
        var p = t.id,
            g = t.value,
            v = o.rowsById,
            m = o.selectSubRows,
            h = void 0 === m || m,
            y = o.getSubRows,
            w = e.selectedRowIds[p],
            R = void 0 !== g ? g : !w;
        if (w === R) return e;
        var b = r({}, e.selectedRowIds);
        return function e(t) {
          var n = v[t];
          if (n.isGrouped || (R ? b[t] = !0 : delete b[t]), h && y(n)) return y(n).forEach(function (t) {
            return e(t.id);
          });
        }(p), r({}, e, {
          selectedRowIds: b
        });
      }

      if (t.type === l.toggleAllPageRowsSelected) {
        var S = t.value,
            C = o.page,
            x = o.rowsById,
            P = o.selectSubRows,
            B = void 0 === P || P,
            E = o.isAllPageRowsSelected,
            I = o.getSubRows,
            F = void 0 !== S ? S : !E,
            G = r({}, e.selectedRowIds);
        return C.forEach(function (e) {
          return function e(t) {
            var n = x[t];
            if (n.isGrouped || (F ? G[t] = !0 : delete G[t]), B && I(n)) return I(n).forEach(function (t) {
              return e(t.id);
            });
          }(e.id);
        }), r({}, e, {
          selectedRowIds: G
        });
      }

      return e;
    }

    function Rt(e) {
      var n = e.data,
          o = e.rows,
          r = e.getHooks,
          i = e.plugins,
          u = e.rowsById,
          s = e.nonGroupedRowsById,
          a = void 0 === s ? u : s,
          c = e.autoResetSelectedRows,
          d = void 0 === c || c,
          p = e.state.selectedRowIds,
          g = e.selectSubRows,
          m = void 0 === g || g,
          y = e.dispatch,
          R = e.page,
          b = e.getSubRows;
      v(i, ["useFilters", "useGroupBy", "useSortBy", "useExpanded", "usePagination"], "useRowSelect");
      var S = t.useMemo(function () {
        var e = [];
        return o.forEach(function (t) {
          var n = m ? function e(t, n, o) {
            if (n[t.id]) return !0;
            var r = o(t);

            if (r && r.length) {
              var i = !0,
                  u = !1;
              return r.forEach(function (t) {
                u && !i || (e(t, n, o) ? u = !0 : i = !1);
              }), !!i || !!u && null;
            }

            return !1;
          }(t, p, b) : !!p[t.id];
          t.isSelected = !!n, t.isSomeSelected = null === n, n && e.push(t);
        }), e;
      }, [o, m, p, b]),
          C = Boolean(Object.keys(a).length && Object.keys(p).length),
          x = C;
      C && Object.keys(a).some(function (e) {
        return !p[e];
      }) && (C = !1), C || R && R.length && R.some(function (e) {
        var t = e.id;
        return !p[t];
      }) && (x = !1);
      var P = h(d);
      w(function () {
        P() && y({
          type: l.resetSelectedRows
        });
      }, [y, n]);
      var B = t.useCallback(function (e) {
        return y({
          type: l.toggleAllRowsSelected,
          value: e
        });
      }, [y]),
          E = t.useCallback(function (e) {
        return y({
          type: l.toggleAllPageRowsSelected,
          value: e
        });
      }, [y]),
          I = t.useCallback(function (e, t) {
        return y({
          type: l.toggleRowSelected,
          id: e,
          value: t
        });
      }, [y]),
          F = h(e),
          G = f(r().getToggleAllRowsSelectedProps, {
        instance: F()
      }),
          A = f(r().getToggleAllPageRowsSelectedProps, {
        instance: F()
      });
      Object.assign(e, {
        selectedFlatRows: S,
        isAllRowsSelected: C,
        isAllPageRowsSelected: x,
        toggleRowSelected: I,
        toggleAllRowsSelected: B,
        getToggleAllRowsSelectedProps: G,
        getToggleAllPageRowsSelectedProps: A,
        toggleAllPageRowsSelected: E
      });
    }

    function bt(e, t) {
      var n = t.instance;
      e.toggleRowSelected = function (t) {
        return n.toggleRowSelected(e.id, t);
      }, e.getToggleRowSelectedProps = f(n.getHooks().getToggleRowSelectedProps, {
        instance: n,
        row: e
      });
    }

    var St = function St(e) {
      return {};
    },
        Ct = function Ct(e) {
      return {};
    };

    l.setRowState = "setRowState", l.setCellState = "setCellState", l.resetRowState = "resetRowState";

    var xt = function xt(e) {
      e.stateReducers.push(Pt), e.useInstance.push(Bt), e.prepareRow.push(Et);
    };

    function Pt(e, t, n, o) {
      var i = o.initialRowStateAccessor,
          u = void 0 === i ? St : i,
          s = o.initialCellStateAccessor,
          a = void 0 === s ? Ct : s,
          c = o.rowsById;
      if (t.type === l.init) return r({
        rowState: {}
      }, e);
      if (t.type === l.resetRowState) return r({}, e, {
        rowState: o.initialState.rowState || {}
      });

      if (t.type === l.setRowState) {
        var d,
            f = t.rowId,
            p = t.value,
            g = void 0 !== e.rowState[f] ? e.rowState[f] : u(c[f]);
        return r({}, e, {
          rowState: r({}, e.rowState, (d = {}, d[f] = m(p, g), d))
        });
      }

      if (t.type === l.setCellState) {
        var v,
            h,
            y,
            w,
            R,
            b = t.rowId,
            S = t.columnId,
            C = t.value,
            x = void 0 !== e.rowState[b] ? e.rowState[b] : u(c[b]),
            P = void 0 !== (null == x ? void 0 : null == (v = x.cellState) ? void 0 : v[S]) ? x.cellState[S] : a(null == (h = c[b]) ? void 0 : null == (y = h.cells) ? void 0 : y.find(function (e) {
          return e.column.id === S;
        }));
        return r({}, e, {
          rowState: r({}, e.rowState, (R = {}, R[b] = r({}, x, {
            cellState: r({}, x.cellState || {}, (w = {}, w[S] = m(C, P), w))
          }), R))
        });
      }
    }

    function Bt(e) {
      var n = e.autoResetRowState,
          o = void 0 === n || n,
          r = e.data,
          i = e.dispatch,
          u = t.useCallback(function (e, t) {
        return i({
          type: l.setRowState,
          rowId: e,
          value: t
        });
      }, [i]),
          s = t.useCallback(function (e, t, n) {
        return i({
          type: l.setCellState,
          rowId: e,
          columnId: t,
          value: n
        });
      }, [i]),
          a = h(o);
      w(function () {
        a() && i({
          type: l.resetRowState
        });
      }, [r]), Object.assign(e, {
        setRowState: u,
        setCellState: s
      });
    }

    function Et(e, t) {
      var n = t.instance,
          o = n.initialRowStateAccessor,
          r = void 0 === o ? St : o,
          i = n.initialCellStateAccessor,
          u = void 0 === i ? Ct : i,
          l = n.state.rowState;
      e && (e.state = void 0 !== l[e.id] ? l[e.id] : r(e), e.setState = function (t) {
        return n.setRowState(e.id, t);
      }, e.cells.forEach(function (t) {
        e.state.cellState || (e.state.cellState = {}), t.state = void 0 !== e.state.cellState[t.column.id] ? e.state.cellState[t.column.id] : u(t), t.setState = function (o) {
          return n.setCellState(e.id, t.column.id, o);
        };
      }));
    }

    xt.pluginName = "useRowState", l.resetColumnOrder = "resetColumnOrder", l.setColumnOrder = "setColumnOrder";

    var It = function It(e) {
      e.stateReducers.push(Ft), e.visibleColumnsDeps.push(function (e, t) {
        var n = t.instance;
        return [].concat(e, [n.state.columnOrder]);
      }), e.visibleColumns.push(Gt), e.useInstance.push(At);
    };

    function Ft(e, t, n, o) {
      return t.type === l.init ? r({
        columnOrder: []
      }, e) : t.type === l.resetColumnOrder ? r({}, e, {
        columnOrder: o.initialState.columnOrder || []
      }) : t.type === l.setColumnOrder ? r({}, e, {
        columnOrder: m(t.columnOrder, e.columnOrder)
      }) : void 0;
    }

    function Gt(e, t) {
      var n = t.instance.state.columnOrder;
      if (!n || !n.length) return e;

      for (var o = [].concat(n), r = [].concat(e), i = [], u = function u() {
        var e = o.shift(),
            t = r.findIndex(function (t) {
          return t.id === e;
        });
        t > -1 && i.push(r.splice(t, 1)[0]);
      }; r.length && o.length;) u();

      return [].concat(i, r);
    }

    function At(e) {
      var n = e.dispatch;
      e.setColumnOrder = t.useCallback(function (e) {
        return n({
          type: l.setColumnOrder,
          columnOrder: e
        });
      }, [n]);
    }

    It.pluginName = "useColumnOrder", c.canResize = !0, l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize";

    var kt = function kt(e) {
      e.getResizerProps = [Ht], e.getHeaderProps.push({
        style: {
          position: "relative"
        }
      }), e.stateReducers.push(Tt), e.useInstance.push(Wt), e.useInstanceBeforeDimensions.push(zt);
    },
        Ht = function Ht(e, t) {
      var n = t.instance,
          o = t.header,
          r = n.dispatch,
          i = function i(e, t) {
        var n = !1;

        if ("touchstart" === e.type) {
          if (e.touches && e.touches.length > 1) return;
          n = !0;
        }

        var o = function (e) {
          var t = [];
          return function e(n) {
            n.columns && n.columns.length && n.columns.map(e);
            t.push(n);
          }(e), t;
        }(t).map(function (e) {
          return [e.id, e.totalWidth];
        }),
            i = n ? Math.round(e.touches[0].clientX) : e.clientX,
            u = function u(e) {
          r({
            type: l.columnResizing,
            clientX: e
          });
        },
            s = function s() {
          return r({
            type: l.columnDoneResizing
          });
        },
            a = {
          mouse: {
            moveEvent: "mousemove",
            moveHandler: function (e) {
              return u(e.clientX);
            },
            upEvent: "mouseup",
            upHandler: function (e) {
              document.removeEventListener("mousemove", a.mouse.moveHandler), document.removeEventListener("mouseup", a.mouse.upHandler), s();
            }
          },
          touch: {
            moveEvent: "touchmove",
            moveHandler: function (e) {
              return e.cancelable && (e.preventDefault(), e.stopPropagation()), u(e.touches[0].clientX), !1;
            },
            upEvent: "touchend",
            upHandler: function (e) {
              document.removeEventListener(a.touch.moveEvent, a.touch.moveHandler), document.removeEventListener(a.touch.upEvent, a.touch.moveHandler), s();
            }
          }
        },
            c = n ? a.touch : a.mouse,
            d = !!function () {
          if ("boolean" == typeof z) return z;
          var e = !1;

          try {
            var t = {
              get passive() {
                return e = !0, !1;
              }

            };
            window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
          } catch (t) {
            e = !1;
          }

          return z = e;
        }() && {
          passive: !1
        };

        document.addEventListener(c.moveEvent, c.moveHandler, d), document.addEventListener(c.upEvent, c.upHandler, d), r({
          type: l.columnStartResizing,
          columnId: t.id,
          columnWidth: t.totalWidth,
          headerIdWidths: o,
          clientX: i
        });
      };

      return [e, {
        onMouseDown: function (e) {
          return e.persist() || i(e, o);
        },
        onTouchStart: function (e) {
          return e.persist() || i(e, o);
        },
        style: {
          cursor: "col-resize"
        },
        draggable: !1,
        role: "separator"
      }];
    };

    function Tt(e, t) {
      if (t.type === l.init) return r({
        columnResizing: {
          columnWidths: {}
        }
      }, e);
      if (t.type === l.resetResize) return r({}, e, {
        columnResizing: {
          columnWidths: {}
        }
      });

      if (t.type === l.columnStartResizing) {
        var n = t.clientX,
            o = t.columnId,
            i = t.columnWidth,
            u = t.headerIdWidths;
        return r({}, e, {
          columnResizing: r({}, e.columnResizing, {
            startX: n,
            headerIdWidths: u,
            columnWidth: i,
            isResizingColumn: o
          })
        });
      }

      if (t.type === l.columnResizing) {
        var s = t.clientX,
            a = e.columnResizing,
            c = a.startX,
            d = a.columnWidth,
            f = a.headerIdWidths,
            p = (s - c) / d,
            g = {};
        return (void 0 === f ? [] : f).forEach(function (e) {
          var t = e[0],
              n = e[1];
          g[t] = Math.max(n + n * p, 0);
        }), r({}, e, {
          columnResizing: r({}, e.columnResizing, {
            columnWidths: r({}, e.columnResizing.columnWidths, {}, g)
          })
        });
      }

      return t.type === l.columnDoneResizing ? r({}, e, {
        columnResizing: r({}, e.columnResizing, {
          startX: null,
          isResizingColumn: null
        })
      }) : void 0;
    }

    kt.pluginName = "useResizeColumns";

    var zt = function zt(e) {
      var t = e.flatHeaders,
          n = e.disableResizing,
          o = e.getHooks,
          r = e.state.columnResizing,
          i = h(e);
      t.forEach(function (e) {
        var t = I(!0 !== e.disableResizing && void 0, !0 !== n && void 0, !0);
        e.canResize = t, e.width = r.columnWidths[e.id] || e.originalWidth || e.width, e.isResizing = r.isResizingColumn === e.id, t && (e.getResizerProps = f(o().getResizerProps, {
          instance: i(),
          header: e
        }));
      });
    };

    function Wt(e) {
      var n = e.plugins,
          o = e.dispatch,
          r = e.autoResetResize,
          i = void 0 === r || r,
          u = e.columns;
      v(n, ["useAbsoluteLayout"], "useResizeColumns");
      var s = h(i);
      w(function () {
        s() && o({
          type: l.resetResize
        });
      }, [u]);
      var a = t.useCallback(function () {
        return o({
          type: l.resetResize
        });
      }, [o]);
      Object.assign(e, {
        resetResizing: a
      });
    }

    var Ot = {
      position: "absolute",
      top: 0
    },
        Mt = function Mt(e) {
      e.getTableBodyProps.push(jt), e.getRowProps.push(jt), e.getHeaderGroupProps.push(jt), e.getFooterGroupProps.push(jt), e.getHeaderProps.push(function (e, t) {
        var n = t.column;
        return [e, {
          style: r({}, Ot, {
            left: n.totalLeft + "px",
            width: n.totalWidth + "px"
          })
        }];
      }), e.getCellProps.push(function (e, t) {
        var n = t.cell;
        return [e, {
          style: r({}, Ot, {
            left: n.column.totalLeft + "px",
            width: n.column.totalWidth + "px"
          })
        }];
      }), e.getFooterProps.push(function (e, t) {
        var n = t.column;
        return [e, {
          style: r({}, Ot, {
            left: n.totalLeft + "px",
            width: n.totalWidth + "px"
          })
        }];
      });
    };

    Mt.pluginName = "useAbsoluteLayout";

    var jt = function jt(e, t) {
      return [e, {
        style: {
          position: "relative",
          width: t.instance.totalColumnsWidth + "px"
        }
      }];
    },
        Nt = {
      display: "inline-block",
      boxSizing: "border-box"
    },
        Lt = function Lt(e, t) {
      return [e, {
        style: {
          display: "flex",
          width: t.instance.totalColumnsWidth + "px"
        }
      }];
    },
        Dt = function Dt(e) {
      e.getRowProps.push(Lt), e.getHeaderGroupProps.push(Lt), e.getFooterGroupProps.push(Lt), e.getHeaderProps.push(function (e, t) {
        var n = t.column;
        return [e, {
          style: r({}, Nt, {
            width: n.totalWidth + "px"
          })
        }];
      }), e.getCellProps.push(function (e, t) {
        var n = t.cell;
        return [e, {
          style: r({}, Nt, {
            width: n.column.totalWidth + "px"
          })
        }];
      }), e.getFooterProps.push(function (e, t) {
        var n = t.column;
        return [e, {
          style: r({}, Nt, {
            width: n.totalWidth + "px"
          })
        }];
      });
    };

    function Vt(e) {
      e.getTableProps.push(_t), e.getRowProps.push(Xt), e.getHeaderGroupProps.push(Xt), e.getFooterGroupProps.push(Xt), e.getHeaderProps.push(qt), e.getCellProps.push(Kt), e.getFooterProps.push(Ut);
    }

    Dt.pluginName = "useBlockLayout", Vt.pluginName = "useFlexLayout";

    var _t = function _t(e, t) {
      return [e, {
        style: {
          minWidth: t.instance.totalColumnsMinWidth + "px"
        }
      }];
    },
        Xt = function Xt(e, t) {
      return [e, {
        style: {
          display: "flex",
          flex: "1 0 auto",
          minWidth: t.instance.totalColumnsMinWidth + "px"
        }
      }];
    },
        qt = function qt(e, t) {
      var n = t.column;
      return [e, {
        style: {
          boxSizing: "border-box",
          flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
          minWidth: n.totalMinWidth + "px",
          width: n.totalWidth + "px"
        }
      }];
    },
        Kt = function Kt(e, t) {
      var n = t.cell;
      return [e, {
        style: {
          boxSizing: "border-box",
          flex: n.column.totalFlexWidth + " 0 auto",
          minWidth: n.column.totalMinWidth + "px",
          width: n.column.totalWidth + "px"
        }
      }];
    },
        Ut = function Ut(e, t) {
      var n = t.column;
      return [e, {
        style: {
          boxSizing: "border-box",
          flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
          minWidth: n.totalMinWidth + "px",
          width: n.totalWidth + "px"
        }
      }];
    };

    function $t(e) {
      e.stateReducers.push(Qt), e.getTableProps.push(Jt), e.getHeaderProps.push(Yt);
    }

    $t.pluginName = "useGridLayout";

    var Jt = function Jt(e, t) {
      return [e, {
        style: {
          display: "grid",
          gridTemplateColumns: t.instance.state.gridLayout.columnWidths.map(function (e) {
            return e;
          }).join(" ")
        }
      }];
    },
        Yt = function Yt(e, t) {
      return [e, {
        id: "header-cell-" + t.column.id,
        style: {
          position: "sticky"
        }
      }];
    };

    function Qt(e, t, n, o) {
      if ("init" === t.type) return r({
        gridLayout: {
          columnWidths: o.columns.map(function () {
            return "auto";
          })
        }
      }, e);

      if ("columnStartResizing" === t.type) {
        var i = t.columnId,
            u = o.visibleColumns.findIndex(function (e) {
          return e.id === i;
        }),
            l = function (e) {
          var t,
              n = null == (t = document.getElementById("header-cell-" + e)) ? void 0 : t.offsetWidth;
          if (void 0 !== n) return n;
        }(i);

        return void 0 !== l ? r({}, e, {
          gridLayout: r({}, e.gridLayout, {
            columnId: i,
            columnIndex: u,
            startingWidth: l
          })
        }) : e;
      }

      if ("columnResizing" === t.type) {
        var s = e.gridLayout,
            a = s.columnIndex,
            c = s.startingWidth,
            d = s.columnWidths,
            f = c - (e.columnResizing.startX - t.clientX),
            p = [].concat(d);
        return p[a] = f + "px", r({}, e, {
          gridLayout: r({}, e.gridLayout, {
            columnWidths: p
          })
        });
      }
    }

    e._UNSTABLE_usePivotColumns = nt, e.actions = l, e.defaultColumn = c, e.defaultGroupByFn = De, e.defaultOrderByFn = Qe, e.defaultRenderer = s, e.emptyRenderer = a, e.ensurePluginOrder = v, e.flexRender = b, e.functionalUpdate = m, e.loopHooks = g, e.makePropGetter = f, e.makeRenderer = R, e.reduceHooks = p, e.safeUseLayoutEffect = y, e.useAbsoluteLayout = Mt, e.useAsyncDebounce = function (e, n) {
      void 0 === n && (n = 0);
      var r = t.useRef({}),
          i = h(e),
          u = h(n);
      return t.useCallback(function () {
        var e = o(regeneratorRuntime.mark(function e() {
          var t,
              n,
              l,
              s = arguments;
          return regeneratorRuntime.wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                for (t = s.length, n = new Array(t), l = 0; l < t; l++) n[l] = s[l];

                return r.current.promise || (r.current.promise = new Promise(function (e, t) {
                  r.current.resolve = e, r.current.reject = t;
                })), r.current.timeout && clearTimeout(r.current.timeout), r.current.timeout = setTimeout(o(regeneratorRuntime.mark(function e() {
                  return regeneratorRuntime.wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return delete r.current.timeout, e.prev = 1, e.t0 = r.current, e.next = 5, i().apply(void 0, n);

                      case 5:
                        e.t1 = e.sent, e.t0.resolve.call(e.t0, e.t1), e.next = 12;
                        break;

                      case 9:
                        e.prev = 9, e.t2 = e.catch(1), r.current.reject(e.t2);

                      case 12:
                        return e.prev = 12, delete r.current.promise, e.finish(12);

                      case 15:
                      case "end":
                        return e.stop();
                    }
                  }, e, null, [[1, 9, 12, 15]]);
                })), u()), e.abrupt("return", r.current.promise);

              case 5:
              case "end":
                return e.stop();
            }
          }, e);
        }));
        return function () {
          return e.apply(this, arguments);
        };
      }(), [i, u]);
    }, e.useBlockLayout = Dt, e.useColumnOrder = It, e.useExpanded = se, e.useFilters = Pe, e.useFlexLayout = Vt, e.useGetLatest = h, e.useGlobalFilter = Ie, e.useGridLayout = $t, e.useGroupBy = ze, e.useMountedLayoutEffect = w, e.usePagination = Ze, e.useResizeColumns = kt, e.useRowSelect = vt, e.useRowState = xt, e.useSortBy = Ue, e.useTable = function (e) {
      for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) o[i - 1] = arguments[i];

      e = ie(e), o = [K].concat(o);
      var u = t.useRef({}),
          s = h(u.current);
      Object.assign(s(), r({}, e, {
        plugins: o,
        hooks: q()
      })), o.filter(Boolean).forEach(function (e) {
        e(s().hooks);
      });
      var a = h(s().hooks);
      s().getHooks = a, delete s().hooks, Object.assign(s(), p(a().useOptions, ie(e)));
      var c = s(),
          d = c.data,
          v = c.columns,
          m = c.initialState,
          y = c.defaultColumn,
          w = c.getSubRows,
          b = c.getRowId,
          E = c.stateReducer,
          I = c.useControlledState,
          F = h(E),
          G = t.useCallback(function (e, t) {
        if (!t.type) throw console.info({
          action: t
        }), new Error("Unknown Action 👆");
        return [].concat(a().stateReducers, Array.isArray(F()) ? F() : [F()]).reduce(function (n, o) {
          return o(n, t, e, s()) || n;
        }, e);
      }, [a, F, s]),
          A = t.useReducer(G, void 0, function () {
        return G(m, {
          type: l.init
        });
      }),
          k = A[0],
          H = A[1],
          T = p([].concat(a().useControlledState, [I]), k, {
        instance: s()
      });
      Object.assign(s(), {
        state: T,
        dispatch: H
      });
      var z = t.useMemo(function () {
        return S(p(a().columns, v, {
          instance: s()
        }));
      }, [a, s, v].concat(p(a().columnsDeps, [], {
        instance: s()
      })));
      s().columns = z;
      var W = t.useMemo(function () {
        return p(a().allColumns, C(z), {
          instance: s()
        }).map(x);
      }, [z, a, s].concat(p(a().allColumnsDeps, [], {
        instance: s()
      })));
      s().allColumns = W;
      var O = t.useMemo(function () {
        for (var e = [], t = [], n = {}, o = [].concat(W); o.length;) {
          var r = o.shift();
          le({
            data: d,
            rows: e,
            flatRows: t,
            rowsById: n,
            column: r,
            getRowId: b,
            getSubRows: w,
            accessValueHooks: a().accessValue,
            getInstance: s
          });
        }

        return [e, t, n];
      }, [W, d, b, w, a, s]),
          M = O[0],
          j = O[1],
          N = O[2];
      Object.assign(s(), {
        rows: M,
        initialRows: [].concat(M),
        flatRows: j,
        rowsById: N
      }), g(a().useInstanceAfterData, s());
      var L = t.useMemo(function () {
        return p(a().visibleColumns, W, {
          instance: s()
        }).map(function (e) {
          return P(e, y);
        });
      }, [a, W, s, y].concat(p(a().visibleColumnsDeps, [], {
        instance: s()
      })));
      W = t.useMemo(function () {
        var e = [].concat(L);
        return W.forEach(function (t) {
          e.find(function (e) {
            return e.id === t.id;
          }) || e.push(t);
        }), e;
      }, [W, L]), s().allColumns = W;
      var D = t.useMemo(function () {
        return p(a().headerGroups, B(L, y), s());
      }, [a, L, y, s].concat(p(a().headerGroupsDeps, [], {
        instance: s()
      })));
      s().headerGroups = D;
      var V = t.useMemo(function () {
        return D.length ? D[0].headers : [];
      }, [D]);
      s().headers = V, s().flatHeaders = D.reduce(function (e, t) {
        return [].concat(e, t.headers);
      }, []), g(a().useInstanceBeforeDimensions, s());

      var _ = L.filter(function (e) {
        return e.isVisible;
      }).map(function (e) {
        return e.id;
      }).sort().join("_");

      L = t.useMemo(function () {
        return L.filter(function (e) {
          return e.isVisible;
        });
      }, [L, _]), s().visibleColumns = L;
      var X = ue(V),
          U = X[0],
          $ = X[1],
          J = X[2];
      return s().totalColumnsMinWidth = U, s().totalColumnsWidth = $, s().totalColumnsMaxWidth = J, g(a().useInstance, s()), [].concat(s().flatHeaders, s().allColumns).forEach(function (e) {
        e.render = R(s(), e), e.getHeaderProps = f(a().getHeaderProps, {
          instance: s(),
          column: e
        }), e.getFooterProps = f(a().getFooterProps, {
          instance: s(),
          column: e
        });
      }), s().headerGroups = t.useMemo(function () {
        return D.filter(function (e, t) {
          return e.headers = e.headers.filter(function (e) {
            return e.headers ? function e(t) {
              return t.filter(function (t) {
                return t.headers ? e(t.headers) : t.isVisible;
              }).length;
            }(e.headers) : e.isVisible;
          }), !!e.headers.length && (e.getHeaderGroupProps = f(a().getHeaderGroupProps, {
            instance: s(),
            headerGroup: e,
            index: t
          }), e.getFooterGroupProps = f(a().getFooterGroupProps, {
            instance: s(),
            headerGroup: e,
            index: t
          }), !0);
        });
      }, [D, s, a]), s().footerGroups = [].concat(s().headerGroups).reverse(), s().prepareRow = t.useCallback(function (e) {
        e.getRowProps = f(a().getRowProps, {
          instance: s(),
          row: e
        }), e.allCells = W.map(function (t) {
          var n = e.values[t.id],
              o = {
            column: t,
            row: e,
            value: n
          };
          return o.getCellProps = f(a().getCellProps, {
            instance: s(),
            cell: o
          }), o.render = R(s(), t, {
            row: e,
            cell: o,
            value: n
          }), o;
        }), e.cells = L.map(function (t) {
          return e.allCells.find(function (e) {
            return e.column.id === t.id;
          });
        }), g(a().prepareRow, e, {
          instance: s()
        });
      }, [a, s, W, L]), s().getTableProps = f(a().getTableProps, {
        instance: s()
      }), s().getTableBodyProps = f(a().getTableBodyProps, {
        instance: s()
      }), g(a().useFinalInstance, s()), s();
    }, Object.defineProperty(e, "__esModule", {
      value: !0
    });
  });
});

createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    factory(exports, React__default) ;
  })(commonjsGlobal, function (exports, React) {

    React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function _asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }

    function _toPrimitive(input, hint) {
      if (typeof input !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];

      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }

      return (hint === "string" ? String : Number)(input);
    }

    function _toPropertyKey(arg) {
      var key = _toPrimitive(arg, "string");

      return typeof key === "symbol" ? key : String(key);
    }

    var renderErr = 'Renderer Error ☝️';
    var actions = {
      init: 'init'
    };

    var defaultRenderer = function defaultRenderer(_ref) {
      var _ref$value = _ref.value,
          value = _ref$value === void 0 ? '' : _ref$value;
      return value;
    };

    var emptyRenderer = function emptyRenderer() {
      return React.createElement(React.Fragment, null, "\xA0");
    };

    var defaultColumn = {
      Cell: defaultRenderer,
      width: 150,
      minWidth: 0,
      maxWidth: Number.MAX_SAFE_INTEGER
    };

    function mergeProps() {
      for (var _len = arguments.length, propList = new Array(_len), _key = 0; _key < _len; _key++) {
        propList[_key] = arguments[_key];
      }

      return propList.reduce(function (props, next) {
        var style = next.style,
            className = next.className,
            rest = _objectWithoutPropertiesLoose(next, ["style", "className"]);

        props = _extends({}, props, {}, rest);

        if (style) {
          props.style = props.style ? _extends({}, props.style || {}, {}, style || {}) : style;
        }

        if (className) {
          props.className = props.className ? props.className + ' ' + className : className;
        }

        if (props.className === '') {
          delete props.className;
        }

        return props;
      }, {});
    }

    function handlePropGetter(prevProps, userProps, meta) {
      // Handle a lambda, pass it the previous props
      if (typeof userProps === 'function') {
        return handlePropGetter({}, userProps(prevProps, meta));
      } // Handle an array, merge each item as separate props


      if (Array.isArray(userProps)) {
        return mergeProps.apply(void 0, [prevProps].concat(userProps));
      } // Handle an object by default, merge the two objects


      return mergeProps(prevProps, userProps);
    }

    var makePropGetter = function makePropGetter(hooks, meta) {
      if (meta === void 0) {
        meta = {};
      }

      return function (userProps) {
        if (userProps === void 0) {
          userProps = {};
        }

        return [].concat(hooks, [userProps]).reduce(function (prev, next) {
          return handlePropGetter(prev, next, _extends({}, meta, {
            userProps: userProps
          }));
        }, {});
      };
    };

    var reduceHooks = function reduceHooks(hooks, initial, meta, allowUndefined) {
      if (meta === void 0) {
        meta = {};
      }

      return hooks.reduce(function (prev, next) {
        var nextValue = next(prev, meta);
        {
          if (!allowUndefined && typeof nextValue === 'undefined') {
            console.info(next);
            throw new Error('React Table: A reducer hook ☝️ just returned undefined! This is not allowed.');
          }
        }
        return nextValue;
      }, initial);
    };

    var loopHooks = function loopHooks(hooks, context, meta) {
      if (meta === void 0) {
        meta = {};
      }

      return hooks.forEach(function (hook) {
        var nextValue = hook(context, meta);
        {
          if (typeof nextValue !== 'undefined') {
            console.info(hook, nextValue);
            throw new Error('React Table: A loop-type hook ☝️ just returned a value! This is not allowed.');
          }
        }
      });
    };

    function ensurePluginOrder(plugins, befores, pluginName, afters) {
      if (afters) {
        throw new Error("Defining plugins in the \"after\" section of ensurePluginOrder is no longer supported (see plugin " + pluginName + ")");
      }

      var pluginIndex = plugins.findIndex(function (plugin) {
        return plugin.pluginName === pluginName;
      });

      if (pluginIndex === -1) {
        {
          throw new Error("The plugin \"" + pluginName + "\" was not found in the plugin list!\nThis usually means you need to need to name your plugin hook by setting the 'pluginName' property of the hook function, eg:\n\n  " + pluginName + ".pluginName = '" + pluginName + "'\n");
        }
      }

      befores.forEach(function (before) {
        var beforeIndex = plugins.findIndex(function (plugin) {
          return plugin.pluginName === before;
        });

        if (beforeIndex > -1 && beforeIndex > pluginIndex) {
          {
            throw new Error("React Table: The " + pluginName + " plugin hook must be placed after the " + before + " plugin hook!");
          }
        }
      });
    }

    function functionalUpdate(updater, old) {
      return typeof updater === 'function' ? updater(old) : updater;
    }

    function useGetLatest(obj) {
      var ref = React.useRef();
      ref.current = obj;
      return React.useCallback(function () {
        return ref.current;
      }, []);
    } // SSR has issues with useLayoutEffect still, so use useEffect during SSR


    var safeUseLayoutEffect = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;

    function useMountedLayoutEffect(fn, deps) {
      var mountedRef = React.useRef(false);
      safeUseLayoutEffect(function () {
        if (mountedRef.current) {
          fn();
        }

        mountedRef.current = true; // eslint-disable-next-line
      }, deps);
    }

    function useAsyncDebounce(defaultFn, defaultWait) {
      if (defaultWait === void 0) {
        defaultWait = 0;
      }

      var debounceRef = React.useRef({});
      var getDefaultFn = useGetLatest(defaultFn);
      var getDefaultWait = useGetLatest(defaultWait);
      return React.useCallback( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _len2,
              args,
              _key2,
              _args2 = arguments;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  for (_len2 = _args2.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = _args2[_key2];
                  }

                  if (!debounceRef.current.promise) {
                    debounceRef.current.promise = new Promise(function (resolve, reject) {
                      debounceRef.current.resolve = resolve;
                      debounceRef.current.reject = reject;
                    });
                  }

                  if (debounceRef.current.timeout) {
                    clearTimeout(debounceRef.current.timeout);
                  }

                  debounceRef.current.timeout = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            delete debounceRef.current.timeout;
                            _context.prev = 1;
                            _context.t0 = debounceRef.current;
                            _context.next = 5;
                            return getDefaultFn().apply(void 0, args);

                          case 5:
                            _context.t1 = _context.sent;

                            _context.t0.resolve.call(_context.t0, _context.t1);

                            _context.next = 12;
                            break;

                          case 9:
                            _context.prev = 9;
                            _context.t2 = _context["catch"](1);
                            debounceRef.current.reject(_context.t2);

                          case 12:
                            _context.prev = 12;
                            delete debounceRef.current.promise;
                            return _context.finish(12);

                          case 15:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[1, 9, 12, 15]]);
                  })), getDefaultWait());
                  return _context2.abrupt("return", debounceRef.current.promise);

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function () {
          return _ref2.apply(this, arguments);
        };
      }(), [getDefaultFn, getDefaultWait]);
    }

    function makeRenderer(instance, column, meta) {
      if (meta === void 0) {
        meta = {};
      }

      return function (type, userProps) {
        if (userProps === void 0) {
          userProps = {};
        }

        var Comp = typeof type === 'string' ? column[type] : type;

        if (typeof Comp === 'undefined') {
          console.info(column);
          throw new Error(renderErr);
        }

        return flexRender(Comp, _extends({}, instance, {
          column: column
        }, meta, {}, userProps));
      };
    }

    function flexRender(Comp, props) {
      return isReactComponent(Comp) ? React.createElement(Comp, props) : Comp;
    }

    function isReactComponent(component) {
      return isClassComponent(component) || typeof component === 'function' || isExoticComponent(component);
    }

    function isClassComponent(component) {
      return typeof component === 'function' && function () {
        var proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
      }();
    }

    function isExoticComponent(component) {
      return typeof component === 'object' && typeof component.$$typeof === 'symbol' && ['react.memo', 'react.forward_ref'].includes(component.$$typeof.description);
    }

    function linkColumnStructure(columns, parent, depth) {
      if (depth === void 0) {
        depth = 0;
      }

      return columns.map(function (column) {
        column = _extends({}, column, {
          parent: parent,
          depth: depth
        });
        assignColumnAccessor(column);

        if (column.columns) {
          column.columns = linkColumnStructure(column.columns, column, depth + 1);
        }

        return column;
      });
    }

    function flattenColumns(columns) {
      return flattenBy(columns, 'columns');
    }

    function assignColumnAccessor(column) {
      // First check for string accessor
      var id = column.id,
          accessor = column.accessor,
          Header = column.Header;

      if (typeof accessor === 'string') {
        id = id || accessor;
        var accessorPath = accessor.split('.');

        accessor = function accessor(row) {
          return getBy(row, accessorPath);
        };
      }

      if (!id && typeof Header === 'string' && Header) {
        id = Header;
      }

      if (!id && column.columns) {
        console.error(column);
        throw new Error('A column ID (or unique "Header" value) is required!');
      }

      if (!id) {
        console.error(column);
        throw new Error('A column ID (or string accessor) is required!');
      }

      Object.assign(column, {
        id: id,
        accessor: accessor
      });
      return column;
    }

    function decorateColumn(column, userDefaultColumn) {
      if (!userDefaultColumn) {
        throw new Error();
      }

      Object.assign(column, _extends({
        // Make sure there is a fallback header, just in case
        Header: emptyRenderer,
        Footer: emptyRenderer
      }, defaultColumn, {}, userDefaultColumn, {}, column));
      Object.assign(column, {
        originalWidth: column.width
      });
      return column;
    } // Build the header groups from the bottom up


    function makeHeaderGroups(allColumns, defaultColumn, additionalHeaderProperties) {
      if (additionalHeaderProperties === void 0) {
        additionalHeaderProperties = function additionalHeaderProperties() {
          return {};
        };
      }

      var headerGroups = [];
      var scanColumns = allColumns;
      var uid = 0;

      var getUID = function getUID() {
        return uid++;
      };

      var _loop = function _loop() {
        // The header group we are creating
        var headerGroup = {
          headers: []
        }; // The parent columns we're going to scan next

        var parentColumns = [];
        var hasParents = scanColumns.some(function (d) {
          return d.parent;
        }); // Scan each column for parents

        scanColumns.forEach(function (column) {
          // What is the latest (last) parent column?
          var latestParentColumn = [].concat(parentColumns).reverse()[0];
          var newParent;

          if (hasParents) {
            // If the column has a parent, add it if necessary
            if (column.parent) {
              newParent = _extends({}, column.parent, {
                originalId: column.parent.id,
                id: column.parent.id + "_" + getUID(),
                headers: [column]
              }, additionalHeaderProperties(column));
            } else {
              // If other columns have parents, we'll need to add a place holder if necessary
              var originalId = column.id + "_placeholder";
              newParent = decorateColumn(_extends({
                originalId: originalId,
                id: column.id + "_placeholder_" + getUID(),
                placeholderOf: column,
                headers: [column]
              }, additionalHeaderProperties(column)), defaultColumn);
            } // If the resulting parent columns are the same, just add
            // the column and increment the header span


            if (latestParentColumn && latestParentColumn.originalId === newParent.originalId) {
              latestParentColumn.headers.push(column);
            } else {
              parentColumns.push(newParent);
            }
          }

          headerGroup.headers.push(column);
        });
        headerGroups.push(headerGroup); // Start scanning the parent columns

        scanColumns = parentColumns;
      };

      while (scanColumns.length) {
        _loop();
      }

      return headerGroups.reverse();
    }

    var pathObjCache = new Map();

    function getBy(obj, path, def) {
      if (!path) {
        return obj;
      }

      var cacheKey = typeof path === 'function' ? path : JSON.stringify(path);

      var pathObj = pathObjCache.get(cacheKey) || function () {
        var pathObj = makePathArray(path);
        pathObjCache.set(cacheKey, pathObj);
        return pathObj;
      }();

      var val;

      try {
        val = pathObj.reduce(function (cursor, pathPart) {
          return cursor[pathPart];
        }, obj);
      } catch (e) {// continue regardless of error
      }

      return typeof val !== 'undefined' ? val : def;
    }

    function getFirstDefined() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      for (var i = 0; i < args.length; i += 1) {
        if (typeof args[i] !== 'undefined') {
          return args[i];
        }
      }
    }

    function isFunction(a) {
      if (typeof a === 'function') {
        return a;
      }
    }

    function flattenBy(arr, key) {
      var flat = [];

      var recurse = function recurse(arr) {
        arr.forEach(function (d) {
          if (!d[key]) {
            flat.push(d);
          } else {
            recurse(d[key]);
          }
        });
      };

      recurse(arr);
      return flat;
    }

    function expandRows(rows, _ref) {
      var manualExpandedKey = _ref.manualExpandedKey,
          expanded = _ref.expanded,
          _ref$expandSubRows = _ref.expandSubRows,
          expandSubRows = _ref$expandSubRows === void 0 ? true : _ref$expandSubRows;
      var expandedRows = [];

      var handleRow = function handleRow(row, addToExpandedRows) {
        if (addToExpandedRows === void 0) {
          addToExpandedRows = true;
        }

        row.isExpanded = row.original && row.original[manualExpandedKey] || expanded[row.id];
        row.canExpand = row.subRows && !!row.subRows.length;

        if (addToExpandedRows) {
          expandedRows.push(row);
        }

        if (row.subRows && row.subRows.length && row.isExpanded) {
          row.subRows.forEach(function (row) {
            return handleRow(row, expandSubRows);
          });
        }
      };

      rows.forEach(function (row) {
        return handleRow(row);
      });
      return expandedRows;
    }

    function getFilterMethod(filter, userFilterTypes, filterTypes) {
      return isFunction(filter) || userFilterTypes[filter] || filterTypes[filter] || filterTypes.text;
    }

    function shouldAutoRemoveFilter(autoRemove, value, column) {
      return autoRemove ? autoRemove(value, column) : typeof value === 'undefined';
    }

    function unpreparedAccessWarning() {
      throw new Error('React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.');
    }

    var passiveSupported = null;

    function passiveEventSupported() {
      // memoize support to avoid adding multiple test events
      if (typeof passiveSupported === 'boolean') return passiveSupported;
      var supported = false;

      try {
        var options = {
          get passive() {
            supported = true;
            return false;
          }

        };
        window.addEventListener('test', null, options);
        window.removeEventListener('test', null, options);
      } catch (err) {
        supported = false;
      }

      passiveSupported = supported;
      return passiveSupported;
    } //


    var reOpenBracket = /\[/g;
    var reCloseBracket = /\]/g;

    function makePathArray(obj) {
      return flattenDeep(obj) // remove all periods in parts
      .map(function (d) {
        return String(d).replace('.', '_');
      }) // join parts using period
      .join('.') // replace brackets with periods
      .replace(reOpenBracket, '.').replace(reCloseBracket, '') // split it back out on periods
      .split('.');
    }

    function flattenDeep(arr, newArr) {
      if (newArr === void 0) {
        newArr = [];
      }

      if (!Array.isArray(arr)) {
        newArr.push(arr);
      } else {
        for (var i = 0; i < arr.length; i += 1) {
          flattenDeep(arr[i], newArr);
        }
      }

      return newArr;
    }

    var defaultGetTableProps = function defaultGetTableProps(props) {
      return _extends({
        role: 'table'
      }, props);
    };

    var defaultGetTableBodyProps = function defaultGetTableBodyProps(props) {
      return _extends({
        role: 'rowgroup'
      }, props);
    };

    var defaultGetHeaderProps = function defaultGetHeaderProps(props, _ref) {
      var column = _ref.column;
      return _extends({
        key: "header_" + column.id,
        colSpan: column.totalVisibleHeaderCount,
        role: 'columnheader'
      }, props);
    };

    var defaultGetFooterProps = function defaultGetFooterProps(props, _ref2) {
      var column = _ref2.column;
      return _extends({
        key: "footer_" + column.id,
        colSpan: column.totalVisibleHeaderCount
      }, props);
    };

    var defaultGetHeaderGroupProps = function defaultGetHeaderGroupProps(props, _ref3) {
      var index = _ref3.index;
      return _extends({
        key: "headerGroup_" + index,
        role: 'row'
      }, props);
    };

    var defaultGetFooterGroupProps = function defaultGetFooterGroupProps(props, _ref4) {
      var index = _ref4.index;
      return _extends({
        key: "footerGroup_" + index
      }, props);
    };

    var defaultGetRowProps = function defaultGetRowProps(props, _ref5) {
      var row = _ref5.row;
      return _extends({
        key: "row_" + row.id,
        role: 'row'
      }, props);
    };

    var defaultGetCellProps = function defaultGetCellProps(props, _ref6) {
      var cell = _ref6.cell;
      return _extends({
        key: "cell_" + cell.row.id + "_" + cell.column.id,
        role: 'cell'
      }, props);
    };

    function makeDefaultPluginHooks() {
      return {
        useOptions: [],
        stateReducers: [],
        useControlledState: [],
        columns: [],
        columnsDeps: [],
        allColumns: [],
        allColumnsDeps: [],
        accessValue: [],
        materializedColumns: [],
        materializedColumnsDeps: [],
        useInstanceAfterData: [],
        visibleColumns: [],
        visibleColumnsDeps: [],
        headerGroups: [],
        headerGroupsDeps: [],
        useInstanceBeforeDimensions: [],
        useInstance: [],
        prepareRow: [],
        getTableProps: [defaultGetTableProps],
        getTableBodyProps: [defaultGetTableBodyProps],
        getHeaderGroupProps: [defaultGetHeaderGroupProps],
        getFooterGroupProps: [defaultGetFooterGroupProps],
        getHeaderProps: [defaultGetHeaderProps],
        getFooterProps: [defaultGetFooterProps],
        getRowProps: [defaultGetRowProps],
        getCellProps: [defaultGetCellProps],
        useFinalInstance: []
      };
    }

    actions.resetHiddenColumns = 'resetHiddenColumns';
    actions.toggleHideColumn = 'toggleHideColumn';
    actions.setHiddenColumns = 'setHiddenColumns';
    actions.toggleHideAllColumns = 'toggleHideAllColumns';

    var useColumnVisibility = function useColumnVisibility(hooks) {
      hooks.getToggleHiddenProps = [defaultGetToggleHiddenProps];
      hooks.getToggleHideAllColumnsProps = [defaultGetToggleHideAllColumnsProps];
      hooks.stateReducers.push(reducer);
      hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions);
      hooks.headerGroupsDeps.push(function (deps, _ref) {
        var instance = _ref.instance;
        return [].concat(deps, [instance.state.hiddenColumns]);
      });
      hooks.useInstance.push(useInstance);
    };

    useColumnVisibility.pluginName = 'useColumnVisibility';

    var defaultGetToggleHiddenProps = function defaultGetToggleHiddenProps(props, _ref2) {
      var column = _ref2.column;
      return [props, {
        onChange: function onChange(e) {
          column.toggleHidden(!e.target.checked);
        },
        style: {
          cursor: 'pointer'
        },
        checked: column.isVisible,
        title: 'Toggle Column Visible'
      }];
    };

    var defaultGetToggleHideAllColumnsProps = function defaultGetToggleHideAllColumnsProps(props, _ref3) {
      var instance = _ref3.instance;
      return [props, {
        onChange: function onChange(e) {
          instance.toggleHideAllColumns(!e.target.checked);
        },
        style: {
          cursor: 'pointer'
        },
        checked: !instance.allColumnsHidden && !instance.state.hiddenColumns.length,
        title: 'Toggle All Columns Hidden',
        indeterminate: !instance.allColumnsHidden && instance.state.hiddenColumns.length
      }];
    };

    function reducer(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          hiddenColumns: []
        }, state);
      }

      if (action.type === actions.resetHiddenColumns) {
        return _extends({}, state, {
          hiddenColumns: instance.initialState.hiddenColumns || []
        });
      }

      if (action.type === actions.toggleHideColumn) {
        var should = typeof action.value !== 'undefined' ? action.value : !state.hiddenColumns.includes(action.columnId);
        var hiddenColumns = should ? [].concat(state.hiddenColumns, [action.columnId]) : state.hiddenColumns.filter(function (d) {
          return d !== action.columnId;
        });
        return _extends({}, state, {
          hiddenColumns: hiddenColumns
        });
      }

      if (action.type === actions.setHiddenColumns) {
        return _extends({}, state, {
          hiddenColumns: functionalUpdate(action.value, state.hiddenColumns)
        });
      }

      if (action.type === actions.toggleHideAllColumns) {
        var shouldAll = typeof action.value !== 'undefined' ? action.value : !state.hiddenColumns.length;
        return _extends({}, state, {
          hiddenColumns: shouldAll ? instance.allColumns.map(function (d) {
            return d.id;
          }) : []
        });
      }
    }

    function useInstanceBeforeDimensions(instance) {
      var headers = instance.headers,
          hiddenColumns = instance.state.hiddenColumns;
      React.useRef(false);

      var handleColumn = function handleColumn(column, parentVisible) {
        column.isVisible = parentVisible && !hiddenColumns.includes(column.id);
        var totalVisibleHeaderCount = 0;

        if (column.headers && column.headers.length) {
          column.headers.forEach(function (subColumn) {
            return totalVisibleHeaderCount += handleColumn(subColumn, column.isVisible);
          });
        } else {
          totalVisibleHeaderCount = column.isVisible ? 1 : 0;
        }

        column.totalVisibleHeaderCount = totalVisibleHeaderCount;
        return totalVisibleHeaderCount;
      };

      var totalVisibleHeaderCount = 0;
      headers.forEach(function (subHeader) {
        return totalVisibleHeaderCount += handleColumn(subHeader, true);
      });
    }

    function useInstance(instance) {
      var columns = instance.columns,
          flatHeaders = instance.flatHeaders,
          dispatch = instance.dispatch,
          allColumns = instance.allColumns,
          getHooks = instance.getHooks,
          hiddenColumns = instance.state.hiddenColumns,
          _instance$autoResetHi = instance.autoResetHiddenColumns,
          autoResetHiddenColumns = _instance$autoResetHi === void 0 ? true : _instance$autoResetHi;
      var getInstance = useGetLatest(instance);
      var allColumnsHidden = allColumns.length === hiddenColumns.length;
      var toggleHideColumn = React.useCallback(function (columnId, value) {
        return dispatch({
          type: actions.toggleHideColumn,
          columnId: columnId,
          value: value
        });
      }, [dispatch]);
      var setHiddenColumns = React.useCallback(function (value) {
        return dispatch({
          type: actions.setHiddenColumns,
          value: value
        });
      }, [dispatch]);
      var toggleHideAllColumns = React.useCallback(function (value) {
        return dispatch({
          type: actions.toggleHideAllColumns,
          value: value
        });
      }, [dispatch]);
      var getToggleHideAllColumnsProps = makePropGetter(getHooks().getToggleHideAllColumnsProps, {
        instance: getInstance()
      });
      flatHeaders.forEach(function (column) {
        column.toggleHidden = function (value) {
          dispatch({
            type: actions.toggleHideColumn,
            columnId: column.id,
            value: value
          });
        };

        column.getToggleHiddenProps = makePropGetter(getHooks().getToggleHiddenProps, {
          instance: getInstance(),
          column: column
        });
      });
      var getAutoResetHiddenColumns = useGetLatest(autoResetHiddenColumns);
      useMountedLayoutEffect(function () {
        if (getAutoResetHiddenColumns()) {
          dispatch({
            type: actions.resetHiddenColumns
          });
        }
      }, [dispatch, columns]);
      Object.assign(instance, {
        allColumnsHidden: allColumnsHidden,
        toggleHideColumn: toggleHideColumn,
        setHiddenColumns: setHiddenColumns,
        toggleHideAllColumns: toggleHideAllColumns,
        getToggleHideAllColumnsProps: getToggleHideAllColumnsProps
      });
    }

    var defaultInitialState = {};
    var defaultColumnInstance = {};

    var defaultReducer = function defaultReducer(state, action, prevState) {
      return state;
    };

    var defaultGetSubRows = function defaultGetSubRows(row, index) {
      return row.subRows || [];
    };

    var defaultGetRowId = function defaultGetRowId(row, index, parent) {
      return "" + (parent ? [parent.id, index].join('.') : index);
    };

    var defaultUseControlledState = function defaultUseControlledState(d) {
      return d;
    };

    function applyDefaults(props) {
      var _props$initialState = props.initialState,
          initialState = _props$initialState === void 0 ? defaultInitialState : _props$initialState,
          _props$defaultColumn = props.defaultColumn,
          defaultColumn = _props$defaultColumn === void 0 ? defaultColumnInstance : _props$defaultColumn,
          _props$getSubRows = props.getSubRows,
          getSubRows = _props$getSubRows === void 0 ? defaultGetSubRows : _props$getSubRows,
          _props$getRowId = props.getRowId,
          getRowId = _props$getRowId === void 0 ? defaultGetRowId : _props$getRowId,
          _props$stateReducer = props.stateReducer,
          stateReducer = _props$stateReducer === void 0 ? defaultReducer : _props$stateReducer,
          _props$useControlledS = props.useControlledState,
          useControlledState = _props$useControlledS === void 0 ? defaultUseControlledState : _props$useControlledS,
          rest = _objectWithoutPropertiesLoose(props, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]);

      return _extends({}, rest, {
        initialState: initialState,
        defaultColumn: defaultColumn,
        getSubRows: getSubRows,
        getRowId: getRowId,
        stateReducer: stateReducer,
        useControlledState: useControlledState
      });
    }

    var useTable = function useTable(props) {
      for (var _len = arguments.length, plugins = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        plugins[_key - 1] = arguments[_key];
      } // Apply default props


      props = applyDefaults(props); // Add core plugins

      plugins = [useColumnVisibility].concat(plugins); // Create the table instance

      var instanceRef = React.useRef({}); // Create a getter for the instance (helps avoid a lot of potential memory leaks)

      var getInstance = useGetLatest(instanceRef.current); // Assign the props, plugins and hooks to the instance

      Object.assign(getInstance(), _extends({}, props, {
        plugins: plugins,
        hooks: makeDefaultPluginHooks()
      })); // Allow plugins to register hooks as early as possible

      plugins.filter(Boolean).forEach(function (plugin) {
        plugin(getInstance().hooks);
      }); // Consume all hooks and make a getter for them

      var getHooks = useGetLatest(getInstance().hooks);
      getInstance().getHooks = getHooks;
      delete getInstance().hooks; // Allow useOptions hooks to modify the options coming into the table

      Object.assign(getInstance(), reduceHooks(getHooks().useOptions, applyDefaults(props)));

      var _getInstance = getInstance(),
          data = _getInstance.data,
          userColumns = _getInstance.columns,
          initialState = _getInstance.initialState,
          defaultColumn = _getInstance.defaultColumn,
          getSubRows = _getInstance.getSubRows,
          getRowId = _getInstance.getRowId,
          stateReducer = _getInstance.stateReducer,
          useControlledState = _getInstance.useControlledState; // Setup user reducer ref


      var getStateReducer = useGetLatest(stateReducer); // Build the reducer

      var reducer = React.useCallback(function (state, action) {
        // Detect invalid actions
        if (!action.type) {
          console.info({
            action: action
          });
          throw new Error('Unknown Action 👆');
        } // Reduce the state from all plugin reducers


        return [].concat(getHooks().stateReducers, Array.isArray(getStateReducer()) ? getStateReducer() : [getStateReducer()]).reduce(function (s, handler) {
          return handler(s, action, state, getInstance()) || s;
        }, state);
      }, [getHooks, getStateReducer, getInstance]); // Start the reducer

      var _React$useReducer = React.useReducer(reducer, undefined, function () {
        return reducer(initialState, {
          type: actions.init
        });
      }),
          reducerState = _React$useReducer[0],
          dispatch = _React$useReducer[1]; // Allow the user to control the final state with hooks


      var state = reduceHooks([].concat(getHooks().useControlledState, [useControlledState]), reducerState, {
        instance: getInstance()
      });
      Object.assign(getInstance(), {
        state: state,
        dispatch: dispatch
      }); // Decorate All the columns

      var columns = React.useMemo(function () {
        return linkColumnStructure(reduceHooks(getHooks().columns, userColumns, {
          instance: getInstance()
        }));
      }, [getHooks, getInstance, userColumns].concat(reduceHooks(getHooks().columnsDeps, [], {
        instance: getInstance()
      })));
      getInstance().columns = columns; // Get the flat list of all columns and allow hooks to decorate
      // those columns (and trigger this memoization via deps)

      var allColumns = React.useMemo(function () {
        return reduceHooks(getHooks().allColumns, flattenColumns(columns), {
          instance: getInstance()
        }).map(assignColumnAccessor);
      }, [columns, getHooks, getInstance].concat(reduceHooks(getHooks().allColumnsDeps, [], {
        instance: getInstance()
      })));
      getInstance().allColumns = allColumns; // Access the row model using initial columns

      var _React$useMemo = React.useMemo(function () {
        var rows = [];
        var flatRows = [];
        var rowsById = {};
        var allColumnsQueue = [].concat(allColumns);

        while (allColumnsQueue.length) {
          var column = allColumnsQueue.shift();
          accessRowsForColumn({
            data: data,
            rows: rows,
            flatRows: flatRows,
            rowsById: rowsById,
            column: column,
            getRowId: getRowId,
            getSubRows: getSubRows,
            accessValueHooks: getHooks().accessValue,
            getInstance: getInstance
          });
        }

        return [rows, flatRows, rowsById];
      }, [allColumns, data, getRowId, getSubRows, getHooks, getInstance]),
          rows = _React$useMemo[0],
          flatRows = _React$useMemo[1],
          rowsById = _React$useMemo[2];

      Object.assign(getInstance(), {
        rows: rows,
        initialRows: [].concat(rows),
        flatRows: flatRows,
        rowsById: rowsById // materializedColumns,

      });
      loopHooks(getHooks().useInstanceAfterData, getInstance()); // Get the flat list of all columns AFTER the rows
      // have been access, and allow hooks to decorate
      // those columns (and trigger this memoization via deps)

      var visibleColumns = React.useMemo(function () {
        return reduceHooks(getHooks().visibleColumns, allColumns, {
          instance: getInstance()
        }).map(function (d) {
          return decorateColumn(d, defaultColumn);
        });
      }, [getHooks, allColumns, getInstance, defaultColumn].concat(reduceHooks(getHooks().visibleColumnsDeps, [], {
        instance: getInstance()
      }))); // Combine new visible columns with all columns

      allColumns = React.useMemo(function () {
        var columns = [].concat(visibleColumns);
        allColumns.forEach(function (column) {
          if (!columns.find(function (d) {
            return d.id === column.id;
          })) {
            columns.push(column);
          }
        });
        return columns;
      }, [allColumns, visibleColumns]);
      getInstance().allColumns = allColumns;
      {
        var duplicateColumns = allColumns.filter(function (column, i) {
          return allColumns.findIndex(function (d) {
            return d.id === column.id;
          }) !== i;
        });

        if (duplicateColumns.length) {
          console.info(allColumns);
          throw new Error("Duplicate columns were found with ids: \"" + duplicateColumns.map(function (d) {
            return d.id;
          }).join(', ') + "\" in the columns array above");
        }
      } // Make the headerGroups

      var headerGroups = React.useMemo(function () {
        return reduceHooks(getHooks().headerGroups, makeHeaderGroups(visibleColumns, defaultColumn), getInstance());
      }, [getHooks, visibleColumns, defaultColumn, getInstance].concat(reduceHooks(getHooks().headerGroupsDeps, [], {
        instance: getInstance()
      })));
      getInstance().headerGroups = headerGroups; // Get the first level of headers

      var headers = React.useMemo(function () {
        return headerGroups.length ? headerGroups[0].headers : [];
      }, [headerGroups]);
      getInstance().headers = headers; // Provide a flat header list for utilities

      getInstance().flatHeaders = headerGroups.reduce(function (all, headerGroup) {
        return [].concat(all, headerGroup.headers);
      }, []);
      loopHooks(getHooks().useInstanceBeforeDimensions, getInstance()); // Filter columns down to visible ones

      var visibleColumnsDep = visibleColumns.filter(function (d) {
        return d.isVisible;
      }).map(function (d) {
        return d.id;
      }).sort().join('_');
      visibleColumns = React.useMemo(function () {
        return visibleColumns.filter(function (d) {
          return d.isVisible;
        });
      }, // eslint-disable-next-line react-hooks/exhaustive-deps
      [visibleColumns, visibleColumnsDep]);
      getInstance().visibleColumns = visibleColumns; // Header Visibility is needed by this point

      var _calculateHeaderWidth = calculateHeaderWidths(headers),
          totalColumnsMinWidth = _calculateHeaderWidth[0],
          totalColumnsWidth = _calculateHeaderWidth[1],
          totalColumnsMaxWidth = _calculateHeaderWidth[2];

      getInstance().totalColumnsMinWidth = totalColumnsMinWidth;
      getInstance().totalColumnsWidth = totalColumnsWidth;
      getInstance().totalColumnsMaxWidth = totalColumnsMaxWidth;
      loopHooks(getHooks().useInstance, getInstance()) // Each materialized header needs to be assigned a render function and other
      // prop getter properties here.
      ;
      [].concat(getInstance().flatHeaders, getInstance().allColumns).forEach(function (column) {
        // Give columns/headers rendering power
        column.render = makeRenderer(getInstance(), column); // Give columns/headers a default getHeaderProps

        column.getHeaderProps = makePropGetter(getHooks().getHeaderProps, {
          instance: getInstance(),
          column: column
        }); // Give columns/headers a default getFooterProps

        column.getFooterProps = makePropGetter(getHooks().getFooterProps, {
          instance: getInstance(),
          column: column
        });
      });
      getInstance().headerGroups = React.useMemo(function () {
        return headerGroups.filter(function (headerGroup, i) {
          // Filter out any headers and headerGroups that don't have visible columns
          headerGroup.headers = headerGroup.headers.filter(function (column) {
            var recurse = function recurse(headers) {
              return headers.filter(function (column) {
                if (column.headers) {
                  return recurse(column.headers);
                }

                return column.isVisible;
              }).length;
            };

            if (column.headers) {
              return recurse(column.headers);
            }

            return column.isVisible;
          }); // Give headerGroups getRowProps

          if (headerGroup.headers.length) {
            headerGroup.getHeaderGroupProps = makePropGetter(getHooks().getHeaderGroupProps, {
              instance: getInstance(),
              headerGroup: headerGroup,
              index: i
            });
            headerGroup.getFooterGroupProps = makePropGetter(getHooks().getFooterGroupProps, {
              instance: getInstance(),
              headerGroup: headerGroup,
              index: i
            });
            return true;
          }

          return false;
        });
      }, [headerGroups, getInstance, getHooks]);
      getInstance().footerGroups = [].concat(getInstance().headerGroups).reverse(); // The prepareRow function is absolutely necessary and MUST be called on
      // any rows the user wishes to be displayed.

      getInstance().prepareRow = React.useCallback(function (row) {
        row.getRowProps = makePropGetter(getHooks().getRowProps, {
          instance: getInstance(),
          row: row
        }); // Build the visible cells for each row

        row.allCells = allColumns.map(function (column) {
          var value = row.values[column.id];
          var cell = {
            column: column,
            row: row,
            value: value
          }; // Give each cell a getCellProps base

          cell.getCellProps = makePropGetter(getHooks().getCellProps, {
            instance: getInstance(),
            cell: cell
          }); // Give each cell a renderer function (supports multiple renderers)

          cell.render = makeRenderer(getInstance(), column, {
            row: row,
            cell: cell,
            value: value
          });
          return cell;
        });
        row.cells = visibleColumns.map(function (column) {
          return row.allCells.find(function (cell) {
            return cell.column.id === column.id;
          });
        }); // need to apply any row specific hooks (useExpanded requires this)

        loopHooks(getHooks().prepareRow, row, {
          instance: getInstance()
        });
      }, [getHooks, getInstance, allColumns, visibleColumns]);
      getInstance().getTableProps = makePropGetter(getHooks().getTableProps, {
        instance: getInstance()
      });
      getInstance().getTableBodyProps = makePropGetter(getHooks().getTableBodyProps, {
        instance: getInstance()
      });
      loopHooks(getHooks().useFinalInstance, getInstance());
      return getInstance();
    };

    function calculateHeaderWidths(headers, left) {
      if (left === void 0) {
        left = 0;
      }

      var sumTotalMinWidth = 0;
      var sumTotalWidth = 0;
      var sumTotalMaxWidth = 0;
      var sumTotalFlexWidth = 0;
      headers.forEach(function (header) {
        var subHeaders = header.headers;
        header.totalLeft = left;

        if (subHeaders && subHeaders.length) {
          var _calculateHeaderWidth2 = calculateHeaderWidths(subHeaders, left),
              totalMinWidth = _calculateHeaderWidth2[0],
              totalWidth = _calculateHeaderWidth2[1],
              totalMaxWidth = _calculateHeaderWidth2[2],
              totalFlexWidth = _calculateHeaderWidth2[3];

          header.totalMinWidth = totalMinWidth;
          header.totalWidth = totalWidth;
          header.totalMaxWidth = totalMaxWidth;
          header.totalFlexWidth = totalFlexWidth;
        } else {
          header.totalMinWidth = header.minWidth;
          header.totalWidth = Math.min(Math.max(header.minWidth, header.width), header.maxWidth);
          header.totalMaxWidth = header.maxWidth;
          header.totalFlexWidth = header.canResize ? header.totalWidth : 0;
        }

        if (header.isVisible) {
          left += header.totalWidth;
          sumTotalMinWidth += header.totalMinWidth;
          sumTotalWidth += header.totalWidth;
          sumTotalMaxWidth += header.totalMaxWidth;
          sumTotalFlexWidth += header.totalFlexWidth;
        }
      });
      return [sumTotalMinWidth, sumTotalWidth, sumTotalMaxWidth, sumTotalFlexWidth];
    }

    function accessRowsForColumn(_ref) {
      var data = _ref.data,
          rows = _ref.rows,
          flatRows = _ref.flatRows,
          rowsById = _ref.rowsById,
          column = _ref.column,
          getRowId = _ref.getRowId,
          getSubRows = _ref.getSubRows,
          accessValueHooks = _ref.accessValueHooks,
          getInstance = _ref.getInstance; // Access the row's data column-by-column
      // We do it this way so we can incrementally add materialized
      // columns after the first pass and avoid excessive looping

      var accessRow = function accessRow(originalRow, rowIndex, depth, parent, parentRows) {
        if (depth === void 0) {
          depth = 0;
        } // Keep the original reference around


        var original = originalRow;
        var id = getRowId(originalRow, rowIndex, parent);
        var row = rowsById[id]; // If the row hasn't been created, let's make it

        if (!row) {
          row = {
            id: id,
            original: original,
            index: rowIndex,
            depth: depth,
            cells: [{}] // This is a dummy cell

          }; // Override common array functions (and the dummy cell's getCellProps function)
          // to show an error if it is accessed without calling prepareRow

          row.cells.map = unpreparedAccessWarning;
          row.cells.filter = unpreparedAccessWarning;
          row.cells.forEach = unpreparedAccessWarning;
          row.cells[0].getCellProps = unpreparedAccessWarning; // Create the cells and values

          row.values = {}; // Push this row into the parentRows array

          parentRows.push(row); // Keep track of every row in a flat array

          flatRows.push(row); // Also keep track of every row by its ID

          rowsById[id] = row; // Get the original subrows

          row.originalSubRows = getSubRows(originalRow, rowIndex); // Then recursively access them

          if (row.originalSubRows) {
            var subRows = [];
            row.originalSubRows.forEach(function (d, i) {
              return accessRow(d, i, depth + 1, row, subRows);
            }); // Keep the new subRows array on the row

            row.subRows = subRows;
          }
        } else if (row.subRows) {
          // If the row exists, then it's already been accessed
          // Keep recursing, but don't worry about passing the
          // accumlator array (those rows already exist)
          row.originalSubRows.forEach(function (d, i) {
            return accessRow(d, i, depth + 1, row);
          });
        } // If the column has an accessor, use it to get a value


        if (column.accessor) {
          row.values[column.id] = column.accessor(originalRow, rowIndex, row, parentRows, data);
        } // Allow plugins to manipulate the column value


        row.values[column.id] = reduceHooks(accessValueHooks, row.values[column.id], {
          row: row,
          column: column,
          instance: getInstance()
        }, true);
      };

      data.forEach(function (originalRow, rowIndex) {
        return accessRow(originalRow, rowIndex, 0, undefined, rows);
      });
    }

    actions.resetExpanded = 'resetExpanded';
    actions.toggleRowExpanded = 'toggleRowExpanded';
    actions.toggleAllRowsExpanded = 'toggleAllRowsExpanded';

    var useExpanded = function useExpanded(hooks) {
      hooks.getToggleAllRowsExpandedProps = [defaultGetToggleAllRowsExpandedProps];
      hooks.getToggleRowExpandedProps = [defaultGetToggleRowExpandedProps];
      hooks.stateReducers.push(reducer$1);
      hooks.useInstance.push(useInstance$1);
      hooks.prepareRow.push(prepareRow);
    };

    useExpanded.pluginName = 'useExpanded';

    var defaultGetToggleAllRowsExpandedProps = function defaultGetToggleAllRowsExpandedProps(props, _ref) {
      var instance = _ref.instance;
      return [props, {
        onClick: function onClick(e) {
          instance.toggleAllRowsExpanded();
        },
        style: {
          cursor: 'pointer'
        },
        title: 'Toggle All Rows Expanded'
      }];
    };

    var defaultGetToggleRowExpandedProps = function defaultGetToggleRowExpandedProps(props, _ref2) {
      var row = _ref2.row;
      return [props, {
        onClick: function onClick() {
          row.toggleRowExpanded();
        },
        style: {
          cursor: 'pointer'
        },
        title: 'Toggle Row Expanded'
      }];
    }; // Reducer


    function reducer$1(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          expanded: {}
        }, state);
      }

      if (action.type === actions.resetExpanded) {
        return _extends({}, state, {
          expanded: instance.initialState.expanded || {}
        });
      }

      if (action.type === actions.toggleAllRowsExpanded) {
        var value = action.value;
        var isAllRowsExpanded = instance.isAllRowsExpanded,
            rowsById = instance.rowsById;
        var expandAll = typeof value !== 'undefined' ? value : !isAllRowsExpanded;

        if (expandAll) {
          var expanded = {};
          Object.keys(rowsById).forEach(function (rowId) {
            expanded[rowId] = true;
          });
          return _extends({}, state, {
            expanded: expanded
          });
        }

        return _extends({}, state, {
          expanded: {}
        });
      }

      if (action.type === actions.toggleRowExpanded) {
        var id = action.id,
            setExpanded = action.value;
        var exists = state.expanded[id];
        var shouldExist = typeof setExpanded !== 'undefined' ? setExpanded : !exists;

        if (!exists && shouldExist) {
          var _extends2;

          return _extends({}, state, {
            expanded: _extends({}, state.expanded, (_extends2 = {}, _extends2[id] = true, _extends2))
          });
        } else if (exists && !shouldExist) {
          var _state$expanded = state.expanded,
              rest = _objectWithoutPropertiesLoose(_state$expanded, [id].map(_toPropertyKey));

          return _extends({}, state, {
            expanded: rest
          });
        } else {
          return state;
        }
      }
    }

    function useInstance$1(instance) {
      var data = instance.data,
          rows = instance.rows,
          rowsById = instance.rowsById,
          _instance$manualExpan = instance.manualExpandedKey,
          manualExpandedKey = _instance$manualExpan === void 0 ? 'expanded' : _instance$manualExpan,
          _instance$paginateExp = instance.paginateExpandedRows,
          paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp,
          _instance$expandSubRo = instance.expandSubRows,
          expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo,
          _instance$autoResetEx = instance.autoResetExpanded,
          autoResetExpanded = _instance$autoResetEx === void 0 ? true : _instance$autoResetEx,
          getHooks = instance.getHooks,
          plugins = instance.plugins,
          expanded = instance.state.expanded,
          dispatch = instance.dispatch;
      ensurePluginOrder(plugins, ['useSortBy', 'useGroupBy', 'usePivotColumns', 'useGlobalFilter'], 'useExpanded');
      var getAutoResetExpanded = useGetLatest(autoResetExpanded);
      var isAllRowsExpanded = Boolean(Object.keys(rowsById).length && Object.keys(expanded).length);

      if (isAllRowsExpanded) {
        if (Object.keys(rowsById).some(function (id) {
          return !expanded[id];
        })) {
          isAllRowsExpanded = false;
        }
      } // Bypass any effects from firing when this changes


      useMountedLayoutEffect(function () {
        if (getAutoResetExpanded()) {
          dispatch({
            type: actions.resetExpanded
          });
        }
      }, [dispatch, data]);
      var toggleRowExpanded = React.useCallback(function (id, value) {
        dispatch({
          type: actions.toggleRowExpanded,
          id: id,
          value: value
        });
      }, [dispatch]);
      var toggleAllRowsExpanded = React.useCallback(function (value) {
        return dispatch({
          type: actions.toggleAllRowsExpanded,
          value: value
        });
      }, [dispatch]);
      var expandedRows = React.useMemo(function () {
        if (paginateExpandedRows) {
          return expandRows(rows, {
            manualExpandedKey: manualExpandedKey,
            expanded: expanded,
            expandSubRows: expandSubRows
          });
        }

        return rows;
      }, [paginateExpandedRows, rows, manualExpandedKey, expanded, expandSubRows]);
      var expandedDepth = React.useMemo(function () {
        return findExpandedDepth(expanded);
      }, [expanded]);
      var getInstance = useGetLatest(instance);
      var getToggleAllRowsExpandedProps = makePropGetter(getHooks().getToggleAllRowsExpandedProps, {
        instance: getInstance()
      });
      Object.assign(instance, {
        preExpandedRows: rows,
        expandedRows: expandedRows,
        rows: expandedRows,
        expandedDepth: expandedDepth,
        isAllRowsExpanded: isAllRowsExpanded,
        toggleRowExpanded: toggleRowExpanded,
        toggleAllRowsExpanded: toggleAllRowsExpanded,
        getToggleAllRowsExpandedProps: getToggleAllRowsExpandedProps
      });
    }

    function prepareRow(row, _ref3) {
      var getHooks = _ref3.instance.getHooks,
          instance = _ref3.instance;

      row.toggleRowExpanded = function (set) {
        return instance.toggleRowExpanded(row.id, set);
      };

      row.getToggleRowExpandedProps = makePropGetter(getHooks().getToggleRowExpandedProps, {
        instance: instance,
        row: row
      });
    }

    function findExpandedDepth(expanded) {
      var maxDepth = 0;
      Object.keys(expanded).forEach(function (id) {
        var splitId = id.split('.');
        maxDepth = Math.max(maxDepth, splitId.length);
      });
      return maxDepth;
    }

    var text = function text(rows, ids, filterValue) {
      rows = rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return String(rowValue).toLowerCase().includes(String(filterValue).toLowerCase());
        });
      });
      return rows;
    };

    text.autoRemove = function (val) {
      return !val;
    };

    var exactText = function exactText(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue !== undefined ? String(rowValue).toLowerCase() === String(filterValue).toLowerCase() : true;
        });
      });
    };

    exactText.autoRemove = function (val) {
      return !val;
    };

    var exactTextCase = function exactTextCase(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue !== undefined ? String(rowValue) === String(filterValue) : true;
        });
      });
    };

    exactTextCase.autoRemove = function (val) {
      return !val;
    };

    var includes = function includes(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue.includes(filterValue);
        });
      });
    };

    includes.autoRemove = function (val) {
      return !val || !val.length;
    };

    var includesAll = function includesAll(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue && rowValue.length && filterValue.every(function (val) {
            return rowValue.includes(val);
          });
        });
      });
    };

    includesAll.autoRemove = function (val) {
      return !val || !val.length;
    };

    var includesSome = function includesSome(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue && rowValue.length && filterValue.some(function (val) {
            return rowValue.includes(val);
          });
        });
      });
    };

    includesSome.autoRemove = function (val) {
      return !val || !val.length;
    };

    var includesValue = function includesValue(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return filterValue.includes(rowValue);
        });
      });
    };

    includesValue.autoRemove = function (val) {
      return !val || !val.length;
    };

    var exact = function exact(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue === filterValue;
        });
      });
    };

    exact.autoRemove = function (val) {
      return typeof val === 'undefined';
    };

    var equals = function equals(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id]; // eslint-disable-next-line eqeqeq

          return rowValue == filterValue;
        });
      });
    };

    equals.autoRemove = function (val) {
      return val == null;
    };

    var between = function between(rows, ids, filterValue) {
      var _ref = filterValue || [],
          min = _ref[0],
          max = _ref[1];

      min = typeof min === 'number' ? min : -Infinity;
      max = typeof max === 'number' ? max : Infinity;

      if (min > max) {
        var temp = min;
        min = max;
        max = temp;
      }

      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue >= min && rowValue <= max;
        });
      });
    };

    between.autoRemove = function (val) {
      return !val || typeof val[0] !== 'number' && typeof val[1] !== 'number';
    };

    var filterTypes = /*#__PURE__*/Object.freeze({
      __proto__: null,
      text: text,
      exactText: exactText,
      exactTextCase: exactTextCase,
      includes: includes,
      includesAll: includesAll,
      includesSome: includesSome,
      includesValue: includesValue,
      exact: exact,
      equals: equals,
      between: between
    });
    actions.resetFilters = 'resetFilters';
    actions.setFilter = 'setFilter';
    actions.setAllFilters = 'setAllFilters';

    var useFilters = function useFilters(hooks) {
      hooks.stateReducers.push(reducer$2);
      hooks.useInstance.push(useInstance$2);
    };

    useFilters.pluginName = 'useFilters';

    function reducer$2(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          filters: []
        }, state);
      }

      if (action.type === actions.resetFilters) {
        return _extends({}, state, {
          filters: instance.initialState.filters || []
        });
      }

      if (action.type === actions.setFilter) {
        var columnId = action.columnId,
            filterValue = action.filterValue;
        var allColumns = instance.allColumns,
            userFilterTypes = instance.filterTypes;
        var column = allColumns.find(function (d) {
          return d.id === columnId;
        });

        if (!column) {
          throw new Error("React-Table: Could not find a column with id: " + columnId);
        }

        var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);
        var previousfilter = state.filters.find(function (d) {
          return d.id === columnId;
        });
        var newFilter = functionalUpdate(filterValue, previousfilter && previousfilter.value); //

        if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter, column)) {
          return _extends({}, state, {
            filters: state.filters.filter(function (d) {
              return d.id !== columnId;
            })
          });
        }

        if (previousfilter) {
          return _extends({}, state, {
            filters: state.filters.map(function (d) {
              if (d.id === columnId) {
                return {
                  id: columnId,
                  value: newFilter
                };
              }

              return d;
            })
          });
        }

        return _extends({}, state, {
          filters: [].concat(state.filters, [{
            id: columnId,
            value: newFilter
          }])
        });
      }

      if (action.type === actions.setAllFilters) {
        var filters = action.filters;
        var _allColumns = instance.allColumns,
            _userFilterTypes = instance.filterTypes;
        return _extends({}, state, {
          // Filter out undefined values
          filters: functionalUpdate(filters, state.filters).filter(function (filter) {
            var column = _allColumns.find(function (d) {
              return d.id === filter.id;
            });

            var filterMethod = getFilterMethod(column.filter, _userFilterTypes || {}, filterTypes);

            if (shouldAutoRemoveFilter(filterMethod.autoRemove, filter.value, column)) {
              return false;
            }

            return true;
          })
        });
      }
    }

    function useInstance$2(instance) {
      var data = instance.data,
          rows = instance.rows,
          flatRows = instance.flatRows,
          rowsById = instance.rowsById,
          allColumns = instance.allColumns,
          userFilterTypes = instance.filterTypes,
          manualFilters = instance.manualFilters,
          _instance$defaultCanF = instance.defaultCanFilter,
          defaultCanFilter = _instance$defaultCanF === void 0 ? false : _instance$defaultCanF,
          disableFilters = instance.disableFilters,
          filters = instance.state.filters,
          dispatch = instance.dispatch,
          _instance$autoResetFi = instance.autoResetFilters,
          autoResetFilters = _instance$autoResetFi === void 0 ? true : _instance$autoResetFi;
      var setFilter = React.useCallback(function (columnId, filterValue) {
        dispatch({
          type: actions.setFilter,
          columnId: columnId,
          filterValue: filterValue
        });
      }, [dispatch]);
      var setAllFilters = React.useCallback(function (filters) {
        dispatch({
          type: actions.setAllFilters,
          filters: filters
        });
      }, [dispatch]);
      allColumns.forEach(function (column) {
        var id = column.id,
            accessor = column.accessor,
            columnDefaultCanFilter = column.defaultCanFilter,
            columnDisableFilters = column.disableFilters; // Determine if a column is filterable

        column.canFilter = accessor ? getFirstDefined(columnDisableFilters === true ? false : undefined, disableFilters === true ? false : undefined, true) : getFirstDefined(columnDefaultCanFilter, defaultCanFilter, false); // Provide the column a way of updating the filter value

        column.setFilter = function (val) {
          return setFilter(column.id, val);
        }; // Provide the current filter value to the column for
        // convenience


        var found = filters.find(function (d) {
          return d.id === id;
        });
        column.filterValue = found && found.value;
      });

      var _React$useMemo = React.useMemo(function () {
        if (manualFilters || !filters.length) {
          return [rows, flatRows, rowsById];
        }

        var filteredFlatRows = [];
        var filteredRowsById = {}; // Filters top level and nested rows

        var filterRows = function filterRows(rows, depth) {
          if (depth === void 0) {
            depth = 0;
          }

          var filteredRows = rows;
          filteredRows = filters.reduce(function (filteredSoFar, _ref) {
            var columnId = _ref.id,
                filterValue = _ref.value; // Find the filters column

            var column = allColumns.find(function (d) {
              return d.id === columnId;
            });

            if (!column) {
              return filteredSoFar;
            }

            if (depth === 0) {
              column.preFilteredRows = filteredSoFar;
            }

            var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);

            if (!filterMethod) {
              console.warn("Could not find a valid 'column.filter' for column with the ID: " + column.id + ".");
              return filteredSoFar;
            } // Pass the rows, id, filterValue and column to the filterMethod
            // to get the filtered rows back


            column.filteredRows = filterMethod(filteredSoFar, [columnId], filterValue);
            return column.filteredRows;
          }, rows); // Apply the filter to any subRows
          // We technically could do this recursively in the above loop,
          // but that would severely hinder the API for the user, since they
          // would be required to do that recursion in some scenarios

          filteredRows.forEach(function (row) {
            filteredFlatRows.push(row);
            filteredRowsById[row.id] = row;

            if (!row.subRows) {
              return;
            }

            row.subRows = row.subRows && row.subRows.length > 0 ? filterRows(row.subRows, depth + 1) : row.subRows;
          });
          return filteredRows;
        };

        return [filterRows(rows), filteredFlatRows, filteredRowsById];
      }, [manualFilters, filters, rows, flatRows, rowsById, allColumns, userFilterTypes]),
          filteredRows = _React$useMemo[0],
          filteredFlatRows = _React$useMemo[1],
          filteredRowsById = _React$useMemo[2];

      React.useMemo(function () {
        // Now that each filtered column has it's partially filtered rows,
        // lets assign the final filtered rows to all of the other columns
        var nonFilteredColumns = allColumns.filter(function (column) {
          return !filters.find(function (d) {
            return d.id === column.id;
          });
        }); // This essentially enables faceted filter options to be built easily
        // using every column's preFilteredRows value

        nonFilteredColumns.forEach(function (column) {
          column.preFilteredRows = filteredRows;
          column.filteredRows = filteredRows;
        });
      }, [filteredRows, filters, allColumns]);
      var getAutoResetFilters = useGetLatest(autoResetFilters);
      useMountedLayoutEffect(function () {
        if (getAutoResetFilters()) {
          dispatch({
            type: actions.resetFilters
          });
        }
      }, [dispatch, manualFilters ? null : data]);
      Object.assign(instance, {
        preFilteredRows: rows,
        preFilteredFlatRows: flatRows,
        preFilteredRowsById: rowsById,
        filteredRows: filteredRows,
        filteredFlatRows: filteredFlatRows,
        filteredRowsById: filteredRowsById,
        rows: filteredRows,
        flatRows: filteredFlatRows,
        rowsById: filteredRowsById,
        setFilter: setFilter,
        setAllFilters: setAllFilters
      });
    }

    actions.resetGlobalFilter = 'resetGlobalFilter';
    actions.setGlobalFilter = 'setGlobalFilter';

    var useGlobalFilter = function useGlobalFilter(hooks) {
      hooks.stateReducers.push(reducer$3);
      hooks.useInstance.push(useInstance$3);
    };

    useGlobalFilter.pluginName = 'useGlobalFilter';

    function reducer$3(state, action, previousState, instance) {
      if (action.type === actions.resetGlobalFilter) {
        return _extends({}, state, {
          globalFilter: instance.initialState.globalFilter || undefined
        });
      }

      if (action.type === actions.setGlobalFilter) {
        var filterValue = action.filterValue;
        var userFilterTypes = instance.userFilterTypes;
        var filterMethod = getFilterMethod(instance.globalFilter, userFilterTypes || {}, filterTypes);
        var newFilter = functionalUpdate(filterValue, state.globalFilter); //

        if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter)) {
          var stateWithoutGlobalFilter = _objectWithoutPropertiesLoose(state, ["globalFilter"]);

          return stateWithoutGlobalFilter;
        }

        return _extends({}, state, {
          globalFilter: newFilter
        });
      }
    }

    function useInstance$3(instance) {
      var data = instance.data,
          rows = instance.rows,
          flatRows = instance.flatRows,
          rowsById = instance.rowsById,
          allColumns = instance.allColumns,
          userFilterTypes = instance.filterTypes,
          globalFilter = instance.globalFilter,
          manualGlobalFilter = instance.manualGlobalFilter,
          globalFilterValue = instance.state.globalFilter,
          dispatch = instance.dispatch,
          _instance$autoResetGl = instance.autoResetGlobalFilter,
          autoResetGlobalFilter = _instance$autoResetGl === void 0 ? true : _instance$autoResetGl,
          disableGlobalFilter = instance.disableGlobalFilter;
      var setGlobalFilter = React.useCallback(function (filterValue) {
        dispatch({
          type: actions.setGlobalFilter,
          filterValue: filterValue
        });
      }, [dispatch]); // TODO: Create a filter cache for incremental high speed multi-filtering
      // This gets pretty complicated pretty fast, since you have to maintain a
      // cache for each row group (top-level rows, and each row's recursive subrows)
      // This would make multi-filtering a lot faster though. Too far?

      var _React$useMemo = React.useMemo(function () {
        if (manualGlobalFilter || typeof globalFilterValue === 'undefined') {
          return [rows, flatRows, rowsById];
        }

        var filteredFlatRows = [];
        var filteredRowsById = {};
        var filterMethod = getFilterMethod(globalFilter, userFilterTypes || {}, filterTypes);

        if (!filterMethod) {
          console.warn("Could not find a valid 'globalFilter' option.");
          return rows;
        }

        allColumns.forEach(function (column) {
          var columnDisableGlobalFilter = column.disableGlobalFilter;
          column.canFilter = getFirstDefined(columnDisableGlobalFilter === true ? false : undefined, disableGlobalFilter === true ? false : undefined, true);
        });
        var filterableColumns = allColumns.filter(function (c) {
          return c.canFilter === true;
        }); // Filters top level and nested rows

        var filterRows = function filterRows(filteredRows) {
          filteredRows = filterMethod(filteredRows, filterableColumns.map(function (d) {
            return d.id;
          }), globalFilterValue);
          filteredRows.forEach(function (row) {
            filteredFlatRows.push(row);
            filteredRowsById[row.id] = row;
            row.subRows = row.subRows && row.subRows.length ? filterRows(row.subRows) : row.subRows;
          });
          return filteredRows;
        };

        return [filterRows(rows), filteredFlatRows, filteredRowsById];
      }, [manualGlobalFilter, globalFilterValue, globalFilter, userFilterTypes, allColumns, rows, flatRows, rowsById, disableGlobalFilter]),
          globalFilteredRows = _React$useMemo[0],
          globalFilteredFlatRows = _React$useMemo[1],
          globalFilteredRowsById = _React$useMemo[2];

      var getAutoResetGlobalFilter = useGetLatest(autoResetGlobalFilter);
      useMountedLayoutEffect(function () {
        if (getAutoResetGlobalFilter()) {
          dispatch({
            type: actions.resetGlobalFilter
          });
        }
      }, [dispatch, manualGlobalFilter ? null : data]);
      Object.assign(instance, {
        preGlobalFilteredRows: rows,
        preGlobalFilteredFlatRows: flatRows,
        preGlobalFilteredRowsById: rowsById,
        globalFilteredRows: globalFilteredRows,
        globalFilteredFlatRows: globalFilteredFlatRows,
        globalFilteredRowsById: globalFilteredRowsById,
        rows: globalFilteredRows,
        flatRows: globalFilteredFlatRows,
        rowsById: globalFilteredRowsById,
        setGlobalFilter: setGlobalFilter,
        disableGlobalFilter: disableGlobalFilter
      });
    }

    function sum(values, aggregatedValues) {
      // It's faster to just add the aggregations together instead of
      // process leaf nodes individually
      return aggregatedValues.reduce(function (sum, next) {
        return sum + (typeof next === 'number' ? next : 0);
      }, 0);
    }

    function min(values) {
      var min = values[0] || 0;
      values.forEach(function (value) {
        if (typeof value === 'number') {
          min = Math.min(min, value);
        }
      });
      return min;
    }

    function max(values) {
      var max = values[0] || 0;
      values.forEach(function (value) {
        if (typeof value === 'number') {
          max = Math.max(max, value);
        }
      });
      return max;
    }

    function minMax(values) {
      var min = values[0] || 0;
      var max = values[0] || 0;
      values.forEach(function (value) {
        if (typeof value === 'number') {
          min = Math.min(min, value);
          max = Math.max(max, value);
        }
      });
      return min + ".." + max;
    }

    function average(values) {
      return sum(null, values) / values.length;
    }

    function median(values) {
      if (!values.length) {
        return null;
      }

      var mid = Math.floor(values.length / 2);
      var nums = [].concat(values).sort(function (a, b) {
        return a - b;
      });
      return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
    }

    function unique(values) {
      return Array.from(new Set(values).values());
    }

    function uniqueCount(values) {
      return new Set(values).size;
    }

    function count(values) {
      return values.length;
    }

    var aggregations = /*#__PURE__*/Object.freeze({
      __proto__: null,
      sum: sum,
      min: min,
      max: max,
      minMax: minMax,
      average: average,
      median: median,
      unique: unique,
      uniqueCount: uniqueCount,
      count: count
    });
    var emptyArray = [];
    var emptyObject = {}; // Actions

    actions.resetGroupBy = 'resetGroupBy';
    actions.setGroupBy = 'setGroupBy';
    actions.toggleGroupBy = 'toggleGroupBy';

    var useGroupBy = function useGroupBy(hooks) {
      hooks.getGroupByToggleProps = [defaultGetGroupByToggleProps];
      hooks.stateReducers.push(reducer$4);
      hooks.visibleColumnsDeps.push(function (deps, _ref) {
        var instance = _ref.instance;
        return [].concat(deps, [instance.state.groupBy]);
      });
      hooks.visibleColumns.push(visibleColumns);
      hooks.useInstance.push(useInstance$4);
      hooks.prepareRow.push(prepareRow$1);
    };

    useGroupBy.pluginName = 'useGroupBy';

    var defaultGetGroupByToggleProps = function defaultGetGroupByToggleProps(props, _ref2) {
      var header = _ref2.header;
      return [props, {
        onClick: header.canGroupBy ? function (e) {
          e.persist();
          header.toggleGroupBy();
        } : undefined,
        style: {
          cursor: header.canGroupBy ? 'pointer' : undefined
        },
        title: 'Toggle GroupBy'
      }];
    }; // Reducer


    function reducer$4(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          groupBy: []
        }, state);
      }

      if (action.type === actions.resetGroupBy) {
        return _extends({}, state, {
          groupBy: instance.initialState.groupBy || []
        });
      }

      if (action.type === actions.setGroupBy) {
        var value = action.value;
        return _extends({}, state, {
          groupBy: value
        });
      }

      if (action.type === actions.toggleGroupBy) {
        var columnId = action.columnId,
            setGroupBy = action.value;
        var resolvedGroupBy = typeof setGroupBy !== 'undefined' ? setGroupBy : !state.groupBy.includes(columnId);

        if (resolvedGroupBy) {
          return _extends({}, state, {
            groupBy: [].concat(state.groupBy, [columnId])
          });
        }

        return _extends({}, state, {
          groupBy: state.groupBy.filter(function (d) {
            return d !== columnId;
          })
        });
      }
    }

    function visibleColumns(columns, _ref3) {
      var groupBy = _ref3.instance.state.groupBy; // Sort grouped columns to the start of the column list
      // before the headers are built

      var groupByColumns = groupBy.map(function (g) {
        return columns.find(function (col) {
          return col.id === g;
        });
      }).filter(Boolean);
      var nonGroupByColumns = columns.filter(function (col) {
        return !groupBy.includes(col.id);
      });
      columns = [].concat(groupByColumns, nonGroupByColumns);
      columns.forEach(function (column) {
        column.isGrouped = groupBy.includes(column.id);
        column.groupedIndex = groupBy.indexOf(column.id);
      });
      return columns;
    }

    var defaultUserAggregations = {};

    function useInstance$4(instance) {
      var data = instance.data,
          rows = instance.rows,
          flatRows = instance.flatRows,
          rowsById = instance.rowsById,
          allColumns = instance.allColumns,
          flatHeaders = instance.flatHeaders,
          _instance$groupByFn = instance.groupByFn,
          groupByFn = _instance$groupByFn === void 0 ? defaultGroupByFn : _instance$groupByFn,
          manualGroupBy = instance.manualGroupBy,
          _instance$aggregation = instance.aggregations,
          userAggregations = _instance$aggregation === void 0 ? defaultUserAggregations : _instance$aggregation,
          plugins = instance.plugins,
          groupBy = instance.state.groupBy,
          dispatch = instance.dispatch,
          _instance$autoResetGr = instance.autoResetGroupBy,
          autoResetGroupBy = _instance$autoResetGr === void 0 ? true : _instance$autoResetGr,
          disableGroupBy = instance.disableGroupBy,
          defaultCanGroupBy = instance.defaultCanGroupBy,
          getHooks = instance.getHooks;
      ensurePluginOrder(plugins, ['useColumnOrder', 'useFilters'], 'useGroupBy');
      var getInstance = useGetLatest(instance);
      allColumns.forEach(function (column) {
        var accessor = column.accessor,
            defaultColumnGroupBy = column.defaultGroupBy,
            columnDisableGroupBy = column.disableGroupBy;
        column.canGroupBy = accessor ? getFirstDefined(column.canGroupBy, columnDisableGroupBy === true ? false : undefined, disableGroupBy === true ? false : undefined, true) : getFirstDefined(column.canGroupBy, defaultColumnGroupBy, defaultCanGroupBy, false);

        if (column.canGroupBy) {
          column.toggleGroupBy = function () {
            return instance.toggleGroupBy(column.id);
          };
        }

        column.Aggregated = column.Aggregated || column.Cell;
      });
      var toggleGroupBy = React.useCallback(function (columnId, value) {
        dispatch({
          type: actions.toggleGroupBy,
          columnId: columnId,
          value: value
        });
      }, [dispatch]);
      var setGroupBy = React.useCallback(function (value) {
        dispatch({
          type: actions.setGroupBy,
          value: value
        });
      }, [dispatch]);
      flatHeaders.forEach(function (header) {
        header.getGroupByToggleProps = makePropGetter(getHooks().getGroupByToggleProps, {
          instance: getInstance(),
          header: header
        });
      });

      var _React$useMemo = React.useMemo(function () {
        if (manualGroupBy || !groupBy.length) {
          return [rows, flatRows, rowsById, emptyArray, emptyObject, flatRows, rowsById];
        } // Ensure that the list of filtered columns exist


        var existingGroupBy = groupBy.filter(function (g) {
          return allColumns.find(function (col) {
            return col.id === g;
          });
        }); // Find the columns that can or are aggregating
        // Uses each column to aggregate rows into a single value

        var aggregateRowsToValues = function aggregateRowsToValues(leafRows, groupedRows, depth) {
          var values = {};
          allColumns.forEach(function (column) {
            // Don't aggregate columns that are in the groupBy
            if (existingGroupBy.includes(column.id)) {
              values[column.id] = groupedRows[0] ? groupedRows[0].values[column.id] : null;
              return;
            } // Aggregate the values


            var aggregateFn = typeof column.aggregate === 'function' ? column.aggregate : userAggregations[column.aggregate] || aggregations[column.aggregate];

            if (aggregateFn) {
              // Get the columnValues to aggregate
              var groupedValues = groupedRows.map(function (row) {
                return row.values[column.id];
              }); // Get the columnValues to aggregate

              var leafValues = leafRows.map(function (row) {
                var columnValue = row.values[column.id];

                if (!depth && column.aggregateValue) {
                  var aggregateValueFn = typeof column.aggregateValue === 'function' ? column.aggregateValue : userAggregations[column.aggregateValue] || aggregations[column.aggregateValue];

                  if (!aggregateValueFn) {
                    console.info({
                      column: column
                    });
                    throw new Error("React Table: Invalid column.aggregateValue option for column listed above");
                  }

                  columnValue = aggregateValueFn(columnValue, row, column);
                }

                return columnValue;
              });
              values[column.id] = aggregateFn(leafValues, groupedValues);
            } else if (column.aggregate) {
              console.info({
                column: column
              });
              throw new Error("React Table: Invalid column.aggregate option for column listed above");
            } else {
              values[column.id] = null;
            }
          });
          return values;
        };

        var groupedFlatRows = [];
        var groupedRowsById = {};
        var onlyGroupedFlatRows = [];
        var onlyGroupedRowsById = {};
        var nonGroupedFlatRows = [];
        var nonGroupedRowsById = {}; // Recursively group the data

        var groupUpRecursively = function groupUpRecursively(rows, depth, parentId) {
          if (depth === void 0) {
            depth = 0;
          } // This is the last level, just return the rows


          if (depth === existingGroupBy.length) {
            return rows;
          }

          var columnId = existingGroupBy[depth]; // Group the rows together for this level

          var rowGroupsMap = groupByFn(rows, columnId); // Peform aggregations for each group

          var aggregatedGroupedRows = Object.entries(rowGroupsMap).map(function (_ref4, index) {
            var groupByVal = _ref4[0],
                groupedRows = _ref4[1];
            var id = columnId + ":" + groupByVal;
            id = parentId ? parentId + ">" + id : id; // First, Recurse to group sub rows before aggregation

            var subRows = groupUpRecursively(groupedRows, depth + 1, id); // Flatten the leaf rows of the rows in this group

            var leafRows = depth ? flattenBy(groupedRows, 'leafRows') : groupedRows;
            var values = aggregateRowsToValues(leafRows, groupedRows, depth);
            var row = {
              id: id,
              isGrouped: true,
              groupByID: columnId,
              groupByVal: groupByVal,
              values: values,
              subRows: subRows,
              leafRows: leafRows,
              depth: depth,
              index: index
            };
            subRows.forEach(function (subRow) {
              groupedFlatRows.push(subRow);
              groupedRowsById[subRow.id] = subRow;

              if (subRow.isGrouped) {
                onlyGroupedFlatRows.push(subRow);
                onlyGroupedRowsById[subRow.id] = subRow;
              } else {
                nonGroupedFlatRows.push(subRow);
                nonGroupedRowsById[subRow.id] = subRow;
              }
            });
            return row;
          });
          return aggregatedGroupedRows;
        };

        var groupedRows = groupUpRecursively(rows);
        groupedRows.forEach(function (subRow) {
          groupedFlatRows.push(subRow);
          groupedRowsById[subRow.id] = subRow;

          if (subRow.isGrouped) {
            onlyGroupedFlatRows.push(subRow);
            onlyGroupedRowsById[subRow.id] = subRow;
          } else {
            nonGroupedFlatRows.push(subRow);
            nonGroupedRowsById[subRow.id] = subRow;
          }
        }); // Assign the new data

        return [groupedRows, groupedFlatRows, groupedRowsById, onlyGroupedFlatRows, onlyGroupedRowsById, nonGroupedFlatRows, nonGroupedRowsById];
      }, [manualGroupBy, groupBy, rows, flatRows, rowsById, allColumns, userAggregations, groupByFn]),
          groupedRows = _React$useMemo[0],
          groupedFlatRows = _React$useMemo[1],
          groupedRowsById = _React$useMemo[2],
          onlyGroupedFlatRows = _React$useMemo[3],
          onlyGroupedRowsById = _React$useMemo[4],
          nonGroupedFlatRows = _React$useMemo[5],
          nonGroupedRowsById = _React$useMemo[6];

      var getAutoResetGroupBy = useGetLatest(autoResetGroupBy);
      useMountedLayoutEffect(function () {
        if (getAutoResetGroupBy()) {
          dispatch({
            type: actions.resetGroupBy
          });
        }
      }, [dispatch, manualGroupBy ? null : data]);
      Object.assign(instance, {
        preGroupedRows: rows,
        preGroupedFlatRow: flatRows,
        preGroupedRowsById: rowsById,
        groupedRows: groupedRows,
        groupedFlatRows: groupedFlatRows,
        groupedRowsById: groupedRowsById,
        onlyGroupedFlatRows: onlyGroupedFlatRows,
        onlyGroupedRowsById: onlyGroupedRowsById,
        nonGroupedFlatRows: nonGroupedFlatRows,
        nonGroupedRowsById: nonGroupedRowsById,
        rows: groupedRows,
        flatRows: groupedFlatRows,
        rowsById: groupedRowsById,
        toggleGroupBy: toggleGroupBy,
        setGroupBy: setGroupBy
      });
    }

    function prepareRow$1(row) {
      row.allCells.forEach(function (cell) {
        var _row$subRows; // Grouped cells are in the groupBy and the pivot cell for the row


        cell.isGrouped = cell.column.isGrouped && cell.column.id === row.groupByID; // Placeholder cells are any columns in the groupBy that are not grouped

        cell.isPlaceholder = !cell.isGrouped && cell.column.isGrouped; // Aggregated cells are not grouped, not repeated, but still have subRows

        cell.isAggregated = !cell.isGrouped && !cell.isPlaceholder && ((_row$subRows = row.subRows) == null ? void 0 : _row$subRows.length);
      });
    }

    function defaultGroupByFn(rows, columnId) {
      return rows.reduce(function (prev, row, i) {
        // TODO: Might want to implement a key serializer here so
        // irregular column values can still be grouped if needed?
        var resKey = "" + row.values[columnId];
        prev[resKey] = Array.isArray(prev[resKey]) ? prev[resKey] : [];
        prev[resKey].push(row);
        return prev;
      }, {});
    }

    var reSplitAlphaNumeric = /([0-9]+)/gm; // Mixed sorting is slow, but very inclusive of many edge cases.
    // It handles numbers, mixed alphanumeric combinations, and even
    // null, undefined, and Infinity

    var alphanumeric = function alphanumeric(rowA, rowB, columnId) {
      var _getRowValuesByColumn = getRowValuesByColumnID(rowA, rowB, columnId),
          a = _getRowValuesByColumn[0],
          b = _getRowValuesByColumn[1]; // Force to strings (or "" for unsupported types)


      a = toString(a);
      b = toString(b); // Split on number groups, but keep the delimiter
      // Then remove falsey split values

      a = a.split(reSplitAlphaNumeric).filter(Boolean);
      b = b.split(reSplitAlphaNumeric).filter(Boolean); // While

      while (a.length && b.length) {
        var aa = a.shift();
        var bb = b.shift();
        var an = parseInt(aa, 10);
        var bn = parseInt(bb, 10);
        var combo = [an, bn].sort(); // Both are string

        if (isNaN(combo[0])) {
          if (aa > bb) {
            return 1;
          }

          if (bb > aa) {
            return -1;
          }

          continue;
        } // One is a string, one is a number


        if (isNaN(combo[1])) {
          return isNaN(an) ? -1 : 1;
        } // Both are numbers


        if (an > bn) {
          return 1;
        }

        if (bn > an) {
          return -1;
        }
      }

      return a.length - b.length;
    };

    function datetime(rowA, rowB, columnId) {
      var _getRowValuesByColumn2 = getRowValuesByColumnID(rowA, rowB, columnId),
          a = _getRowValuesByColumn2[0],
          b = _getRowValuesByColumn2[1];

      a = a.getTime();
      b = b.getTime();
      return compareBasic(a, b);
    }

    function basic(rowA, rowB, columnId) {
      var _getRowValuesByColumn3 = getRowValuesByColumnID(rowA, rowB, columnId),
          a = _getRowValuesByColumn3[0],
          b = _getRowValuesByColumn3[1];

      return compareBasic(a, b);
    }

    function string(rowA, rowB, columnId) {
      var _getRowValuesByColumn4 = getRowValuesByColumnID(rowA, rowB, columnId),
          a = _getRowValuesByColumn4[0],
          b = _getRowValuesByColumn4[1];

      a = a.split('').filter(Boolean);
      b = b.split('').filter(Boolean);

      while (a.length && b.length) {
        var aa = a.shift();
        var bb = b.shift();
        var alower = aa.toLowerCase();
        var blower = bb.toLowerCase(); // Case insensitive comparison until characters match

        if (alower > blower) {
          return 1;
        }

        if (blower > alower) {
          return -1;
        } // If lowercase characters are identical


        if (aa > bb) {
          return 1;
        }

        if (bb > aa) {
          return -1;
        }

        continue;
      }

      return a.length - b.length;
    }

    function number(rowA, rowB, columnId) {
      var _getRowValuesByColumn5 = getRowValuesByColumnID(rowA, rowB, columnId),
          a = _getRowValuesByColumn5[0],
          b = _getRowValuesByColumn5[1];

      var replaceNonNumeric = /[^0-9.]/gi;
      a = Number(String(a).replace(replaceNonNumeric, ''));
      b = Number(String(b).replace(replaceNonNumeric, ''));
      return compareBasic(a, b);
    } // Utils


    function compareBasic(a, b) {
      return a === b ? 0 : a > b ? 1 : -1;
    }

    function getRowValuesByColumnID(row1, row2, columnId) {
      return [row1.values[columnId], row2.values[columnId]];
    }

    function toString(a) {
      if (typeof a === 'number') {
        if (isNaN(a) || a === Infinity || a === -Infinity) {
          return '';
        }

        return String(a);
      }

      if (typeof a === 'string') {
        return a;
      }

      return '';
    }

    var sortTypes = /*#__PURE__*/Object.freeze({
      __proto__: null,
      alphanumeric: alphanumeric,
      datetime: datetime,
      basic: basic,
      string: string,
      number: number
    });
    actions.resetSortBy = 'resetSortBy';
    actions.setSortBy = 'setSortBy';
    actions.toggleSortBy = 'toggleSortBy';
    actions.clearSortBy = 'clearSortBy';
    defaultColumn.sortType = 'alphanumeric';
    defaultColumn.sortDescFirst = false;

    var useSortBy = function useSortBy(hooks) {
      hooks.getSortByToggleProps = [defaultGetSortByToggleProps];
      hooks.stateReducers.push(reducer$5);
      hooks.useInstance.push(useInstance$5);
    };

    useSortBy.pluginName = 'useSortBy';

    var defaultGetSortByToggleProps = function defaultGetSortByToggleProps(props, _ref) {
      var instance = _ref.instance,
          column = _ref.column;
      var _instance$isMultiSort = instance.isMultiSortEvent,
          isMultiSortEvent = _instance$isMultiSort === void 0 ? function (e) {
        return e.shiftKey;
      } : _instance$isMultiSort;
      return [props, {
        onClick: column.canSort ? function (e) {
          e.persist();
          column.toggleSortBy(undefined, !instance.disableMultiSort && isMultiSortEvent(e));
        } : undefined,
        style: {
          cursor: column.canSort ? 'pointer' : undefined
        },
        title: column.canSort ? 'Toggle SortBy' : undefined
      }];
    }; // Reducer


    function reducer$5(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          sortBy: []
        }, state);
      }

      if (action.type === actions.resetSortBy) {
        return _extends({}, state, {
          sortBy: instance.initialState.sortBy || []
        });
      }

      if (action.type === actions.clearSortBy) {
        var sortBy = state.sortBy;
        var newSortBy = sortBy.filter(function (d) {
          return d.id !== action.columnId;
        });
        return _extends({}, state, {
          sortBy: newSortBy
        });
      }

      if (action.type === actions.setSortBy) {
        var _sortBy = action.sortBy;
        return _extends({}, state, {
          sortBy: _sortBy
        });
      }

      if (action.type === actions.toggleSortBy) {
        var columnId = action.columnId,
            desc = action.desc,
            multi = action.multi;
        var allColumns = instance.allColumns,
            disableMultiSort = instance.disableMultiSort,
            disableSortRemove = instance.disableSortRemove,
            disableMultiRemove = instance.disableMultiRemove,
            _instance$maxMultiSor = instance.maxMultiSortColCount,
            maxMultiSortColCount = _instance$maxMultiSor === void 0 ? Number.MAX_SAFE_INTEGER : _instance$maxMultiSor;
        var _sortBy2 = state.sortBy; // Find the column for this columnId

        var column = allColumns.find(function (d) {
          return d.id === columnId;
        });
        var sortDescFirst = column.sortDescFirst; // Find any existing sortBy for this column

        var existingSortBy = _sortBy2.find(function (d) {
          return d.id === columnId;
        });

        var existingIndex = _sortBy2.findIndex(function (d) {
          return d.id === columnId;
        });

        var hasDescDefined = typeof desc !== 'undefined' && desc !== null;
        var _newSortBy = []; // What should we do with this sort action?

        var sortAction;

        if (!disableMultiSort && multi) {
          if (existingSortBy) {
            sortAction = 'toggle';
          } else {
            sortAction = 'add';
          }
        } else {
          // Normal mode
          if (existingIndex !== _sortBy2.length - 1 || _sortBy2.length !== 1) {
            sortAction = 'replace';
          } else if (existingSortBy) {
            sortAction = 'toggle';
          } else {
            sortAction = 'replace';
          }
        } // Handle toggle states that will remove the sortBy


        if (sortAction === 'toggle' && // Must be toggling
        !disableSortRemove && // If disableSortRemove, disable in general
        !hasDescDefined && ( // Must not be setting desc
        multi ? !disableMultiRemove : true) && ( // If multi, don't allow if disableMultiRemove
        existingSortBy && // Finally, detect if it should indeed be removed
        existingSortBy.desc && !sortDescFirst || !existingSortBy.desc && sortDescFirst)) {
          sortAction = 'remove';
        }

        if (sortAction === 'replace') {
          _newSortBy = [{
            id: columnId,
            desc: hasDescDefined ? desc : sortDescFirst
          }];
        } else if (sortAction === 'add') {
          _newSortBy = [].concat(_sortBy2, [{
            id: columnId,
            desc: hasDescDefined ? desc : sortDescFirst
          }]); // Take latest n columns

          _newSortBy.splice(0, _newSortBy.length - maxMultiSortColCount);
        } else if (sortAction === 'toggle') {
          // This flips (or sets) the
          _newSortBy = _sortBy2.map(function (d) {
            if (d.id === columnId) {
              return _extends({}, d, {
                desc: hasDescDefined ? desc : !existingSortBy.desc
              });
            }

            return d;
          });
        } else if (sortAction === 'remove') {
          _newSortBy = _sortBy2.filter(function (d) {
            return d.id !== columnId;
          });
        }

        return _extends({}, state, {
          sortBy: _newSortBy
        });
      }
    }

    function useInstance$5(instance) {
      var data = instance.data,
          rows = instance.rows,
          flatRows = instance.flatRows,
          allColumns = instance.allColumns,
          _instance$orderByFn = instance.orderByFn,
          orderByFn = _instance$orderByFn === void 0 ? defaultOrderByFn : _instance$orderByFn,
          userSortTypes = instance.sortTypes,
          manualSortBy = instance.manualSortBy,
          defaultCanSort = instance.defaultCanSort,
          disableSortBy = instance.disableSortBy,
          flatHeaders = instance.flatHeaders,
          sortBy = instance.state.sortBy,
          dispatch = instance.dispatch,
          plugins = instance.plugins,
          getHooks = instance.getHooks,
          _instance$autoResetSo = instance.autoResetSortBy,
          autoResetSortBy = _instance$autoResetSo === void 0 ? true : _instance$autoResetSo;
      ensurePluginOrder(plugins, ['useFilters', 'useGlobalFilter', 'useGroupBy', 'usePivotColumns'], 'useSortBy');
      var setSortBy = React.useCallback(function (sortBy) {
        dispatch({
          type: actions.setSortBy,
          sortBy: sortBy
        });
      }, [dispatch]); // Updates sorting based on a columnId, desc flag and multi flag

      var toggleSortBy = React.useCallback(function (columnId, desc, multi) {
        dispatch({
          type: actions.toggleSortBy,
          columnId: columnId,
          desc: desc,
          multi: multi
        });
      }, [dispatch]); // use reference to avoid memory leak in #1608

      var getInstance = useGetLatest(instance); // Add the getSortByToggleProps method to columns and headers

      flatHeaders.forEach(function (column) {
        var accessor = column.accessor,
            defaultColumnCanSort = column.canSort,
            columnDisableSortBy = column.disableSortBy,
            id = column.id;
        var canSort = accessor ? getFirstDefined(columnDisableSortBy === true ? false : undefined, disableSortBy === true ? false : undefined, true) : getFirstDefined(defaultCanSort, defaultColumnCanSort, false);
        column.canSort = canSort;

        if (column.canSort) {
          column.toggleSortBy = function (desc, multi) {
            return toggleSortBy(column.id, desc, multi);
          };

          column.clearSortBy = function () {
            dispatch({
              type: actions.clearSortBy,
              columnId: column.id
            });
          };
        }

        column.getSortByToggleProps = makePropGetter(getHooks().getSortByToggleProps, {
          instance: getInstance(),
          column: column
        });
        var columnSort = sortBy.find(function (d) {
          return d.id === id;
        });
        column.isSorted = !!columnSort;
        column.sortedIndex = sortBy.findIndex(function (d) {
          return d.id === id;
        });
        column.isSortedDesc = column.isSorted ? columnSort.desc : undefined;
      });

      var _React$useMemo = React.useMemo(function () {
        if (manualSortBy || !sortBy.length) {
          return [rows, flatRows];
        }

        var sortedFlatRows = []; // Filter out sortBys that correspond to non existing columns

        var availableSortBy = sortBy.filter(function (sort) {
          return allColumns.find(function (col) {
            return col.id === sort.id;
          });
        });

        var sortData = function sortData(rows) {
          // Use the orderByFn to compose multiple sortBy's together.
          // This will also perform a stable sorting using the row index
          // if needed.
          var sortedData = orderByFn(rows, availableSortBy.map(function (sort) {
            // Support custom sorting methods for each column
            var column = allColumns.find(function (d) {
              return d.id === sort.id;
            });

            if (!column) {
              throw new Error("React-Table: Could not find a column with id: " + sort.id + " while sorting");
            }

            var sortType = column.sortType; // Look up sortBy functions in this order:
            // column function
            // column string lookup on user sortType
            // column string lookup on built-in sortType
            // default function
            // default string lookup on user sortType
            // default string lookup on built-in sortType

            var sortMethod = isFunction(sortType) || (userSortTypes || {})[sortType] || sortTypes[sortType];

            if (!sortMethod) {
              throw new Error("React-Table: Could not find a valid sortType of '" + sortType + "' for column '" + sort.id + "'.");
            } // Return the correct sortFn.
            // This function should always return in ascending order


            return function (a, b) {
              return sortMethod(a, b, sort.id, sort.desc);
            };
          }), // Map the directions
          availableSortBy.map(function (sort) {
            // Detect and use the sortInverted option
            var column = allColumns.find(function (d) {
              return d.id === sort.id;
            });

            if (column && column.sortInverted) {
              return sort.desc;
            }

            return !sort.desc;
          })); // If there are sub-rows, sort them

          sortedData.forEach(function (row) {
            sortedFlatRows.push(row);

            if (!row.subRows || row.subRows.length === 0) {
              return;
            }

            row.subRows = sortData(row.subRows);
          });
          return sortedData;
        };

        return [sortData(rows), sortedFlatRows];
      }, [manualSortBy, sortBy, rows, flatRows, allColumns, orderByFn, userSortTypes]),
          sortedRows = _React$useMemo[0],
          sortedFlatRows = _React$useMemo[1];

      var getAutoResetSortBy = useGetLatest(autoResetSortBy);
      useMountedLayoutEffect(function () {
        if (getAutoResetSortBy()) {
          dispatch({
            type: actions.resetSortBy
          });
        }
      }, [manualSortBy ? null : data]);
      Object.assign(instance, {
        preSortedRows: rows,
        preSortedFlatRows: flatRows,
        sortedRows: sortedRows,
        sortedFlatRows: sortedFlatRows,
        rows: sortedRows,
        flatRows: sortedFlatRows,
        setSortBy: setSortBy,
        toggleSortBy: toggleSortBy
      });
    }

    function defaultOrderByFn(arr, funcs, dirs) {
      return [].concat(arr).sort(function (rowA, rowB) {
        for (var i = 0; i < funcs.length; i += 1) {
          var sortFn = funcs[i];
          var desc = dirs[i] === false || dirs[i] === 'desc';
          var sortInt = sortFn(rowA, rowB);

          if (sortInt !== 0) {
            return desc ? -sortInt : sortInt;
          }
        }

        return dirs[0] ? rowA.index - rowB.index : rowB.index - rowA.index;
      });
    }

    var pluginName = 'usePagination'; // Actions

    actions.resetPage = 'resetPage';
    actions.gotoPage = 'gotoPage';
    actions.setPageSize = 'setPageSize';

    var usePagination = function usePagination(hooks) {
      hooks.stateReducers.push(reducer$6);
      hooks.useInstance.push(useInstance$6);
    };

    usePagination.pluginName = pluginName;

    function reducer$6(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          pageSize: 10,
          pageIndex: 0
        }, state);
      }

      if (action.type === actions.resetPage) {
        return _extends({}, state, {
          pageIndex: instance.initialState.pageIndex || 0
        });
      }

      if (action.type === actions.gotoPage) {
        var pageCount = instance.pageCount,
            page = instance.page;
        var newPageIndex = functionalUpdate(action.pageIndex, state.pageIndex);
        var canNavigate = false;

        if (newPageIndex > state.pageIndex) {
          // next page
          canNavigate = pageCount === -1 ? page.length >= state.pageSize : newPageIndex < pageCount;
        } else if (newPageIndex < state.pageIndex) {
          // prev page
          canNavigate = newPageIndex > -1;
        }

        if (!canNavigate) {
          return state;
        }

        return _extends({}, state, {
          pageIndex: newPageIndex
        });
      }

      if (action.type === actions.setPageSize) {
        var pageSize = action.pageSize;
        var topRowIndex = state.pageSize * state.pageIndex;
        var pageIndex = Math.floor(topRowIndex / pageSize);
        return _extends({}, state, {
          pageIndex: pageIndex,
          pageSize: pageSize
        });
      }
    }

    function useInstance$6(instance) {
      var rows = instance.rows,
          _instance$autoResetPa = instance.autoResetPage,
          autoResetPage = _instance$autoResetPa === void 0 ? true : _instance$autoResetPa,
          _instance$manualExpan = instance.manualExpandedKey,
          manualExpandedKey = _instance$manualExpan === void 0 ? 'expanded' : _instance$manualExpan,
          plugins = instance.plugins,
          userPageCount = instance.pageCount,
          _instance$paginateExp = instance.paginateExpandedRows,
          paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp,
          _instance$expandSubRo = instance.expandSubRows,
          expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo,
          _instance$state = instance.state,
          pageSize = _instance$state.pageSize,
          pageIndex = _instance$state.pageIndex,
          expanded = _instance$state.expanded,
          globalFilter = _instance$state.globalFilter,
          filters = _instance$state.filters,
          groupBy = _instance$state.groupBy,
          sortBy = _instance$state.sortBy,
          dispatch = instance.dispatch,
          data = instance.data,
          manualPagination = instance.manualPagination;
      ensurePluginOrder(plugins, ['useGlobalFilter', 'useFilters', 'useGroupBy', 'useSortBy', 'useExpanded'], 'usePagination');
      var getAutoResetPage = useGetLatest(autoResetPage);
      useMountedLayoutEffect(function () {
        if (getAutoResetPage()) {
          dispatch({
            type: actions.resetPage
          });
        }
      }, [dispatch, manualPagination ? null : data, globalFilter, filters, groupBy, sortBy]);
      var pageCount = manualPagination ? userPageCount : Math.ceil(rows.length / pageSize);
      var pageOptions = React.useMemo(function () {
        return pageCount > 0 ? [].concat(new Array(pageCount)).fill(null).map(function (d, i) {
          return i;
        }) : [];
      }, [pageCount]);
      var page = React.useMemo(function () {
        var page;

        if (manualPagination) {
          page = rows;
        } else {
          var pageStart = pageSize * pageIndex;
          var pageEnd = pageStart + pageSize;
          page = rows.slice(pageStart, pageEnd);
        }

        if (paginateExpandedRows) {
          return page;
        }

        return expandRows(page, {
          manualExpandedKey: manualExpandedKey,
          expanded: expanded,
          expandSubRows: expandSubRows
        });
      }, [expandSubRows, expanded, manualExpandedKey, manualPagination, pageIndex, pageSize, paginateExpandedRows, rows]);
      var canPreviousPage = pageIndex > 0;
      var canNextPage = pageCount === -1 ? page.length >= pageSize : pageIndex < pageCount - 1;
      var gotoPage = React.useCallback(function (pageIndex) {
        dispatch({
          type: actions.gotoPage,
          pageIndex: pageIndex
        });
      }, [dispatch]);
      var previousPage = React.useCallback(function () {
        return gotoPage(function (old) {
          return old - 1;
        });
      }, [gotoPage]);
      var nextPage = React.useCallback(function () {
        return gotoPage(function (old) {
          return old + 1;
        });
      }, [gotoPage]);
      var setPageSize = React.useCallback(function (pageSize) {
        dispatch({
          type: actions.setPageSize,
          pageSize: pageSize
        });
      }, [dispatch]);
      Object.assign(instance, {
        pageOptions: pageOptions,
        pageCount: pageCount,
        page: page,
        canPreviousPage: canPreviousPage,
        canNextPage: canNextPage,
        gotoPage: gotoPage,
        previousPage: previousPage,
        nextPage: nextPage,
        setPageSize: setPageSize
      });
    }

    actions.resetPivot = 'resetPivot';
    actions.togglePivot = 'togglePivot';

    var _UNSTABLE_usePivotColumns = function _UNSTABLE_usePivotColumns(hooks) {
      hooks.getPivotToggleProps = [defaultGetPivotToggleProps];
      hooks.stateReducers.push(reducer$7);
      hooks.useInstanceAfterData.push(useInstanceAfterData);
      hooks.allColumns.push(allColumns);
      hooks.accessValue.push(accessValue);
      hooks.materializedColumns.push(materializedColumns);
      hooks.materializedColumnsDeps.push(materializedColumnsDeps);
      hooks.visibleColumns.push(visibleColumns$1);
      hooks.visibleColumnsDeps.push(visibleColumnsDeps);
      hooks.useInstance.push(useInstance$7);
      hooks.prepareRow.push(prepareRow$2);
    };

    _UNSTABLE_usePivotColumns.pluginName = 'usePivotColumns';
    var defaultPivotColumns = [];

    var defaultGetPivotToggleProps = function defaultGetPivotToggleProps(props, _ref) {
      var header = _ref.header;
      return [props, {
        onClick: header.canPivot ? function (e) {
          e.persist();
          header.togglePivot();
        } : undefined,
        style: {
          cursor: header.canPivot ? 'pointer' : undefined
        },
        title: 'Toggle Pivot'
      }];
    }; // Reducer


    function reducer$7(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          pivotColumns: defaultPivotColumns
        }, state);
      }

      if (action.type === actions.resetPivot) {
        return _extends({}, state, {
          pivotColumns: instance.initialState.pivotColumns || defaultPivotColumns
        });
      }

      if (action.type === actions.togglePivot) {
        var columnId = action.columnId,
            setPivot = action.value;
        var resolvedPivot = typeof setPivot !== 'undefined' ? setPivot : !state.pivotColumns.includes(columnId);

        if (resolvedPivot) {
          return _extends({}, state, {
            pivotColumns: [].concat(state.pivotColumns, [columnId])
          });
        }

        return _extends({}, state, {
          pivotColumns: state.pivotColumns.filter(function (d) {
            return d !== columnId;
          })
        });
      }
    }

    function useInstanceAfterData(instance) {
      instance.allColumns.forEach(function (column) {
        column.isPivotSource = instance.state.pivotColumns.includes(column.id);
      });
    }

    function allColumns(columns, _ref2) {
      var instance = _ref2.instance;
      columns.forEach(function (column) {
        column.isPivotSource = instance.state.pivotColumns.includes(column.id);
        column.uniqueValues = new Set();
      });
      return columns;
    }

    function accessValue(value, _ref3) {
      var column = _ref3.column;

      if (column.uniqueValues && typeof value !== 'undefined') {
        column.uniqueValues.add(value);
      }

      return value;
    }

    function materializedColumns(materialized, _ref4) {
      var instance = _ref4.instance;
      var allColumns = instance.allColumns,
          state = instance.state;

      if (!state.pivotColumns.length || !state.groupBy || !state.groupBy.length) {
        return materialized;
      }

      var pivotColumns = state.pivotColumns.map(function (id) {
        return allColumns.find(function (d) {
          return d.id === id;
        });
      }).filter(Boolean);
      var sourceColumns = allColumns.filter(function (d) {
        return !d.isPivotSource && !state.groupBy.includes(d.id) && !state.pivotColumns.includes(d.id);
      });

      var buildPivotColumns = function buildPivotColumns(depth, parent, pivotFilters) {
        if (depth === void 0) {
          depth = 0;
        }

        if (pivotFilters === void 0) {
          pivotFilters = [];
        }

        var pivotColumn = pivotColumns[depth];

        if (!pivotColumn) {
          return sourceColumns.map(function (sourceColumn) {
            // TODO: We could offer support here for renesting pivoted
            // columns inside copies of their header groups. For now,
            // that seems like it would be (1) overkill on nesting, considering
            // you already get nesting for every pivot level and (2)
            // really hard. :)
            return _extends({}, sourceColumn, {
              canPivot: false,
              isPivoted: true,
              parent: parent,
              depth: depth,
              id: "" + (parent ? parent.id + "." + sourceColumn.id : sourceColumn.id),
              accessor: function accessor(originalRow, i, row) {
                if (pivotFilters.every(function (filter) {
                  return filter(row);
                })) {
                  return row.values[sourceColumn.id];
                }
              }
            });
          });
        }

        var uniqueValues = Array.from(pivotColumn.uniqueValues).sort();
        return uniqueValues.map(function (uniqueValue) {
          var columnGroup = _extends({}, pivotColumn, {
            Header: pivotColumn.PivotHeader || typeof pivotColumn.header === 'string' ? pivotColumn.Header + ": " + uniqueValue : uniqueValue,
            isPivotGroup: true,
            parent: parent,
            depth: depth,
            id: parent ? parent.id + "." + pivotColumn.id + "." + uniqueValue : pivotColumn.id + "." + uniqueValue,
            pivotValue: uniqueValue
          });

          columnGroup.columns = buildPivotColumns(depth + 1, columnGroup, [].concat(pivotFilters, [function (row) {
            return row.values[pivotColumn.id] === uniqueValue;
          }]));
          return columnGroup;
        });
      };

      var newMaterialized = flattenColumns(buildPivotColumns());
      return [].concat(materialized, newMaterialized);
    }

    function materializedColumnsDeps(deps, _ref5) {
      var _ref5$instance$state = _ref5.instance.state,
          pivotColumns = _ref5$instance$state.pivotColumns,
          groupBy = _ref5$instance$state.groupBy;
      return [].concat(deps, [pivotColumns, groupBy]);
    }

    function visibleColumns$1(visibleColumns, _ref6) {
      var state = _ref6.instance.state;
      visibleColumns = visibleColumns.filter(function (d) {
        return !d.isPivotSource;
      });

      if (state.pivotColumns.length && state.groupBy && state.groupBy.length) {
        visibleColumns = visibleColumns.filter(function (column) {
          return column.isGrouped || column.isPivoted;
        });
      }

      return visibleColumns;
    }

    function visibleColumnsDeps(deps, _ref7) {
      var instance = _ref7.instance;
      return [].concat(deps, [instance.state.pivotColumns, instance.state.groupBy]);
    }

    function useInstance$7(instance) {
      var columns = instance.columns,
          allColumns = instance.allColumns,
          flatHeaders = instance.flatHeaders,
          getHooks = instance.getHooks,
          plugins = instance.plugins,
          dispatch = instance.dispatch,
          _instance$autoResetPi = instance.autoResetPivot,
          autoResetPivot = _instance$autoResetPi === void 0 ? true : _instance$autoResetPi,
          manaulPivot = instance.manaulPivot,
          disablePivot = instance.disablePivot,
          defaultCanPivot = instance.defaultCanPivot;
      ensurePluginOrder(plugins, ['useGroupBy'], 'usePivotColumns');
      var getInstance = useGetLatest(instance);
      allColumns.forEach(function (column) {
        var accessor = column.accessor,
            defaultColumnPivot = column.defaultPivot,
            columnDisablePivot = column.disablePivot;
        column.canPivot = accessor ? getFirstDefined(column.canPivot, columnDisablePivot === true ? false : undefined, disablePivot === true ? false : undefined, true) : getFirstDefined(column.canPivot, defaultColumnPivot, defaultCanPivot, false);

        if (column.canPivot) {
          column.togglePivot = function () {
            return instance.togglePivot(column.id);
          };
        }

        column.Aggregated = column.Aggregated || column.Cell;
      });

      var togglePivot = function togglePivot(columnId, value) {
        dispatch({
          type: actions.togglePivot,
          columnId: columnId,
          value: value
        });
      };

      flatHeaders.forEach(function (header) {
        header.getPivotToggleProps = makePropGetter(getHooks().getPivotToggleProps, {
          instance: getInstance(),
          header: header
        });
      });
      var getAutoResetPivot = useGetLatest(autoResetPivot);
      useMountedLayoutEffect(function () {
        if (getAutoResetPivot()) {
          dispatch({
            type: actions.resetPivot
          });
        }
      }, [dispatch, manaulPivot ? null : columns]);
      Object.assign(instance, {
        togglePivot: togglePivot
      });
    }

    function prepareRow$2(row) {
      row.allCells.forEach(function (cell) {
        // Grouped cells are in the pivotColumns and the pivot cell for the row
        cell.isPivoted = cell.column.isPivoted;
      });
    }

    var pluginName$1 = 'useRowSelect'; // Actions

    actions.resetSelectedRows = 'resetSelectedRows';
    actions.toggleAllRowsSelected = 'toggleAllRowsSelected';
    actions.toggleRowSelected = 'toggleRowSelected';
    actions.toggleAllPageRowsSelected = 'toggleAllPageRowsSelected';

    var useRowSelect = function useRowSelect(hooks) {
      hooks.getToggleRowSelectedProps = [defaultGetToggleRowSelectedProps];
      hooks.getToggleAllRowsSelectedProps = [defaultGetToggleAllRowsSelectedProps];
      hooks.getToggleAllPageRowsSelectedProps = [defaultGetToggleAllPageRowsSelectedProps];
      hooks.stateReducers.push(reducer$8);
      hooks.useInstance.push(useInstance$8);
      hooks.prepareRow.push(prepareRow$3);
    };

    useRowSelect.pluginName = pluginName$1;

    var defaultGetToggleRowSelectedProps = function defaultGetToggleRowSelectedProps(props, _ref) {
      var instance = _ref.instance,
          row = _ref.row;
      var _instance$manualRowSe = instance.manualRowSelectedKey,
          manualRowSelectedKey = _instance$manualRowSe === void 0 ? 'isSelected' : _instance$manualRowSe;
      var checked = false;

      if (row.original && row.original[manualRowSelectedKey]) {
        checked = true;
      } else {
        checked = row.isSelected;
      }

      return [props, {
        onChange: function onChange(e) {
          row.toggleRowSelected(e.target.checked);
        },
        style: {
          cursor: 'pointer'
        },
        checked: checked,
        title: 'Toggle Row Selected',
        indeterminate: row.isSomeSelected
      }];
    };

    var defaultGetToggleAllRowsSelectedProps = function defaultGetToggleAllRowsSelectedProps(props, _ref2) {
      var instance = _ref2.instance;
      return [props, {
        onChange: function onChange(e) {
          instance.toggleAllRowsSelected(e.target.checked);
        },
        style: {
          cursor: 'pointer'
        },
        checked: instance.isAllRowsSelected,
        title: 'Toggle All Rows Selected',
        indeterminate: Boolean(!instance.isAllRowsSelected && Object.keys(instance.state.selectedRowIds).length)
      }];
    };

    var defaultGetToggleAllPageRowsSelectedProps = function defaultGetToggleAllPageRowsSelectedProps(props, _ref3) {
      var instance = _ref3.instance;
      return [props, {
        onChange: function onChange(e) {
          instance.toggleAllPageRowsSelected(e.target.checked);
        },
        style: {
          cursor: 'pointer'
        },
        checked: instance.isAllPageRowsSelected,
        title: 'Toggle All Current Page Rows Selected',
        indeterminate: Boolean(!instance.isAllPageRowsSelected && instance.page.some(function (_ref4) {
          var id = _ref4.id;
          return instance.state.selectedRowIds[id];
        }))
      }];
    }; // eslint-disable-next-line max-params


    function reducer$8(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          selectedRowIds: {}
        }, state);
      }

      if (action.type === actions.resetSelectedRows) {
        return _extends({}, state, {
          selectedRowIds: instance.initialState.selectedRowIds || {}
        });
      }

      if (action.type === actions.toggleAllRowsSelected) {
        var setSelected = action.value;
        var isAllRowsSelected = instance.isAllRowsSelected,
            rowsById = instance.rowsById,
            _instance$nonGroupedR = instance.nonGroupedRowsById,
            nonGroupedRowsById = _instance$nonGroupedR === void 0 ? rowsById : _instance$nonGroupedR;
        var selectAll = typeof setSelected !== 'undefined' ? setSelected : !isAllRowsSelected; // Only remove/add the rows that are visible on the screen
        //  Leave all the other rows that are selected alone.

        var selectedRowIds = Object.assign({}, state.selectedRowIds);

        if (selectAll) {
          Object.keys(nonGroupedRowsById).forEach(function (rowId) {
            selectedRowIds[rowId] = true;
          });
        } else {
          Object.keys(nonGroupedRowsById).forEach(function (rowId) {
            delete selectedRowIds[rowId];
          });
        }

        return _extends({}, state, {
          selectedRowIds: selectedRowIds
        });
      }

      if (action.type === actions.toggleRowSelected) {
        var id = action.id,
            _setSelected = action.value;
        var _rowsById = instance.rowsById,
            _instance$selectSubRo = instance.selectSubRows,
            selectSubRows = _instance$selectSubRo === void 0 ? true : _instance$selectSubRo,
            getSubRows = instance.getSubRows;
        var isSelected = state.selectedRowIds[id];
        var shouldExist = typeof _setSelected !== 'undefined' ? _setSelected : !isSelected;

        if (isSelected === shouldExist) {
          return state;
        }

        var newSelectedRowIds = _extends({}, state.selectedRowIds);

        var handleRowById = function handleRowById(id) {
          var row = _rowsById[id];

          if (!row.isGrouped) {
            if (shouldExist) {
              newSelectedRowIds[id] = true;
            } else {
              delete newSelectedRowIds[id];
            }
          }

          if (selectSubRows && getSubRows(row)) {
            return getSubRows(row).forEach(function (row) {
              return handleRowById(row.id);
            });
          }
        };

        handleRowById(id);
        return _extends({}, state, {
          selectedRowIds: newSelectedRowIds
        });
      }

      if (action.type === actions.toggleAllPageRowsSelected) {
        var _setSelected2 = action.value;

        var page = instance.page,
            _rowsById2 = instance.rowsById,
            _instance$selectSubRo2 = instance.selectSubRows,
            _selectSubRows = _instance$selectSubRo2 === void 0 ? true : _instance$selectSubRo2,
            isAllPageRowsSelected = instance.isAllPageRowsSelected,
            _getSubRows = instance.getSubRows;

        var _selectAll = typeof _setSelected2 !== 'undefined' ? _setSelected2 : !isAllPageRowsSelected;

        var _newSelectedRowIds = _extends({}, state.selectedRowIds);

        var _handleRowById = function _handleRowById(id) {
          var row = _rowsById2[id];

          if (!row.isGrouped) {
            if (_selectAll) {
              _newSelectedRowIds[id] = true;
            } else {
              delete _newSelectedRowIds[id];
            }
          }

          if (_selectSubRows && _getSubRows(row)) {
            return _getSubRows(row).forEach(function (row) {
              return _handleRowById(row.id);
            });
          }
        };

        page.forEach(function (row) {
          return _handleRowById(row.id);
        });
        return _extends({}, state, {
          selectedRowIds: _newSelectedRowIds
        });
      }

      return state;
    }

    function useInstance$8(instance) {
      var data = instance.data,
          rows = instance.rows,
          getHooks = instance.getHooks,
          plugins = instance.plugins,
          rowsById = instance.rowsById,
          _instance$nonGroupedR2 = instance.nonGroupedRowsById,
          nonGroupedRowsById = _instance$nonGroupedR2 === void 0 ? rowsById : _instance$nonGroupedR2,
          _instance$autoResetSe = instance.autoResetSelectedRows,
          autoResetSelectedRows = _instance$autoResetSe === void 0 ? true : _instance$autoResetSe,
          selectedRowIds = instance.state.selectedRowIds,
          _instance$selectSubRo3 = instance.selectSubRows,
          selectSubRows = _instance$selectSubRo3 === void 0 ? true : _instance$selectSubRo3,
          dispatch = instance.dispatch,
          page = instance.page,
          getSubRows = instance.getSubRows;
      ensurePluginOrder(plugins, ['useFilters', 'useGroupBy', 'useSortBy', 'useExpanded', 'usePagination'], 'useRowSelect');
      var selectedFlatRows = React.useMemo(function () {
        var selectedFlatRows = [];
        rows.forEach(function (row) {
          var isSelected = selectSubRows ? getRowIsSelected(row, selectedRowIds, getSubRows) : !!selectedRowIds[row.id];
          row.isSelected = !!isSelected;
          row.isSomeSelected = isSelected === null;

          if (isSelected) {
            selectedFlatRows.push(row);
          }
        });
        return selectedFlatRows;
      }, [rows, selectSubRows, selectedRowIds, getSubRows]);
      var isAllRowsSelected = Boolean(Object.keys(nonGroupedRowsById).length && Object.keys(selectedRowIds).length);
      var isAllPageRowsSelected = isAllRowsSelected;

      if (isAllRowsSelected) {
        if (Object.keys(nonGroupedRowsById).some(function (id) {
          return !selectedRowIds[id];
        })) {
          isAllRowsSelected = false;
        }
      }

      if (!isAllRowsSelected) {
        if (page && page.length && page.some(function (_ref5) {
          var id = _ref5.id;
          return !selectedRowIds[id];
        })) {
          isAllPageRowsSelected = false;
        }
      }

      var getAutoResetSelectedRows = useGetLatest(autoResetSelectedRows);
      useMountedLayoutEffect(function () {
        if (getAutoResetSelectedRows()) {
          dispatch({
            type: actions.resetSelectedRows
          });
        }
      }, [dispatch, data]);
      var toggleAllRowsSelected = React.useCallback(function (value) {
        return dispatch({
          type: actions.toggleAllRowsSelected,
          value: value
        });
      }, [dispatch]);
      var toggleAllPageRowsSelected = React.useCallback(function (value) {
        return dispatch({
          type: actions.toggleAllPageRowsSelected,
          value: value
        });
      }, [dispatch]);
      var toggleRowSelected = React.useCallback(function (id, value) {
        return dispatch({
          type: actions.toggleRowSelected,
          id: id,
          value: value
        });
      }, [dispatch]);
      var getInstance = useGetLatest(instance);
      var getToggleAllRowsSelectedProps = makePropGetter(getHooks().getToggleAllRowsSelectedProps, {
        instance: getInstance()
      });
      var getToggleAllPageRowsSelectedProps = makePropGetter(getHooks().getToggleAllPageRowsSelectedProps, {
        instance: getInstance()
      });
      Object.assign(instance, {
        selectedFlatRows: selectedFlatRows,
        isAllRowsSelected: isAllRowsSelected,
        isAllPageRowsSelected: isAllPageRowsSelected,
        toggleRowSelected: toggleRowSelected,
        toggleAllRowsSelected: toggleAllRowsSelected,
        getToggleAllRowsSelectedProps: getToggleAllRowsSelectedProps,
        getToggleAllPageRowsSelectedProps: getToggleAllPageRowsSelectedProps,
        toggleAllPageRowsSelected: toggleAllPageRowsSelected
      });
    }

    function prepareRow$3(row, _ref6) {
      var instance = _ref6.instance;

      row.toggleRowSelected = function (set) {
        return instance.toggleRowSelected(row.id, set);
      };

      row.getToggleRowSelectedProps = makePropGetter(instance.getHooks().getToggleRowSelectedProps, {
        instance: instance,
        row: row
      });
    }

    function getRowIsSelected(row, selectedRowIds, getSubRows) {
      if (selectedRowIds[row.id]) {
        return true;
      }

      var subRows = getSubRows(row);

      if (subRows && subRows.length) {
        var allChildrenSelected = true;
        var someSelected = false;
        subRows.forEach(function (subRow) {
          // Bail out early if we know both of these
          if (someSelected && !allChildrenSelected) {
            return;
          }

          if (getRowIsSelected(subRow, selectedRowIds, getSubRows)) {
            someSelected = true;
          } else {
            allChildrenSelected = false;
          }
        });
        return allChildrenSelected ? true : someSelected ? null : false;
      }

      return false;
    }

    var defaultInitialRowStateAccessor = function defaultInitialRowStateAccessor(row) {
      return {};
    };

    var defaultInitialCellStateAccessor = function defaultInitialCellStateAccessor(cell) {
      return {};
    }; // Actions


    actions.setRowState = 'setRowState';
    actions.setCellState = 'setCellState';
    actions.resetRowState = 'resetRowState';

    var useRowState = function useRowState(hooks) {
      hooks.stateReducers.push(reducer$9);
      hooks.useInstance.push(useInstance$9);
      hooks.prepareRow.push(prepareRow$4);
    };

    useRowState.pluginName = 'useRowState';

    function reducer$9(state, action, previousState, instance) {
      var _instance$initialRowS = instance.initialRowStateAccessor,
          initialRowStateAccessor = _instance$initialRowS === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS,
          _instance$initialCell = instance.initialCellStateAccessor,
          initialCellStateAccessor = _instance$initialCell === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell,
          rowsById = instance.rowsById;

      if (action.type === actions.init) {
        return _extends({
          rowState: {}
        }, state);
      }

      if (action.type === actions.resetRowState) {
        return _extends({}, state, {
          rowState: instance.initialState.rowState || {}
        });
      }

      if (action.type === actions.setRowState) {
        var _extends2;

        var rowId = action.rowId,
            value = action.value;
        var oldRowState = typeof state.rowState[rowId] !== 'undefined' ? state.rowState[rowId] : initialRowStateAccessor(rowsById[rowId]);
        return _extends({}, state, {
          rowState: _extends({}, state.rowState, (_extends2 = {}, _extends2[rowId] = functionalUpdate(value, oldRowState), _extends2))
        });
      }

      if (action.type === actions.setCellState) {
        var _oldRowState$cellStat, _rowsById$_rowId, _rowsById$_rowId$cell, _extends3, _extends4;

        var _rowId = action.rowId,
            columnId = action.columnId,
            _value = action.value;

        var _oldRowState = typeof state.rowState[_rowId] !== 'undefined' ? state.rowState[_rowId] : initialRowStateAccessor(rowsById[_rowId]);

        var oldCellState = typeof (_oldRowState == null ? void 0 : (_oldRowState$cellStat = _oldRowState.cellState) == null ? void 0 : _oldRowState$cellStat[columnId]) !== 'undefined' ? _oldRowState.cellState[columnId] : initialCellStateAccessor((_rowsById$_rowId = rowsById[_rowId]) == null ? void 0 : (_rowsById$_rowId$cell = _rowsById$_rowId.cells) == null ? void 0 : _rowsById$_rowId$cell.find(function (cell) {
          return cell.column.id === columnId;
        }));
        return _extends({}, state, {
          rowState: _extends({}, state.rowState, (_extends4 = {}, _extends4[_rowId] = _extends({}, _oldRowState, {
            cellState: _extends({}, _oldRowState.cellState || {}, (_extends3 = {}, _extends3[columnId] = functionalUpdate(_value, oldCellState), _extends3))
          }), _extends4))
        });
      }
    }

    function useInstance$9(instance) {
      var _instance$autoResetRo = instance.autoResetRowState,
          autoResetRowState = _instance$autoResetRo === void 0 ? true : _instance$autoResetRo,
          data = instance.data,
          dispatch = instance.dispatch;
      var setRowState = React.useCallback(function (rowId, value) {
        return dispatch({
          type: actions.setRowState,
          rowId: rowId,
          value: value
        });
      }, [dispatch]);
      var setCellState = React.useCallback(function (rowId, columnId, value) {
        return dispatch({
          type: actions.setCellState,
          rowId: rowId,
          columnId: columnId,
          value: value
        });
      }, [dispatch]);
      var getAutoResetRowState = useGetLatest(autoResetRowState);
      useMountedLayoutEffect(function () {
        if (getAutoResetRowState()) {
          dispatch({
            type: actions.resetRowState
          });
        }
      }, [data]);
      Object.assign(instance, {
        setRowState: setRowState,
        setCellState: setCellState
      });
    }

    function prepareRow$4(row, _ref) {
      var instance = _ref.instance;
      var _instance$initialRowS2 = instance.initialRowStateAccessor,
          initialRowStateAccessor = _instance$initialRowS2 === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS2,
          _instance$initialCell2 = instance.initialCellStateAccessor,
          initialCellStateAccessor = _instance$initialCell2 === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell2,
          rowState = instance.state.rowState;

      if (row) {
        row.state = typeof rowState[row.id] !== 'undefined' ? rowState[row.id] : initialRowStateAccessor(row);

        row.setState = function (updater) {
          return instance.setRowState(row.id, updater);
        };

        row.cells.forEach(function (cell) {
          if (!row.state.cellState) {
            row.state.cellState = {};
          }

          cell.state = typeof row.state.cellState[cell.column.id] !== 'undefined' ? row.state.cellState[cell.column.id] : initialCellStateAccessor(cell);

          cell.setState = function (updater) {
            return instance.setCellState(row.id, cell.column.id, updater);
          };
        });
      }
    }

    actions.resetColumnOrder = 'resetColumnOrder';
    actions.setColumnOrder = 'setColumnOrder';

    var useColumnOrder = function useColumnOrder(hooks) {
      hooks.stateReducers.push(reducer$a);
      hooks.visibleColumnsDeps.push(function (deps, _ref) {
        var instance = _ref.instance;
        return [].concat(deps, [instance.state.columnOrder]);
      });
      hooks.visibleColumns.push(visibleColumns$2);
      hooks.useInstance.push(useInstance$a);
    };

    useColumnOrder.pluginName = 'useColumnOrder';

    function reducer$a(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          columnOrder: []
        }, state);
      }

      if (action.type === actions.resetColumnOrder) {
        return _extends({}, state, {
          columnOrder: instance.initialState.columnOrder || []
        });
      }

      if (action.type === actions.setColumnOrder) {
        return _extends({}, state, {
          columnOrder: functionalUpdate(action.columnOrder, state.columnOrder)
        });
      }
    }

    function visibleColumns$2(columns, _ref2) {
      var columnOrder = _ref2.instance.state.columnOrder; // If there is no order, return the normal columns

      if (!columnOrder || !columnOrder.length) {
        return columns;
      }

      var columnOrderCopy = [].concat(columnOrder); // If there is an order, make a copy of the columns

      var columnsCopy = [].concat(columns); // And make a new ordered array of the columns

      var columnsInOrder = []; // Loop over the columns and place them in order into the new array

      var _loop = function _loop() {
        var targetColumnId = columnOrderCopy.shift();
        var foundIndex = columnsCopy.findIndex(function (d) {
          return d.id === targetColumnId;
        });

        if (foundIndex > -1) {
          columnsInOrder.push(columnsCopy.splice(foundIndex, 1)[0]);
        }
      };

      while (columnsCopy.length && columnOrderCopy.length) {
        _loop();
      } // If there are any columns left, add them to the end


      return [].concat(columnsInOrder, columnsCopy);
    }

    function useInstance$a(instance) {
      var dispatch = instance.dispatch;
      instance.setColumnOrder = React.useCallback(function (columnOrder) {
        return dispatch({
          type: actions.setColumnOrder,
          columnOrder: columnOrder
        });
      }, [dispatch]);
    }

    defaultColumn.canResize = true; // Actions

    actions.columnStartResizing = 'columnStartResizing';
    actions.columnResizing = 'columnResizing';
    actions.columnDoneResizing = 'columnDoneResizing';
    actions.resetResize = 'resetResize';

    var useResizeColumns = function useResizeColumns(hooks) {
      hooks.getResizerProps = [defaultGetResizerProps];
      hooks.getHeaderProps.push({
        style: {
          position: 'relative'
        }
      });
      hooks.stateReducers.push(reducer$b);
      hooks.useInstance.push(useInstance$b);
      hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions$1);
    };

    var defaultGetResizerProps = function defaultGetResizerProps(props, _ref) {
      var instance = _ref.instance,
          header = _ref.header;
      var dispatch = instance.dispatch;

      var onResizeStart = function onResizeStart(e, header) {
        var isTouchEvent = false;

        if (e.type === 'touchstart') {
          // lets not respond to multiple touches (e.g. 2 or 3 fingers)
          if (e.touches && e.touches.length > 1) {
            return;
          }

          isTouchEvent = true;
        }

        var headersToResize = getLeafHeaders(header);
        var headerIdWidths = headersToResize.map(function (d) {
          return [d.id, d.totalWidth];
        });
        var clientX = isTouchEvent ? Math.round(e.touches[0].clientX) : e.clientX;

        var dispatchMove = function dispatchMove(clientXPos) {
          dispatch({
            type: actions.columnResizing,
            clientX: clientXPos
          });
        };

        var dispatchEnd = function dispatchEnd() {
          return dispatch({
            type: actions.columnDoneResizing
          });
        };

        var handlersAndEvents = {
          mouse: {
            moveEvent: 'mousemove',
            moveHandler: function moveHandler(e) {
              return dispatchMove(e.clientX);
            },
            upEvent: 'mouseup',
            upHandler: function upHandler(e) {
              document.removeEventListener('mousemove', handlersAndEvents.mouse.moveHandler);
              document.removeEventListener('mouseup', handlersAndEvents.mouse.upHandler);
              dispatchEnd();
            }
          },
          touch: {
            moveEvent: 'touchmove',
            moveHandler: function moveHandler(e) {
              if (e.cancelable) {
                e.preventDefault();
                e.stopPropagation();
              }

              dispatchMove(e.touches[0].clientX);
              return false;
            },
            upEvent: 'touchend',
            upHandler: function upHandler(e) {
              document.removeEventListener(handlersAndEvents.touch.moveEvent, handlersAndEvents.touch.moveHandler);
              document.removeEventListener(handlersAndEvents.touch.upEvent, handlersAndEvents.touch.moveHandler);
              dispatchEnd();
            }
          }
        };
        var events = isTouchEvent ? handlersAndEvents.touch : handlersAndEvents.mouse;
        var passiveIfSupported = passiveEventSupported() ? {
          passive: false
        } : false;
        document.addEventListener(events.moveEvent, events.moveHandler, passiveIfSupported);
        document.addEventListener(events.upEvent, events.upHandler, passiveIfSupported);
        dispatch({
          type: actions.columnStartResizing,
          columnId: header.id,
          columnWidth: header.totalWidth,
          headerIdWidths: headerIdWidths,
          clientX: clientX
        });
      };

      return [props, {
        onMouseDown: function onMouseDown(e) {
          return e.persist() || onResizeStart(e, header);
        },
        onTouchStart: function onTouchStart(e) {
          return e.persist() || onResizeStart(e, header);
        },
        style: {
          cursor: 'col-resize'
        },
        draggable: false,
        role: 'separator'
      }];
    };

    useResizeColumns.pluginName = 'useResizeColumns';

    function reducer$b(state, action) {
      if (action.type === actions.init) {
        return _extends({
          columnResizing: {
            columnWidths: {}
          }
        }, state);
      }

      if (action.type === actions.resetResize) {
        return _extends({}, state, {
          columnResizing: {
            columnWidths: {}
          }
        });
      }

      if (action.type === actions.columnStartResizing) {
        var clientX = action.clientX,
            columnId = action.columnId,
            columnWidth = action.columnWidth,
            headerIdWidths = action.headerIdWidths;
        return _extends({}, state, {
          columnResizing: _extends({}, state.columnResizing, {
            startX: clientX,
            headerIdWidths: headerIdWidths,
            columnWidth: columnWidth,
            isResizingColumn: columnId
          })
        });
      }

      if (action.type === actions.columnResizing) {
        var _clientX = action.clientX;

        var _state$columnResizing = state.columnResizing,
            startX = _state$columnResizing.startX,
            _columnWidth = _state$columnResizing.columnWidth,
            _state$columnResizing2 = _state$columnResizing.headerIdWidths,
            _headerIdWidths = _state$columnResizing2 === void 0 ? [] : _state$columnResizing2;

        var deltaX = _clientX - startX;
        var percentageDeltaX = deltaX / _columnWidth;
        var newColumnWidths = {};

        _headerIdWidths.forEach(function (_ref2) {
          var headerId = _ref2[0],
              headerWidth = _ref2[1];
          newColumnWidths[headerId] = Math.max(headerWidth + headerWidth * percentageDeltaX, 0);
        });

        return _extends({}, state, {
          columnResizing: _extends({}, state.columnResizing, {
            columnWidths: _extends({}, state.columnResizing.columnWidths, {}, newColumnWidths)
          })
        });
      }

      if (action.type === actions.columnDoneResizing) {
        return _extends({}, state, {
          columnResizing: _extends({}, state.columnResizing, {
            startX: null,
            isResizingColumn: null
          })
        });
      }
    }

    var useInstanceBeforeDimensions$1 = function useInstanceBeforeDimensions(instance) {
      var flatHeaders = instance.flatHeaders,
          disableResizing = instance.disableResizing,
          getHooks = instance.getHooks,
          columnResizing = instance.state.columnResizing;
      var getInstance = useGetLatest(instance);
      flatHeaders.forEach(function (header) {
        var canResize = getFirstDefined(header.disableResizing === true ? false : undefined, disableResizing === true ? false : undefined, true);
        header.canResize = canResize;
        header.width = columnResizing.columnWidths[header.id] || header.originalWidth || header.width;
        header.isResizing = columnResizing.isResizingColumn === header.id;

        if (canResize) {
          header.getResizerProps = makePropGetter(getHooks().getResizerProps, {
            instance: getInstance(),
            header: header
          });
        }
      });
    };

    function useInstance$b(instance) {
      var plugins = instance.plugins,
          dispatch = instance.dispatch,
          _instance$autoResetRe = instance.autoResetResize,
          autoResetResize = _instance$autoResetRe === void 0 ? true : _instance$autoResetRe,
          columns = instance.columns;
      ensurePluginOrder(plugins, ['useAbsoluteLayout'], 'useResizeColumns');
      var getAutoResetResize = useGetLatest(autoResetResize);
      useMountedLayoutEffect(function () {
        if (getAutoResetResize()) {
          dispatch({
            type: actions.resetResize
          });
        }
      }, [columns]);
      var resetResizing = React.useCallback(function () {
        return dispatch({
          type: actions.resetResize
        });
      }, [dispatch]);
      Object.assign(instance, {
        resetResizing: resetResizing
      });
    }

    function getLeafHeaders(header) {
      var leafHeaders = [];

      var recurseHeader = function recurseHeader(header) {
        if (header.columns && header.columns.length) {
          header.columns.map(recurseHeader);
        }

        leafHeaders.push(header);
      };

      recurseHeader(header);
      return leafHeaders;
    }

    var cellStyles = {
      position: 'absolute',
      top: 0
    };

    var useAbsoluteLayout = function useAbsoluteLayout(hooks) {
      hooks.getTableBodyProps.push(getRowStyles);
      hooks.getRowProps.push(getRowStyles);
      hooks.getHeaderGroupProps.push(getRowStyles);
      hooks.getFooterGroupProps.push(getRowStyles);
      hooks.getHeaderProps.push(function (props, _ref) {
        var column = _ref.column;
        return [props, {
          style: _extends({}, cellStyles, {
            left: column.totalLeft + "px",
            width: column.totalWidth + "px"
          })
        }];
      });
      hooks.getCellProps.push(function (props, _ref2) {
        var cell = _ref2.cell;
        return [props, {
          style: _extends({}, cellStyles, {
            left: cell.column.totalLeft + "px",
            width: cell.column.totalWidth + "px"
          })
        }];
      });
      hooks.getFooterProps.push(function (props, _ref3) {
        var column = _ref3.column;
        return [props, {
          style: _extends({}, cellStyles, {
            left: column.totalLeft + "px",
            width: column.totalWidth + "px"
          })
        }];
      });
    };

    useAbsoluteLayout.pluginName = 'useAbsoluteLayout';

    var getRowStyles = function getRowStyles(props, _ref4) {
      var instance = _ref4.instance;
      return [props, {
        style: {
          position: 'relative',
          width: instance.totalColumnsWidth + "px"
        }
      }];
    };

    var cellStyles$1 = {
      display: 'inline-block',
      boxSizing: 'border-box'
    };

    var getRowStyles$1 = function getRowStyles(props, _ref) {
      var instance = _ref.instance;
      return [props, {
        style: {
          display: 'flex',
          width: instance.totalColumnsWidth + "px"
        }
      }];
    };

    var useBlockLayout = function useBlockLayout(hooks) {
      hooks.getRowProps.push(getRowStyles$1);
      hooks.getHeaderGroupProps.push(getRowStyles$1);
      hooks.getFooterGroupProps.push(getRowStyles$1);
      hooks.getHeaderProps.push(function (props, _ref2) {
        var column = _ref2.column;
        return [props, {
          style: _extends({}, cellStyles$1, {
            width: column.totalWidth + "px"
          })
        }];
      });
      hooks.getCellProps.push(function (props, _ref3) {
        var cell = _ref3.cell;
        return [props, {
          style: _extends({}, cellStyles$1, {
            width: cell.column.totalWidth + "px"
          })
        }];
      });
      hooks.getFooterProps.push(function (props, _ref4) {
        var column = _ref4.column;
        return [props, {
          style: _extends({}, cellStyles$1, {
            width: column.totalWidth + "px"
          })
        }];
      });
    };

    useBlockLayout.pluginName = 'useBlockLayout';

    function useFlexLayout(hooks) {
      hooks.getTableProps.push(getTableProps);
      hooks.getRowProps.push(getRowStyles$2);
      hooks.getHeaderGroupProps.push(getRowStyles$2);
      hooks.getFooterGroupProps.push(getRowStyles$2);
      hooks.getHeaderProps.push(getHeaderProps);
      hooks.getCellProps.push(getCellProps);
      hooks.getFooterProps.push(getFooterProps);
    }

    useFlexLayout.pluginName = 'useFlexLayout';

    var getTableProps = function getTableProps(props, _ref) {
      var instance = _ref.instance;
      return [props, {
        style: {
          minWidth: instance.totalColumnsMinWidth + "px"
        }
      }];
    };

    var getRowStyles$2 = function getRowStyles(props, _ref2) {
      var instance = _ref2.instance;
      return [props, {
        style: {
          display: 'flex',
          flex: '1 0 auto',
          minWidth: instance.totalColumnsMinWidth + "px"
        }
      }];
    };

    var getHeaderProps = function getHeaderProps(props, _ref3) {
      var column = _ref3.column;
      return [props, {
        style: {
          boxSizing: 'border-box',
          flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : undefined,
          minWidth: column.totalMinWidth + "px",
          width: column.totalWidth + "px"
        }
      }];
    };

    var getCellProps = function getCellProps(props, _ref4) {
      var cell = _ref4.cell;
      return [props, {
        style: {
          boxSizing: 'border-box',
          flex: cell.column.totalFlexWidth + " 0 auto",
          minWidth: cell.column.totalMinWidth + "px",
          width: cell.column.totalWidth + "px"
        }
      }];
    };

    var getFooterProps = function getFooterProps(props, _ref5) {
      var column = _ref5.column;
      return [props, {
        style: {
          boxSizing: 'border-box',
          flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : undefined,
          minWidth: column.totalMinWidth + "px",
          width: column.totalWidth + "px"
        }
      }];
    };

    function useGridLayout(hooks) {
      hooks.stateReducers.push(reducer$c);
      hooks.getTableProps.push(getTableProps$1);
      hooks.getHeaderProps.push(getHeaderProps$1);
    }

    useGridLayout.pluginName = 'useGridLayout';

    var getTableProps$1 = function getTableProps(props, _ref) {
      var instance = _ref.instance;
      return [props, {
        style: {
          display: "grid",
          gridTemplateColumns: instance.state.gridLayout.columnWidths.map(function (w) {
            return w;
          }).join(" ")
        }
      }];
    };

    var getHeaderProps$1 = function getHeaderProps(props, _ref2) {
      var column = _ref2.column;
      return [props, {
        id: "header-cell-" + column.id,
        style: {
          position: "sticky" //enables a scroll wrapper to be placed around the table and have sticky headers

        }
      }];
    };

    function reducer$c(state, action, previousState, instance) {
      if (action.type === "init") {
        return _extends({
          gridLayout: {
            columnWidths: instance.columns.map(function () {
              return "auto";
            })
          }
        }, state);
      }

      if (action.type === "columnStartResizing") {
        var columnId = action.columnId;
        var columnIndex = instance.visibleColumns.findIndex(function (col) {
          return col.id === columnId;
        });
        var elWidth = getElementWidth(columnId);

        if (elWidth !== undefined) {
          return _extends({}, state, {
            gridLayout: _extends({}, state.gridLayout, {
              columnId: columnId,
              columnIndex: columnIndex,
              startingWidth: elWidth
            })
          });
        } else {
          return state;
        }
      }

      if (action.type === "columnResizing") {
        var _state$gridLayout = state.gridLayout,
            _columnIndex = _state$gridLayout.columnIndex,
            startingWidth = _state$gridLayout.startingWidth,
            columnWidths = _state$gridLayout.columnWidths;
        var change = state.columnResizing.startX - action.clientX;
        var newWidth = startingWidth - change;
        var columnWidthsCopy = [].concat(columnWidths);
        columnWidthsCopy[_columnIndex] = newWidth + "px";
        return _extends({}, state, {
          gridLayout: _extends({}, state.gridLayout, {
            columnWidths: columnWidthsCopy
          })
        });
      }
    }

    function getElementWidth(columnId) {
      var _document$getElementB;

      var width = (_document$getElementB = document.getElementById("header-cell-" + columnId)) == null ? void 0 : _document$getElementB.offsetWidth;

      if (width !== undefined) {
        return width;
      }
    }

    exports._UNSTABLE_usePivotColumns = _UNSTABLE_usePivotColumns;
    exports.actions = actions;
    exports.defaultColumn = defaultColumn;
    exports.defaultGroupByFn = defaultGroupByFn;
    exports.defaultOrderByFn = defaultOrderByFn;
    exports.defaultRenderer = defaultRenderer;
    exports.emptyRenderer = emptyRenderer;
    exports.ensurePluginOrder = ensurePluginOrder;
    exports.flexRender = flexRender;
    exports.functionalUpdate = functionalUpdate;
    exports.loopHooks = loopHooks;
    exports.makePropGetter = makePropGetter;
    exports.makeRenderer = makeRenderer;
    exports.reduceHooks = reduceHooks;
    exports.safeUseLayoutEffect = safeUseLayoutEffect;
    exports.useAbsoluteLayout = useAbsoluteLayout;
    exports.useAsyncDebounce = useAsyncDebounce;
    exports.useBlockLayout = useBlockLayout;
    exports.useColumnOrder = useColumnOrder;
    exports.useExpanded = useExpanded;
    exports.useFilters = useFilters;
    exports.useFlexLayout = useFlexLayout;
    exports.useGetLatest = useGetLatest;
    exports.useGlobalFilter = useGlobalFilter;
    exports.useGridLayout = useGridLayout;
    exports.useGroupBy = useGroupBy;
    exports.useMountedLayoutEffect = useMountedLayoutEffect;
    exports.usePagination = usePagination;
    exports.useResizeColumns = useResizeColumns;
    exports.useRowSelect = useRowSelect;
    exports.useRowState = useRowState;
    exports.useSortBy = useSortBy;
    exports.useTable = useTable;
    Object.defineProperty(exports, '__esModule', {
      value: true
    });
  });
});

var reactTable = createCommonjsModule(function (module) {
  {
    module.exports = reactTable_production_min;
  }
});

function RoundedRightIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "1em",
    height: "1em",
    viewBox: "0 0 45 45",
    fill: "none"
  }, props), React.createElement("g", {
    opacity: 0.9
  }, React.createElement("circle", {
    cx: 22.5,
    cy: 20.5,
    r: 16.5,
    fill: "#fff",
    stroke: "#ccc"
  })), React.createElement("path", {
    d: "M20 13l7 7-7 7",
    stroke: "#0E0F11",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

const MemoRoundedRightIcon = React.memo(RoundedRightIcon);

function RoundedLeftIcon(props) {
  return React.createElement("svg", _extends$1({
    width: "1em",
    height: "1em",
    viewBox: "0 0 45 45",
    fill: "none"
  }, props), React.createElement("g", {
    opacity: 0.9
  }, React.createElement("circle", {
    cx: 22.5,
    cy: 20.5,
    r: 16.5,
    transform: "rotate(-180 22.5 20.5)",
    fill: "#fff",
    stroke: "#ccc"
  })), React.createElement("path", {
    d: "M25 28l-7-7 7-7",
    stroke: "#0E0F11",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

const MemoRoundedLeftIcon = React.memo(RoundedLeftIcon);

const _excluded$8 = ["fadeAmount", "showFade", "showButtons", "sx", "children"];
const HorizontalContainer = _ref => {
  let {
    fadeAmount = '10%',
    showFade = true,
    showButtons = true,
    sx = {},
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$8);

  const initialAmounts = React__default.useRef({
    lFade: '0%',
    rFade: fadeAmount
  });
  const widthRef = useRef(null);
  const [{
    lFade,
    rFade
  }, setFadeAmounts] = useState(initialAmounts.current); // get width and update if changed

  const {
    width
  } = useWindowSize();
  useEffect(() => {
    if (widthRef.current) {
      if (widthRef.current.scrollWidth <= widthRef.current.offsetWidth) {
        initialAmounts.current = {
          lFade: '0%',
          rFade: '0%'
        };
        setFadeAmounts(initialAmounts.current);
      } else {
        initialAmounts.current = {
          lFade: '0%',
          rFade: fadeAmount
        };
        setFadeAmounts(initialAmounts.current);
      }
    }
  }, [width]);
  const handleScroll = React__default.useCallback(() => {
    var _widthRef$current, _widthRef$current2;

    if (!widthRef.current) return;

    if (widthRef.current.scrollLeft <= 0) {
      setFadeAmounts(initialAmounts.current);
    } else if (widthRef.current.scrollLeft + widthRef.current.offsetWidth >= ((_widthRef$current = widthRef.current) == null ? void 0 : _widthRef$current.scrollWidth)) {
      setFadeAmounts({
        lFade: fadeAmount,
        rFade: '0%'
      });
    } else if (widthRef.current.scrollLeft + widthRef.current.offsetWidth <= ((_widthRef$current2 = widthRef.current) == null ? void 0 : _widthRef$current2.scrollWidth)) {
      setFadeAmounts({
        lFade: fadeAmount,
        rFade: fadeAmount
      });
    }
  }, [widthRef, fadeAmount]);
  const handleLeftRightScroll = React__default.useCallback((left = true) => {
    var _widthRef$current3, _widthRef$current4;

    if (!widthRef.current) return;
    const scrollLeftAmount = widthRef.current.scrollLeft + (left ? +300 : -300);
    widthRef.current.scrollTo({
      left: scrollLeftAmount,
      behavior: 'smooth'
    });

    if (scrollLeftAmount <= 0) {
      setFadeAmounts({
        lFade: '0%',
        rFade: fadeAmount
      });
    } else if (scrollLeftAmount + widthRef.current.offsetWidth >= ((_widthRef$current3 = widthRef.current) == null ? void 0 : _widthRef$current3.scrollWidth)) {
      setFadeAmounts({
        lFade: fadeAmount,
        rFade: '0%'
      });
    } else if (scrollLeftAmount + widthRef.current.offsetWidth <= ((_widthRef$current4 = widthRef.current) == null ? void 0 : _widthRef$current4.scrollWidth)) {
      setFadeAmounts({
        lFade: fadeAmount,
        rFade: fadeAmount
      });
    }
  }, [widthRef, fadeAmount]);
  return React__default.createElement(Flex, {
    sx: {
      position: 'relative',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none'
      }
    },
    onWheel: handleScroll,
    onScroll: handleScroll
  }, React__default.createElement(Flex, {
    sx: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      width: !showFade ? 0 : lFade,
      height: '100%',
      backgroundImage: 'linear-gradient(-90deg, rgba(255, 255, 255, 0.3) 0%, rgba(255,255,255,0.5) 45%, #fff 100%)'
    }
  }), React__default.createElement(Flex, {
    sx: {
      position: 'absolute',
      height: '100%',
      top: 0,
      bottom: 0,
      left: {
        base: 0,
        md: '-15px'
      },
      justifyContent: 'flex-end',
      alignItems: 'center',
      cursor: 'pointer',
      display: showButtons && lFade && lFade !== '0%' ? 'flex' : 'none'
    },
    onClick: () => handleLeftRightScroll(false)
  }, React__default.createElement(Box, {
    as: MemoRoundedLeftIcon,
    sx: {
      height: '50px',
      width: '50px',
      zIndex: 1
    }
  })), React__default.createElement(Flex, _extends$1({
    sx: {
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      overflowY: 'hidden',
      overflowX: 'scroll',
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      width: '100%'
    },
    ref: widthRef
  }, props), children, (rFade != null ? rFade : '0%') !== '0%' && React__default.createElement(Box, {
    sx: {
      paddingRight: 6
    }
  })), React__default.createElement(Flex, {
    sx: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      width: !showFade ? 0 : rFade,
      height: '100%',
      backgroundImage: 'linear-gradient(90deg, rgba(255, 255, 255, 0.3) 0%, rgba(255,255,255,0.5) 45%, #fff 100%)'
    }
  }, React__default.createElement(Flex, {
    sx: {
      position: 'absolute',
      height: '100%',
      justifyContent: 'flex-end',
      top: 0,
      bottom: 0,
      right: {
        base: 0,
        md: '-15px'
      },
      alignItems: 'center',
      cursor: 'pointer',
      display: showButtons && rFade && rFade !== '0%' ? 'flex' : 'none'
    },
    onClick: () => handleLeftRightScroll(true)
  }, React__default.createElement(Box, {
    as: MemoRoundedRightIcon,
    sx: {
      height: '50px',
      width: '50px',
      zIndex: 1
    }
  }))));
};

const _excluded$7 = ["className"];
const Table = forwardRef((props, ref) => {
  const {
    data: _data = [],
    columns: _columns = [],
    boldLastRow = false,
    containerProps = {}
  } = props;
  const data = React__default.useMemo(() => _data, [_data]);
  const columns = React__default.useMemo(() => _columns, [_columns]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow //@ts-ignore

  } = reactTable.useTable({
    columns,
    data
  });
  return React__default.createElement(HorizontalContainer, _extends$1({}, containerProps), React__default.createElement(Box, _extends$1({
    as: "table",
    ref: ref
  }, getTableProps(), {
    width: "100%"
  }), React__default.createElement(Box, {
    as: "thead"
  }, headerGroups.map(headerGroup => React__default.createElement(Box, _extends$1({
    as: "tr"
  }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(column => React__default.createElement(Box, _extends$1({
    as: "th"
  }, column.getHeaderProps(), {
    sx: {
      backgroundColor: 'transparent',
      color: 'gray.500',
      text: 'sm',
      fontWeight: 'normal',
      margin: 0,
      paddingY: 4,
      paddingRight: 4,
      textAlign: 'left',
      borderBottom: '1px solid',
      borderColor: 'gray.300'
    }
  }), column.render('Header')))))), React__default.createElement(Box, _extends$1({
    as: "tbody"
  }, getTableBodyProps()), rows.map(row => {
    prepareRow(row);
    const isLastRow = rows.length === row.index + 1;
    return React__default.createElement(Box, _extends$1({
      as: "tr"
    }, row.getRowProps(), {
      sx: {
        borderTop: boldLastRow && isLastRow ? '1px solid' : 0,
        borderColor: 'gray.300'
      }
    }), row.cells.map(cell => {
      const _cell$getCellProps = cell.getCellProps(),
            cellProps = _objectWithoutPropertiesLoose$2(_cell$getCellProps, _excluded$7);

      return React__default.createElement(Box, _extends$1({
        as: "td"
      }, cellProps, {
        sx: {
          text: 'base',
          fontWeight: isLastRow && boldLastRow ? 'bold' : 'normal',
          paddingY: 3,
          paddingRight: 4
        }
      }), cell.render('Cell'));
    }));
  }))));
});

const _excluded$6 = ["foregroundColor", "backgroundColor"];
const Progress = forwardRef(function Progress(_ref, ref) {
  let {
    foregroundColor = 'purple.600',
    backgroundColor = 'purple.200'
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$6);

  return React__default.createElement(Box, _extends$1({
    ref: ref,
    as: "progress"
  }, props, {
    sx: {
      display: 'block',
      width: '100%',
      minHeight: '10px',
      height: '10px',
      margin: 0,
      padding: 0,
      overflow: 'hidden',
      appearance: 'none',
      color: foregroundColor,
      bg: backgroundColor,
      borderRadius: '8px',
      border: 'none',
      '&::-webkit-progress-bar': {
        bg: 'transparent',
        borderRadius: '8px',
        borderRight: '1px solid #fff'
      },
      '&::-webkit-progress-value': {
        bg: 'currentcolor',
        borderRadius: '8px',
        borderRight: '1px solid #fff'
      },
      '&::-moz-progress-bar': {
        bg: 'currentcolor',
        borderRadius: '8px'
      }
    }
  }));
});

const Tag = ({
  backgroundColor: _backgroundColor = 'gray.200',
  textColor: _textColor = 'inherit',
  sx: _sx = {},
  children
}) => React__default.createElement(Box, null, React__default.createElement(Flex, {
  sx: _extends$1({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    bg: _backgroundColor,
    color: _textColor,
    paddingY: '0.25rem',
    paddingX: '0.5rem',
    text: 'sm',
    fontWeight: 'bold',
    borderRadius: 'full',
    lineHeight: '1.5 !important'
  }, _sx)
}, children));

const _excluded$5 = ["sx"];
const Container = forwardRef(function Container(_ref, ref) {
  let {
    sx = {}
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$5);

  return React__default.createElement(Box, _extends$1({
    ref: ref,
    sx: _extends$1({
      width: {
        sm: '640px',
        md: '768px',
        lg: '1024px',
        xl: '1280px'
      },
      maxWidth: {
        sm: '640px',
        md: '768px',
        lg: '1024px',
        xl: '1280px'
      },
      margin: 'auto'
    }, sx)
  }, props));
});

const _excluded$4 = ["label", "value", "backgroundColor", "foregroundColor", "indicatorColor"];
const PercentageBar = _ref => {
  let {
    label,
    value,
    backgroundColor = 'transparent',
    foregroundColor = 'blue.100',
    indicatorColor = 'blue.600'
  } = _ref,
      rest = _objectWithoutPropertiesLoose$2(_ref, _excluded$4);

  return React__default.createElement(Flex, _extends$1({
    sx: {
      width: '100%',
      backgroundColor
    }
  }, rest), React__default.createElement(Flex, {
    sx: {
      borderRight: '4px solid',
      borderColor: indicatorColor,
      backgroundColor: foregroundColor,
      justifyContent: 'space-between',
      maxHeight: '40px',
      minWidth: 'fit-content',
      width: `${value}%`,
      paddingX: 3,
      paddingY: 1
    }
  }, React__default.createElement(Box, {
    sx: {
      marginRight: 8
    }
  }, label), React__default.createElement(Box, {
    sx: {
      fontWeight: 'bold'
    }
  }, value, "%")));
};

const _excluded$3 = ["children", "widthRef"];
const useHorizontalContainer = () => {
  const initialAmounts = React.useRef({
    disableLeft: true,
    disableRight: false
  });
  const widthRef = React.useRef(null);
  const [{
    disableLeft,
    disableRight
  }, setDisabledStates] = React.useState(initialAmounts.current);
  const {
    width
  } = useWindowSize();
  React.useEffect(() => {
    if (widthRef.current) {
      if (widthRef.current.scrollWidth <= widthRef.current.offsetWidth) {
        initialAmounts.current = {
          disableLeft: true,
          disableRight: true
        };
      } else {
        initialAmounts.current = {
          disableLeft: true,
          disableRight: false
        };
      }

      setDisabledStates(initialAmounts.current);
    }
  }, [width]);
  const handleScroll = React.useCallback(() => {
    if (!widthRef.current) return;

    if (widthRef.current.scrollLeft <= 0) {
      setDisabledStates(initialAmounts.current);
    } else if (widthRef.current.scrollLeft + widthRef.current.offsetWidth + 10 >= widthRef.current.scrollWidth) {
      // Check for scrollLeft + offsetWidth + 10 since SOMETIMES
      // scrollLeft + offsetWidth is not quite >= scrollWith
      setDisabledStates({
        disableLeft: false,
        disableRight: true
      });
    } else if (widthRef.current.scrollLeft + widthRef.current.offsetWidth <= widthRef.current.scrollWidth) {
      setDisabledStates({
        disableLeft: false,
        disableRight: false
      });
    }
  }, [widthRef]);
  const handleLeftRightScroll = React.useCallback(direction => {
    if (!widthRef.current) return;
    const scrollLeftAmount = widthRef.current.scrollLeft + (direction === 'RIGHT' ? +300 : -300);
    widthRef.current.scrollTo({
      left: scrollLeftAmount,
      behavior: 'smooth'
    });

    if (scrollLeftAmount <= 0) {
      setDisabledStates(initialAmounts.current);
    } else if (scrollLeftAmount + widthRef.current.offsetWidth >= widthRef.current.scrollWidth) {
      setDisabledStates({
        disableLeft: false,
        disableRight: true
      });
    } else if (scrollLeftAmount + widthRef.current.offsetWidth <= widthRef.current.scrollWidth) {
      setDisabledStates({
        disableLeft: false,
        disableRight: false
      });
    }
  }, [widthRef]);
  const HorizontalContainer = React.useCallback(_ref => {
    let {
      children,
      widthRef
    } = _ref,
        props = _objectWithoutPropertiesLoose$2(_ref, _excluded$3);

    return React.createElement(Flex, {
      sx: {
        position: 'relative',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none'
        }
      },
      onWheel: handleScroll,
      onScroll: handleScroll
    }, React.createElement(Flex, _extends$1({
      ref: widthRef,
      sx: {
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        overflowY: 'hidden',
        overflowX: 'scroll',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none'
        },
        width: '100%'
      }
    }, props), children));
  }, [widthRef]);
  const LeftButton = React.memo(props => React.createElement(Flex, _extends$1({
    sx: {
      cursor: disableLeft ? 'not-allowed' : 'pointer',
      opacity: disableLeft ? 0.3 : 1
    },
    onClick: disableLeft ? () => {} : () => handleLeftRightScroll('LEFT')
  }, props), React.createElement(Box, {
    as: LeftIcon,
    sx: {
      height: '33px',
      width: '33px'
    }
  })));
  const RightButton = React.memo(props => React.createElement(Flex, _extends$1({
    sx: {
      cursor: disableRight ? 'not-allowed' : 'pointer',
      opacity: disableRight ? 0.3 : 1
    },
    onClick: disableRight ? () => {} : () => handleLeftRightScroll('RIGHT')
  }, props), React.createElement(Box, {
    as: RightIcon,
    sx: {
      height: '33px',
      width: '33px'
    }
  })));
  return {
    HorizontalContainer,
    widthRef,
    handleScrollLeft: () => handleLeftRightScroll('LEFT'),
    handleScrollRight: () => handleLeftRightScroll('RIGHT'),
    LeftButton,
    RightButton,
    disableLeft,
    disableRight
  };
};
const LeftIcon = React.memo(props => React.createElement("svg", _extends$1({
  width: "1em",
  height: "1em",
  viewBox: "0 0 45 45",
  fill: "none"
}, props), React.createElement("g", {
  opacity: 0.9
}, React.createElement("circle", {
  cx: 22.5,
  cy: 20.5,
  r: 16.5,
  transform: "rotate(-180 22.5 20.5)",
  fill: "#fff",
  stroke: "#ccc"
})), React.createElement("path", {
  d: "M25 28l-7-7 7-7",
  stroke: "#0E0F11",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const RightIcon = React.memo(props => React.createElement("svg", _extends$1({
  width: "1em",
  height: "1em",
  viewBox: "0 0 45 45",
  fill: "none"
}, props), React.createElement("g", {
  opacity: 0.9
}, React.createElement("circle", {
  cx: 22.5,
  cy: 20.5,
  r: 16.5,
  fill: "#fff",
  stroke: "#ccc"
})), React.createElement("path", {
  d: "M20 13l7 7-7 7",
  stroke: "#0E0F11",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

const _excluded$2 = ["ratio", "children"];
const AspectRatio = forwardRef(function AspectRatio(_ref, ref) {
  let {
    ratio = 4 / 3,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$2);

  return React__default.createElement(Box, {
    ref: ref,
    sx: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, React__default.createElement(Box, {
    sx: {
      width: '100%',
      height: 0,
      paddingBottom: 100 / ratio + '%'
    }
  }), React__default.createElement(Box, _extends$1({}, props, {
    sx: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  }), children));
});

const _excluded$1 = ["variant", "sx"];

const Image = forwardRef(function Image(_ref, ref) {
  let {
    sx = {}
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded$1);

  // const variantStyle = useVariant('images', variant)
  return React__default.createElement(Box, _extends$1({
    ref: ref,
    as: "img",
    sx: _extends$1({
      maxWidth: '100%',
      height: 'auto'
    }, props.sx, sx)
  }, props));
});

const _excluded = ["ratio"];
const AspectImage = forwardRef(function AspectImage(_ref, ref) {
  let {
    ratio
  } = _ref,
      props = _objectWithoutPropertiesLoose$2(_ref, _excluded);

  return React__default.createElement(AspectRatio, {
    ratio: ratio
  }, React__default.createElement(Image, _extends$1({
    ref: ref
  }, props, {
    sx: {
      objectFit: 'cover'
    }
  })));
});

const AwningLogo = React.memo(function (props) {
  return React.createElement("svg", _extends$1({
    width: "109",
    height: "32",
    viewBox: "0 0 109 32",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M27.494 13.957c0-1.663-.208-2.91-.66-3.914-1.18-2.493-3.887-2.978-6.004-2.978-4.13 0-6.63 1.8-6.63 4.537 0 1.108.452 1.94.452 1.94h3.158s-.243-.486-.243-1.178c0-1.593 1.354-2.182 3.159-2.182 1.284 0 3.124.415 3.124 2.008 0 1.455-.695 2.148-3.957 2.563-3.471.45-6.283 1.524-6.283 5.195 0 3.082 1.979 5.126 5.797 5.126 2.117 0 3.818-1.109 4.581-2.182h.105v1.835h3.401v-10.77zm-3.575 4.156c0 2.008-1.319 3.878-4.026 3.878-1.91 0-2.742-.866-2.742-2.147 0-1.177.937-1.94 3.228-2.25 1.388-.174 2.811-.451 3.436-1.282h.104v1.8zM38.556 7.411l-2.95 11.048c-.243.831-.486 2.043-.52 2.216-.07-.207-.313-1.385-.521-2.25L31.927 7.41H27.97l4.963 17.316h4.13l2.535-9.281.798-3.048c.035.243.451 1.801.764 3.048l2.533 9.281h4.096l4.963-17.316h-3.956L46.192 18.46l-.52 2.251s-.313-1.385-.556-2.251L42.201 7.41h-3.645zM57.72 15.065c0-3.775 1.84-4.537 3.471-4.537 1.666 0 3.297.831 3.297 4.433v9.766h3.68v-10.32c0-4.71-2.36-7.342-6.11-7.342-1.943 0-3.47.97-4.303 2.286h-.07V7.41H54.11v17.316h3.61v-9.662zM74.705 24.727V7.411h-3.644v17.316h3.644zm-4.477-22.06c0 1.523 1.11 2.632 2.638 2.632 1.561 0 2.672-1.109 2.672-2.632 0-1.559-1.11-2.667-2.672-2.667-1.528 0-2.638 1.108-2.638 2.667zM81.316 15.065c0-3.775 1.84-4.537 3.471-4.537 1.666 0 3.298.831 3.298 4.433v9.766h3.679v-10.32c0-4.71-2.36-7.342-6.11-7.342-1.943 0-3.47.97-4.303 2.286h-.07V7.41h-3.575v17.316h3.61v-9.662zM100.904 20.017c4.339 0 6.595-2.874 6.595-6.199 0-1.143-.208-2.182-.729-3.082l1.909-1.524-1.943-2.493-1.979 1.593c-1.111-.831-2.429-1.247-3.957-1.247-3.957 0-6.733 2.84-6.733 6.753 0 1.732.555 3.325 1.84 4.468-.764.485-1.736 1.558-1.736 3.013 0 3.151 3.193 3.567 6.109 3.705 2.603.139 4.095.45 4.095 1.905 0 1.247-1.041 1.974-3.783 1.974-2.395 0-3.749-.762-3.749-2.008 0-.728.243-1.178.243-1.178h-3.158s-.347.727-.347 1.697c0 3.463 3.089 4.606 7.011 4.606 4.2 0 7.22-1.593 7.22-5.056 0-4.087-2.985-4.78-6.109-4.987-2.326-.174-4.027-.139-4.027-1.143 0-.485.313-.866.625-1.143.799.242 1.632.346 2.603.346zm-.138-9.731c2.047 0 3.262 1.247 3.262 3.463 0 1.593-1.041 3.117-3.262 3.117-2.257 0-3.194-1.697-3.194-3.152 0-1.974 1.18-3.428 3.194-3.428z",
    fill: "#2E2D2D"
  }), React.createElement("path", {
    d: "M0 .11h27.541L0 13.48V.11z",
    fill: "#19C535"
  }));
});

export { ActionButton, AspectImage, AspectRatio, AwningLogo, BaseInput, BaseStyles, Box, Button, CSSReset, Checkbox, ClampText, Container, DatePicker, Divider, Field, Flex, Grid, HorizontalContainer, Input, InputCurrency, InputDual, InputPassword, InputPercent, InputWithAdornment, Label, LinkButton, PercentageBar, Progress, Radio, RadioButton, RadioGroup, Select, SelectItem, Slider, Switch, Table, Tag, Text, Textarea, ThemeProvider, Tooltip, baseColors, baseFontWeights, baseFonts, borderWidths, colors, css$1 as css, fontSizes, fontWeights, fonts, forwardRef, get$2 as get, getNonSystemProps, getSystemProps, jsx, letterSpacings, lineHeights, merge$1 as merge, parseResponsiveObjects, radii, shadows, sizes, space, styles, text, theme, transitions, useCollapse, useHorizontalContainer, useThemeUI, useVariant, useWindowSize, zIndices };
//# sourceMappingURL=index.js.map
